/*! @twilio/flex-ui-core.js 0.57.0
The following license applies to all parts of this software except as documented below.

Copyright (c) 2018 Twilio, Inc.
All rights reserved.

 Licensed under the Apache License, Version 2.0 (the “License”);
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an “AS IS” BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.


This software includes react under the following license.

Copyright (c) Facebook, Inc. and its affiliates.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.


This software includes redux under the following license.
Copyright (c) 2015-present Dan Abramov

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.


This software includes semver under the following license.
Copyright (c) Isaac Z. Schlueter and Contributors

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR
IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.


This software includes loglevel under the following license.
Copyright (c) 2013 Tim Perry

Permission is hereby granted, free of charge, to any person
obtaining a copy of this software and associated documentation
files (the "Software"), to deal in the Software without
restriction, including without limitation the rights to use,
copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the
Software is furnished to do so, subject to the following
conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
OTHER DEALINGS IN THE SOFTWARE.


This software includes hoist-non-react-statics under the following license.

Software License Agreement (BSD License)
========================================

Copyright (c) 2015, Yahoo! Inc. All rights reserved.
----------------------------------------------------

Redistribution and use of this software in source and binary forms, with or
without modification, are permitted provided that the following conditions are
met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.
  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.
  * Neither the name of Yahoo! Inc. nor the names of YUI's contributors may be
    used to endorse or promote products derived from this software without
    specific prior written permission of Yahoo! Inc.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.*/
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.FlexCore = t() : (e.Twilio = e.Twilio || {}, e.Twilio.FlexCore = t());
}(window, function () {
  return function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "/assets/", n(n.s = 105);
  }([function (e, t) {
    e.exports = require("react");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getBackgroundWithHoverCSS = t.withTheme = t.styled = void 0;
    var i = n(3),
      a = n(51);
    o(n(290), t), t.styled = i.default;
    t.withTheme = function (e) {
      return a.withTheme(e);
    };
    t.getBackgroundWithHoverCSS = function (e, t, n, r) {
      void 0 === n && (n = !1), void 0 === r && (r = !1), e || (e = "rgba(0, 0, 0, 0)");
      var o = "rgba(0, 0, 0, 0.2)",
        i = "rgba(0, 0, 0, 0.3)";
      if (t && (o = "rgba(255, 255, 255, 0.2)", i = "rgba(255, 255, 255, 0.3)"), n) return "\n            background-image: linear-gradient(to top, " + e + ", " + e + ");\n            background-color: " + o + ";\n            background-blend-mode: color;\n        ";
      var a = "\n        background-image: linear-gradient(to top, " + e + ", " + e + ");\n    ";
      return r || (a = a + "\n            &:hover {\n                background-color: " + o + ";\n                background-blend-mode: color;\n            }\n            &:active {\n                background-color: " + i + ";\n                background-blend-mode: color;\n            }\n        "), a;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.log = void 0;
    var r = n(107).getLogger("twilio-flex-ui-core");
    t.log = r, t.default = r;
  }, function (e, t) {
    e.exports = require("react-emotion");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CompiledTemplate = t.Template = t.templates = void 0;
    var r = n(11);
    Object.defineProperty(t, "Template", {
      enumerable: !0,
      get: function get() {
        return r.Template;
      }
    }), Object.defineProperty(t, "CompiledTemplate", {
      enumerable: !0,
      get: function get() {
        return r.CompiledTemplate;
      }
    });
    var o = r.templates;
    t.templates = o;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.connect = t.ChatModule = void 0;
    var r = n(106),
      o = n(30),
      i = n(8),
      a = function a(e) {
        return e;
      },
      l = function () {
        function e() {}
        return e.init = function (t, n) {
          void 0 === n && (n = a), e.localStateCallback = n, e.localStore = t;
        }, Object.defineProperty(e, "state", {
          get: function get() {
            if (!e.localStateCallback) throw i.ErrorManager.createAndProcessError("Trying to get ChatModule state without ChatModule being initialized", {
              context: "ChatModule"
            });
            return e.stateCallback(e.localStore.getState());
          },
          enumerable: !1,
          configurable: !0
        }), e.dispatch = function (t) {
          if (!e.localStore) throw i.ErrorManager.createAndProcessError("Trying to dispatch an action against ChatModule state without ChatModule being initialized", {
            context: "ChatModule"
          });
          return e.localStore.dispatch(t);
        }, Object.defineProperty(e, "events", {
          get: function get() {
            return e.localEvents;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "stateCallback", {
          get: function get() {
            return e.localStateCallback;
          },
          enumerable: !1,
          configurable: !0
        }), e.localEvents = new o.ChatEventEmitter(), e;
      }();
    t.ChatModule = l, t.connect = function (e, t, n, o) {
      return void 0 === t && (t = void 0), void 0 === n && (n = void 0), void 0 === o && (o = void 0), r.connect(function (t, n) {
        return e(l.stateCallback(t), n);
      }, t, n, o);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FlexBoxColumn = t.FlexBoxProperties = t.FlexBox = void 0;
    var r = n(50);
    Object.defineProperty(t, "FlexBox", {
      enumerable: !0,
      get: function get() {
        return r.FlexBox;
      }
    }), Object.defineProperty(t, "FlexBoxProperties", {
      enumerable: !0,
      get: function get() {
        return r.FlexBoxProperties;
      }
    });
    var o = n(110);
    Object.defineProperty(t, "FlexBoxColumn", {
      enumerable: !0,
      get: function get() {
        return o.FlexBoxColumn;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SvgContainerProps = t.IconProps = t.Icon = void 0;
    var r = n(291);
    Object.defineProperty(t, "Icon", {
      enumerable: !0,
      get: function get() {
        return r.Icon;
      }
    });
    var o = n(293);
    Object.defineProperty(t, "IconProps", {
      enumerable: !0,
      get: function get() {
        return o.IconProps;
      }
    }), Object.defineProperty(t, "SvgContainerProps", {
      enumerable: !0,
      get: function get() {
        return o.SvgContainerProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ErrorManager = void 0;
    var r = n(2),
      o = n(19),
      i = function () {
        function e() {}
        return e.prototype.processError = function (e) {
          return this.errorProcessingOverride ? this.errorProcessingOverride(e) : (o.isCoreError(e) ? r.log.error(e.logLine) : r.log.error(e.message), e);
        }, e.prototype.createAndProcessError = function (e, t) {
          void 0 === t && (t = {});
          var n = new o.CoreError(e, t);
          return this.processError(n);
        }, e;
      }();
    t.ErrorManager = new i();
  }, function (e, t, n) {
    "use strict";

    var _r,
      o = this && this.__extends || (_r = function r(e, t) {
        return (_r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      a = this && this.__assign || function () {
        return (a = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      l = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      s = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || l(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DynamicComponent = t.DefaultContentFragment = t.ContentFragment = void 0;
    var c = n(12),
      u = n(0),
      p = n(3),
      d = n(6),
      f = n(19),
      h = n(8),
      m = n(14),
      g = n(2),
      v = n(10);
    s(n(35), t);
    var y = n(51),
      b = y.channel,
      _ = y.contextTypes,
      O = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return this.props.children;
        }, t;
      }(u.Component);
    t.ContentFragment = O;
    var C = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.render = function () {
        return this.props.children;
      }, t;
    }(u.Component);
    t.DefaultContentFragment = C;
    var w = function (e) {
      function t(t, n) {
        return e.call(this, t, n) || this;
      }
      return o(t, e), t.prototype.componentDidCatch = function (e) {
        if (f.isCoreError(e)) throw e;
        throw h.ErrorManager.createAndProcessError(m.ErrorMessages.DYNAMIC_COMPONENT_GENERIC_MESSAGE, {
          wrappedError: e,
          description: "An error has been detected inside the " + this.props.name + " DynamicComponent",
          context: "DynamicComponent"
        });
      }, t.prototype.componentWillMount = function () {
        var e = this,
          t = this.context[b];
        void 0 !== t ? this.themeUnsubscribeId = t.subscribe(function (t) {
          e.theme = t, e.forceUpdate();
        }) : g.log.error("No theme context");
      }, t.prototype.componentWillUnmount = function () {
        -1 !== this.themeUnsubscribeId && this.context[b].unsubscribe(this.themeUnsubscribeId);
      }, t.prototype.parseFragment = function (e, n, r, o, i, a) {
        var l,
          s = [],
          c = !1,
          p = function p(e, n) {
            var r = u.Children.map(e.props.children, function (r, o) {
              return {
                sortOrder: void 0 === e.props.sortOrder ? s.length + o : e.props.sortOrder,
                node: r = n ? t.cloneElementWithProps(r, i) : r
              };
            });
            e.props.replace ? (l = r, c = c || void 0 === e.props.align) : s.push.apply(s, r);
          },
          d = u.Children.only(n),
          f = d.props.children;
        "start" === e && (u.Children.toArray(f).find(function (e) {
          return u.isValidElement(e) && e.type === O;
        }) || p(d, !1));
        var g = function g(t) {
            var n = t;
            if (!u.isValidElement(n) || n.type !== O) return !1;
            if (n.props.if && !n.props.if(i)) return !1;
            var r = n.props.align;
            return r === e || "start" === e && void 0 === r;
          },
          y = function y(e, t) {
            u.Children.toArray(e).filter(g).forEach(function (e) {
              p(e, t);
            });
          };
        y(f, !1), y(r, !0), y(o, !0);
        var b = l && l.length > 0 ? l : s;
        if (a.length > 0) {
          var _ = a.filter(function (e) {
            return !e.options.if || e.options.if(i);
          });
          b = b.filter(function (e) {
            return !_.find(function (t) {
              return !!u.isValidElement(e.node) && e.node.key === t.key;
            });
          });
        }
        if (b.find(function (e) {
          if (!u.isValidElement(e.node)) return !1;
          var t = e.node;
          return t.type !== C && (null === t.key || void 0 === t.key);
        })) throw h.ErrorManager.createAndProcessError(m.ErrorMessages.DYNAMIC_COMPONENT_ELEMENTS_WITHOUT_KEY, {
          context: "DynamicComponent",
          description: "Elements without key in " + this.props.name
        });
        var w = v.Utils.stableSort(b, function (e, t) {
          return e.sortOrder - t.sortOrder;
        }).map(function (e) {
          return e.node;
        });
        return this.props.renderChildren && (w = this.props.renderChildren(w, e)), {
          replacedDefault: c,
          items: w
        };
      }, t.prototype.render = function () {
        var e = this.props,
          t = e.children,
          n = e.customChildren,
          r = e.childProps,
          o = e.contentStore,
          i = e.name,
          l = e.vertical,
          s = e.noContainers,
          p = e.subContainer,
          f = u.Children.only(t),
          g = a(a({}, r), {
            theme: this.theme
          }),
          v = this.parseFragment("start", t, n, o.fragments, g, o.removeRequests),
          y = null,
          b = null,
          _ = null;
        if (s && p) throw h.ErrorManager.createAndProcessError(m.ErrorMessages.DYNAMIC_COMPONENT_MUTUALLY_EXCLUSIVE, {
          description: "noContainers and subContainer prop cannot be both set!",
          context: "DynamicComponent"
        });
        s || (b = p ? u.cloneElement(p, {
          vertical: l,
          key: "start",
          className: c.cx("Twilio-" + i + "-default", x && M),
          overflow: "hidden"
        }, v.items) : u.createElement(d.FlexBox, {
          vertical: l,
          key: "start",
          className: c.cx("Twilio-" + i + "-default", x && M),
          overflow: "hidden"
        }, v.items)), v.replacedDefault || (y = this.parseFragment("end", t, n, o.fragments, g, o.removeRequests), s || (x && y.items.push(u.createElement(T, null, i, "-end")), _ = u.createElement(d.FlexBox, {
          vertical: l,
          key: "end",
          className: c.cx("Twilio-" + i + "-end", x && M),
          noGrow: !0,
          overflow: "hidden"
        }, y.items)));
        var O = c.css(this.props.rootContainerStyles),
          w = s ? [v.items, y ? y.items : []] : [b, _];
        if (s && 0 === v.items.length && (!y || 0 === y.items.length)) {
          var P = u.Children.only(t);
          if (P.props.children) w = [u.Children.toArray(P.props.children).find(function (e) {
            return u.isValidElement(e) && e.type === C;
          })];
        }
        return x && w.push(u.createElement(T, null, i)), u.cloneElement(f, {
          className: c.cx("Twilio", "Twilio-" + i, O, x && E)
        }, w);
      }, t.cloneElementWithProps = function (e, t) {
        var n = e;
        return u.isValidElement(e) && "string" != typeof e.type ? u.cloneElement(n, a(a({}, t), e.props), n.props.children) : e;
      }, t.displayName = "DynamicComponent", t.defaultProps = {
        rootContainerStyles: "display: flex;\n            position: relative;\n            overflow-x: hidden;"
      }, t.contextTypes = _, t;
    }(u.PureComponent);
    t.DynamicComponent = w;
    var x = !1,
      E = "DynamicComponentDebug",
      M = "DynamicComponentContainerDebug";
    x && c.injectGlobal(P || (P = i(["\n        .", ",\n        .", ",\n        .", " {\n            border-color: transparent;\n        }\n        .", " {\n            position: relative;\n        }\n        .", ":hover {\n            border: 3px solid red;\n        }\n        .", ":hover {\n            border: 2px solid green;\n        }\n        .", ":hover > .DebugLabel,\n        .", ":hover > .DebugLabel {\n            display: flex;\n        }\n        .", " > * {\n            border: 1px solid transparent;\n        }\n        .", ":hover > *:hover {\n            border: 1px solid blue;\n        }\n        .", " > .DebugLabel {\n            color: red;\n        }\n        .", " > .DebugLabel {\n            color: green;\n        }\n    "], ["\n        .", ",\n        .", ",\n        .", " {\n            border-color: transparent;\n        }\n        .", " {\n            position: relative;\n        }\n        .", ":hover {\n            border: 3px solid red;\n        }\n        .", ":hover {\n            border: 2px solid green;\n        }\n        .", ":hover > .DebugLabel,\n        .", ":hover > .DebugLabel {\n            display: flex;\n        }\n        .", " > * {\n            border: 1px solid transparent;\n        }\n        .", ":hover > *:hover {\n            border: 1px solid blue;\n        }\n        .", " > .DebugLabel {\n            color: red;\n        }\n        .", " > .DebugLabel {\n            color: green;\n        }\n    "])), E, M, "DynamicComponentContainerItemDebug", M, E, M, M, E, M, M, E, M);
    var P,
      j,
      A,
      I = p.default("div")(j || (j = i(["\n    margin: auto;\n    background: yellow;\n    z-index: 10000;\n"], ["\n    margin: auto;\n    background: yellow;\n    z-index: 10000;\n"]))),
      S = p.default("div")(A || (A = i(["\n    display: none;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    pointer-events: none;\n"], ["\n    display: none;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    pointer-events: none;\n"]))),
      T = function T(e) {
        var t = e.children;
        return u.createElement(S, {
          className: "DebugLabel"
        }, u.createElement(I, null, t));
      };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, l = i.length; a < l; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Utils = void 0;
    var i = n(0),
      a = n(2),
      l = n(4),
      s = "((?:\\s|^))(((?:(http|https|Http|Https|rtsp|Rtsp):\\/\\/(?:(?:[a-zA-Z0-9\\$\\-\\_\\.\\+\\!\\*\\'\\(\\)\\,\\;\\?\\&\\=]|(?:\\%[a-fA-F0-9]{2})){1,64}(?:\\:(?:[a-zA-Z0-9\\$\\-\\_\\.\\+\\!\\*\\'\\(\\)\\,\\;\\?\\&\\=]|(?:\\%[a-fA-F0-9]{2})){1,25})?\\@)?)?((?:(?:[a-zA-Z0-9][a-zA-Z0-9\\-]{0,64}\\.)+(?:(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])|(?:app)|(?:biz|buzz|b[abdefghijmnorstvwyz])|(?:cat|com|coop|credit|c[acdfghiklmnoruvxyz])|d[ejkmoz]|(?:edu|e[cegrstu])|f[ijkmor]|(?:gov|g[abdefghilmnpqrstuwy])|h[kmnrtu]|(?:info|int|i[delmnoqrst])|(?:jobs|j[emop])|k[eghimnrwyz]|l[abcikrstuvy]|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])|(?:name|net|n[acefgilopruz])|(?:org|om)|(?:pro|p[aefghklmnrstwy])|qa|r[eouw]|s[abcdeghijklmnortuvyz]|(?:tel|travel|t[cdfghjklmnoprtvwz])|u[agkmsyz]|v[aceginu]|w[fs]|y[etu]|z[amw]))|(?:(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[0-9])))(?:\\:\\d{1,5})?)((?:\\/|\\?)(?:(?:[a-zA-Z0-9\\;\\/\\?\\:\\@\\&\\=\\#\\~\\-\\.\\+\\!\\*\\'\\(\\)\\,\\_])|(?:\\%[a-fA-F0-9]{2}))*)?(?:\\b|$))",
      c = function () {
        function e() {}
        return e.stableSort = function (e, t) {
          var n = e.map(function (e, t) {
            return {
              index: t,
              value: e
            };
          });
          return n.sort(function (e, n) {
            return t(e.value, n.value) || e.index - n.index;
          }), n.map(function (e) {
            return e.value;
          });
        }, e.merge = function (t, n, r) {
          void 0 === r && (r = !0);
          var o = Object.assign({}, t);
          return e.mergeInto(o, n, r);
        }, e.mergeInto = function (t, n, r) {
          return void 0 === r && (r = !0), Object.keys(n).forEach(function (o) {
            var i = n[o],
              a = !1;
            "object" != typeof i || null === i || i instanceof Array || Object.getPrototypeOf(i) !== Object.prototype || (i = e.merge(t[o] || {}, i, r), a = !0), (r || void 0 === t[o] || a) && (t[o] = i);
          }), t;
        }, e.mergeArrayItems = function (e) {
          return e.reduce(function (e, t) {
            return e.concat(t);
          }, []);
        }, e.updateDefaultProps = function (e, t) {
          var n = this;
          t && 0 !== Object.keys(t).length && Object.keys(t).forEach(function (r) {
            var o = e[r];
            if (!o) return a.log.warn("updateDefaultProps, component does not exist:", r);
            var i = t[r];
            if (o.defaultProps) {
              var l = !1;
              Object.keys(i).forEach(function (e) {
                if (void 0 === o.defaultProps[e]) {
                  var t = i[e];
                  o.overrideProps && t !== o.overrideProps[e] && (o.overrideProps[e] = t, l = !0), delete i[e];
                } else a.log.warn("updateDefaultProps, component.defaultProps[propName] has been explicity set and cannot be overridden:", r, e);
              }), l && Object.prototype.hasOwnProperty.call(o, "updateAll") && o.updateAll();
            }
            return n.updateDefaultProps(o, i);
          });
        }, e.getNameForMember = function (e, t, n, r) {
          return n && e ? n : t || n || r;
        }, e.formatString = function (e) {
          for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
          for (var r = 0; r < t.length; r++) {
            var o = new RegExp("\\{" + r + "\\}", "gm");
            e = e.replace(o, t[r]);
          }
          return e;
        }, e.parseVersion = function (e) {
          if (e) {
            var t = e.split(new RegExp("[.+-]"));
            if (!(t.length < 3)) return {
              major: parseInt(t[0], 10),
              minor: parseInt(t[1], 10),
              build: parseInt(t[2], 10)
            };
          }
        }, e.isGreaterThanTargetVersion = function (e, t) {
          return !(!e || !t) && (e.major > t.major || e.major === t.major && (e.minor > t.minor || e.minor === t.minor && e.build >= t.build));
        }, e.copyMap = function (e) {
          if (e) {
            var t = new Map();
            return e.forEach(function (e, n) {
              t.set(n, e);
            }), t;
          }
        }, e.isSameDate = function (e, t) {
          return e.getDate() === t.getDate() && e.getMonth() === t.getMonth() && e.getFullYear() === t.getFullYear();
        }, e.isToday = function (e) {
          var t = new Date();
          return this.isSameDate(t, e);
        }, e.isYesterday = function (e) {
          var t = new Date();
          return t.setDate(t.getDate() - 1), this.isSameDate(e, t);
        }, e.formatSeparatorDate = function (e) {
          return this.isToday(e) ? l.templates.Today() : this.isYesterday(e) ? l.templates.Yesterday() : e.toLocaleDateString();
        }, e.parseText = function (e) {
          var t = this,
            n = [];
          e = e.trim();
          var r = new RegExp(/[\n\r]/),
            o = e.split(r);
          return o.forEach(function (e, r) {
            for (var a, l = 0; a = t.urlRegexp.exec(e);) {
              n.push(e.substr(l, a.index + a[1].length - l));
              var s = a[2],
                c = s;
              t.simpleUrlRegexp.exec(s) || (c = "http://" + s), n.push(i.createElement("a", {
                href: c,
                key: l,
                target: "_blank"
              }, [s])), l = a.index + a[0].length;
            }
            l < e.length && n.push(e.substr(l, e.length)), r < o.length - 1 && n.push(i.createElement("br", {
              key: r
            }));
          }), n;
        }, e.parseMDText = function (e) {
          var t = this;
          void 0 === e && (e = "");
          var n = "(^|[^~])~([^~\\n]+)~([^~]|$)",
            r = "(\\[[^\\[\\]]+\\]) +(\\([^\\(\\)]+\\))",
            o = s,
            i = "^>(?:.+)\n(?=>)",
            a = ["(?:^(?!(?:-|\\*)|(?:\\d\\.))(?:.+?)\n)", "(?:\n(?!-|\\*|(?:\\d\\.)|\n))"].join("|");
          return e.replace(new RegExp(n + "|" + a + "|" + i + "|" + o + "|" + r, "gm"), function (e) {
            if (e.match(n)) return e.replace(/~/g, "~~");
            if (e.match(/^>(.+)\n$/)) return e + "\n \n\n";
            if (e.match(/^(.*)\n$/)) return e + "\n";
            if (e.match(r)) {
              var i = e.match(r);
              return "" + i[1] + (l = i[2]);
            }
            if (e.match(o)) {
              var a = " " === e.charAt(0);
              a && (e = e.substring(1));
              var l = e;
              return t.simpleUrlRegexp.exec(e) || (l = "http://" + e), (a ? " " : "") + "[" + e + "](" + l + ")";
            }
            return e;
          });
        }, e.formatTimeDurationInFull = function (e, t, n, r) {
          var o = e + "d:",
            i = t + ":",
            a = n + ":",
            l = String(r);
          return 0 === e && (o = ""), t < 10 && (i = "0" + i), 0 === t && (i = ""), n < 10 && (a = "0" + a), r < 10 && (l = "0" + l), o + i + a + l;
        }, e.formatTimeDurationInCompact = function (e, t, n, r) {
          return e > 0 ? e + "d" : t > 0 ? t + "h" : n > 0 ? n + "m" : r + "s";
        }, e.formatTimeDurationInShort = function (e, t, n, r) {
          return e > 0 ? e + "d" + (0 === t ? "" : " " + t + "h") : t > 0 ? t + "h" + (0 === n ? "" : " " + n + "min") : n > 0 ? n + ":" + (r < 10 ? "0" + r : "" + r) : r + "s";
        }, e.formatTimeDuration = function (t, n) {
          void 0 === n && (n = "full");
          var r = t < 0;
          r && (t = -t);
          var o,
            i = new Date(t),
            a = Math.floor(t / 864e5),
            l = i.getUTCHours(),
            s = i.getUTCMinutes(),
            c = i.getSeconds();
          return o = "compact" === n ? e.formatTimeDurationInCompact(a, l, s, c) : "short" === n ? e.formatTimeDurationInShort(a, l, s, c) : e.formatTimeDurationInFull(a, l, s, c), r ? "-" + o : o;
        }, e.areEqual = function (e, t) {
          if ("object" == typeof e && "object" == typeof t) {
            if (Object.keys(e).length < Object.keys(t).length) {
              var n = e;
              e = t, t = n;
            }
            return Object.keys(e).every(function (n) {
              return e[n] === t[n];
            });
          }
          return e === t;
        }, e.haveSameValues = function (e, t, n) {
          var i = this;
          void 0 === n && (n = {});
          var a = r(r({}, e), t);
          return Object.keys(a).every(function (r) {
            var a = e[r],
              l = t[r];
            if (n.equalUndefinedToEmptyArray && (void 0 === a && (a = []), void 0 === l && (l = [])), "object" != typeof a || "object" != typeof l) return a === l;
            if (!Array.isArray(a) || !Array.isArray(l)) return !Array.isArray(a) && !Array.isArray(l) && i.haveSameValues(a, l);
            var s = o(a, l).filter(function (e, t, n) {
              return t === n.indexOf(e);
            });
            return s.length === a.length && s.length === l.length;
          });
        }, e.simpleUrlRegexp = new RegExp("^https?://[^\\s]+", "i"), e.urlRegexp = RegExp(s, "gi"), e;
      }();
    t.Utils = c;
  }, function (e, t, n) {
    "use strict";

    var _r2,
      o = this && this.__extends || (_r2 = function r(e, t) {
        return (_r2 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r2(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Template = t.templates = t.initWithStrings = void 0;
    var l = n(0),
      s = n(2),
      c = /{{{\s*\S+\s*}}}/g;
    function u(e) {
      function t(t) {
        return "{{{{raw}}}}" !== (n = t[0]) && "{{{{/raw}}}}" !== n && !((r = t.index) > 0 && "\\" === e.charAt(r - 1));
        var n, r;
      }
      for (var n; null !== (n = c.exec(e));) if (t(n)) return !0;
      return !1;
    }
    var p = {};
    t.templates = p, t.initWithStrings = function (e) {
      Object.keys(e).forEach(function (t) {
        var n,
          r = e[t];
        if (u(r)) s.log.error("Unsafe template detected, use {{unsafeString [variableName]}} to render unescaped string. Template key: ", t, "Template:", r), n = function n() {
          return "UNSAFE template: " + t;
        };else {
          var o = Handlebars.compile(r);
          n = function n(e) {
            return o(e, {
              allowProtoMethodsByDefault: !0,
              allowProtoPropertiesByDefault: !0
            });
          };
        }
        p[t] = n;
      });
    };
    var d = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.escapeHtml = function (e) {
          if (void 0 === e) return "";
          var t = document.createElement("div");
          return t.appendChild(document.createTextNode(e)), t.innerHTML;
        }, t;
      }
      return o(t, e), t.prototype.render = function () {
        var e = this,
          t = this.props,
          n = t.source,
          r = t.code,
          o = a(t, ["source", "code"]),
          s = i(i({}, o), {
            forceUpdate: o.forceUpdate || function () {
              return e.forceUpdate();
            }
          }),
          c = n || !!r && p[r],
          u = c ? c(s) : this.escapeHtml(r);
        return "<" === u.substr(0, 1) ? l.createElement("div", {
          className: this.props.className,
          dangerouslySetInnerHTML: {
            __html: u
          }
        }) : l.createElement("span", {
          className: this.props.className,
          dangerouslySetInnerHTML: {
            __html: u
          }
        });
      }, t.defaultProps = {
        className: "Twilio"
      }, t;
    }(l.Component);
    t.Template = d;
  }, function (e, t) {
    e.exports = require("emotion");
  }, function (e, t, n) {
    "use strict";

    var _r3,
      o = this && this.__extends || (_r3 = function r(e, t) {
        return (_r3 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r3(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Notifications = t.NotificationManager = t.NotificationType = t.NotificationEvent = t.DefaultNotificationHandlerType = t.NotificationIds = void 0;
    var a = n(21),
      l = n(8),
      s = n(14),
      c = n(2),
      u = n(33);
    t.NotificationIds = u;
    var p,
      d = n(10);
    !function (e) {
      e.Browser = "browser", e.InApp = "inapp";
    }(t.DefaultNotificationHandlerType || (t.DefaultNotificationHandlerType = {})), function (e) {
      e.notificationAdded = "notificationAdded", e.notificationDismissed = "notificationDismissed", e.beforeAddNotification = "beforeAddNotification";
    }(p = t.NotificationEvent || (t.NotificationEvent = {})), function (e) {
      e.information = "information", e.success = "success", e.warning = "warning", e.error = "error";
    }(t.NotificationType || (t.NotificationType = {}));
    var f = function (e) {
      function t() {
        var t = e.call(this) || this;
        return t.registeredNotifications = new Map(), t.activeNotifications = [], t.handlers = {}, t.setMaxListeners(100), t;
      }
      return o(t, e), t.prototype.registerNotification = function (e) {
        if (e = i({}, e), this.registeredNotifications.get(e.id)) throw l.ErrorManager.createAndProcessError(s.ErrorMessages.NOTIFICATION_ALREADY_REGISTERED, {
          context: "NotificationManager"
        });
        void 0 === e.timeout && (e.timeout = t.defaultTimeout), void 0 === e.closeButton && (e.closeButton = !0), this.registeredNotifications.set(e.id, e);
      }, t.prototype.showNotificationSingle = function (e) {
        this.activeNotifications.filter(function (t) {
          return t.id === e;
        }).length || this.showNotification(e);
      }, t.prototype.showNotification = function (e, t) {
        if ("string" != typeof e) return c.log.error("Attempting to call showNotification with the id which is not a string"), null;
        var n = this.registeredNotifications.get(e);
        if (!n) return c.log.warn("Attempting to show a notification that has been deleted or hasn't been registered"), null;
        var r = d.Utils.merge({}, n);
        r.context = t;
        var o = this.listeners("beforeAddNotification");
        if (o.length > 0) {
          var i = !1,
            a = function a() {
              i = !0;
            };
          if (c.log.debug('Executing "beforeAddNotification" listeners with', r), o.forEach(function (e) {
            try {
              e(r, a);
            } catch (e) {
              c.log.error("Error from beforeAddNotification:", e);
            }
          }), i) return c.log.info("Notification " + e + " cancelled by beforeAddNotification event"), null;
        }
        return this.activeNotifications.push(r), this.emit(p.notificationAdded, r), r;
      }, t.prototype.dismissNotification = function (e) {
        var t = this.activeNotifications.indexOf(e);
        t > -1 && (this.activeNotifications.splice(t, 1), this.emit(p.notificationDismissed, e));
      }, t.prototype.dismissNotificationById = function (e) {
        var t = this;
        this.activeNotifications.filter(function (t) {
          return t.id === e;
        }).forEach(function (e) {
          t.dismissNotification(e);
        });
      }, t.prototype.dismissAll = function () {
        var e = this;
        this.activeNotifications.slice().forEach(function (t) {
          e.dismissNotification(t);
        });
      }, t.prototype.registerHandler = function (e) {
        var t = e.id;
        c.log.debug("registering notification handler " + t), this.handlers[t] && c.log.info("replacing notification handler " + t), this.handlers[t] = e;
      }, t.prototype.toggleNotificationHandler = function (e, t) {
        this.handlers[e] ? this.handlers[e].enabled = t : c.log.warn("handler with id " + e + " doesn't exist");
      }, t.prototype.isNotificationHandlerEnabled = function (e) {
        return this.handlers[e] && this.handlers[e].enabled;
      }, t.defaultTimeout = 8e3, t;
    }(a.EventEmitter);
    t.NotificationManager = f, t.Notifications = new f();
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ErrorMessages = void 0, function (e) {
      e.DYNAMIC_COMPONENT_NAME_MISSING = "name is missing", e.DYNAMIC_COMPONENT_GENERIC_MESSAGE = "An error has been detected inside DynamicComponent", e.DYNAMIC_COMPONENT_ELEMENTS_WITHOUT_KEY = "Elements without key in DynamicComponent", e.DYNAMIC_COMPONENT_MUTUALLY_EXCLUSIVE = "Mutually exclusive properties are set", e.DYNAMIC_CONTENT_STORE_CHILD_INVALID = "Child provided is not a valid React element", e.DYNAMIC_CONTENT_STORE_NO_KEY = "No key prop provided", e.ACTION_PENDING = "Action is pending", e.ACTION_DOESNT_EXIST = "Action does not exist", e.ACTION_BLOCKED = "Action is blocked", e.ACTION_ON_BEFORE = "Error on before event", e.ACTION_NOT_INVOKED = "Action with payload was not invoked", e.NOTIFICATION_ALREADY_REGISTERED = "Notification already registered", e.NOTIFICATION_INVALID_FILTER = "Invalid filter provided", e.NO_CHAT_CLIENT = "No chat client", e.CHAT_CHANNEL_LOAD_FAILED = "Failed to load chat channel", e.FILE_ATTACHMENT_READ_ONLY = "File attachment is read only", e.FILE_ATTACHMENT_SEND_MESSAGE_INVALID_TYPE = "Failed to send message. Invalid file type", e.FILE_ATTACHMENT_SEND_MESSAGE_INVALID_SIZE = "Failed to send message. Invalid file size", e.FILE_ATTACHMENT_DOWNLOAD_INVALID_TYPE = "Failed to download. Invalid file type", e.FILE_ATTACHMENT_DOWNLOAD_INVALID_SIZE = "Failed to download. Invalid file size", e.FILE_ATTACHMENT_ATTACH_INVALID_TYPE = "Failed to attach. Invalid file type", e.FILE_ATTACHMENT_ATTACH_INVALID_SIZE = "Failed to attach. Invalid file size", e.FILE_ATTACHMENT_GENERIC_ERROR = "Unable to send media", e.FILE_ATTACHMENT_DISABLED = "File attachment is disabled", e.FILE_ATTACHMENT_NOT_A_PARTICIPANT = "Failed to download. You are not a chat participant.", e.FILE_ATTACHMENT_UNABLE_TO_DOWNLOAD = "Unabled to download media", e.AUDIO_PLAYER_MEDIA_URL_MISSING = "A mediaUrl must be provided", e.MEDIA_QUEUE_SIZE = "Media cannot be enqueued: size limit reached", e.MEDIA_ALREADY_ENQUEUED = "Media cannot be enqueued: it has enqueued already", e.SEND_TYPING_FAILED = "Failed to send typing indicator", e.FAILED_TO_SEND_MESSAGE_TO_CHANNEL = "Failed to send message to channel";
    }(t.ErrorMessages || (t.ErrorMessages = {}));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FieldErrorMessage = t.FieldContainer = t.Description = t.Label = t.StyledButton = t.Form = void 0;
    var o,
      i,
      a,
      l,
      s,
      c,
      u = n(1),
      p = n(23);
    t.Form = u.styled("form")(o || (o = r(["\n    display: flex;\n    flex-flow: column;\n    font-size: 14px;\n    background: #fff;\n    width: 100%;\n    box-sizing: border-box;\n    flex-grow: 1;\n    flex-shrink: 0;\n"], ["\n    display: flex;\n    flex-flow: column;\n    font-size: 14px;\n    background: #fff;\n    width: 100%;\n    box-sizing: border-box;\n    flex-grow: 1;\n    flex-shrink: 0;\n"]))), t.StyledButton = u.styled(p.Button)(i || (i = r(["\n    align-self: flex-start;\n    border-radius: 0;\n    padding: 9px 16px;\n    height: auto;\n    text-transform: uppercase;\n    margin-top: 20px;\n"], ["\n    align-self: flex-start;\n    border-radius: 0;\n    padding: 9px 16px;\n    height: auto;\n    text-transform: uppercase;\n    margin-top: 20px;\n"]))), t.Label = u.styled("label")(a || (a = r(["\n    display: inline-block;\n    margin-bottom: 10px;\n    font-size: 12px;\n"], ["\n    display: inline-block;\n    margin-bottom: 10px;\n    font-size: 12px;\n"]))), t.Description = u.styled("div")(l || (l = r(["\n    font-size: 14px;\n"], ["\n    font-size: 14px;\n"]))), t.FieldContainer = u.styled("div")(s || (s = r(["\n    display: block;\n    clear: both;\n    margin-top: 20px;\n    width: 100%;\n"], ["\n    display: block;\n    clear: both;\n    margin-top: 20px;\n    width: 100%;\n"]))), t.FieldErrorMessage = u.styled("div")(c || (c = r(["\n    color: ", ";\n    font-size: 12px;\n    margin-top: 4px;\n"], ["\n    color: ", ";\n    font-size: 12px;\n    margin-top: 4px;\n"])), function (e) {
      return e.theme.colors.errorColor;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              s(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            try {
              s(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, l);
          }
          s((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: l(0),
          throw: l(1),
          return: l(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function l(i) {
          return function (l) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, l]);
          };
        }
      },
      a = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, l = i.length; a < l; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChannelHelper = t.ChannelListener = t.Actions = t.reduce = t.ACTION_MEDIA_MESSAGE_REJECTED = t.ACTION_REMOVE_PENDING_MEDIA_MESSAGE = t.ACTION_ADD_PENDING_MEDIA_MESSAGE = t.ACTION_LOAD_CHANNEL = t.ACTION_UPDATE_CHANNEL = t.ACTION_TYPING_ENDED = t.ACTION_TYPING_STARTED = t.ACTION_UPDATED_MESSAGE = t.ACTION_UPDATED_MEMBER = t.ACTION_REMOVED_MEMBER = t.ACTION_REMOVED_MESSAGE = t.ACTION_LOAD_CHANNEL_MESSAGES = t.ACTION_CONSUME_MESSAGE = t.ACTION_INIT_CHANNEL_MEMBERS = t.ACTION_UNLOAD_CHANNEL = t.ACTION_INIT_CHANNEL = t.ACTION_USER_UPDATED = t.ACTION_ADDED_MEMBER = t.ACTION_ADDED_MESSAGE = void 0;
    var l = n(31),
      s = n(5),
      c = n(19),
      u = n(8),
      p = n(14),
      d = n(2),
      f = n(33),
      h = n(13),
      m = n(25),
      g = n(10),
      v = n(34),
      y = n(48),
      b = {
        currentPaginator: void 0,
        inputText: "",
        selectionStart: 0,
        selectionEnd: 0,
        isLoadingMembers: !1,
        isLoadingMessages: !1,
        isLoadingChannel: !1,
        errorWhileLoadingChannel: !1,
        lastConsumedMessageIndex: 0,
        lastConsumedMessageByCurrentUserIndex: 0,
        listener: void 0,
        members: new Map(),
        unconsumedMessages: [],
        messages: [],
        pendingMessages: [],
        source: void 0,
        typers: []
      },
      _ = function _() {};
    t.ACTION_ADDED_MESSAGE = "CHANNEL_ADD_MESSAGE", t.ACTION_ADDED_MEMBER = "CHANNEL_ADD_MEMBER", t.ACTION_USER_UPDATED = "CHANNEL_USER_UPDATED", t.ACTION_INIT_CHANNEL = "CHANNEL_INIT", t.ACTION_UNLOAD_CHANNEL = "CHANNEL_UNLOAD", t.ACTION_INIT_CHANNEL_MEMBERS = "CHANNEL_INIT_MEMBERS", t.ACTION_CONSUME_MESSAGE = "ACTION_CONSUME_MESSAGE", t.ACTION_LOAD_CHANNEL_MESSAGES = "CHANNEL_LOAD_MESSAGES", t.ACTION_REMOVED_MESSAGE = "CHANNEL_REMOVE_MESSAGE", t.ACTION_REMOVED_MEMBER = "CHANNEL_REMOVE_MEMBER", t.ACTION_UPDATED_MEMBER = "CHANNEL_UPDATED_MEMBER", t.ACTION_UPDATED_MESSAGE = "CHANNEL_UPDATE_MESSAGE", t.ACTION_TYPING_STARTED = "CHANNEL_TYPING_STARTED", t.ACTION_TYPING_ENDED = "CHANNEL_TYPING_ENDED", t.ACTION_UPDATE_CHANNEL = "CHANNEL_UPDATE", t.ACTION_LOAD_CHANNEL = "CHANNEL_LOAD", t.ACTION_ADD_PENDING_MEDIA_MESSAGE = "ACTION_ADD_PENDING_MEDIA_MESSAGE", t.ACTION_REMOVE_PENDING_MEDIA_MESSAGE = "ACTION_REMOVE_PENDING_MEDIA_MESSAGE", t.ACTION_MEDIA_MESSAGE_REJECTED = "ACTION_MEDIA_MESSAGE_REJECTED", t.reduce = function (e, n) {
      switch (void 0 === e && (e = b), n.type) {
        case t.ACTION_INIT_CHANNEL:
          var o = n.payload;
          return r(r({}, b), {
            source: o.channel,
            listener: o.listener
          });
        case t.ACTION_UNLOAD_CHANNEL:
          return e.listener && e.listener.stop(), r({}, b);
        case t.ACTION_INIT_CHANNEL_MEMBERS + "_PENDING":
          return r(r({}, e), {
            isLoadingMembers: !0
          });
        case t.ACTION_INIT_CHANNEL_MEMBERS + "_FULFILLED":
          var i = n.payload;
          return r(r({}, e), {
            members: i,
            isLoadingMembers: !1
          });
        case t.ACTION_INIT_CHANNEL_MEMBERS + "_REJECTED":
          return r(r({}, e), {
            isLoadingMembers: !1
          });
        case t.ACTION_LOAD_CHANNEL_MESSAGES + "_PENDING":
          return r(r({}, e), {
            isLoadingMessages: !0
          });
        case t.ACTION_LOAD_CHANNEL_MESSAGES + "_REJECTED":
          return r(r({}, e), {
            isLoadingMessages: !1
          });
        case t.ACTION_LOAD_CHANNEL_MESSAGES + "_FULFILLED":
          if (!(F = n.meta.chatState) || !F.session.client) return e;
          var l = F.session.client.user.identity,
            s = n.payload,
            c = s.items.map(function (t) {
              return w({
                message: t,
                identity: l,
                channelState: e
              });
            }),
            u = e.messages.length && e.messages[0];
          if (u && s.items.length && u.index <= s.items[s.items.length - 1].index && u.index >= s.items[0].index) {
            var p = e.messages.filter(function (e) {
              return !c.find(function (t) {
                return t.index === e.index;
              });
            });
            c = c.concat(p);
          } else c = c.concat(e.messages);
          for (var d = 0; d < Math.min(s.items.length + 1, c.length); d++) c[d] = w({
            message: c[d].source,
            identity: l,
            nextMessage: d < c.length - 1 ? c[d + 1].source : void 0,
            previousMessage: d > 0 ? c[d - 1].source : void 0,
            channelState: e
          });
          var f = e.source ? e.source.lastConsumedMessageIndex : 0,
            h = c.filter(function (e) {
              return e.index > f;
            });
          return r(r({}, e), {
            isLoadingMessages: !1,
            currentPaginator: s,
            messages: c,
            lastConsumedMessageByCurrentUserIndex: f,
            unconsumedMessages: h
          });
        case t.ACTION_ADD_PENDING_MEDIA_MESSAGE:
          var m = n.payload.media,
            y = (F = n.meta.chatState) && F.session.client ? F.session.client.user.identity : "",
            _ = e.pendingMessages.length,
            O = _ > 0 ? e.pendingMessages[_ - 1] : e.messages[e.messages.length - 1],
            C = {
              index: _,
              groupWithNext: !1,
              groupWithPrevious: !!O && O.source.author === y,
              isFromMe: !0,
              isSending: !0,
              source: {
                index: _,
                media: m,
                author: y,
                type: "media",
                sid: null,
                body: null,
                timestamp: new Date(),
                channel: n.payload.channel
              }
            };
          return r(r({}, e), {
            pendingMessages: a(e.pendingMessages, [C])
          });
        case t.ACTION_REMOVE_PENDING_MEDIA_MESSAGE:
          var E = n.payload.media;
          return r(r({}, e), {
            pendingMessages: e.pendingMessages.filter(function (e) {
              return e.source.media.sid !== E.sid && e.source.media.filename !== E.filename && e.source.media.contentType !== E.contentType;
            })
          });
        case t.ACTION_MEDIA_MESSAGE_REJECTED:
          var M = n.payload.media;
          return r(r({}, e), {
            pendingMessages: e.pendingMessages.map(function (e) {
              return e.source.media.sid === M.sid ? r(r({}, e), {
                isSending: !1,
                error: !0
              }) : e;
            })
          });
        case t.ACTION_ADDED_MESSAGE:
          if (!(F = n.meta.chatState) || !F.session.client) return e;
          var P = n.payload;
          if (e.messages.find(function (e) {
            return e.index === P.index;
          })) return e;
          var j = F.session.client.user.identity,
            A = w({
              message: P,
              identity: j,
              channelState: e
            }),
            I = a(e.messages, [A]);
          for (d = Math.max(I.length - 2, 0); d < I.length; d++) I[d] = w({
            message: I[d].source,
            identity: j,
            nextMessage: d < I.length - 1 ? I[d + 1].source : void 0,
            previousMessage: d > 0 ? I[d - 1].source : void 0,
            channelState: e
          });
          var S = F.messageList,
            T = S.activeChatChannel,
            N = S.isScrollToBottom;
          h = void 0;
          h = A.isFromMe ? e.unconsumedMessages : T === (e.source || {}).sid && N ? [] : a(e.unconsumedMessages, [A]);
          var k = [];
          return e.pendingMessages.length && (k = e.pendingMessages.map(function (t, n) {
            var o = 0 === n ? A : e.pendingMessages[n - 1];
            return r(r({}, t), {
              groupWithPrevious: t.source.author === o.source.author
            });
          })), r(r({}, e), {
            messages: I,
            unconsumedMessages: h,
            pendingMessages: k
          });
        case t.ACTION_REMOVED_MESSAGE:
          if (!(F = n.meta.chatState) || !F.session.client) return e;
          var B = n.payload,
            z = e.messages.findIndex(function (e) {
              return e.index === B.index;
            });
          (I = e.messages.slice()).splice(z, 1);
          for (d = Math.max(0, z - 1); d <= Math.min(z, I.length - 1); d++) I[d] = w({
            message: I[d].source,
            identity: F.session.client.user.identity,
            nextMessage: d < I.length - 1 ? I[d + 1].source : void 0,
            previousMessage: d > 0 ? I[d - 1].source : void 0,
            channelState: e
          });
          return r(r({}, e), {
            messages: I
          });
        case t.ACTION_UPDATED_MESSAGE:
          if (!(F = n.meta.chatState) || !F.session.client) return e;
          var L = n.payload;
          z = e.messages.findIndex(function (e) {
            return e.index === L.index;
          });
          return (I = e.messages.slice())[z] = w({
            message: L,
            identity: F.session.client.user.identity,
            nextMessage: z < I.length - 1 ? I[z + 1].source : void 0,
            previousMessage: z > 0 ? I[z - 1].source : void 0,
            channelState: e
          }), r(r({}, e), {
            messages: I
          });
        case t.ACTION_ADDED_MEMBER:
          var D = n.payload;
          return (q = g.Utils.copyMap(e.members)).set(D.source.identity, D), r(r({}, e), {
            members: q
          });
        case t.ACTION_REMOVED_MEMBER:
          D = n.payload;
          return (q = g.Utils.copyMap(e.members)).delete(D.source.identity) ? r(r({}, e), {
            members: q
          }) : e;
        case t.ACTION_UPDATED_MEMBER:
          var F,
            H = n.payload,
            R = H.lastConsumedMessageIndex;
          if ((F = n.meta.chatState) && F.session.client && H.identity === F.session.client.user.identity) {
            h = [];
            return h = e.messages.find(function (e) {
              return e.index > R;
            }) ? e.unconsumedMessages : [], r(r({}, e), {
              lastConsumedMessageByCurrentUserIndex: R,
              unconsumedMessages: h
            });
          }
          return r(r({}, e), {
            lastConsumedMessageIndex: R
          });
        case t.ACTION_TYPING_STARTED:
          var V = n.payload;
          if (-1 === e.typers.findIndex(function (e) {
            return e.source.identity === V.source.identity;
          })) {
            var U = e.typers.slice();
            return U.push(V), r(r({}, e), {
              typers: U
            });
          }
          return e;
        case t.ACTION_TYPING_ENDED:
          var W = n.payload,
            G = e.typers.filter(function (e) {
              return e.source.identity !== W.source.identity;
            });
          return r(r({}, e), {
            typers: G
          });
        case t.ACTION_USER_UPDATED:
          var q,
            Y = n.payload;
          return Y && (D = e.members.get(Y.identity)) ? ((q = g.Utils.copyMap(e.members)).set(Y.identity, x(D.source, Y.friendlyName, Y.online)), r(r({}, e), {
            members: q
          })) : e;
        case t.ACTION_UPDATE_CHANNEL:
          return r(r({}, e), n.payload);
        case v.ACTION_UPDATE_CHANNEL_INPUT:
          return n.payload.attachedFile && e.inputText ? r(r({}, e), {
            inputText: "",
            selectionStart: 0,
            selectionEnd: 0
          }) : e;
        case t.ACTION_LOAD_CHANNEL + "_PENDING":
          return r(r({}, e), {
            isLoadingChannel: !0,
            errorWhileLoadingChannel: !1
          });
        case t.ACTION_LOAD_CHANNEL + "_FULFILLED":
          return r(r({}, e), {
            isLoadingChannel: !1,
            errorWhileLoadingChannel: !1
          });
        case t.ACTION_LOAD_CHANNEL + "_REJECTED":
          return r(r({}, e), {
            isLoadingChannel: !1,
            errorWhileLoadingChannel: !0
          });
        default:
          return e;
      }
    };
    var O = function () {
      function e() {}
      return Object.defineProperty(e, "dispatcher", {
        get: function get() {
          return this._dispatcher || s.ChatModule.dispatch;
        },
        set: function set(e) {
          this._dispatcher = e;
        },
        enumerable: !1,
        configurable: !0
      }), e.dispatchChannelAction = function (e, t, n, r) {
        this.dispatcher({
          type: t,
          payload: n,
          meta: {
            channelSid: e,
            chatState: r
          }
        });
      }, e.init = function (e) {
        var n = this,
          r = s.ChatModule.state.channels[e.sid];
        r && r.listener && r.listener.stop();
        var o = new C(e);
        this.dispatchChannelAction(e.sid, t.ACTION_INIT_CHANNEL, {
          channel: e,
          listener: o
        });
        var i = [],
          a = e.getMembers().then(function (e) {
            var t = new Map();
            return e.forEach(function (e) {
              e.getUser().then(function (e) {
                o.startListeningUser(e);
              }).catch(function () {});
            }), Promise.all(e.map(function (e) {
              return e.getUserDescriptor().then(function (n) {
                i.push(n), t.set(e.identity, x(e, n.friendlyName, n.online));
              }).catch(function () {
                var n = e.attributes;
                n && n.friendly_name && t.set(e.sid, x(e, n.friendly_name, !1));
              });
            })).then(function () {
              return t;
            });
          }).catch(function (t) {
            return Promise.reject(u.ErrorManager.createAndProcessError("Failed to load chat channel members", {
              type: c.CoreErrorType.chatSDK,
              description: "Failed to load members for chat channel " + e.sid,
              context: "ChannelState.init",
              wrappedError: t
            }));
          });
        a.then(function (t) {
          return n.dispatchChannelAction(e.sid, y.ACTION_CACHE_USERS, i), t;
        }), this.dispatchChannelAction(e.sid, t.ACTION_INIT_CHANNEL_MEMBERS, a);
        var l,
          p = e.getMessages(this.MESSAGE_LOAD_COUNT).catch(function (t) {
            return Promise.reject(u.ErrorManager.createAndProcessError("Failed to load chat channel messages", {
              type: c.CoreErrorType.chatSDK,
              description: "Failed to load messages for chat channel " + e.sid,
              context: "ChannelState.init",
              wrappedError: t
            }));
          });
        return this.dispatchChannelAction(e.sid, t.ACTION_LOAD_CHANNEL_MESSAGES, p, s.ChatModule.state), a.then(function (e) {
          l = e;
        }).then(function () {
          return p;
        }).then(function (e) {
          return n.loadUserDescriptorForMissingMembers(e, l);
        });
      }, e.unload = function (e) {
        this.dispatchChannelAction(e, t.ACTION_UNLOAD_CHANNEL, void 0);
      }, e.loadMessagesFromHistory = function (e) {
        var n = this;
        if (!e.source || !e.currentPaginator) return !1;
        if (!e.currentPaginator.hasPrevPage || e.isLoadingMessages) return !1;
        var r = e.currentPaginator.prevPage();
        return this.dispatchChannelAction(e.source.sid, t.ACTION_LOAD_CHANNEL_MESSAGES, r, s.ChatModule.state), r.then(function (t) {
          return n.loadUserDescriptorForMissingMembers(t, e.members);
        }).catch(function (t) {
          var n;
          return Promise.reject(u.ErrorManager.createAndProcessError("Failed to load chat channel messages", {
            type: c.CoreErrorType.chatSDK,
            description: "Failed to load previous messages for chat channel " + (null === (n = e.source) || void 0 === n ? void 0 : n.sid),
            context: "ChannelState.loadMessagesFromHistory",
            wrappedError: t
          }));
        });
      }, e.loadUserDescriptorForMissingMembers = function (e, t) {
        e.items.forEach(function (e) {
          t.has(e.author) || y.Actions.fetchUserDescriptor(e.author);
        });
      }, e.deprecatedSetInputText = function (e, n, r, o) {
        void 0 === r && (r = 0), void 0 === o && (o = 0), e.source && this.dispatchChannelAction(e.source.sid, t.ACTION_UPDATE_CHANNEL, {
          selectionStart: r,
          selectionEnd: o,
          inputText: n
        });
      }, e.updateLastConsumedMessageIndex = function (e, t) {
        e.source && E.isUserMemberOfChannel(e) && e.source.updateLastConsumedMessageIndex(t);
      }, e.removeAllListeners = function () {
        d.log.debug("Channel state removeAllListeners"), Object.keys(s.ChatModule.state.channels).forEach(function (e) {
          var t = s.ChatModule.state.channels[e];
          t.listener && t.listener.stop();
        });
      }, e.initWithChannelSid = function (e) {
        var n = this;
        if (e) {
          var r = s.ChatModule.state.channels[e];
          if (!r || !r.listener && !r.isLoadingChannel) {
            if (!s.ChatModule.state.session.client) return u.ErrorManager.createAndProcessError(p.ErrorMessages.NO_CHAT_CLIENT, {
              description: "No chat client found on the state when initialising ChannelState",
              context: "ChatModule"
            }), void this.dispatchChannelAction(e, t.ACTION_LOAD_CHANNEL + "_REJECTED", {});
            this.dispatchChannelAction(e, t.ACTION_LOAD_CHANNEL + "_PENDING", {}), s.ChatModule.state.session.client.getChannelBySid(e).then(function (r) {
              n.dispatchChannelAction(e, t.ACTION_LOAD_CHANNEL + "_FULFILLED", {}), n.init(r);
            }).catch(function (r) {
              u.ErrorManager.createAndProcessError(p.ErrorMessages.CHAT_CHANNEL_LOAD_FAILED, {
                context: "ChatModule",
                description: e,
                wrappedError: r
              }), n.dispatchChannelAction(e, t.ACTION_LOAD_CHANNEL + "_REJECTED", {});
            });
          }
        } else u.ErrorManager.createAndProcessError(p.ErrorMessages.CHAT_CHANNEL_LOAD_FAILED, {
          context: "ChatModule",
          description: "Missing sid"
        });
      }, e.addPendingMessage = function (e, n) {
        var r = this.getMediaFromFile(e);
        this.dispatchChannelAction(n.sid, t.ACTION_ADD_PENDING_MEDIA_MESSAGE, {
          media: r,
          channel: n
        }, s.ChatModule.state);
      }, e.removePendingMessage = function (e, n) {
        var r = this.getMediaFromFile(e);
        this.dispatchChannelAction(n.sid, t.ACTION_REMOVE_PENDING_MEDIA_MESSAGE, {
          media: r
        });
      }, e.rejectMediaMessage = function (e, n) {
        var r = this.getMediaFromFile(e);
        this.dispatchChannelAction(n.sid, t.ACTION_MEDIA_MESSAGE_REJECTED, {
          media: r
        });
      }, e.getMediaFromFile = function (e) {
        return {
          sid: e.name,
          filename: e.name,
          contentType: e.type,
          size: e.size
        };
      }, e.MESSAGE_LOAD_COUNT = 20, e;
    }();
    t.Actions = O;
    var C = function () {
      function e(e) {
        var n = this;
        this._listening = !1, this.handleMessageAdded = function (e) {
          n.dispatchMessageOrMemberAction(t.ACTION_ADDED_MESSAGE, e, s.ChatModule.state), n.showNewMessageNotification(e);
          var r = s.ChatModule.state.session.client,
            o = r && r.user.identity === e.author;
          e.media && !o && m.TelemetryBridge.emit(m.TelemetryBridgeMessageType.MEDIA_MESSAGE_RECEIVED, e);
        }, this.handleMessageUpdated = function (e) {
          n.dispatchMessageOrMemberAction(t.ACTION_UPDATED_MESSAGE, e.message, s.ChatModule.state);
        }, this.handleMessageRemoved = function (e) {
          n.dispatchMessageOrMemberAction(t.ACTION_REMOVED_MESSAGE, e, s.ChatModule.state);
        }, this.handleMemberJoined = function (e) {
          y.Actions.fetchUserDescriptor(e.identity), e.getUserDescriptor().then(function (r) {
            n.dispatchMessageOrMemberAction(t.ACTION_ADDED_MEMBER, x(e, r.friendlyName, r.online));
          }), e.getUser().then(function (e) {
            n.startListeningUser(e);
          });
        }, this.handleMemberLeft = function (e) {
          n.dispatchMessageOrMemberAction(t.ACTION_REMOVED_MEMBER, x(e, "", !1)), e.getUser().then(function (e) {
            n.stopListeningUser(e);
          });
        }, this.handleMemberUpdated = function (e) {
          n.dispatchMessageOrMemberAction(t.ACTION_UPDATED_MEMBER, e.member, s.ChatModule.state);
        }, this.handleTypingStarted = function (e) {
          e.getUserDescriptor().then(function (r) {
            n.dispatchMessageOrMemberAction(t.ACTION_TYPING_STARTED, x(e, r.friendlyName, r.online));
          });
        }, this.handleTypingEnded = function (e) {
          e.getUserDescriptor().then(function (r) {
            n.dispatchMessageOrMemberAction(t.ACTION_TYPING_ENDED, x(e, r.friendlyName, r.online));
          });
        }, this.handleUserUpdated = function (e) {
          n.dispatchMessageOrMemberAction(t.ACTION_USER_UPDATED, e.user);
        }, this.handleChannelUpdated = function (e) {
          O.dispatchChannelAction(e.channel.sid, t.ACTION_UPDATE_CHANNEL, {});
        }, this._users = new Map(), this._channel = e, this.start();
      }
      return e.prototype.start = function () {
        this._listening || (this._channel.addListener("messageAdded", this.handleMessageAdded), this._channel.addListener("messageRemoved", this.handleMessageRemoved), this._channel.addListener("messageUpdated", this.handleMessageUpdated), this._channel.addListener("memberJoined", this.handleMemberJoined), this._channel.addListener("memberLeft", this.handleMemberLeft), this._channel.addListener("typingStarted", this.handleTypingStarted), this._channel.addListener("typingEnded", this.handleTypingEnded), this._channel.addListener("memberUpdated", this.handleMemberUpdated), this._channel.on("updated", this.handleChannelUpdated), this._listening = !0);
      }, e.prototype.stop = function () {
        var e = this;
        this._listening && (this._channel.removeListener("messageAdded", this.handleMessageAdded), this._channel.removeListener("messageRemoved", this.handleMessageRemoved), this._channel.removeListener("messageUpdated", this.handleMessageUpdated), this._channel.removeListener("memberJoined", this.handleMemberJoined), this._channel.removeListener("memberLeft", this.handleMemberLeft), this._channel.removeListener("typingStarted", this.handleTypingStarted), this._channel.removeListener("typingEnded", this.handleTypingEnded), this._channel.removeListener("memberUpdated", this.handleMemberUpdated), this._channel.removeListener("updated", this.handleChannelUpdated), this._users.forEach(function (t) {
          e.stopListeningUser(t.user);
        }), this._listening = !1);
      }, e.prototype.startListeningUser = function (e) {
        var t = this;
        if (!this._users.has(e.identity)) {
          var n = new _();
          n.user = e, n.callback = function (e) {
            t.handleUserUpdated(e);
          }, e.addListener("updated", n.callback), this._users.set(e.identity, n);
        }
      }, e.prototype.stopListeningUser = function (e) {
        if (this._users.has(e.identity)) {
          var t = this._users.get(e.identity);
          t && t.user.removeListener("updated", t.callback);
        }
      }, e.prototype.dispatchMessageOrMemberAction = function (e, t, n) {
        O.dispatchChannelAction(this._channel.sid, e, t, n);
      }, e.prototype.showNewMessageNotification = function (e) {
        return o(this, void 0, void 0, function () {
          var t, n, r, o, a;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return s.ChatModule.state.session.client ? (t = s.ChatModule.state.session.client.user.identity, [4, e.channel.getMembers().catch(function (t) {
                  return Promise.reject(u.ErrorManager.createAndProcessError("Failed to load chat channel members", {
                    type: c.CoreErrorType.chatSDK,
                    description: "Failed to load members for chat channel " + e.channel.sid,
                    context: "ChannelState.showNewMessageNotification",
                    wrappedError: t
                  }));
                })]) : [2];
              case 1:
                return n = i.sent(), e.author !== t && n.find(function (e) {
                  return e.identity === t;
                }) ? (r = e.channel.sid, (o = s.ChatModule.state.channels[r]) ? (a = new l.ChatChannelHelper(o), h.Notifications.showNotification(f.NewChatMessage, {
                  lastMessage: a.lastMessage
                }), [2]) : [2]) : [2];
            }
          });
        });
      }, e.prototype.isListening = function () {
        return this._listening;
      }, e;
    }();
    function w(e) {
      var t = e.message,
        n = e.nextMessage,
        r = e.previousMessage,
        o = e.identity,
        i = e.channelState,
        a = t.author,
        l = !!n && t.author === n.author,
        s = !!r && t.author === r.author;
      if (i) {
        var c = i && i.members && i.members.get(t.author);
        a = c && c.friendlyName;
      }
      return {
        groupWithNext: l,
        groupWithPrevious: s,
        isFromMe: t.author === o,
        index: t.index,
        source: t,
        authorName: a
      };
    }
    function x(e, t, n) {
      return {
        friendlyName: t,
        source: e,
        online: n
      };
    }
    t.ChannelListener = C;
    var E = function () {
      function e() {}
      return e.isUserMemberOfChannel = function (e) {
        return e && e.source && "joined" === e.source.status;
      }, e;
    }();
    t.ChannelHelper = E;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getSupportedFileExtensionRegex = t.getFileIcon = t.canAttachFile = t.isFileAttachmentReadOnly = t.isFileAttachmentEnabled = t.isValidFileType = t.isValidFileSize = t.getAllowedFileExtensions = t.getMaxFileSizeInMB = t.getMaxFileSize = t.ALLOWED_FILE_EXTENSIONS = t.MAX_FILE_SIZE = t.FILE_TYPES = void 0;
    var r = n(57),
      o = n(31),
      i = n(5);
    t.FILE_TYPES = {
      jpg: {
        extension: /(\.jpg)$/i,
        type: /^(image)/i,
        iconName: "GenericImage"
      },
      jpeg: {
        extension: /(\.jpeg)$/i,
        type: /^(image)/i,
        iconName: "GenericImage"
      },
      png: {
        extension: /(\.png)$/i,
        type: /^(image)/i,
        iconName: "GenericImage"
      },
      gif: {
        extension: /(\.gif)$/i,
        type: /^(image)/i,
        iconName: "GenericImage"
      },
      pdf: {
        extension: /(\.pdf)$/i,
        type: /^(application\/pdf)$/,
        iconName: "Pdf"
      }
    }, t.MAX_FILE_SIZE = 10485760, t.ALLOWED_FILE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "txt", "pdf"];
    t.getMaxFileSize = function () {
      var e = r.ChatManager.config.fileAttachment;
      return e && e.maxFileSize ? e.maxFileSize : t.MAX_FILE_SIZE;
    };
    t.getMaxFileSizeInMB = function () {
      return t.getMaxFileSize() / 1024 / 1024 + "MB";
    };
    t.getAllowedFileExtensions = function () {
      var e = r.ChatManager.config.fileAttachment;
      return e && Array.isArray(e.acceptedExtensions) ? e.acceptedExtensions : t.ALLOWED_FILE_EXTENSIONS;
    };
    t.isValidFileSize = function (e) {
      return !!e && t.getMaxFileSize() >= e.size;
    };
    t.isValidFileType = function (e) {
      if (!e) return !1;
      var n = t.getAllowedFileExtensions(),
        r = Object.values(t.FILE_TYPES).find(function (t) {
          return e.name && e.name.match(t.extension) && e.type && e.type.match(t.type);
        });
      if (r) return Boolean(n.find(function (e) {
        return ("." + e).match(r.extension);
      }));
      var o = (/^(.+)\.(.+)?/.exec(e.name) || [])[2];
      return n.indexOf(o) > -1;
    };
    t.isFileAttachmentEnabled = function (e) {
      var t = i.ChatModule.state.channels[e];
      return "web" === new o.ChatChannelHelper(t).channelType && Boolean(r.ChatManager.config.fileAttachment) && r.ChatManager.config.fileAttachment.enabled;
    };
    t.isFileAttachmentReadOnly = function () {
      return !!r.ChatManager.config.fileAttachment && Boolean(r.ChatManager.config.fileAttachment.readOnly);
    };
    t.canAttachFile = function (e, n) {
      return !(e.attachedFiles || [])[0] && !!n.messages.length && !t.isFileAttachmentReadOnly();
    };
    t.getFileIcon = function (e) {
      var n = Object.values(t.FILE_TYPES).find(function (t) {
        return e.name && e.name.match(t.extension) && e.type && e.type.match(t.type);
      });
      return n ? n.iconName : "GenericDoc";
    };
    t.getSupportedFileExtensionRegex = function (e) {
      var n = e || "",
        r = Object.values(t.FILE_TYPES).find(function (e) {
          return n.match(e.extension);
        });
      return r ? r.extension : void 0;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IconButtonProps = t.IconButton = void 0;
    var r = n(307);
    Object.defineProperty(t, "IconButton", {
      enumerable: !0,
      get: function get() {
        return r.IconButton;
      }
    }), Object.defineProperty(t, "IconButtonProps", {
      enumerable: !0,
      get: function get() {
        return r.IconButtonProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r4,
      o,
      i,
      a = this && this.__extends || (_r4 = function r(e, t) {
        return (_r4 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r4(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.isCoreError = t.CoreError = t.CoreErrorSeverity = t.CoreErrorType = void 0, function (e) {
      e.app = "app", e.chatSDK = "chatSDK";
    }(o = t.CoreErrorType || (t.CoreErrorType = {})), function (e) {
      e.user = "user", e.normal = "normal", e.severe = "severe";
    }(i = t.CoreErrorSeverity || (t.CoreErrorSeverity = {}));
    var l = function (e) {
      function t(n, r) {
        void 0 === r && (r = {});
        var a = e.call(this, n) || this;
        return a.content = r, a.content.type || (a.content.type = o.app), a.content.severity || (a.content.severity = i.normal), a.time = new Date(), Object.setPrototypeOf(a, t.prototype), a;
      }
      return a(t, e), Object.defineProperty(t.prototype, "type", {
        get: function get() {
          return this.content.type;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "logLine", {
        get: function get() {
          var e = this.content,
            t = e.description,
            n = e.context,
            r = e.wrappedError,
            o = t || this.message,
            i = "";
          return r && (r.message ? i = '\n\nOriginal error:\n"' + r.message + '"' : "string" == typeof r && (i = '\n\nOriginal error:\n"' + r + '"')), this.time.toLocaleString() + " - " + (n || "") + ": " + o + i;
        },
        enumerable: !1,
        configurable: !0
      }), t;
    }(Error);
    t.CoreError = l;
    t.isCoreError = function (e) {
      return e instanceof l;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessagingCanvasContextType = t.MessagingCanvasContext = t.MessagingCanvas = void 0;
    var i = n(300);
    Object.defineProperty(t, "MessagingCanvas", {
      enumerable: !0,
      get: function get() {
        return i.MessagingCanvas;
      }
    }), o(n(70), t), o(n(342), t);
    var a = n(71);
    Object.defineProperty(t, "MessagingCanvasContext", {
      enumerable: !0,
      get: function get() {
        return a.MessagingCanvasContext;
      }
    }), Object.defineProperty(t, "MessagingCanvasContextType", {
      enumerable: !0,
      get: function get() {
        return a.MessagingCanvasContextType;
      }
    });
  }, function (e, t) {
    e.exports = require("events");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              s(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            try {
              s(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, l);
          }
          s((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: l(0),
          throw: l(1),
          return: l(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function l(i) {
          return function (l) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, l]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Actions = t.ActionsImpl = void 0;
    var i = n(21),
      a = n(19),
      l = n(8),
      s = n(14),
      c = n(2),
      u = function () {
        function e() {
          this.actions = new Map(), this.replacedActions = new Map(), this.payloadUpdateFunctions = new Map(), this.pendingInvocations = new Map(), this.blockedActions = new Map(), this.emitter = new i.EventEmitter(), this.emitter.setMaxListeners(0);
        }
        return e.prototype.registerAction = function (e, t, n) {
          c.log.info("registerAction", e), this.actions.set(e, t), this.payloadUpdateFunctions.set(e, n);
        }, e.prototype.invokeAction = function (e, t) {
          return r(this, void 0, Promise, function () {
            var n, r, i, u, p, d, f, h, m, g, v;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  if (c.log.debug('Action "' + e + '" invoked with', t), !(n = this.actions.get(e))) throw l.ErrorManager.createAndProcessError(s.ErrorMessages.ACTION_DOESNT_EXIST, {
                    description: "Action " + e + " does not exist!",
                    context: "Actions"
                  });
                  if (this.findPendingActions(e, t).first) throw l.ErrorManager.createAndProcessError(s.ErrorMessages.ACTION_PENDING, {
                    description: "Action " + e + " is pending",
                    context: "Actions"
                  });
                  if (this.findBlockedActions(e, t).first) throw l.ErrorManager.createAndProcessError(s.ErrorMessages.ACTION_BLOCKED, {
                    description: "Action " + e + " has been blocked",
                    context: "Actions"
                  });
                  if ((r = this.payloadUpdateFunctions.get(e)) && (t = r(t), c.log.debug("Action: updated payload for " + e, t)), i = !1, u = function u() {
                    i = !0;
                  }, this.registerInvocation(e, t), p = "before" + e, !this.emitter.listeners(p).length) return [3, 4];
                  c.log.debug('Executing "' + p + '" listeners with', t), o.label = 1;
                case 1:
                  return o.trys.push([1, 3,, 4]), [4, this.customEmit(p, t, u)];
                case 2:
                  return o.sent(), [3, 4];
                case 3:
                  return d = o.sent(), l.ErrorManager.createAndProcessError(s.ErrorMessages.ACTION_ON_BEFORE, {
                    description: 'Error on "' + p + '":',
                    context: "Actions",
                    wrappedError: d
                  }), [3, 4];
                case 4:
                  if (i) throw this.unregisterInvocation(e, t), c.log.info("Action " + e + " cancelled by before event"), new Error("Action " + e + " cancelled by before event");
                  f = this.replacedActions.get(e), h = null, o.label = 5;
                case 5:
                  return o.trys.push([5, 10,, 11]), f ? (c.log.debug("Running replaced action " + e + " with", t), [4, f(t, n)]) : [3, 7];
                case 6:
                  return h = o.sent(), [3, 9];
                case 7:
                  return c.log.debug('Executing action function "' + e + '" with', t), [4, n(t)];
                case 8:
                  h = o.sent(), o.label = 9;
                case 9:
                  return [3, 11];
                case 10:
                  if (m = o.sent(), this.unregisterInvocation(e, t), a.isCoreError(m)) throw m;
                  throw g = "string" == typeof m ? m : m.message, l.ErrorManager.createAndProcessError(g, {
                    description: "Error in action " + e + " body: " + g,
                    context: "Actions",
                    wrappedError: m
                  });
                case 11:
                  c.log.debug('Executing "after' + e + '" listeners with', t), o.label = 12;
                case 12:
                  return o.trys.push([12, 14,, 15]), [4, this.customEmit("after" + e, t)];
                case 13:
                  return o.sent(), [3, 15];
                case 14:
                  return v = o.sent(), c.log.error("Error on after" + e + ":", v), [3, 15];
                case 15:
                  return this.unregisterInvocation(e, t), [2, h];
              }
            });
          });
        }, e.prototype.catchErrorIfIsPromise = function (e, t) {
          return t && t.catch ? t.catch(function (t) {
            c.log.error("Error on " + e + ":", t);
          }) : t;
        }, e.prototype.customEmit = function (e) {
          for (var t = this, n = [], r = 1; r < arguments.length; r++) n[r - 1] = arguments[r];
          var o = this.emitter.listeners(e);
          return Promise.all(o.map(function (r) {
            return t.catchErrorIfIsPromise(e, r.apply(void 0, n));
          }));
        }, e.prototype.replaceAction = function (e, t) {
          c.log.debug("Replacing action", e, "with", t), this.replacedActions.set(e, t);
        }, e.prototype.addListener = function (e, t) {
          return c.log.debug('Adding Actions listener for event "' + String(e) + '"', t), this.emitter.addListener(e, t);
        }, e.prototype.on = function (e, t) {
          return c.log.warn("Please use `addListener` instead"), this.addListener(e, t);
        }, e.prototype.removeListener = function (e, t) {
          return c.log.debug("Removing Actions listener ", t, ' for event "' + String(e) + '" '), this.emitter.removeListener(e, t);
        }, e.prototype.removeAllListeners = function (e) {
          return c.log.debug('Removing all Actions listeners for event "' + String(e) + '"'), this.emitter.removeAllListeners(e);
        }, e.prototype.emit = function () {
          for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
          return c.log.error("Invalid method. Please use Actions.invokeAction instead."), !1;
        }, e.prototype.registerInvocation = function (e, t) {
          c.log.debug("registerInvocation", e, t);
          var n = this.pendingInvocations.get(e) || [];
          this.pendingInvocations.has(e) || this.pendingInvocations.set(e, n), n.push({
            action: e,
            payload: t
          }), this.customEmit("invocationBegin");
        }, e.prototype.unregisterInvocation = function (e, t) {
          c.log.debug("unregisterInvocation", e, t);
          var n = this.pendingInvocations.get(e) || [],
            r = n.findIndex(function (n) {
              return n.action === e && n.payload === t;
            });
          if (r < 0) throw l.ErrorManager.createAndProcessError(s.ErrorMessages.ACTION_NOT_INVOKED, {
            context: "Actions"
          });
          n.splice(r, 1), this.customEmit("invocationEnd");
        }, e.prototype.findPendingActions = function (e, t) {
          var n = this,
            r = (Array.isArray(e) ? e : [e]).map(function (e) {
              return (n.pendingInvocations.get(e) || []).find(function (n) {
                return p(t, e)(n.payload);
              });
            }),
            o = {};
          return r.forEach(function (e) {
            void 0 !== e && (o[e.action] = e.payload, o.first || (o.first = e));
          }), o;
        }, e.prototype.findBlockedActions = function (e, t) {
          var n = this,
            r = (Array.isArray(e) ? e : [e]).map(function (e) {
              return (n.blockedActions.get(e) || []).find(function (n) {
                return p(t, e)(n.payload);
              });
            }),
            o = {};
          return r.forEach(function (e) {
            void 0 !== e && (o[e.action] = e.payload, o.first || (o.first = e));
          }), o;
        }, e.prototype.blockAction = function (e, t) {
          this.setActionBlocked(!0, e, t);
        }, e.prototype.unblockAction = function (e, t) {
          this.setActionBlocked(!1, e, t);
        }, e.prototype.setActionBlocked = function (e, t, n) {
          c.log.debug("Set action " + t + " blocked=" + e, n);
          var r = this.blockedActions.get(t) || [];
          this.blockedActions.has(t) || this.blockedActions.set(t, r);
          var o = !1;
          if (e) r.push({
            action: t,
            payload: n
          }), o = !0;else {
            var i = r.filter(function (e) {
              return !p(n, t)(e.payload);
            });
            (o = i.length !== r.length) && this.blockedActions.set(t, i);
          }
          o && this.customEmit("actionBlockedChanged", e, t, n);
        }, e;
      }();
    t.ActionsImpl = u, t.Actions = new u();
    var p = function p(e, t) {
      return function (n) {
        return void 0 === e || e === n || "function" == typeof e && !!e(n, t) || "object" == typeof e && "object" == typeof n && Object.keys(e).every(function (t) {
          return n[t] === e[t];
        });
      };
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ButtonThemeProps = t.LinkProps = t.Link = t.StyledButtonProps = t.StyledButton = t.ButtonProps = t.Button = void 0;
    var r = n(297);
    Object.defineProperty(t, "Button", {
      enumerable: !0,
      get: function get() {
        return r.Button;
      }
    }), Object.defineProperty(t, "ButtonProps", {
      enumerable: !0,
      get: function get() {
        return r.ButtonProps;
      }
    });
    var o = n(39);
    Object.defineProperty(t, "StyledButton", {
      enumerable: !0,
      get: function get() {
        return o.StyledButton;
      }
    }), Object.defineProperty(t, "StyledButtonProps", {
      enumerable: !0,
      get: function get() {
        return o.StyledButtonProps;
      }
    });
    var i = n(298);
    Object.defineProperty(t, "Link", {
      enumerable: !0,
      get: function get() {
        return i.Link;
      }
    }), Object.defineProperty(t, "LinkProps", {
      enumerable: !0,
      get: function get() {
        return i.LinkProps;
      }
    });
    var a = n(299);
    Object.defineProperty(t, "ButtonThemeProps", {
      enumerable: !0,
      get: function get() {
        return a.ButtonThemeProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createTheme = void 0;
    var o = n(82);
    t.createTheme = function (e, t) {
      var n = o.createMuiTheme(e, t),
        i = t ? e.darkTextColor : e.lightTextColor;
      return r(r({}, n), {
        colors: e,
        calculated: {
          lightTheme: t,
          textColor: i
        },
        FormComponents: {
          TextArea: {
            color: i
          },
          Input: {
            color: i
          },
          Select: {
            color: i
          }
        },
        Button: {
          lightHover: !t
        },
        Dialpad: {
          Button: {
            Container: {
              backgroundColor: "rgba(0, 0, 0, 0)",
              lightHover: !t,
              color: i,
              disabled: {
                color: e.disabledColor,
                cursor: "not-allowed"
              }
            },
            Caption: {
              color: "inherit"
            },
            Description: {
              color: "inherit"
            }
          }
        },
        Dialer: {
          CallButton: {
            backgroundColor: e.defaultButtonColor,
            color: e.lightTextColor,
            lightHover: !1,
            disabled: {
              cursor: "not-allowed"
            }
          }
        },
        Avatar: {
          Container: {
            borderColor: e.base5,
            background: e.base1
          },
          AvailabilityIcon: {
            borderColor: e.base5
          }
        },
        Menu: {
          Item: {
            lightHover: !t
          },
          Items: {
            color: i,
            background: e.base2
          }
        },
        Tabs: {
          Container: {
            color: e.base11
          },
          LabelsContainer: {
            borderColor: e.base4
          },
          Button: {
            lightHover: !t
          },
          Active: {
            background: e.tabSelectedColor
          },
          Inactive: {}
        },
        Chat: {
          MessagingCanvas: {
            Container: {
              background: e.base1
            }
          },
          MessageList: {
            DateSeparatorLine: {
              borderColor: e.base4
            },
            DateSeparatorText: {
              color: i
            },
            TypingIndicator: {
              color: i
            }
          },
          MessageInput: {
            Container: {
              background: e.base2,
              color: i,
              "::placeholder": {
                color: i
              }
            },
            Button: {
              color: "#ffffff",
              background: "#1976D2"
            },
            AttachFileButton: {
              background: e.base1,
              lightHover: !t
            },
            FileBox: {
              background: e.base1
            },
            RemoveFileButton: {
              lightHover: !t
            }
          },
          MessageListItem: {
            FromMe: {
              Avatar: {
                color: "#ffffff",
                background: "#1976D2"
              },
              Bubble: {
                color: "#ffffff",
                background: "#1976D2"
              },
              Header: {
                color: "#ffffff"
              },
              Media: {
                Container: {
                  background: e.base2,
                  color: i,
                  lightHover: !t
                },
                Actions: {
                  color: i
                }
              }
            },
            FromOthers: {
              Avatar: {
                color: e.base11,
                background: e.base2
              },
              Bubble: {
                color: i,
                background: e.base2
              },
              Header: {
                color: i
              },
              Media: {
                Container: {
                  background: e.base2,
                  color: i,
                  lightHover: !0
                },
                Actions: {
                  color: i
                }
              }
            },
            ReadStatus: {
              color: i
            },
            ErrorStatus: {
              color: e.errorColor
            }
          },
          MessageCanvasTray: {
            Container: {
              background: e.base2,
              color: i
            },
            Button: {
              color: e.lightTextColor,
              background: e.defaultButtonColor,
              lightHover: !1
            }
          },
          WelcomeMessage: {
            Container: {
              color: i
            },
            Icon: {
              color: e.base11
            }
          },
          FileAttachmentDropArea: {
            MainDropArea: {
              background: t ? "rgba(255, 255, 255, 0.9)" : "rgba(0, 0, 0, 0.9)",
              borderColor: e.defaultButtonColor
            },
            Icon: {
              color: e.defaultButtonColor
            },
            Title: {},
            SubTitle: {}
          }
        },
        UserCard: {
          AvatarContainer: {
            background: e.base1,
            color: e.base11,
            borderColor: e.base5
          },
          AvailabilityContainer: {
            borderColor: e.base5
          }
        },
        Progress: {
          Circular: {
            staticBackgroundBorderColor: e.lightTextColor,
            animatingBackgroundBorderColor: e.base4,
            animatingForegroundBorderColor: e.defaultButtonColor
          }
        },
        SidePanel: {
          Container: {
            borderColor: e.base4,
            color: i
          },
          Header: {
            borderColor: e.base4,
            color: i
          },
          HeaderButton: {}
        },
        FilterList: {
          ApplyButton: {
            backgroundImage: "linear-gradient(to top, " + e.defaultButtonColor + ", " + e.defaultButtonColor + ")"
          },
          ResetButton: {
            borderColor: e.base6,
            color: i
          },
          ItemContainer: {
            borderColor: e.base4
          },
          ItemContainerExpanded: {
            background: e.base1
          }
        },
        Badge: {
          OuterCircle: {
            background: "inherit"
          },
          InnerCircle: {
            color: "#fff",
            background: "#ea1010"
          }
        },
        CountrySelector: {
          CountryList: {
            backgroundColor: e.base1,
            borderColor: e.base4
          },
          CountryItem: {
            lightHover: !t,
            Selected: {
              backgroundColor: e.base3
            }
          },
          Flag: {
            borderColor: e.base4
          }
        },
        DataTable: {
          Header: {
            root: {},
            clickable: {
              "&:hover": {
                cursor: "pointer",
                textDecoration: "underline"
              }
            },
            withSubHeader: {}
          },
          SubHeader: {
            root: {},
            clickable: {
              "&:hover": {
                cursor: "pointer",
                textDecoration: "underline"
              }
            }
          }
        }
      });
    };
    var i = {
      colors: {
        base1: "#000000",
        base2: "#000000",
        base3: "#000000",
        base4: "#000000",
        base5: "#000000",
        base6: "#000000",
        base7: "#000000",
        base8: "#000000",
        base9: "#000000",
        base10: "#000000",
        base11: "#000000",
        errorColor: "#CB3232",
        errorGlow: "rgba(234, 16, 16, 0.2)",
        buttonHoverColor: "rgba(0, 0, 0, 0.2)",
        tabSelectedColor: "#009cff",
        connectingColor: "#ff9800",
        disconnectedColor: "#c0192d",
        notificationBackgroundColorInformation: "#ffffff",
        notificationBackgroundColorSuccess: "#d0f4d1",
        notificationBackgroundColorWarning: "#ffe3b9",
        notificationBackgroundColorError: "#feced3",
        notificationIconColorError: "#d32f2f",
        notificationIconColorWarning: "#ea6c00",
        userAvailableColor: "#31aa71",
        userUnavailableColor: "#999999",
        defaultButtonColor: "#1976d2",
        lightTextColor: "#ffffff",
        darkTextColor: "#222222",
        disabledColor: "#d9dce4",
        focusColor: "#197bdd",
        focusGlow: "rgba(25, 123, 221, 0.2)"
      }
    };
    t.default = i;
  }, function (e, t, n) {
    "use strict";

    var _r5,
      o = this && this.__extends || (_r5 = function r(e, t) {
        return (_r5 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r5(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TelemetryBridge = t.TelemetryBridgeMessageType = void 0;
    var i = n(21);
    !function (e) {
      e.MEDIA_MESSAGE_SENT = "MEDIA_MESSAGE_SENT", e.MEDIA_MESSAGE_RECEIVED = "MEDIA_MESSAGE_RECEIVED", e.DYNAMIC_COMPONENT_PROGRAMMABILITY = "DYNAMIC_COMPONENT_PROGRAMMABILITY";
    }(t.TelemetryBridgeMessageType || (t.TelemetryBridgeMessageType = {}));
    var a = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.emit = function (t, n) {
        return e.prototype.emit.call(this, t, n);
      }, t;
    }(i.EventEmitter);
    t.TelemetryBridge = new a();
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.current = t.ClientListener = t.Actions = t.reduce = t.ACTION_CHAT_SESSION_UNINIT = t.ACTION_APP_ACTIVE = t.ACTION_CLIENT_CONNECTION = t.ACTION_INIT_SESSION = void 0;
    var o = n(16),
      i = n(5),
      a = n(2),
      l = {
        connectionState: "",
        client: void 0,
        listener: void 0,
        isActive: !0
      };
    t.ACTION_INIT_SESSION = "CHAT_SESSION_INIT", t.ACTION_CLIENT_CONNECTION = "CHAT_SESSION_CLIENT_CONNECTION", t.ACTION_APP_ACTIVE = "CHAT_SESSION_APP_ACTIVE", t.ACTION_CHAT_SESSION_UNINIT = "CHAT_SESSION_UNINIT", t.reduce = function (e, n) {
      switch (void 0 === e && (e = l), n.type) {
        case t.ACTION_INIT_SESSION:
          var o = n.payload;
          e.listener && e.listener.stop();
          var i = new c(o);
          return r(r({}, l), {
            listener: i,
            client: o,
            connectionState: o.connectionState
          });
        case t.ACTION_CLIENT_CONNECTION:
          var a = n.payload;
          return r(r({}, e), {
            connectionState: a
          });
        case t.ACTION_APP_ACTIVE:
          return r(r({}, e), {
            isActive: n.payload
          });
        case t.ACTION_CHAT_SESSION_UNINIT:
          return l;
        default:
          return e;
      }
    };
    var s = function () {
      function e() {}
      return Object.defineProperty(e, "dispatcher", {
        get: function get() {
          return this._dispatcher || i.ChatModule.dispatch;
        },
        set: function set(e) {
          this._dispatcher = e;
        },
        enumerable: !1,
        configurable: !0
      }), e.init = function (e) {
        this.dispatcher({
          type: t.ACTION_INIT_SESSION,
          payload: e
        });
      }, e.dispatchConnectionState = function (e) {
        this.dispatcher({
          type: t.ACTION_CLIENT_CONNECTION,
          payload: e
        });
      }, e.setActive = function (e) {
        this.dispatcher({
          type: t.ACTION_APP_ACTIVE,
          payload: e
        });
      }, e.shutdown = function () {
        a.log.debug("ChatSession state logout"), o.Actions.removeAllListeners();
        var e = i.ChatModule.state.session.listener;
        e && e.stop();
        var n = i.ChatModule.state.session.client;
        n && (n.removeAllListeners(), n.shutdown().catch(function () {
          a.log.warn("Failed to shutdown Chat Client gracefully");
        })), this.dispatcher({
          type: t.ACTION_CHAT_SESSION_UNINIT
        });
      }, e;
    }();
    t.Actions = s;
    var c = function () {
      function e(e) {
        this._listening = !1, this.handleConnectionStateChanged = function (e) {
          s.dispatchConnectionState(e);
        }, this._client = e, this.start();
      }
      return e.prototype.start = function () {
        this._listening || (this._client.addListener("connectionStateChanged", this.handleConnectionStateChanged), this._listening = !0);
      }, e.prototype.stop = function () {
        this._listening && (this._client.removeListener("connectionStateChanged", this.handleConnectionStateChanged), this._listening = !1);
      }, e.prototype.isListening = function () {
        return this._listening;
      }, e;
    }();
    t.ClientListener = c, t.current = function () {
      return i.ChatModule.state.session;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IcnEmpty = t.IcnEmailBold = t.IcnEmail = t.IcnEdit = t.IcnDirectoryBold = t.IcnDirectory = t.IcnDialpadLarge = t.IcnDialpad = t.IcnDefaultAvatarBold = t.IcnDefaultAvatar = t.IcnDataBold = t.IcnData = t.IcnDashboardsBold = t.IcnDashboards = t.IcnDashboardBold = t.IcnDashboard = t.IcnConnectionError = t.IcnCogs = t.IcnCloseLarge = t.IcnClose = t.IcnClock = t.IcnChannel = t.IcnCallSmall = t.IcnCallBold = t.IcnCall = t.IcnBulbBold = t.IcnBulb = t.IcnBellBold = t.IcnBell = t.IcnBackArrow = t.IcnAttachment = t.IcnArrowUp = t.IcnArrowRight = t.IcnArrowLeft = t.IcnArrowDown = t.IcnAnalyzeBold = t.IcnAnalyze = t.IcnAlertTriangle = t.IcnAlert = t.IcnAgentsViewBold = t.IcnAgentsView = t.IcnAgentsBold = t.IcnAgents = t.IcnAgentNotifyBold = t.IcnAgentNotify = t.IcnAgentBold = t.IcnAgent = t.IcnAdd = t.IcnAcceptLarge = t.IcnAccept = void 0, t.IcnMessage = t.IcnLogoutBold = t.IcnLogout = t.IcnLoading = t.IcnLineBold = t.IcnLine = t.IcnLeaveCallLarge = t.IcnLeaveCall = t.IcnInspectionsBold = t.IcnInspections = t.IcnInfoBold = t.IcnInfo = t.IcnIncomingTransferBold = t.IcnIncomingTransfer = t.IcnIncomingCallBold = t.IcnIncomingCall = t.IcnHoldOffLarge = t.IcnHoldOff = t.IcnHoldLargeBold = t.IcnHoldLarge = t.IcnHoldBoldSmall = t.IcnHoldBold = t.IcnHold = t.IcnHelpBold = t.IcnHelp = t.IcnHangupLarge = t.IcnHangupBold = t.IcnHangup = t.IcnHamburgerNotify = t.IcnHamburger = t.IcnGroupCallBold = t.IcnGroupCall = t.IcnGreyIndicator = t.IcnGreenIndicator = t.IcnGenericTaskBold = t.IcnGenericTask = t.IcnGenericImage = t.IcnGenericDoc = t.IcnFullscreen = t.IcnFolder = t.IcnFlexBanner = t.IcnFilterUp = t.IcnFilterTrigger = t.IcnFilter = t.IcnFacebookBold = t.IcnFacebook = t.IcnEyeBold = t.IcnEye = t.IcnError = t.IcnEmptyContent = void 0, t.IcnThumbdownBold = t.IcnThumbdown = t.IcnTasksSmall = t.IcnTasksLarge = t.IcnSupportabilityBold = t.IcnSupportability = t.IcnSupervisorBold = t.IcnSupervisor = t.IcnSuggested = t.IcnSpeechSearchesBold = t.IcnSpeechSearches = t.IcnSmsBold = t.IcnSmsAlt = t.IcnSms = t.IcnSideMenuOn = t.IcnSideMenuOff = t.IcnSettingsBold = t.IcnSettings = t.IcnSendLarge = t.IcnSearch = t.IcnResize = t.IcnRead = t.IcnQueuesBold = t.IcnQueues = t.IcnQueue = t.IcnQuestionnairesBold = t.IcnQuestionnaires = t.IcnPlay = t.IcnPdf = t.IcnPause = t.IcnParticipant = t.IcnOutboundCallBold = t.IcnOutboundCall = t.IcnOpenInNewWindow = t.IcnOpen = t.IcnNoData = t.IcnNoChat = t.IcnNoCRM = t.IcnMuteLargeBold = t.IcnMuteLarge = t.IcnMuteBold = t.IcnMute = t.IcnMore = t.IcnMonitorSmall = t.IcnMonitorOffLarge = t.IcnMonitorBoldLarge = t.IcnMinus = t.IcnMinimize = t.IcnMessaging = t.IcnMessageBold = void 0, t.IcnWhatsappBold = t.IcnWhatsapp = t.IcnVolumeBold = t.IcnVolume = t.IcnVoiceSmall = t.IcnVoiceBold = t.IcnVoice = t.IcnVideoBold = t.IcnVideo = t.IcnTwilio = t.IcnTransferLarge = t.IcnTransferBold = t.IcnTransfer = t.IcnThumbupBold = t.IcnThumbup = void 0;
    var r = n(116);
    Object.defineProperty(t, "IcnAccept", {
      enumerable: !0,
      get: function get() {
        return r.default;
      }
    });
    var o = n(117);
    Object.defineProperty(t, "IcnAcceptLarge", {
      enumerable: !0,
      get: function get() {
        return o.default;
      }
    });
    var i = n(118);
    Object.defineProperty(t, "IcnAdd", {
      enumerable: !0,
      get: function get() {
        return i.default;
      }
    });
    var a = n(119);
    Object.defineProperty(t, "IcnAgent", {
      enumerable: !0,
      get: function get() {
        return a.default;
      }
    });
    var l = n(120);
    Object.defineProperty(t, "IcnAgentBold", {
      enumerable: !0,
      get: function get() {
        return l.default;
      }
    });
    var s = n(121);
    Object.defineProperty(t, "IcnAgentNotify", {
      enumerable: !0,
      get: function get() {
        return s.default;
      }
    });
    var c = n(122);
    Object.defineProperty(t, "IcnAgentNotifyBold", {
      enumerable: !0,
      get: function get() {
        return c.default;
      }
    });
    var u = n(123);
    Object.defineProperty(t, "IcnAgents", {
      enumerable: !0,
      get: function get() {
        return u.default;
      }
    });
    var p = n(124);
    Object.defineProperty(t, "IcnAgentsBold", {
      enumerable: !0,
      get: function get() {
        return p.default;
      }
    });
    var d = n(125);
    Object.defineProperty(t, "IcnAgentsView", {
      enumerable: !0,
      get: function get() {
        return d.default;
      }
    });
    var f = n(126);
    Object.defineProperty(t, "IcnAgentsViewBold", {
      enumerable: !0,
      get: function get() {
        return f.default;
      }
    });
    var h = n(127);
    Object.defineProperty(t, "IcnAlert", {
      enumerable: !0,
      get: function get() {
        return h.default;
      }
    });
    var m = n(128);
    Object.defineProperty(t, "IcnAlertTriangle", {
      enumerable: !0,
      get: function get() {
        return m.default;
      }
    });
    var g = n(129);
    Object.defineProperty(t, "IcnAnalyze", {
      enumerable: !0,
      get: function get() {
        return g.default;
      }
    });
    var v = n(130);
    Object.defineProperty(t, "IcnAnalyzeBold", {
      enumerable: !0,
      get: function get() {
        return v.default;
      }
    });
    var y = n(52);
    Object.defineProperty(t, "IcnArrowDown", {
      enumerable: !0,
      get: function get() {
        return y.default;
      }
    });
    var b = n(131);
    Object.defineProperty(t, "IcnArrowLeft", {
      enumerable: !0,
      get: function get() {
        return b.default;
      }
    });
    var _ = n(132);
    Object.defineProperty(t, "IcnArrowRight", {
      enumerable: !0,
      get: function get() {
        return _.default;
      }
    });
    var O = n(53);
    Object.defineProperty(t, "IcnArrowUp", {
      enumerable: !0,
      get: function get() {
        return O.default;
      }
    });
    var C = n(133);
    Object.defineProperty(t, "IcnAttachment", {
      enumerable: !0,
      get: function get() {
        return C.default;
      }
    });
    var w = n(134);
    Object.defineProperty(t, "IcnBackArrow", {
      enumerable: !0,
      get: function get() {
        return w.default;
      }
    });
    var x = n(135);
    Object.defineProperty(t, "IcnBell", {
      enumerable: !0,
      get: function get() {
        return x.default;
      }
    });
    var E = n(136);
    Object.defineProperty(t, "IcnBellBold", {
      enumerable: !0,
      get: function get() {
        return E.default;
      }
    });
    var M = n(137);
    Object.defineProperty(t, "IcnBulb", {
      enumerable: !0,
      get: function get() {
        return M.default;
      }
    });
    var P = n(138);
    Object.defineProperty(t, "IcnBulbBold", {
      enumerable: !0,
      get: function get() {
        return P.default;
      }
    });
    var j = n(139);
    Object.defineProperty(t, "IcnCall", {
      enumerable: !0,
      get: function get() {
        return j.default;
      }
    });
    var A = n(140);
    Object.defineProperty(t, "IcnCallBold", {
      enumerable: !0,
      get: function get() {
        return A.default;
      }
    });
    var I = n(141);
    Object.defineProperty(t, "IcnCallSmall", {
      enumerable: !0,
      get: function get() {
        return I.default;
      }
    });
    var S = n(142);
    Object.defineProperty(t, "IcnChannel", {
      enumerable: !0,
      get: function get() {
        return S.default;
      }
    });
    var T = n(143);
    Object.defineProperty(t, "IcnClock", {
      enumerable: !0,
      get: function get() {
        return T.default;
      }
    });
    var N = n(144);
    Object.defineProperty(t, "IcnClose", {
      enumerable: !0,
      get: function get() {
        return N.default;
      }
    });
    var k = n(145);
    Object.defineProperty(t, "IcnCloseLarge", {
      enumerable: !0,
      get: function get() {
        return k.default;
      }
    });
    var B = n(146);
    Object.defineProperty(t, "IcnCogs", {
      enumerable: !0,
      get: function get() {
        return B.default;
      }
    });
    var z = n(147);
    Object.defineProperty(t, "IcnConnectionError", {
      enumerable: !0,
      get: function get() {
        return z.default;
      }
    });
    var L = n(148);
    Object.defineProperty(t, "IcnDashboard", {
      enumerable: !0,
      get: function get() {
        return L.default;
      }
    });
    var D = n(149);
    Object.defineProperty(t, "IcnDashboardBold", {
      enumerable: !0,
      get: function get() {
        return D.default;
      }
    });
    var F = n(150);
    Object.defineProperty(t, "IcnDashboards", {
      enumerable: !0,
      get: function get() {
        return F.default;
      }
    });
    var H = n(151);
    Object.defineProperty(t, "IcnDashboardsBold", {
      enumerable: !0,
      get: function get() {
        return H.default;
      }
    });
    var R = n(152);
    Object.defineProperty(t, "IcnData", {
      enumerable: !0,
      get: function get() {
        return R.default;
      }
    });
    var V = n(153);
    Object.defineProperty(t, "IcnDataBold", {
      enumerable: !0,
      get: function get() {
        return V.default;
      }
    });
    var U = n(154);
    Object.defineProperty(t, "IcnDefaultAvatar", {
      enumerable: !0,
      get: function get() {
        return U.default;
      }
    });
    var W = n(155);
    Object.defineProperty(t, "IcnDefaultAvatarBold", {
      enumerable: !0,
      get: function get() {
        return W.default;
      }
    });
    var G = n(156);
    Object.defineProperty(t, "IcnDialpad", {
      enumerable: !0,
      get: function get() {
        return G.default;
      }
    });
    var q = n(157);
    Object.defineProperty(t, "IcnDialpadLarge", {
      enumerable: !0,
      get: function get() {
        return q.default;
      }
    });
    var Y = n(158);
    Object.defineProperty(t, "IcnDirectory", {
      enumerable: !0,
      get: function get() {
        return Y.default;
      }
    });
    var K = n(159);
    Object.defineProperty(t, "IcnDirectoryBold", {
      enumerable: !0,
      get: function get() {
        return K.default;
      }
    });
    var Q = n(160);
    Object.defineProperty(t, "IcnEdit", {
      enumerable: !0,
      get: function get() {
        return Q.default;
      }
    });
    var Z = n(161);
    Object.defineProperty(t, "IcnEmail", {
      enumerable: !0,
      get: function get() {
        return Z.default;
      }
    });
    var J = n(162);
    Object.defineProperty(t, "IcnEmailBold", {
      enumerable: !0,
      get: function get() {
        return J.default;
      }
    });
    var X = n(163);
    Object.defineProperty(t, "IcnEmpty", {
      enumerable: !0,
      get: function get() {
        return X.default;
      }
    });
    var $ = n(164);
    Object.defineProperty(t, "IcnEmptyContent", {
      enumerable: !0,
      get: function get() {
        return $.default;
      }
    });
    var ee = n(165);
    Object.defineProperty(t, "IcnError", {
      enumerable: !0,
      get: function get() {
        return ee.default;
      }
    });
    var te = n(166);
    Object.defineProperty(t, "IcnEye", {
      enumerable: !0,
      get: function get() {
        return te.default;
      }
    });
    var ne = n(167);
    Object.defineProperty(t, "IcnEyeBold", {
      enumerable: !0,
      get: function get() {
        return ne.default;
      }
    });
    var re = n(168);
    Object.defineProperty(t, "IcnFacebook", {
      enumerable: !0,
      get: function get() {
        return re.default;
      }
    });
    var oe = n(169);
    Object.defineProperty(t, "IcnFacebookBold", {
      enumerable: !0,
      get: function get() {
        return oe.default;
      }
    });
    var ie = n(170);
    Object.defineProperty(t, "IcnFilter", {
      enumerable: !0,
      get: function get() {
        return ie.default;
      }
    });
    var ae = n(171);
    Object.defineProperty(t, "IcnFilterTrigger", {
      enumerable: !0,
      get: function get() {
        return ae.default;
      }
    });
    var le = n(172);
    Object.defineProperty(t, "IcnFilterUp", {
      enumerable: !0,
      get: function get() {
        return le.default;
      }
    });
    var se = n(173);
    Object.defineProperty(t, "IcnFlexBanner", {
      enumerable: !0,
      get: function get() {
        return se.default;
      }
    });
    var ce = n(174);
    Object.defineProperty(t, "IcnFolder", {
      enumerable: !0,
      get: function get() {
        return ce.default;
      }
    });
    var ue = n(175);
    Object.defineProperty(t, "IcnFullscreen", {
      enumerable: !0,
      get: function get() {
        return ue.default;
      }
    });
    var pe = n(176);
    Object.defineProperty(t, "IcnGenericDoc", {
      enumerable: !0,
      get: function get() {
        return pe.default;
      }
    });
    var de = n(177);
    Object.defineProperty(t, "IcnGenericImage", {
      enumerable: !0,
      get: function get() {
        return de.default;
      }
    });
    var fe = n(178);
    Object.defineProperty(t, "IcnGenericTask", {
      enumerable: !0,
      get: function get() {
        return fe.default;
      }
    });
    var he = n(179);
    Object.defineProperty(t, "IcnGenericTaskBold", {
      enumerable: !0,
      get: function get() {
        return he.default;
      }
    });
    var me = n(180);
    Object.defineProperty(t, "IcnGreenIndicator", {
      enumerable: !0,
      get: function get() {
        return me.default;
      }
    });
    var ge = n(181);
    Object.defineProperty(t, "IcnGreyIndicator", {
      enumerable: !0,
      get: function get() {
        return ge.default;
      }
    });
    var ve = n(182);
    Object.defineProperty(t, "IcnGroupCall", {
      enumerable: !0,
      get: function get() {
        return ve.default;
      }
    });
    var ye = n(183);
    Object.defineProperty(t, "IcnGroupCallBold", {
      enumerable: !0,
      get: function get() {
        return ye.default;
      }
    });
    var be = n(184);
    Object.defineProperty(t, "IcnHamburger", {
      enumerable: !0,
      get: function get() {
        return be.default;
      }
    });
    var _e = n(185);
    Object.defineProperty(t, "IcnHamburgerNotify", {
      enumerable: !0,
      get: function get() {
        return _e.default;
      }
    });
    var Oe = n(186);
    Object.defineProperty(t, "IcnHangup", {
      enumerable: !0,
      get: function get() {
        return Oe.default;
      }
    });
    var Ce = n(187);
    Object.defineProperty(t, "IcnHangupBold", {
      enumerable: !0,
      get: function get() {
        return Ce.default;
      }
    });
    var we = n(188);
    Object.defineProperty(t, "IcnHangupLarge", {
      enumerable: !0,
      get: function get() {
        return we.default;
      }
    });
    var xe = n(189);
    Object.defineProperty(t, "IcnHelp", {
      enumerable: !0,
      get: function get() {
        return xe.default;
      }
    });
    var Ee = n(190);
    Object.defineProperty(t, "IcnHelpBold", {
      enumerable: !0,
      get: function get() {
        return Ee.default;
      }
    });
    var Me = n(191);
    Object.defineProperty(t, "IcnHold", {
      enumerable: !0,
      get: function get() {
        return Me.default;
      }
    });
    var Pe = n(192);
    Object.defineProperty(t, "IcnHoldBold", {
      enumerable: !0,
      get: function get() {
        return Pe.default;
      }
    });
    var je = n(193);
    Object.defineProperty(t, "IcnHoldBoldSmall", {
      enumerable: !0,
      get: function get() {
        return je.default;
      }
    });
    var Ae = n(194);
    Object.defineProperty(t, "IcnHoldLarge", {
      enumerable: !0,
      get: function get() {
        return Ae.default;
      }
    });
    var Ie = n(195);
    Object.defineProperty(t, "IcnHoldLargeBold", {
      enumerable: !0,
      get: function get() {
        return Ie.default;
      }
    });
    var Se = n(196);
    Object.defineProperty(t, "IcnHoldOff", {
      enumerable: !0,
      get: function get() {
        return Se.default;
      }
    });
    var Te = n(197);
    Object.defineProperty(t, "IcnHoldOffLarge", {
      enumerable: !0,
      get: function get() {
        return Te.default;
      }
    });
    var Ne = n(198);
    Object.defineProperty(t, "IcnIncomingCall", {
      enumerable: !0,
      get: function get() {
        return Ne.default;
      }
    });
    var ke = n(199);
    Object.defineProperty(t, "IcnIncomingCallBold", {
      enumerable: !0,
      get: function get() {
        return ke.default;
      }
    });
    var Be = n(200);
    Object.defineProperty(t, "IcnIncomingTransfer", {
      enumerable: !0,
      get: function get() {
        return Be.default;
      }
    });
    var ze = n(201);
    Object.defineProperty(t, "IcnIncomingTransferBold", {
      enumerable: !0,
      get: function get() {
        return ze.default;
      }
    });
    var Le = n(202);
    Object.defineProperty(t, "IcnInfo", {
      enumerable: !0,
      get: function get() {
        return Le.default;
      }
    });
    var De = n(203);
    Object.defineProperty(t, "IcnInfoBold", {
      enumerable: !0,
      get: function get() {
        return De.default;
      }
    });
    var Fe = n(204);
    Object.defineProperty(t, "IcnInspections", {
      enumerable: !0,
      get: function get() {
        return Fe.default;
      }
    });
    var He = n(205);
    Object.defineProperty(t, "IcnInspectionsBold", {
      enumerable: !0,
      get: function get() {
        return He.default;
      }
    });
    var Re = n(206);
    Object.defineProperty(t, "IcnLeaveCall", {
      enumerable: !0,
      get: function get() {
        return Re.default;
      }
    });
    var Ve = n(207);
    Object.defineProperty(t, "IcnLeaveCallLarge", {
      enumerable: !0,
      get: function get() {
        return Ve.default;
      }
    });
    var Ue = n(208);
    Object.defineProperty(t, "IcnLine", {
      enumerable: !0,
      get: function get() {
        return Ue.default;
      }
    });
    var We = n(209);
    Object.defineProperty(t, "IcnLineBold", {
      enumerable: !0,
      get: function get() {
        return We.default;
      }
    });
    var Ge = n(210);
    Object.defineProperty(t, "IcnLoading", {
      enumerable: !0,
      get: function get() {
        return Ge.default;
      }
    });
    var qe = n(211);
    Object.defineProperty(t, "IcnLogout", {
      enumerable: !0,
      get: function get() {
        return qe.default;
      }
    });
    var Ye = n(212);
    Object.defineProperty(t, "IcnLogoutBold", {
      enumerable: !0,
      get: function get() {
        return Ye.default;
      }
    });
    var Ke = n(213);
    Object.defineProperty(t, "IcnMessage", {
      enumerable: !0,
      get: function get() {
        return Ke.default;
      }
    });
    var Qe = n(214);
    Object.defineProperty(t, "IcnMessageBold", {
      enumerable: !0,
      get: function get() {
        return Qe.default;
      }
    });
    var Ze = n(215);
    Object.defineProperty(t, "IcnMessaging", {
      enumerable: !0,
      get: function get() {
        return Ze.default;
      }
    });
    var Je = n(216);
    Object.defineProperty(t, "IcnMinimize", {
      enumerable: !0,
      get: function get() {
        return Je.default;
      }
    });
    var Xe = n(217);
    Object.defineProperty(t, "IcnMinus", {
      enumerable: !0,
      get: function get() {
        return Xe.default;
      }
    });
    var $e = n(218);
    Object.defineProperty(t, "IcnMonitorBoldLarge", {
      enumerable: !0,
      get: function get() {
        return $e.default;
      }
    });
    var et = n(219);
    Object.defineProperty(t, "IcnMonitorOffLarge", {
      enumerable: !0,
      get: function get() {
        return et.default;
      }
    });
    var tt = n(220);
    Object.defineProperty(t, "IcnMonitorSmall", {
      enumerable: !0,
      get: function get() {
        return tt.default;
      }
    });
    var nt = n(221);
    Object.defineProperty(t, "IcnMore", {
      enumerable: !0,
      get: function get() {
        return nt.default;
      }
    });
    var rt = n(222);
    Object.defineProperty(t, "IcnMute", {
      enumerable: !0,
      get: function get() {
        return rt.default;
      }
    });
    var ot = n(223);
    Object.defineProperty(t, "IcnMuteBold", {
      enumerable: !0,
      get: function get() {
        return ot.default;
      }
    });
    var it = n(224);
    Object.defineProperty(t, "IcnMuteLarge", {
      enumerable: !0,
      get: function get() {
        return it.default;
      }
    });
    var at = n(225);
    Object.defineProperty(t, "IcnMuteLargeBold", {
      enumerable: !0,
      get: function get() {
        return at.default;
      }
    });
    var lt = n(226);
    Object.defineProperty(t, "IcnNoCRM", {
      enumerable: !0,
      get: function get() {
        return lt.default;
      }
    });
    var st = n(227);
    Object.defineProperty(t, "IcnNoChat", {
      enumerable: !0,
      get: function get() {
        return st.default;
      }
    });
    var ct = n(228);
    Object.defineProperty(t, "IcnNoData", {
      enumerable: !0,
      get: function get() {
        return ct.default;
      }
    });
    var ut = n(229);
    Object.defineProperty(t, "IcnOpen", {
      enumerable: !0,
      get: function get() {
        return ut.default;
      }
    });
    var pt = n(230);
    Object.defineProperty(t, "IcnOpenInNewWindow", {
      enumerable: !0,
      get: function get() {
        return pt.default;
      }
    });
    var dt = n(231);
    Object.defineProperty(t, "IcnOutboundCall", {
      enumerable: !0,
      get: function get() {
        return dt.default;
      }
    });
    var ft = n(232);
    Object.defineProperty(t, "IcnOutboundCallBold", {
      enumerable: !0,
      get: function get() {
        return ft.default;
      }
    });
    var ht = n(233);
    Object.defineProperty(t, "IcnParticipant", {
      enumerable: !0,
      get: function get() {
        return ht.default;
      }
    });
    var mt = n(234);
    Object.defineProperty(t, "IcnPause", {
      enumerable: !0,
      get: function get() {
        return mt.default;
      }
    });
    var gt = n(235);
    Object.defineProperty(t, "IcnPdf", {
      enumerable: !0,
      get: function get() {
        return gt.default;
      }
    });
    var vt = n(236);
    Object.defineProperty(t, "IcnPlay", {
      enumerable: !0,
      get: function get() {
        return vt.default;
      }
    });
    var yt = n(237);
    Object.defineProperty(t, "IcnQuestionnaires", {
      enumerable: !0,
      get: function get() {
        return yt.default;
      }
    });
    var bt = n(238);
    Object.defineProperty(t, "IcnQuestionnairesBold", {
      enumerable: !0,
      get: function get() {
        return bt.default;
      }
    });
    var _t = n(239);
    Object.defineProperty(t, "IcnQueue", {
      enumerable: !0,
      get: function get() {
        return _t.default;
      }
    });
    var Ot = n(240);
    Object.defineProperty(t, "IcnQueues", {
      enumerable: !0,
      get: function get() {
        return Ot.default;
      }
    });
    var Ct = n(241);
    Object.defineProperty(t, "IcnQueuesBold", {
      enumerable: !0,
      get: function get() {
        return Ct.default;
      }
    });
    var wt = n(242);
    Object.defineProperty(t, "IcnRead", {
      enumerable: !0,
      get: function get() {
        return wt.default;
      }
    });
    var xt = n(243);
    Object.defineProperty(t, "IcnResize", {
      enumerable: !0,
      get: function get() {
        return xt.default;
      }
    });
    var Et = n(244);
    Object.defineProperty(t, "IcnSearch", {
      enumerable: !0,
      get: function get() {
        return Et.default;
      }
    });
    var Mt = n(245);
    Object.defineProperty(t, "IcnSendLarge", {
      enumerable: !0,
      get: function get() {
        return Mt.default;
      }
    });
    var Pt = n(246);
    Object.defineProperty(t, "IcnSettings", {
      enumerable: !0,
      get: function get() {
        return Pt.default;
      }
    });
    var jt = n(247);
    Object.defineProperty(t, "IcnSettingsBold", {
      enumerable: !0,
      get: function get() {
        return jt.default;
      }
    });
    var At = n(248);
    Object.defineProperty(t, "IcnSideMenuOff", {
      enumerable: !0,
      get: function get() {
        return At.default;
      }
    });
    var It = n(249);
    Object.defineProperty(t, "IcnSideMenuOn", {
      enumerable: !0,
      get: function get() {
        return It.default;
      }
    });
    var St = n(250);
    Object.defineProperty(t, "IcnSms", {
      enumerable: !0,
      get: function get() {
        return St.default;
      }
    });
    var Tt = n(251);
    Object.defineProperty(t, "IcnSmsAlt", {
      enumerable: !0,
      get: function get() {
        return Tt.default;
      }
    });
    var Nt = n(252);
    Object.defineProperty(t, "IcnSmsBold", {
      enumerable: !0,
      get: function get() {
        return Nt.default;
      }
    });
    var kt = n(253);
    Object.defineProperty(t, "IcnSpeechSearches", {
      enumerable: !0,
      get: function get() {
        return kt.default;
      }
    });
    var Bt = n(254);
    Object.defineProperty(t, "IcnSpeechSearchesBold", {
      enumerable: !0,
      get: function get() {
        return Bt.default;
      }
    });
    var zt = n(255);
    Object.defineProperty(t, "IcnSuggested", {
      enumerable: !0,
      get: function get() {
        return zt.default;
      }
    });
    var Lt = n(256);
    Object.defineProperty(t, "IcnSupervisor", {
      enumerable: !0,
      get: function get() {
        return Lt.default;
      }
    });
    var Dt = n(257);
    Object.defineProperty(t, "IcnSupervisorBold", {
      enumerable: !0,
      get: function get() {
        return Dt.default;
      }
    });
    var Ft = n(258);
    Object.defineProperty(t, "IcnSupportability", {
      enumerable: !0,
      get: function get() {
        return Ft.default;
      }
    });
    var Ht = n(259);
    Object.defineProperty(t, "IcnSupportabilityBold", {
      enumerable: !0,
      get: function get() {
        return Ht.default;
      }
    });
    var Rt = n(260);
    Object.defineProperty(t, "IcnTasksLarge", {
      enumerable: !0,
      get: function get() {
        return Rt.default;
      }
    });
    var Vt = n(261);
    Object.defineProperty(t, "IcnTasksSmall", {
      enumerable: !0,
      get: function get() {
        return Vt.default;
      }
    });
    var Ut = n(262);
    Object.defineProperty(t, "IcnThumbdown", {
      enumerable: !0,
      get: function get() {
        return Ut.default;
      }
    });
    var Wt = n(263);
    Object.defineProperty(t, "IcnThumbdownBold", {
      enumerable: !0,
      get: function get() {
        return Wt.default;
      }
    });
    var Gt = n(264);
    Object.defineProperty(t, "IcnThumbup", {
      enumerable: !0,
      get: function get() {
        return Gt.default;
      }
    });
    var qt = n(265);
    Object.defineProperty(t, "IcnThumbupBold", {
      enumerable: !0,
      get: function get() {
        return qt.default;
      }
    });
    var Yt = n(266);
    Object.defineProperty(t, "IcnTransfer", {
      enumerable: !0,
      get: function get() {
        return Yt.default;
      }
    });
    var Kt = n(267);
    Object.defineProperty(t, "IcnTransferBold", {
      enumerable: !0,
      get: function get() {
        return Kt.default;
      }
    });
    var Qt = n(268);
    Object.defineProperty(t, "IcnTransferLarge", {
      enumerable: !0,
      get: function get() {
        return Qt.default;
      }
    });
    var Zt = n(269);
    Object.defineProperty(t, "IcnTwilio", {
      enumerable: !0,
      get: function get() {
        return Zt.default;
      }
    });
    var Jt = n(270);
    Object.defineProperty(t, "IcnVideo", {
      enumerable: !0,
      get: function get() {
        return Jt.default;
      }
    });
    var Xt = n(271);
    Object.defineProperty(t, "IcnVideoBold", {
      enumerable: !0,
      get: function get() {
        return Xt.default;
      }
    });
    var $t = n(272);
    Object.defineProperty(t, "IcnVoice", {
      enumerable: !0,
      get: function get() {
        return $t.default;
      }
    });
    var en = n(273);
    Object.defineProperty(t, "IcnVoiceBold", {
      enumerable: !0,
      get: function get() {
        return en.default;
      }
    });
    var tn = n(274);
    Object.defineProperty(t, "IcnVoiceSmall", {
      enumerable: !0,
      get: function get() {
        return tn.default;
      }
    });
    var nn = n(275);
    Object.defineProperty(t, "IcnVolume", {
      enumerable: !0,
      get: function get() {
        return nn.default;
      }
    });
    var rn = n(276);
    Object.defineProperty(t, "IcnVolumeBold", {
      enumerable: !0,
      get: function get() {
        return rn.default;
      }
    });
    var on = n(277);
    Object.defineProperty(t, "IcnWhatsapp", {
      enumerable: !0,
      get: function get() {
        return on.default;
      }
    });
    var an = n(278);
    Object.defineProperty(t, "IcnWhatsappBold", {
      enumerable: !0,
      get: function get() {
        return an.default;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r6,
      o = this && this.__extends || (_r6 = function r(e, t) {
        return (_r6 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r6(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.withDefaultPropsUpdate = void 0;
    var a = n(0),
      l = n(282),
      s = function s() {
        var e = this;
        this.callbacks = [], this.update = function (t) {
          e.callbacks.forEach(function (e) {
            return e(t);
          });
        }, this.on = function (t) {
          e.callbacks.push(t);
        }, this.off = function (t) {
          e.callbacks = e.callbacks.filter(function (e) {
            return e !== t;
          });
        };
      };
    t.withDefaultPropsUpdate = function (e) {
      var t = e,
        n = function (e) {
          function n() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.updateCb = function () {
              t.forceUpdate();
            }, t;
          }
          return o(n, e), n.getInitialDefaultProps = function () {
            return t.defaultProps;
          }, n.updateAll = function () {
            this.callbacks.update();
          }, n.prototype.componentDidMount = function () {
            n.callbacks.on(this.updateCb);
          }, n.prototype.componentWillUnmount = function () {
            n.callbacks.off(this.updateCb);
          }, n.prototype.render = function () {
            return a.createElement(t, i({}, function (e, t) {
              if ("object" != typeof e || "object" != typeof t) return e;
              var n = Object.keys(t);
              if (0 === n.length) return e;
              var r = i({}, e);
              return n.forEach(function (e) {
                void 0 === r[e] && (r[e] = t[e]);
              }), r;
            }(this.props, n.overrideProps)));
          }, n.overrideProps = {}, n.defaultProps = function (e) {
            if ("object" != typeof e) return e;
            var t = {};
            return Object.keys(e).forEach(function (e) {
              t[e] = void 0;
            }), t;
          }(t.defaultProps), n.displayName = t.displayName, n.callbacks = new s(), n;
        }(a.Component);
      return l(n, t, {
        updateAll: !0
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Animations = void 0;
    var o,
      i,
      a = n(3),
      l = a.keyframes(o || (o = r(["\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n"], ["\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n"]))),
      s = a.keyframes(i || (i = r(["\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n"], ["\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n"])));
    t.Animations = {
      FADE_IN_DURATION: .15,
      FADE_OUT_DURATION: .07,
      SLIDE_IN_DURATION: .18,
      SLIDE_OUT_DURATION: .05,
      SPIN_DURATION: 1.5,
      FadeInOutTransition: function FadeInOutTransition(e, t, n, r) {
        return void 0 === t && (t = .15), void 0 === n && (n = .07), void 0 === r && (r = 0), "\n    transition: visibility " + (e ? t : n) + "s ease-in " + r + "s, opacity " + (e ? t : n) + "s " + (e ? "ease-in" : "ease-out") + " " + r + "s;\n    opacity: " + (e ? 1 : 0) + ";\n    visibility: " + (e ? "visible" : "hidden") + ";\n    pointer-events: " + (e ? "inherit" : "none") + ";\n  ";
      },
      SlideInTransition: function SlideInTransition(e, t, n) {
        return void 0 === t && (t = .18), void 0 === n && (n = .05), "\n    transition: all " + (e ? t : n) + "s " + (e ? "ease-in" : "ease-out") + ";\n";
      },
      AppearKeyFrames: l,
      AppearAnimation: function AppearAnimation(e, t) {
        return void 0 === e && (e = .15), void 0 === t && (t = 0), "animation: " + l + " " + e + "s ease-in " + t + "s 1 normal both;";
      },
      SpinKeyFrames: s,
      SpinAnimation: function SpinAnimation(e) {
        return void 0 === e && (e = 1.5), "animation: " + s + " " + e + "s linear infinite;";
      }
    };
  }, function (e, t, n) {
    "use strict";

    var _r7,
      o = this && this.__extends || (_r7 = function r(e, t) {
        return (_r7 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r7(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChatEventEmitter = t.ChatEvent = void 0;
    var i,
      a = n(21);
    !function (e) {
      e[e.chatInputFocus = 0] = "chatInputFocus", e[e.chatInputBlur = 1] = "chatInputBlur", e[e.chatInputRowsChanged = 2] = "chatInputRowsChanged", e[e.chatMessagePosted = 3] = "chatMessagePosted", e[e.chatMediaMessagePosted = 4] = "chatMediaMessagePosted", e[e.chatMediaDownloaded = 5] = "chatMediaDownloaded";
    }(i = t.ChatEvent || (t.ChatEvent = {}));
    var l = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.emitInputFocus = function (e) {
        this.emit(i[i.chatInputFocus], e);
      }, t.prototype.emitInputBlur = function (e) {
        this.emit(i[i.chatInputBlur], e);
      }, t.prototype.emitInputRowsChanged = function (e) {
        this.emit(i[i.chatInputRowsChanged], e);
      }, t.prototype.emitMessagePosted = function (e, t) {
        this.emit(i[i.chatMessagePosted], e, t);
      }, t.prototype.emitMediaMessagePosted = function (e, t) {
        this.emit(i[i.chatMediaMessagePosted], e, t);
      }, t.prototype.emitMediaDownloaded = function (e) {
        this.emit(i[i.chatMediaDownloaded], e);
      }, t;
    }(a.EventEmitter);
    t.ChatEventEmitter = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChatChannelHelper = void 0;
    var r = n(32),
      o = n(2),
      i = function () {
        function e(e) {
          this.channel = e;
        }
        return Object.defineProperty(e.prototype, "lastMessage", {
          get: function get() {
            var e = this.channel && Array.isArray(this.channel.pendingMessages) && this.channel.pendingMessages[this.channel.pendingMessages.length - 1],
              t = this.channel && Array.isArray(this.channel.messages) && this.channel.messages[this.channel.messages.length - 1];
            return e && (!t || e.source.timestamp > t.source.timestamp) ? e : t;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "typers", {
          get: function get() {
            return this.channel.typers;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "isCustomerOnline", {
          get: function get() {
            return this.channel ? Array.from(this.channel.members.values()).some(function (e) {
              var t = e.source.attributes,
                n = !!t && t[r.CHANNEL_MEMBER_TYPE];
              return !(!n || n !== r.CHANNEL_CUSTOMER_MEMBER_TYPE) && !!e.online;
            }) : (o.log.error("Error determining if customer is online. No channel defined"), !1);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "channelType", {
          get: function get() {
            return this.channel ? this.channel.source.attributes.channel_type : (o.log.error("Error determining channel type. No channel defined"), null);
          },
          enumerable: !1,
          configurable: !0
        }), e;
      }();
    t.ChatChannelHelper = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CHANNEL_AGENT_MEMBER_TYPE = t.CHANNEL_CUSTOMER_MEMBER_TYPE = t.CHANNEL_MEMBER_TYPE = t.CHANNEL_STATUS_INACTIVE = t.CHANNEL_STATUS_ACTIVE = t.CHANNEL_STATUS_ATTRIBUTE = void 0, t.CHANNEL_STATUS_ATTRIBUTE = "status", t.CHANNEL_STATUS_ACTIVE = "ACTIVE", t.CHANNEL_STATUS_INACTIVE = "INACTIVE", t.CHANNEL_MEMBER_TYPE = "member_type", t.CHANNEL_CUSTOMER_MEMBER_TYPE = "guest", t.CHANNEL_AGENT_MEMBER_TYPE = "agent";
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DownloadFileInvalidSize = t.DownloadFileInvalidType = t.AttachFileInvalidSize = t.AttachFileInvalidType = t.SendMediaMessageInvalidSize = t.SendMediaMessageInvalidType = t.NewChatMessage = t.UNKNOWN = void 0, t.UNKNOWN = "UNKNOWN", t.NewChatMessage = "NewChatMessage", t.SendMediaMessageInvalidType = "SendMediaMessageInvalidType", t.SendMediaMessageInvalidSize = "SendMediaMessageInvalidSize", t.AttachFileInvalidType = "AttachFileInvalidType", t.AttachFileInvalidSize = "AttachFileInvalidSize", t.DownloadFileInvalidType = "DownloadFileInvalidType", t.DownloadFileInvalidSize = "DownloadFileInvalidSize";
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, l = i.length; a < l; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Actions = t.reduce = t.ACTION_DETACH_CHANNEL_FILES = t.ACTION_ATTACH_CHANNEL_FILES = t.ACTION_UPDATE_CHANNEL_INPUT = void 0;
    var i = n(5),
      a = n(16),
      l = n(26),
      s = {},
      c = {
        inputText: "",
        selectionStart: 0,
        selectionEnd: 0,
        attachedFiles: []
      };
    t.ACTION_UPDATE_CHANNEL_INPUT = "CHANNEL_INPUT_UPDATE", t.ACTION_ATTACH_CHANNEL_FILES = "CHANNEL_FILES_ATTACH", t.ACTION_DETACH_CHANNEL_FILES = "CHANNEL_FILES_DETACH", t.reduce = function (e, n) {
      var i, u, p, d;
      if (void 0 === e && (e = s), n.type === l.ACTION_CHAT_SESSION_UNINIT) return s;
      if (!n.meta) return e;
      var f = n.meta.channelSid;
      if (!f) return e;
      switch (n.type) {
        case a.ACTION_INIT_CHANNEL:
          return r(r({}, e), ((i = {})[f] = c, i));
        case a.ACTION_UNLOAD_CHANNEL:
          var h = r({}, e);
          return delete h[f], h;
        case t.ACTION_UPDATE_CHANNEL_INPUT:
          return r(r({}, e), ((u = {})[f] = r(r({}, n.payload), {
            attachedFiles: []
          }), u));
        case t.ACTION_ATTACH_CHANNEL_FILES:
          return r(r({}, e), ((p = {})[f] = {
            selectionStart: 0,
            selectionEnd: 0,
            inputText: "",
            attachedFiles: o(e[f].attachedFiles || [], [n.payload.attachedFile])
          }, p));
        case t.ACTION_DETACH_CHANNEL_FILES:
          var m = n.payload.attachedFile,
            g = m.name,
            v = m.size,
            y = m.type;
          return r(r({}, e), ((d = {})[f] = {
            selectionStart: 0,
            selectionEnd: 0,
            inputText: "",
            attachedFiles: (e[f].attachedFiles || []).filter(function (e) {
              return e.name !== g || e.size !== v || e.type !== y;
            })
          }, d));
        default:
          return e;
      }
    };
    var u = function () {
      function e() {}
      return Object.defineProperty(e, "dispatcher", {
        get: function get() {
          return this._dispatcher || i.ChatModule.dispatch;
        },
        set: function set(e) {
          this._dispatcher = e;
        },
        enumerable: !1,
        configurable: !0
      }), e.setInputText = function (e, n, r, o) {
        void 0 === r && (r = 0), void 0 === o && (o = 0), e.source && this.dispatcher({
          type: t.ACTION_UPDATE_CHANNEL_INPUT,
          payload: {
            selectionStart: r,
            selectionEnd: o,
            inputText: n
          },
          meta: {
            channelSid: e.source.sid
          }
        });
      }, e.attachFile = function (e, n) {
        e.source && this.dispatcher({
          type: t.ACTION_ATTACH_CHANNEL_FILES,
          payload: {
            attachedFile: n
          },
          meta: {
            channelSid: e.source.sid
          }
        });
      }, e.detachFile = function (e, n) {
        e.source && this.dispatcher({
          type: t.ACTION_DETACH_CHANNEL_FILES,
          payload: {
            attachedFile: n
          },
          meta: {
            channelSid: e.source.sid
          }
        });
      }, e;
    }();
    t.Actions = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DynamicContentStore = void 0;
    var o = n(0),
      i = n(9),
      a = n(2),
      l = n(25),
      s = n(8),
      c = n(14),
      u = function () {
        function e(e) {
          var t = this;
          this._removeRequests = [], this.registeredFragments = [], this.removeRegistration = function (e) {
            t.registeredFragments = t.registeredFragments.filter(function (t) {
              return t !== e;
            });
          }, this._name = e;
        }
        return Object.defineProperty(e.prototype, "name", {
          get: function get() {
            return this._name;
          },
          enumerable: !1,
          configurable: !0
        }), e.prototype.add = function (e, t) {
          var n = this;
          if (void 0 === t && (t = void 0), !o.isValidElement(e)) throw s.ErrorManager.createAndProcessError(c.ErrorMessages.DYNAMIC_CONTENT_STORE_CHILD_INVALID, {
            description: "Child provided to " + this.name + " is not a valid React element",
            context: "DynamicContentStore"
          });
          if (void 0 === e.key || null === e.key) throw s.ErrorManager.createAndProcessError(c.ErrorMessages.DYNAMIC_CONTENT_STORE_NO_KEY, {
            description: "No key prop provided when adding component to " + this.name,
            context: "DynamicContentStore"
          });
          var r = o.createElement(i.ContentFragment, t, e);
          return a.log.debug("Adding component ", e, 'with key "' + e.key + '" to "' + this.name + '"'), l.TelemetryBridge.emit(l.TelemetryBridgeMessageType.DYNAMIC_COMPONENT_PROGRAMMABILITY, {
            name: this.name,
            command: "add",
            callType: "dynamic_component",
            options: t
          }), this.registeredFragments.push(r), function () {
            return n.removeRegistration(r);
          };
        }, e.prototype.remove = function (e, t) {
          var n = this;
          void 0 === t && (t = {});
          var o = {
            key: e,
            options: t
          };
          return this._removeRequests.push(o), a.log.debug('Removing component with key "' + e + '" from "' + this.name + '"'), l.TelemetryBridge.emit(l.TelemetryBridgeMessageType.DYNAMIC_COMPONENT_PROGRAMMABILITY, {
            name: this.name,
            command: "remove",
            callType: "dynamic_component",
            options: r(r({}, t), {
              key: e
            })
          }), function () {
            n._removeRequests = n._removeRequests.filter(function (e) {
              return e !== o;
            });
          };
        }, e.prototype.replace = function (e, t) {
          return void 0 === t && (t = {}), t.replace = !0, a.log.debug('Replacing component with key "' + e.key + '" with', e, 'in "' + this.name + '"'), l.TelemetryBridge.emit(l.TelemetryBridgeMessageType.DYNAMIC_COMPONENT_PROGRAMMABILITY, {
            name: this.name,
            command: "replace",
            callType: "dynamic_component",
            options: t
          }), this.add(e, t);
        }, Object.defineProperty(e.prototype, "fragments", {
          get: function get() {
            return this.registeredFragments;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "removeRequests", {
          get: function get() {
            return this._removeRequests;
          },
          enumerable: !1,
          configurable: !0
        }), e;
      }();
    t.DynamicContentStore = u;
  }, function (e, t, n) {
    "use strict";

    var _r8,
      o = this && this.__extends || (_r8 = function r(e, t) {
        return (_r8 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r8(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ActionStateListener = void 0;
    var i = n(0),
      a = n(22),
      l = n(10),
      s = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            pendingActions: a.Actions.findPendingActions(t.props.action, t.props.payload),
            blockedActions: a.Actions.findBlockedActions(t.props.action, t.props.payload)
          }, t.handleInvocationsChanged = function () {
            var e = a.Actions.findPendingActions(t.props.action, t.props.payload),
              n = a.Actions.findBlockedActions(t.props.action, t.props.payload);
            l.Utils.areEqual(t.state.pendingActions, e) && l.Utils.areEqual(t.state.blockedActions, n) || t.setState(function () {
              return {
                pendingActions: e,
                blockedActions: n
              };
            });
          }, t;
        }
        return o(t, e), t.prototype.componentDidUpdate = function (e) {
          e !== this.props && this.handleInvocationsChanged();
        }, t.prototype.componentDidMount = function () {
          a.Actions.addListener("invocationBegin", this.handleInvocationsChanged), a.Actions.addListener("invocationEnd", this.handleInvocationsChanged), a.Actions.addListener("actionBlockedChanged", this.handleInvocationsChanged);
        }, t.prototype.componentWillUnmount = function () {
          a.Actions.removeListener("invocationBegin", this.handleInvocationsChanged), a.Actions.removeListener("invocationEnd", this.handleInvocationsChanged), a.Actions.removeListener("actionBlockedChanged", this.handleInvocationsChanged);
        }, t.prototype.render = function () {
          return this.props.children({
            disabled: !!this.state.pendingActions.first || !!this.state.blockedActions.first
          });
        }, t;
      }(i.Component);
    t.ActionStateListener = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.VisibilityContextProvider = void 0;
    var r = n(0);
    t.VisibilityContextProvider = r.createContext(!0);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.BadgeVariants = void 0, function (e) {
      e.standard = "standard", e.dot = "dot", e.danger = "danger";
    }(t.BadgeVariants || (t.BadgeVariants = {}));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledButton = t.getHoverBackground = t.getColor = t.getDisabledBackground = void 0;
    var o,
      i = n(1);
    function a(e) {
      return e.override && e.override.disabledColor || e.theme.Button.disabledColor;
    }
    function l(e) {
      return e.override && e.override.color || e.theme.Button.color;
    }
    function s(e) {
      return i.getBackgroundWithHoverCSS(e.override && e.override.background || e.theme.Button.background, e.override ? e.override.lightHover : e.theme.Button.lightHover);
    }
    t.getDisabledBackground = a, t.getColor = l, t.getHoverBackground = s, t.StyledButton = i.styled("button")(o || (o = r(["\n    padding: 0;\n    border: none;\n    background: none;\n    outline: none;\n    align-self: center;\n    padding-left: 16px;\n    padding-right: 16px;\n    height: 28px;\n    color: inherit;\n    font-size: 10px;\n    font-weight: bold;\n    letter-spacing: 2px;\n    white-space: nowrap;\n    border-radius: ", ";\n\n    ", "\n\n    &:disabled {\n        opacity: 0.5;\n        background: ", ";\n    }\n    color: ", ";\n\n    ", ";\n"], ["\n    padding: 0;\n    border: none;\n    background: none;\n    outline: none;\n    align-self: center;\n    padding-left: 16px;\n    padding-right: 16px;\n    height: 28px;\n    color: inherit;\n    font-size: 10px;\n    font-weight: bold;\n    letter-spacing: 2px;\n    white-space: nowrap;\n    border-radius: ", ";\n\n    ", "\n\n    &:disabled {\n        opacity: 0.5;\n        background: ", ";\n    }\n    color: ", ";\n\n    ", ";\n"])), function (e) {
      return e.roundCorners ? "100px" : "0px";
    }, function (e) {
      return e.isLink && "\n        display: inline-flex;\n        text-decoration: none;\n        align-items: center;\n    ";
    }, a, l, s), t.StyledButton.defaultProps = {
      roundCorners: !0
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InputAreaStyle = t.MessageInputProps = t.MessageInput = void 0;
    var r = n(301);
    Object.defineProperty(t, "MessageInput", {
      enumerable: !0,
      get: function get() {
        return r.MessageInput;
      }
    });
    var o = n(316);
    Object.defineProperty(t, "MessageInputProps", {
      enumerable: !0,
      get: function get() {
        return o.MessageInputProps;
      }
    }), Object.defineProperty(t, "InputAreaStyle", {
      enumerable: !0,
      get: function get() {
        return o.InputAreaStyle;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              s(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            try {
              s(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, l);
          }
          s((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: l(0),
          throw: l(1),
          return: l(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function l(i) {
          return function (l) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, l]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.tryInvokeAction = void 0;
    var i = n(22);
    t.tryInvokeAction = function (e, t) {
      return r(this, void 0, Promise, function () {
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2,, 3]), [4, i.Actions.invokeAction(e, t)];
            case 1:
              return n.sent(), [3, 3];
            case 2:
              return n.sent(), [3, 3];
            case 3:
              return [2];
          }
        });
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageListChildrenProps = t.MessageList = void 0, o(n(60), t);
    var i = n(317);
    Object.defineProperty(t, "MessageList", {
      enumerable: !0,
      get: function get() {
        return i.MessageList;
      }
    }), Object.defineProperty(t, "MessageListChildrenProps", {
      enumerable: !0,
      get: function get() {
        return i.MessageListChildrenProps;
      }
    }), o(n(67), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageBubbleProps = t.MessageBubble = void 0;
    var i = n(320);
    Object.defineProperty(t, "MessageBubble", {
      enumerable: !0,
      get: function get() {
        return i.MessageBubble;
      }
    });
    var a = n(326);
    Object.defineProperty(t, "MessageBubbleProps", {
      enumerable: !0,
      get: function get() {
        return a.MessageBubbleProps;
      }
    }), o(n(44), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledBlockQuote = t.MediaMessageActions = t.MediaMessageContainer = t.MediaMessageErrorContainer = t.BodyContainer = t.TimeContainer = t.UserNameContainer = t.HeaderContainer = t.Container = void 0;
    var o,
      i,
      a,
      l,
      s,
      c,
      u,
      p,
      d,
      f = n(1),
      h = n(6);
    t.Container = f.styled(h.FlexBoxColumn)(o || (o = r(["\n    overflow-x: hidden;\n\n    ", "\n    & a {\n        color: ", ";\n    }\n    background: ", ";\n    border-radius: ", ";\n    margin-left: ", ";\n    opacity: ", ";\n"], ["\n    overflow-x: hidden;\n\n    ", "\n    & a {\n        color: ", ";\n    }\n    background: ", ";\n    border-radius: ", ";\n    margin-left: ", ";\n    opacity: ", ";\n"])), function (e) {
      return e.message.isFromMe ? e.theme.Chat.MessageListItem.FromMe.Bubble : e.theme.Chat.MessageListItem.FromOthers.Bubble;
    }, function (e) {
      var t = e.message.isFromMe ? e.theme.Chat.MessageListItem.FromMe.Bubble.color : e.theme.Chat.MessageListItem.FromOthers.Bubble.color;
      return t !== e.theme.colors.darkTextColor ? t : "";
    }, function (e) {
      return "Minimal" === e.messageStyle ? "transparent" : void 0;
    }, function (e) {
      return "Rounded" === e.messageStyle || "Wide" === e.messageStyle ? "4px" : "0px";
    }, function (e) {
      return e.message.isFromMe && "Minimal" !== e.messageStyle && "Wide" !== e.messageStyle ? "32px" : "0px";
    }, function (e) {
      return e.message.error ? .5 : void 0;
    }), t.HeaderContainer = f.styled(h.FlexBox)(i || (i = r(["\n    padding-left: 12px;\n    padding-right: 12px;\n    padding-top: ", ";\n    justify-content: ", ";\n\n    ", "\n"], ["\n    padding-left: 12px;\n    padding-right: 12px;\n    padding-top: ", ";\n    justify-content: ", ";\n\n    ", "\n"])), function (e) {
      return "Minimal" === e.messageStyle ? "0px" : "5px";
    }, function (e) {
      return "Minimal" === e.messageStyle ? "flex-start" : "space-between";
    }, function (e) {
      return e.message.isFromMe ? e.theme.Chat.MessageListItem.FromMe.Header : e.theme.Chat.MessageListItem.FromOthers.Header;
    }), t.UserNameContainer = f.styled("div")(a || (a = r(["\n    font-size: 10px;\n    margin-top: 0;\n    margin-bottom: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    flex: 0 1 auto;\n    margin-right: 8px;\n    font-weight: bold;\n"], ["\n    font-size: 10px;\n    margin-top: 0;\n    margin-bottom: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    flex: 0 1 auto;\n    margin-right: 8px;\n    font-weight: bold;\n"]))), t.TimeContainer = f.styled("div")(l || (l = r(["\n    font-size: 10px;\n    margin-top: 0;\n    margin-bottom: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    flex: 0 0 auto;\n"], ["\n    font-size: 10px;\n    margin-top: 0;\n    margin-bottom: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    flex: 0 0 auto;\n"]))), t.BodyContainer = f.styled("div")(s || (s = r(["\n    padding-left: 12px;\n    padding-right: 12px;\n    margin-top: 3px;\n    margin-bottom: 0px;\n    font-size: 12px;\n    line-height: 1.54;\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    padding-bottom: ", ";\n"], ["\n    padding-left: 12px;\n    padding-right: 12px;\n    margin-top: 3px;\n    margin-bottom: 0px;\n    font-size: 12px;\n    line-height: 1.54;\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    padding-bottom: ", ";\n"])), function (e) {
      return "Minimal" === e.messageStyle ? "0px" : "8px";
    }), t.MediaMessageErrorContainer = f.styled(t.BodyContainer)(c || (c = r(["\n    font-style: italic;\n"], ["\n    font-style: italic;\n"]))), t.MediaMessageContainer = f.styled("button")(u || (u = r(["\n    display: flex;\n    align-items: center;\n    margin-top: 5px;\n    padding: 0;\n    border: none;\n    outline: none;\n    text-align: left;\n    justify-content: space-between;\n    ", "\n    ", "\n"], ["\n    display: flex;\n    align-items: center;\n    margin-top: 5px;\n    padding: 0;\n    border: none;\n    outline: none;\n    text-align: left;\n    justify-content: space-between;\n    ", "\n    ", "\n"])), function (e) {
      return !e.message.isSending && !e.disabled && "\n    &:hover {\n        " + f.getBackgroundWithHoverCSS(e.message.isFromMe ? e.theme.Chat.MessageListItem.FromMe.Media.Container.background : e.theme.Chat.MessageListItem.FromOthers.Media.Container.background, e.message.isFromMe ? e.theme.Chat.MessageListItem.FromMe.Media.Container.lightHover : e.theme.Chat.MessageListItem.FromOthers.Media.Container.lightHover, !0) + "\n        .Twilio-Media-MessageBubble-Action {\n            visibility: visible;\n        }\n    }";
    }, function (e) {
      return e.message.isFromMe ? e.theme.Chat.MessageListItem.FromMe.Media.Container : e.theme.Chat.MessageListItem.FromOthers.Media.Container;
    }), t.MediaMessageActions = f.styled("div")(p || (p = r(["\n    width: 48px;\n    height: 48px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    visibility: hidden;\n    ", "\n"], ["\n    width: 48px;\n    height: 48px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    visibility: hidden;\n    ", "\n"])), function (e) {
      return e.message.isFromMe ? e.theme.Chat.MessageListItem.FromMe.Media.Actions : e.theme.Chat.MessageListItem.FromOthers.Media.Actions;
    }), t.StyledBlockQuote = f.styled("blockquote")(d || (d = r(['\n    position: relative;\n    padding-left: 8px;\n    margin: 0;\n    font-style: italic;\n    &:before {\n        content: "";\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        display: block;\n        width: 2px;\n        opacity: 0.4;\n        background-color: ', ";\n    }\n"], ['\n    position: relative;\n    padding-left: 8px;\n    margin: 0;\n    font-style: italic;\n    &:before {\n        content: "";\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        display: block;\n        width: 2px;\n        opacity: 0.4;\n        background-color: ', ";\n    }\n"])), function (e) {
      var t = e.theme;
      return e.message.isFromMe ? t.Chat.MessageListItem.FromMe.Bubble.color : t.Chat.MessageListItem.FromOthers.Bubble.color;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(362), t);
  }, function (e, t) {
    e.exports = require("@material-ui/core/Input");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.reduce = void 0;
    var o = n(16),
      i = n(26),
      a = {};
    t.reduce = function (e, t) {
      if (void 0 === e && (e = a), t.type === i.ACTION_CHAT_SESSION_UNINIT) return a;
      if (!t.meta) return e;
      var n = t.meta.channelSid;
      if (!n) return e;
      var l = e[n],
        s = o.reduce(l, t);
      if (l !== s) {
        var c = r({}, e);
        switch (t.type) {
          case o.ACTION_UNLOAD_CHANNEL:
            delete c[n];
            break;
          default:
            c[n] = s;
        }
        return c;
      }
      return e;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Actions = t.reduce = t.ACTION_CACHE_USERS = void 0;
    var o = n(5),
      i = n(2),
      a = n(16);
    t.ACTION_CACHE_USERS = "CHAT_CACHE_USERS", t.reduce = function (e, n) {
      var o;
      switch (void 0 === e && (e = {}), n.type) {
        case a.ACTION_USER_UPDATED:
          var i = n.payload;
          return r(r({}, e), ((o = {})[i.identity] = i, o));
        case t.ACTION_CACHE_USERS:
          var l = n.payload;
          if (!l || !l.length) return e;
          var s = r({}, e);
          return l.forEach(function (e) {
            s[e.identity] = e;
          }), s;
        default:
          return e;
      }
    };
    var l = function () {
      function e() {}
      return Object.defineProperty(e, "dispatcher", {
        get: function get() {
          return o.ChatModule.dispatch;
        },
        enumerable: !1,
        configurable: !0
      }), e.dispatchCachedUsers = function (e) {
        this.dispatcher({
          type: t.ACTION_CACHE_USERS,
          payload: e
        });
      }, e.fetchUserDescriptor = function (t) {
        var n = this;
        if (this.userDescriptorRequestCache.has(t)) {
          var r = this.userDescriptorRequestCache.get(t);
          return Promise.resolve(r);
        }
        var a = o.ChatModule.state.session.client;
        return a ? (this.userDescriptorRequestCache.set(t, null), a.getUserDescriptor(t).then(function (t) {
          return n.userDescriptorRequestCache.set(t.identity, t), e.dispatchCachedUsers([t]), t;
        }).catch(function (e) {
          return i.log.warn("User descriptor could not be retrieved for identity '" + t + "'. " + e), n.userDescriptorRequestCache.delete(t), null;
        })) : Promise.reject(Error("no client"));
      }, e.userDescriptorRequestCache = new Map(), e;
    }();
    t.Actions = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Actions = t.reduce = t.ACTION_CHANGE_CHAT_CHANNEL = t.ACTION_CHANGE_SCROLL_POSITION = void 0;
    var o = n(5);
    t.ACTION_CHANGE_SCROLL_POSITION = "CHAT_CHANGE_SCROLL_POSITION", t.ACTION_CHANGE_CHAT_CHANNEL = "CHAT_CHANGE_CHAT_CHANNEL";
    var i = {
      isScrollToBottom: !1,
      activeChatChannel: ""
    };
    t.reduce = function (e, n) {
      switch (void 0 === e && (e = i), n.type) {
        case t.ACTION_CHANGE_SCROLL_POSITION:
          return r(r({}, e), {
            isScrollToBottom: n.payload
          });
        case t.ACTION_CHANGE_CHAT_CHANNEL:
          return r(r({}, e), {
            activeChatChannel: n.payload
          });
        default:
          return e;
      }
    };
    var a = function () {
      function e() {}
      return Object.defineProperty(e, "dispatcher", {
        get: function get() {
          return o.ChatModule.dispatch;
        },
        enumerable: !1,
        configurable: !0
      }), e.updateScrollPosition = function (e) {
        o.ChatModule.dispatch({
          type: t.ACTION_CHANGE_SCROLL_POSITION,
          payload: e
        });
      }, e.updateActiveChatChannel = function (e) {
        o.ChatModule.dispatch({
          type: t.ACTION_CHANGE_CHAT_CHANNEL,
          payload: e
        });
      }, e;
    }();
    t.Actions = a;
  }, function (e, t, n) {
    "use strict";

    var _r9,
      o = this && this.__extends || (_r9 = function r(e, t) {
        return (_r9 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r9(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FlexBox = void 0;
    var i = n(3),
      a = n(0),
      l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = t.css(this.props);
          return a.createElement("div", {
            className: e
          }, this.props.children);
        }, t.css = function (e) {
          void 0 === e && (e = {});
          var t = e.className,
            n = void 0 === t ? "" : t,
            r = e.noGrow,
            o = void 0 !== r && r,
            a = e.vertical,
            l = void 0 !== a && a,
            s = e.noShrink,
            c = void 0 !== s && s,
            u = e.allowWrap,
            p = void 0 !== u && u,
            d = e.overflow,
            f = void 0 === d ? void 0 : d;
          return i.cx(n, i.css({
            display: "flex",
            flexWrap: p ? "wrap" : "nowrap",
            flexGrow: o ? 0 : 1,
            flexShrink: c ? 0 : 1,
            flexDirection: l ? "column" : "row",
            overflowX: "hidden" === f ? "hidden" : void 0
          }));
        }, t;
      }(a.PureComponent);
    t.FlexBox = l;
  }, function (e, t) {
    e.exports = require("emotion-theming");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M15.887 10.203a.626.626 0 01.922 0 .723.723 0 010 .979l-4.35 4.615a.626.626 0 01-.923 0l-4.345-4.61a.723.723 0 010-.978.626.626 0 01.922 0l3.884 4.12 3.89-4.126z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M8.113 14.797a.626.626 0 01-.922 0 .723.723 0 010-.979l4.35-4.615a.626.626 0 01.923 0l4.345 4.61a.723.723 0 010 .978.626.626 0 01-.922 0l-3.884-4.12-3.89 4.126z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Markdown = void 0;
    var r = n(280);
    Object.defineProperty(t, "Markdown", {
      enumerable: !0,
      get: function get() {
        return r.Markdown;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AriaLive = void 0, function (e) {
      e.Off = "off", e.Polite = "polite", e.Assertive = "assertive";
    }(t.AriaLive || (t.AriaLive = {}));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageCanvasTray = t.MessageList = t.InlineMessage = t.InlineDateSeparator = t.MessageBubble = t.MessageListItem = t.MessageInput = t.MessagingCanvasContext = t.MessagingCanvas = void 0;
    var r = n(20);
    Object.defineProperty(t, "MessagingCanvas", {
      enumerable: !0,
      get: function get() {
        return r.MessagingCanvas;
      }
    }), Object.defineProperty(t, "MessagingCanvasContext", {
      enumerable: !0,
      get: function get() {
        return r.MessagingCanvasContext;
      }
    });
    var o = n(40);
    Object.defineProperty(t, "MessageInput", {
      enumerable: !0,
      get: function get() {
        return o.MessageInput;
      }
    });
    var i = n(61);
    Object.defineProperty(t, "MessageListItem", {
      enumerable: !0,
      get: function get() {
        return i.MessageListItem;
      }
    });
    var a = n(43);
    Object.defineProperty(t, "MessageBubble", {
      enumerable: !0,
      get: function get() {
        return a.MessageBubble;
      }
    });
    var l = n(343);
    Object.defineProperty(t, "InlineDateSeparator", {
      enumerable: !0,
      get: function get() {
        return l.InlineDateSeparator;
      }
    });
    var s = n(346);
    Object.defineProperty(t, "InlineMessage", {
      enumerable: !0,
      get: function get() {
        return s.InlineMessage;
      }
    });
    var c = n(42);
    Object.defineProperty(t, "MessageList", {
      enumerable: !0,
      get: function get() {
        return c.MessageList;
      }
    });
    var u = n(68);
    Object.defineProperty(t, "MessageCanvasTray", {
      enumerable: !0,
      get: function get() {
        return u.MessageCanvasTray;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChatManager = void 0;
    var o = {},
      i = function () {
        function e() {}
        return Object.defineProperty(e, "config", {
          get: function get() {
            return o;
          },
          set: function set(e) {
            o = r({}, e);
          },
          enumerable: !1,
          configurable: !0
        }), e;
      }();
    t.ChatManager = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FilePreview = void 0;
    var r = n(311);
    Object.defineProperty(t, "FilePreview", {
      enumerable: !0,
      get: function get() {
        return r.FilePreview;
      }
    });
  }, function (e, t) {
    e.exports = require("lodash.debounce");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = t.ListContainer = void 0;
    var o,
      i,
      a = n(1);
    t.ListContainer = a.styled("div")(o || (o = r(["\n    display: flex;\n    flex-flow: row wrap;\n    flex-grow: 1;\n\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    padding-left: 3.75%;\n    padding-right: 3.75%;\n"], ["\n    display: flex;\n    flex-flow: row wrap;\n    flex-grow: 1;\n\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    padding-left: 3.75%;\n    padding-right: 3.75%;\n"]))), t.Container = a.styled("div")(i || (i = r(["\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    margin-top: auto;\n"], ["\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    margin-top: auto;\n"])));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageListItemProps = t.AvatarProps = t.Avatar = t.MessageListItem = void 0, o(n(62), t);
    var i = n(319);
    Object.defineProperty(t, "MessageListItem", {
      enumerable: !0,
      get: function get() {
        return i.MessageListItem;
      }
    });
    var a = n(64);
    Object.defineProperty(t, "Avatar", {
      enumerable: !0,
      get: function get() {
        return a.Avatar;
      }
    }), Object.defineProperty(t, "AvatarProps", {
      enumerable: !0,
      get: function get() {
        return a.AvatarProps;
      }
    });
    var l = n(329);
    Object.defineProperty(t, "MessageListItemProps", {
      enumerable: !0,
      get: function get() {
        return l.MessageListItemProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MediaErrorContainer = t.MessageReadContainer = t.StyledSpike = t.BubbleContainer = t.Container = void 0;
    var o,
      i,
      a,
      l,
      s,
      c = n(6),
      u = n(1),
      p = n(318);
    t.Container = u.styled("div")(o || (o = r(["\n    flex: 1 1 100%;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 0px;\n    margin-top: ", ";\n    overflow: hidden;\n"], ["\n    flex: 1 1 100%;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 0px;\n    margin-top: ", ";\n    overflow: hidden;\n"])), function (e) {
      var t = e.messageStyle,
        n = e.message;
      return "Minimal" === t ? "24px" : n.groupWithPrevious ? "4px" : "Rounded" === t ? "20px" : "12px";
    }), t.BubbleContainer = u.styled("div")(i || (i = r(["\n    display: flex;\n    flex-direction: column;\n    max-width: ", ";\n    min-width: ", ";\n    overflow-x: hidden;\n\n    margin-left: ", ";\n    margin-right: ", ";\n"], ["\n    display: flex;\n    flex-direction: column;\n    max-width: ", ";\n    min-width: ", ";\n    overflow-x: hidden;\n\n    margin-left: ", ";\n    margin-right: ", ";\n"])), function (e) {
      return "Wide" === e.messageStyle ? "auto" : "440px";
    }, function (e) {
      return "Wide" === e.messageStyle ? "100%" : "100px";
    }, function (e) {
      var t = e.messageStyle,
        n = e.isFromMe;
      return "Minimal" === t || "Wide" === t ? "0px" : n ? "auto" : "0px";
    }, function (e) {
      var t = e.messageStyle,
        n = e.isFromMe;
      return "Minimal" === t || "Wide" === t ? "8px" : n ? "0px" : "44px";
    }), t.StyledSpike = u.styled(p.Spike)(a || (a = r(["\n    align-self: ", ";\n    color: ", ";\n"], ["\n    align-self: ", ";\n    color: ", ";\n"])), function (e) {
      return e.reverse ? "flex-end" : "flex-start";
    }, function (e) {
      return e.reverse ? e.theme.Chat.MessageListItem.FromMe.Bubble.background : e.theme.Chat.MessageListItem.FromOthers.Bubble.background;
    }), t.MessageReadContainer = u.styled(c.FlexBox)(l || (l = r(["\n    align-items: center;\n    margin-left: auto;\n    font-size: 10px;\n\n    .Twilio-Icon {\n        margin-left: 4px;\n    }\n\n    ", "\n"], ["\n    align-items: center;\n    margin-left: auto;\n    font-size: 10px;\n\n    .Twilio-Icon {\n        margin-left: 4px;\n    }\n\n    ", "\n"])), function (e) {
      return e.theme.Chat.MessageListItem.ReadStatus;
    }), t.MediaErrorContainer = u.styled(c.FlexBox)(s || (s = r(["\n    align-items: center;\n    margin-left: auto;\n    font-size: 10px;\n    ", ";\n"], ["\n    align-items: center;\n    margin-left: auto;\n    font-size: 10px;\n    ", ";\n"])), function (e) {
      return e.theme.Chat.MessageListItem.ErrorStatus;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CircularProgressProps = t.CircularProgressThemeProps = t.CircularProgress = void 0;
    var r = n(323);
    Object.defineProperty(t, "CircularProgress", {
      enumerable: !0,
      get: function get() {
        return r.CircularProgress;
      }
    });
    var o = n(325);
    Object.defineProperty(t, "CircularProgressThemeProps", {
      enumerable: !0,
      get: function get() {
        return o.CircularProgressThemeProps;
      }
    }), Object.defineProperty(t, "CircularProgressProps", {
      enumerable: !0,
      get: function get() {
        return o.CircularProgressProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Avatar = void 0;
    var r = n(0),
      o = n(7),
      i = n(328);
    t.Avatar = function (e) {
      return "Minimal" === e.messageStyle ? r.createElement(i.AvatarLine, {
        className: "Twilio-ChatItem-AvatarLine",
        message: e.message
      }) : (t = e.message.isFromMe || e.message.groupWithPrevious ? null : e.avatarUrl ? r.createElement("img", {
        src: e.avatarUrl,
        alt: ""
      }) : r.createElement(o.Icon, {
        icon: "DefaultAvatar"
      }), r.createElement(i.StyledAvatarDiv, {
        className: "Twilio-ChatItem-Avatar",
        messageStyle: e.messageStyle,
        message: e.message
      }, t));
      var t;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WelcomeMessage = void 0, o(n(66), t);
    var i = n(330);
    Object.defineProperty(t, "WelcomeMessage", {
      enumerable: !0,
      get: function get() {
        return i.WelcomeMessage;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IconContainer = t.Container = void 0;
    var o = n(0),
      i = n(1),
      a = n(7);
    t.Container = i.styled("div")(l || (l = r(["\n    display: flex;\n    overflow: hidden;\n    margin-top: 20px;\n    margin-right: auto;\n    margin-bottom: 20px;\n    margin-left: auto;\n    flex: 1 100%;\n    ", "\n"], ["\n    display: flex;\n    overflow: hidden;\n    margin-top: 20px;\n    margin-right: auto;\n    margin-bottom: 20px;\n    margin-left: auto;\n    flex: 1 100%;\n    ", "\n"])), function (e) {
      return e.theme.Chat.WelcomeMessage.Container;
    });
    var l,
      s,
      c = i.styled("div")(s || (s = r(["\n    margin-bottom: 4px;\n    height: 24px;\n    width: 24px;\n    align-self: center;\n    ", "\n"], ["\n    margin-bottom: 4px;\n    height: 24px;\n    width: 24px;\n    align-self: center;\n    ", "\n"])), function (e) {
        return e.theme.Chat.WelcomeMessage.Icon;
      });
    t.IconContainer = function (e) {
      var t = e.icon;
      return o.createElement(c, {
        className: "Twilio-WelcomeMessage-IconContainer"
      }, o.createElement(a.Icon, {
        icon: t
      }));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TypingIndicator = void 0;
    var r = n(0),
      o = n(4),
      i = n(10),
      a = n(333);
    t.TypingIndicator = function (e) {
      var t = e.memberDisplayOptions,
        n = e.typers,
        l = "";
      return 1 === n.length && (l = i.Utils.getNameForMember(t.theirFriendlyNameOverride, t.theirDefaultName, n[0].friendlyName, n[0].source.identity)), r.createElement(a.TypingIndicatorDiv, {
        className: "Twilio-TypingIndicator",
        key: "TypingIndicator"
      }, 1 === n.length && r.createElement(o.Template, {
        source: o.templates.TypingIndicator,
        name: l
      }), n.length > 1 && r.createElement(o.Template, {
        source: o.templates.TypingIndicatorMultiple,
        count: n.length
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageCanvasTrayProps = t.MessageCanvasTray = void 0, o(n(69), t);
    var i = n(340);
    Object.defineProperty(t, "MessageCanvasTray", {
      enumerable: !0,
      get: function get() {
        return i.MessageCanvasTray;
      }
    }), Object.defineProperty(t, "MessageCanvasTrayProps", {
      enumerable: !0,
      get: function get() {
        return i.MessageCanvasTrayProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ActionButton = t.Container = void 0;
    var o,
      i,
      a = n(23),
      l = n(6),
      s = n(1);
    t.Container = s.styled(l.FlexBoxColumn)(o || (o = r(["\n    display: flex;\n    margin-left: auto;\n    margin-right: auto;\n    align-items: center;\n    width: 100%;\n    min-height: 140px;\n\n    p {\n        margin-top: 4px;\n        margin-bottom: 12px;\n        margin-left: 47px;\n        margin-right: 47.5px;\n    }\n\n    .MessageCanvasTrayContent {\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        margin-top: 20px;\n        h6 {\n            font-size: 18px;\n            font-weight: normal;\n            margin: 0px;\n        }\n    }\n\n    ", "\n"], ["\n    display: flex;\n    margin-left: auto;\n    margin-right: auto;\n    align-items: center;\n    width: 100%;\n    min-height: 140px;\n\n    p {\n        margin-top: 4px;\n        margin-bottom: 12px;\n        margin-left: 47px;\n        margin-right: 47.5px;\n    }\n\n    .MessageCanvasTrayContent {\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        margin-top: 20px;\n        h6 {\n            font-size: 18px;\n            font-weight: normal;\n            margin: 0px;\n        }\n    }\n\n    ", "\n"])), function (e) {
      return e.theme.Chat.MessageCanvasTray.Container;
    }), t.ActionButton = s.styled(a.Button)(i || (i = r(["\n    height: 28px;\n    align-self: center;\n    font-size: 12px;\n    margin-bottom: 21px;\n    ", "\n"], ["\n    height: 28px;\n    align-self: center;\n    font-size: 12px;\n    margin-bottom: 21px;\n    ", "\n"])), function (e) {
      return e.theme.Chat.MessageCanvasTray.Button;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ContentContainer = t.Container = void 0;
    var o,
      i,
      a = n(6),
      l = n(1);
    t.Container = l.styled(a.FlexBoxColumn)(o || (o = r(["\n    margin-left: auto;\n    margin-right: auto;\n    font-size: 12px;\n    width: 100%;\n    ", "\n"], ["\n    margin-left: auto;\n    margin-right: auto;\n    font-size: 12px;\n    width: 100%;\n    ", "\n"])), function (e) {
      return e.theme.Chat.MessagingCanvas.Container;
    }), t.ContentContainer = l.styled(a.FlexBoxColumn)(i || (i = r(["\n    height: 0px;\n    width: 100%;\n    max-width: 640px;\n    align-self: center;\n"], ["\n    height: 0px;\n    width: 100%;\n    max-width: 640px;\n    align-self: center;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessagingCanvasContext = void 0;
    var r = n(0);
    t.MessagingCanvasContext = r.createContext(void 0);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = void 0;
    var o,
      i = n(6),
      a = n(1);
    t.Container = a.styled(i.FlexBox)(o || (o = r(["\n    margin-top: 40px;\n\n    margin-bottom: ", ";\n"], ["\n    margin-top: 40px;\n\n    margin-bottom: ", ";\n"])), function (e) {
      return e.message.groupWithPrevious || "Squared" !== e.messageStyle ? e.message.groupWithPrevious ? "Minimal" === e.messageStyle ? "16px" : "36px" : "20px" : "28px";
    });
  }, function (e, t) {
    e.exports = require("@material-ui/core/TableRow");
  }, function (e, t) {
    e.exports = require("@material-ui/core/TableCell");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HeaderCellContentWrapper = t.SubHeaderCellContentWrapper = t.HeaderCellWithSubheader = t.TableCell = t.StyledTableRow = void 0;
    var o,
      i,
      a,
      l = n(1),
      s = n(73),
      c = n(74),
      u = n(76);
    t.StyledTableRow = l.styled(s.default)(o || (o = r(["\n    cursor: ", ";\n"], ["\n    cursor: ", ";\n"])), function (e) {
      return e.onClick ? "pointer" : "default";
    }), t.TableCell = u.withStyles(function (e) {
      return {};
    })(c.default), t.HeaderCellWithSubheader = u.withStyles(function (e) {
      return {
        head: {
          borderBottomWidth: 0
        }
      };
    })(c.default), t.SubHeaderCellContentWrapper = l.styled("span")(i || (i = r(["\n    position: relative;\n    padding-right: 24px;\n    vertical-align: middle;\n    height: 30px;\n    text-transform: none;\n    font-weight: initial;\n    letter-spacing: initial;\n\n    ", ";\n    ", "\n"], ["\n    position: relative;\n    padding-right: 24px;\n    vertical-align: middle;\n    height: 30px;\n    text-transform: none;\n    font-weight: initial;\n    letter-spacing: initial;\n\n    ", ";\n    ", "\n"])), function (e) {
      return e.theme.DataTable.SubHeader.root;
    }, function (e) {
      var t = e.clickable,
        n = e.theme;
      return t && n.DataTable.SubHeader.clickable;
    }), t.HeaderCellContentWrapper = l.styled("span")(a || (a = r(["\n    position: relative;\n    padding-right: 24px;\n    vertical-align: middle;\n\n    ", "\n    ", "}\n    ", "\n"], ["\n    position: relative;\n    padding-right: 24px;\n    vertical-align: middle;\n\n    ", "\n    ", "}\n    ", "\n"])), function (e) {
      return e.theme.DataTable.Header.root;
    }, function (e) {
      var t = e.hasSubHeader,
        n = e.theme;
      return t && n.DataTable.Header.withSubHeader;
    }, function (e) {
      var t = e.clickable,
        n = e.theme;
      return t && n.DataTable.Header.clickable;
    });
  }, function (e, t) {
    e.exports = require("@material-ui/core");
  }, function (e, t, n) {
    "use strict";

    var _r10,
      o = this && this.__extends || (_r10 = function r(e, t) {
        return (_r10 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r10(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Dialpad = void 0;
    var a = n(0),
      l = n(78),
      s = n(364),
      c = n(365);
    function u(e) {
      return /[0-9#*+]/.test(e);
    }
    var p = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        return n.ignoreTargets = ["INPUT", "TEXTAREA"], n.onKeyDownHandler = function (e) {
          var t,
            r,
            o,
            i = e.target.tagName,
            a = (null === (t = n.props.inputRef) || void 0 === t ? void 0 : t.current) === e.target,
            l = n.ignoreTargets.indexOf(i) > -1 && !a;
          a || l || "BACKSPACE" === e.key.toUpperCase() && (null === (o = (r = n.props).onUndo) || void 0 === o || o.call(r));
        }, n.onKeyPressHandler = function (e) {
          var t,
            r = e.target.tagName,
            o = e.key;
          if (!n.state.animate[o]) {
            var a = (null === (t = n.props.inputRef) || void 0 === t ? void 0 : t.current) === e.target;
            !(n.ignoreTargets.indexOf(r) > -1 && !a) && u(o) && (a || n.props.onClick(e.key), n.setState(function (e) {
              var t;
              return {
                animate: i(i({}, e.animate), (t = {}, t[o] = !0, t))
              };
            }));
          }
        }, n.onKeyUpHandler = function (e) {
          var t = e.target.tagName,
            r = e.key,
            o = n.props.inputRef && n.props.inputRef.current === e.target;
          !(n.ignoreTargets.indexOf(t) > -1 && !o) && u(r) && n.setState(function (e) {
            var t;
            return {
              animate: i(i({}, e.animate), (t = {}, t[r] = !1, t))
            };
          });
        }, n.state = {
          animate: {}
        }, n;
      }
      return o(t, e), t.prototype.componentDidMount = function () {
        window.addEventListener("keydown", this.onKeyDownHandler), window.addEventListener("keypress", this.onKeyPressHandler), window.addEventListener("keyup", this.onKeyUpHandler);
      }, t.prototype.componentWillUnmount = function () {
        window.removeEventListener("keydown", this.onKeyDownHandler), window.removeEventListener("keypress", this.onKeyPressHandler), window.removeEventListener("keyup", this.onKeyUpHandler);
      }, t.prototype.render = function () {
        var e = this.props,
          t = e.onClick,
          n = e.disabled,
          r = e.compact,
          o = this.state.animate,
          u = {
            onClick: t,
            disabled: n,
            compact: r
          };
        return a.createElement(l.DialpadLayout, null, a.createElement(l.Row, null, a.createElement(s.DialpadButton, i({
          animate: o[1],
          value: c.DialpadButtons.ONE,
          options: "—"
        }, u)), a.createElement(s.DialpadButton, i({
          animate: o[2],
          value: c.DialpadButtons.TWO,
          options: "ABC"
        }, u)), a.createElement(s.DialpadButton, i({
          animate: o[3],
          value: c.DialpadButtons.THREE,
          options: "DEF"
        }, u))), a.createElement(l.Row, null, a.createElement(s.DialpadButton, i({
          animate: o[4],
          value: c.DialpadButtons.FOUR,
          options: "GHI"
        }, u)), a.createElement(s.DialpadButton, i({
          animate: o[5],
          value: c.DialpadButtons.FIVE,
          options: "JKL"
        }, u)), a.createElement(s.DialpadButton, i({
          animate: o[6],
          value: c.DialpadButtons.SIX,
          options: "MNO"
        }, u))), a.createElement(l.Row, null, a.createElement(s.DialpadButton, i({
          animate: o[7],
          value: c.DialpadButtons.SEVEN,
          options: "PQRS"
        }, u)), a.createElement(s.DialpadButton, i({
          animate: o[8],
          value: c.DialpadButtons.EIGHT,
          options: "TUV"
        }, u)), a.createElement(s.DialpadButton, i({
          animate: o[9],
          value: c.DialpadButtons.NINE,
          options: "WXYZ"
        }, u))), a.createElement(l.Row, null, a.createElement(s.DialpadButton, i({
          animate: o["*"],
          value: c.DialpadButtons.ASTERISK
        }, u)), a.createElement(s.DialpadButton, i({
          animate: o[0],
          value: c.DialpadButtons.ZERO,
          options: "+",
          longPressable: !0
        }, u)), a.createElement(s.DialpadButton, i({
          animate: o["#"],
          value: c.DialpadButtons.HASH
        }, u))));
      }, t;
    }(a.PureComponent);
    t.Dialpad = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Description = t.Caption = t.Button = t.DialpadLayout = t.Row = void 0;
    var o,
      i,
      a,
      l,
      s,
      c = n(3),
      u = n(1);
    t.Row = c.default("div")(o || (o = r(["\n    display: flex;\n    flex-direction: row;\n    flex-grow: 0;\n"], ["\n    display: flex;\n    flex-direction: row;\n    flex-grow: 0;\n"]))), t.DialpadLayout = c.default("div")(i || (i = r(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n"], ["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n"]))), t.Button = c.default("div")(a || (a = r(["\n    width: 33%;\n    display: flex;\n    flex-grow: 0;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    user-select: none;\n    transition: background-color 200ms;\n    ", ";\n\n    height: ", ";\n"], ["\n    width: 33%;\n    display: flex;\n    flex-grow: 0;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    user-select: none;\n    transition: background-color 200ms;\n    ", ";\n\n    height: ", ";\n"])), function (e) {
      return e.disabled ? e.theme.Dialpad.Button.Container.disabled : u.getBackgroundWithHoverCSS(e.theme.Dialpad.Button.Container.backgroundColor, e.theme.Dialpad.Button.Container.lightHover, e.animate);
    }, function (e) {
      return e.compact ? "38px" : "56px";
    }), t.Caption = c.default("span")(l || (l = r(["\n    font-size: 18px;\n    line-height: 1.33;\n    ", "\n    font-size: ", ";\n"], ["\n    font-size: 18px;\n    line-height: 1.33;\n    ", "\n    font-size: ", ";\n"])), function (e) {
      return e.theme.Dialpad.Button.Caption;
    }, function (e) {
      return e.compact ? "14px" : "18px";
    }), t.Description = c.default("span")(s || (s = r(["\n    font-size: 10px;\n    line-height: 1.6;\n    letter-spacing: 2px;\n    margin-left: 2px; /* Visually aligns caption under corresponding digit */\n    ", "\n\n    height: ", ";\n"], ["\n    font-size: 10px;\n    line-height: 1.6;\n    letter-spacing: 2px;\n    margin-left: 2px; /* Visually aligns caption under corresponding digit */\n    ", "\n\n    height: ", ";\n"])), function (e) {
      return e.theme.Dialpad.Button.Description;
    }, function (e) {
      return e.compact ? "8x" : "10px";
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CallButton = t.DialerActions = t.DialerContainer = t.ClearInputButton = t.PhoneInputContainer = t.PhoneInput = t.Caption = void 0;
    var o,
      i,
      a,
      l,
      s,
      c,
      u,
      p = n(46),
      d = n(3),
      f = n(27),
      h = n(1);
    t.Caption = d.default("label")(o || (o = r(["\n    display: block;\n    text-transform: uppercase;\n    font-size: 10px;\n    line-height: 1.6;\n    letter-spacing: 2px;\n    margin-bottom: 8px;\n"], ["\n    display: block;\n    text-transform: uppercase;\n    font-size: 10px;\n    line-height: 1.6;\n    letter-spacing: 2px;\n    margin-bottom: 8px;\n"]))), t.PhoneInput = d.default(p.default)(i || (i = r(["\n    display: flex;\n    flex-grow: 1;\n    font-size: 12px;\n    line-height: 1.33;\n    letter-spacing: normal;\n    input {\n        padding-right: 26px;\n    }\n"], ["\n    display: flex;\n    flex-grow: 1;\n    font-size: 12px;\n    line-height: 1.33;\n    letter-spacing: normal;\n    input {\n        padding-right: 26px;\n    }\n"]))), t.PhoneInputContainer = d.default("div")(a || (a = r(["\n    display: flex;\n    position: relative;\n    overflow: hidden;\n    margin-bottom: 16px;\n"], ["\n    display: flex;\n    position: relative;\n    overflow: hidden;\n    margin-bottom: 16px;\n"]))), t.ClearInputButton = d.default("div")(l || (l = r(["\n    display: flex;\n    align-items: center;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    opacity: ", ";\n    transform: translateX(", "px);\n    transition: all 200ms ease-out;\n    padding: 4px;\n    cursor: pointer;\n    position: absolute;\n"], ["\n    display: flex;\n    align-items: center;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    opacity: ", ";\n    transform: translateX(", "px);\n    transition: all 200ms ease-out;\n    padding: 4px;\n    cursor: pointer;\n    position: absolute;\n"])), function (e) {
      return e.isVisible ? 1 : 0;
    }, function (e) {
      return e.isVisible ? 0 : 10;
    }), t.DialerContainer = d.default("div")(s || (s = r(["\n    width: 100%;\n"], ["\n    width: 100%;\n"]))), t.DialerActions = d.default("div")(c || (c = r(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 16px;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 16px;\n"]))), t.CallButton = d.default(f.IcnCall)(u || (u = r(["\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    padding: 8px;\n    cursor: pointer;\n    ", ";\n    ", ";\n"], ["\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    padding: 8px;\n    cursor: pointer;\n    ", ";\n    ", ";\n"])), function (e) {
      return e.theme.Dialer.CallButton;
    }, function (e) {
      return h.getBackgroundWithHoverCSS(e.theme.Dialer.CallButton.backgroundColor, e.theme.Dialer.CallButton.lightHover, !1, e.disabled);
    });
  }, function (e, t) {
    e.exports = require("@material-ui/core/MenuItem");
  }, function (e, t) {
    e.exports = require("@material-ui/core/Select");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createMuiTheme = t.getHover = void 0;
    var o = n(373);
    function i(e, t) {
      var n = "rgba(0, 0, 0, 0.2)";
      t && (n = "rgba(255, 255, 255, 0.2)");
      var o = {
        backgroundColor: "" + n,
        backgroundBlendMode: "color"
      };
      return e && (o = r(r({}, o), {
        backgroundImage: "linear-gradient(to top, " + e + ", " + e + ")"
      })), o;
    }
    t.getHover = i, t.createMuiTheme = function (e, t) {
      var n = t ? e.darkTextColor : e.lightTextColor;
      return {
        palette: {
          action: {
            hover: "rgba(0, 0, 0, 0)"
          },
          error: {
            main: e.errorColor
          },
          primary: {
            main: e.defaultButtonColor,
            primary: e.defaultButtonColor
          },
          text: {
            primary: n,
            secondary: n,
            disabled: e.disabledColor,
            hint: n
          }
        },
        overrides: {
          MuiFormLabel: {
            root: {
              fontSize: 12,
              marginBottom: 8
            }
          },
          MuiFormHelperText: {
            root: {
              fontSize: "10px !important",
              lineHeight: "1.6",
              color: n,
              paddingTop: 4,
              paddingBottom: 4
            }
          },
          MuiInput: {
            input: {
              color: n,
              boxShadow: "none",
              border: "1px solid " + e.base4,
              fontSize: 12,
              lineHeight: "16px",
              paddingTop: 7,
              paddingBottom: 7,
              paddingLeft: 12,
              paddingRight: 12,
              boxSizing: "border-box",
              "&:focus": {
                background: e.base1,
                boxShadow: "0px 0px 0px 2px " + e.focusGlow,
                border: "1px solid " + e.focusColor
              },
              "&$disabled": {
                borderColor: e.disabledColor,
                color: e.disabledColor,
                cursor: "not-allowed"
              }
            },
            inputType: {
              height: "initial"
            },
            multiline: {
              padding: "0"
            },
            error: {
              color: e.errorColor,
              "& input, & input:focus, & textarea, & textarea:focus": {
                boxShadow: "0px 0px 0px 2px " + e.errorGlow,
                border: "1px solid " + e.errorColor
              }
            }
          },
          MuiMenuItem: {
            root: {
              background: e.base1,
              color: n,
              fontSize: 12,
              height: 24,
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 12,
              paddingRight: 12,
              margin: "0px 1px 1px 1px",
              "&:hover": i(e.base1, !t),
              "&$selected": {
                fontWeight: "bold"
              }
            }
          },
          MuiModal: {
            root: {
              fontFamily: "Open Sans"
            }
          },
          MuiSelect: {
            select: {
              "&:focus": {
                background: e.base1
              },
              "&[aria-pressed='true'] ~ .Twilio-Dropdown": {
                transform: "scaleY(-1)"
              },
              "&$disabled": {
                borderColor: e.disabledColor,
                color: e.disabledColor,
                cursor: "not-allowed",
                "& ~ div > svg": {
                  color: "inherit"
                }
              },
              fontSize: 12,
              paddingRight: 48
            },
            icon: {
              right: 6,
              color: n
            }
          },
          MuiTable: {
            root: {
              tableLayout: "fixed"
            }
          },
          MuiTableRow: {
            head: {
              height: "24px",
              "&:hover": {
                background: "transparent"
              }
            },
            root: {
              height: "52px",
              "&$selected": {
                backgroundColor: "inherit",
                background: "linear-gradient(to right,\n                        " + e.defaultButtonColor + " 0%,\n                        " + e.defaultButtonColor + " 4px,\n                        " + e.base2 + " 4px,\n                        " + e.base2 + " 100%)"
              },
              "&$hover:hover": i(void 0, !t)
            }
          },
          MuiTableCell: {
            root: {
              padding: "0px 0px 0px 0px",
              fontSize: "10px",
              "&:first-child": {
                paddingLeft: "6px"
              },
              borderBottomColor: e.base4
            },
            head: {
              fontSize: "10px",
              fontWeight: "bold",
              color: n,
              letterSpacing: "2px",
              textTransform: "uppercase",
              "&:first-child": {
                paddingLeft: "12px"
              }
            },
            body: {
              fontSize: "10px",
              color: n,
              verticalAlign: "center"
            }
          },
          MuiSwitch: {
            root: {
              width: 39,
              marginRight: 3
            },
            bar: {
              height: 8,
              top: "50%",
              marginTop: -4,
              opacity: "1 !important",
              backgroundColor: e.disabledColor
            },
            icon: {
              width: 16,
              height: 16,
              marginRight: "auto",
              background: "#ffffff",
              border: "1px solid #000"
            },
            iconChecked: {
              background: "#ffffff",
              border: "1px solid #000",
              opacity: 1,
              transform: "translateX(6px)"
            }
          },
          MuiSwitchBase: {
            root: {
              width: 39,
              height: 32
            }
          },
          MuiFormControlLabel: {
            root: {
              marginLeft: 0,
              marginRight: 12
            },
            label: {
              fontSize: 12,
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap"
            }
          },
          MuiCheckbox: {
            root: {
              color: e.base6
            }
          }
        },
        props: {
          MuiButtonBase: {
            disableRipple: !0
          },
          MuiInput: {
            disableUnderline: !0
          },
          MuiSelect: {
            MenuProps: {
              MenuListProps: {
                disablePadding: !0
              },
              PaperProps: {
                square: !0,
                style: {
                  boxShadow: "inset 0px -1px 0px 1px " + e.base4,
                  background: e.base1
                }
              },
              anchorOrigin: {
                horizontal: "left",
                vertical: "bottom"
              },
              getContentAnchorEl: null,
              marginThreshold: 0,
              transitionDuration: 0
            },
            IconComponent: o.SelectDropDownIcon
          }
        },
        typography: {
          useNextVariants: !0,
          fontFamily: "inherit"
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    var _r11,
      o = this && this.__extends || (_r11 = function r(e, t) {
        return (_r11 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r11(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FiltersList = t.FiltersListItemType = void 0;
    var a = n(0),
      l = n(10),
      s = n(6),
      c = n(380),
      u = n(383),
      p = n(387);
    !function (e) {
      e.multiValue = "multiValue";
    }(t.FiltersListItemType || (t.FiltersListItemType = {}));
    var d = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {
          currentFilters: {},
          expandedFilterId: "",
          selectedLegacyFilterQuery: ""
        }, t.hasFilterApplied = function () {
          return !l.Utils.haveSameValues(t.props.defaultFilters, t.state.currentFilters, {
            equalUndefinedToEmptyArray: !0
          }) || "" !== t.state.selectedLegacyFilterQuery;
        }, t.hasAllChangesApplied = function () {
          return l.Utils.haveSameValues(t.props.appliedFilters, t.state.currentFilters, {
            equalUndefinedToEmptyArray: !0
          }) && t.props.appliedLegacyFilterQuery === t.state.selectedLegacyFilterQuery;
        }, t.handleFilterChange = function (e) {
          return function (n) {
            t.setState(function (t) {
              var r;
              return {
                currentFilters: i(i({}, t.currentFilters), (r = {}, r[e] = n, r))
              };
            });
          };
        }, t.handleSubmit = function (e) {
          e.preventDefault(), t.applyFilters();
        }, t.handleReset = function (e) {
          e.preventDefault();
          var n = t.props.defaultFilters;
          t.setState({
            currentFilters: i({}, n),
            selectedLegacyFilterQuery: ""
          }), t.props.handleResetClick(n);
        }, t.handleExpandClick = function (e) {
          t.setState(function (t) {
            return {
              expandedFilterId: t.expandedFilterId === e ? "" : e
            };
          });
        }, t.handleSelectLegacyFilter = function (e) {
          t.setState({
            selectedLegacyFilterQuery: e
          });
        }, t;
      }
      return o(t, e), t.getDerivedStateFromProps = function (e, t) {
        return i(i({}, t), {
          currentFilters: l.Utils.areEqual(e.appliedFilters, t.lastAppliedFilters) ? t.currentFilters : e.appliedFilters,
          lastAppliedFilters: e.appliedFilters
        });
      }, t.getDefaultFilterValues = function (e) {
        return e.reduce(function (e, t) {
          if (!t.options) return e;
          var n = t.options.filter(function (e) {
            return e.default;
          }).map(function (e) {
            return e.value;
          });
          return n.length && (e[t.id] = n), e;
        }, {});
      }, t.prototype.render = function () {
        var e = this,
          t = this.props,
          n = t.headerLabel,
          r = t.resetLabel,
          o = t.applyLabel,
          l = t.filters,
          d = t.actionsDisabled;
        return a.createElement("form", {
          onSubmit: this.handleSubmit
        }, a.createElement(s.FlexBox, {
          vertical: !0
        }, a.createElement(c.FiltersListHeader, {
          headerLabel: n,
          handleResetClick: this.handleReset,
          applyLabel: o,
          resetLabel: r,
          applyButtonDisabled: this.hasAllChangesApplied() || d,
          resetButtonDisabled: !this.hasFilterApplied() && this.hasAllChangesApplied() || d
        }), l.map(function (t) {
          return a.createElement(u.FiltersListItem, i({}, t, {
            key: t.id,
            handleChange: e.handleFilterChange(t.id),
            currentValue: e.state.currentFilters[t.id],
            isExpanded: e.state.expandedFilterId === t.id,
            handleExpandClick: e.handleExpandClick,
            showExpandToggle: l.length > 1
          }));
        }), this.props.legacyFilters && this.props.legacyFilters.length > 0 && a.createElement(p.LegacyFiltersItem, {
          filters: this.props.legacyFilters,
          onSelectLegacyFilterQuery: this.handleSelectLegacyFilter,
          selectedLegacyFilterQuery: this.state.selectedLegacyFilterQuery
        })));
      }, t.prototype.applyFilters = function () {
        this.props.handleApplyClick(this.state.currentFilters, this.state.selectedLegacyFilterQuery);
      }, t.defaultProps = {
        actionsDisabled: !1
      }, t;
    }(a.Component);
    t.FiltersList = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CheckboxGroupField = t.CheckboxGroup = void 0;
    var r = n(385);
    Object.defineProperty(t, "CheckboxGroup", {
      enumerable: !0,
      get: function get() {
        return r.CheckboxGroup;
      }
    }), Object.defineProperty(t, "CheckboxGroupField", {
      enumerable: !0,
      get: function get() {
        return r.CheckboxGroupField;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CheckboxContainer = t.StyledCheckbox = t.StyledCheckboxLabel = t.Container = void 0;
    var o,
      i,
      a,
      l,
      s = n(1),
      c = n(386),
      u = n(6);
    t.Container = s.styled(u.FlexBox)(o || (o = r(["\n    align-items: stretch;\n    display: flex;\n"], ["\n    align-items: stretch;\n    display: flex;\n"]))), t.StyledCheckboxLabel = s.styled("label")(i || (i = r(["\n    width: 100%;\n    font-size: 12px;\n    user-select: none;\n    padding-left: 8px;\n"], ["\n    width: 100%;\n    font-size: 12px;\n    user-select: none;\n    padding-left: 8px;\n"]))), t.StyledCheckbox = s.styled(c.default)(a || (a = r(["\n    width: 18px; // icon size\n    height: 18px; // icon size\n    overflow: hidden;\n    border-radius: 0;\n    box-sizing: border-box;\n"], ["\n    width: 18px; // icon size\n    height: 18px; // icon size\n    overflow: hidden;\n    border-radius: 0;\n    box-sizing: border-box;\n"]))), t.CheckboxContainer = s.styled(u.FlexBox)(l || (l = r(["\n    align-items: center;\n    padding: 4px 16px;\n    box-sizing: border-box;\n"], ["\n    align-items: center;\n    padding: 4px 16px;\n    box-sizing: border-box;\n"])));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FieldContainer = t.ExpandIconButton = t.Label = t.Title = t.InnerHeader = t.Header = t.Container = void 0;
    var o,
      i,
      a,
      l,
      s,
      c,
      u,
      p = n(1),
      d = n(18);
    t.Container = p.styled("div")(o || (o = r(["\n    border-top: 1px solid;\n    transition: background-color 0.2s, padding-bottom 0.2s;\n    padding-bottom: ", ";\n\n    ", ";\n\n    &:last-of-type {\n        border-bottom-width: 1px;\n        border-bottom-style: solid;\n    }\n\n    ", "\n"], ["\n    border-top: 1px solid;\n    transition: background-color 0.2s, padding-bottom 0.2s;\n    padding-bottom: ", ";\n\n    ", ";\n\n    &:last-of-type {\n        border-bottom-width: 1px;\n        border-bottom-style: solid;\n    }\n\n    ", "\n"])), function (e) {
      return e.isExpanded || !e.showExpandToggle ? "8px" : 0;
    }, function (e) {
      return e.theme.FilterList.ItemContainer;
    }, function (e) {
      return e.showExpandToggle && e.isExpanded && e.theme.FilterList.ItemContainerExpanded;
    }), t.Header = p.styled("label")(i || (i = r(["\n    padding: 8px 16px;\n    flex-grow: 1;\n    display: flex;\n    align-items: center;\n    cursor: ", ";\n"], ["\n    padding: 8px 16px;\n    flex-grow: 1;\n    display: flex;\n    align-items: center;\n    cursor: ", ";\n"])), function (e) {
      return e.showExpandToggle ? "pointer" : "default";
    }), t.InnerHeader = p.styled("div")(a || (a = r(["\n    flex-grow: 1;\n"], ["\n    flex-grow: 1;\n"]))), t.Title = p.styled("div")(l || (l = r(["\n    font-size: 10px;\n    font-weight: normal;\n    margin: 0;\n"], ["\n    font-size: 10px;\n    font-weight: normal;\n    margin: 0;\n"]))), t.Label = p.styled("div")(s || (s = r(["\n    font-size: 12px;\n    font-weight: bold;\n    margin: 0;\n"], ["\n    font-size: 12px;\n    font-weight: bold;\n    margin: 0;\n"]))), t.ExpandIconButton = p.styled(d.IconButton)(c || (c = r([""], [""]))), t.FieldContainer = p.styled("div")(u || (u = r(["\n    max-height: 220px;\n    display: ", ";\n    overflow: auto;\n"], ["\n    max-height: 220px;\n    display: ", ";\n    overflow: auto;\n"])), function (e) {
      return e.isExpanded || !e.showExpandToggle ? "block" : "none";
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = t.StyledSelect = void 0;
    var o,
      i,
      a = n(1),
      l = n(81),
      s = n(15);
    t.StyledSelect = a.styled(l.default)(o || (o = r(['\n    width: 100%;\n\n    [class*="MuiSelect-selectMenu"] {\n        border-color: ', ";\n    }\n"], ['\n    width: 100%;\n\n    [class*="MuiSelect-selectMenu"] {\n        border-color: ', ";\n    }\n"])), function (e) {
      return e.error ? e.theme.colors.errorColor : "";
    }), t.Container = a.styled(s.FieldContainer)(i || (i = r(["\n    select {\n        width: 100%;\n        display: block;\n        clear: both;\n    }\n\n    ", "\n"], ["\n    select {\n        width: 100%;\n        display: block;\n        clear: both;\n    }\n\n    ", "\n"])), function (e) {
      return e.theme.FormComponents.Select;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(391), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(393), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(394), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(396), t);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(398), t), o(n(93), t);
  }, function (e, t, n) {
    "use strict";

    var _r12,
      o = this && this.__extends || (_r12 = function r(e, t) {
        return (_r12 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r12(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var l = e.length - 1; l >= 0; l--) (o = e[l]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ThumbButton = t.ThumbDirections = void 0;
    var a = n(1),
      l = n(0),
      s = n(7),
      c = n(400);
    !function (e) {
      e[e.up = 0] = "up", e[e.down = 1] = "down";
    }(t.ThumbDirections || (t.ThumbDirections = {}));
    var u = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.handleClick = function () {
          t.props.handleClick(t.props.direction);
        }, t;
      }
      return o(t, e), t.prototype.render = function () {
        return l.createElement(c.ThumbButtonContainer, null, l.createElement("div", {
          role: "presentation",
          className: this.props.selected ? "circle-selected" : "circle",
          onClick: this.handleClick
        }, l.createElement(s.Icon, {
          icon: this.props.selected ? this.props.icon + "-bold" : this.props.icon
        })));
      }, t = i([a.withTheme], t);
    }(l.PureComponent);
    t.ThumbButton = u;
  }, function (e, t, n) {
    "use strict";

    var _r13,
      o = this && this.__extends || (_r13 = function r(e, t) {
        return (_r13 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r13(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LegendItem = t.LabelPosition = void 0;
    var i,
      a = n(0),
      l = n(403);
    !function (e) {
      e.Start = "start", e.End = "end";
    }(i = t.LabelPosition || (t.LabelPosition = {}));
    var s = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.render = function () {
        var e = this.props,
          t = e.label,
          n = e.color,
          r = e.displayValue,
          o = e.value,
          s = e.showLabel,
          c = e.renderMarker,
          u = s && a.createElement(l.Label, null, t);
        return a.createElement(l.ItemWrapper, {
          className: "Twilio-LegendItem-ItemWrapper"
        }, this.props.labelPosition === i.Start && u, a.createElement(l.ValueWrapper, null, c ? c(this.props) : a.createElement(l.Disc, {
          className: "Twilio-LegendItem-Disk",
          "aria-label": t,
          color: n
        }), a.createElement(l.Value, {
          className: "Twilio-LegendItem-Value"
        }, r || o)), this.props.labelPosition === i.End && u);
      }, t.defaultProps = {
        showLabel: !0,
        labelPosition: i.End
      }, t;
    }(a.PureComponent);
    t.LegendItem = s;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledUl = void 0;
    var o,
      i = n(1);
    t.StyledUl = i.styled("ul")(o || (o = r(["\n    margin: 0;\n    padding: 0;\n    list-style: none;\n\n    li {\n        display: flex;\n    }\n\n    ", "\n    ", "\n"], ["\n    margin: 0;\n    padding: 0;\n    list-style: none;\n\n    li {\n        display: flex;\n    }\n\n    ", "\n    ", "\n"])), function (e) {
      return e.theme.Menu.Items;
    }, function (e) {
      return e.styleOverride && e.styleOverride.Items;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ModalPopupProps = t.ModalPopup = void 0;
    var r = n(409);
    Object.defineProperty(t, "ModalPopup", {
      enumerable: !0,
      get: function get() {
        return r.ModalPopup;
      }
    }), Object.defineProperty(t, "ModalPopupProps", {
      enumerable: !0,
      get: function get() {
        return r.ModalPopupProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NotificationBarItemProps = t.NotificationBarItem = void 0;
    var r = n(415);
    Object.defineProperty(t, "NotificationBarItem", {
      enumerable: !0,
      get: function get() {
        return r.NotificationBarItem;
      }
    }), Object.defineProperty(t, "NotificationBarItemProps", {
      enumerable: !0,
      get: function get() {
        return r.NotificationBarItemProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ActionItemContainer = t.ActionsContainer = t.MessageContainer = t.BottomBorder = t.NotificationContainer = t.NotificationBarContainer = void 0;
    var o,
      i,
      a,
      l,
      s,
      c,
      u = n(13),
      p = n(1);
    t.NotificationBarContainer = p.styled("div")(o || (o = r(["\n    display: flex;\n    position: absolute;\n    width: 100%;\n    z-index: 3;\n    overflow: hidden;\n    flex-direction: column;\n"], ["\n    display: flex;\n    position: absolute;\n    width: 100%;\n    z-index: 3;\n    overflow: hidden;\n    flex-direction: column;\n"]))), t.NotificationContainer = p.styled("div")(i || (i = r(["\n    display: flex;\n    min-height: 24px;\n    flex: 1 1 auto;\n    position: relative;\n    align-items: center;\n    padding-left: 4px;\n    padding-right: 4px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    background-color: ", ";\n"], ["\n    display: flex;\n    min-height: 24px;\n    flex: 1 1 auto;\n    position: relative;\n    align-items: center;\n    padding-left: 4px;\n    padding-right: 4px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    background-color: ", ";\n"])), function (e) {
      if (e.backgroundColor) return e.backgroundColor;
      switch (e.type) {
        case u.NotificationType.success:
          return e.theme.colors.notificationBackgroundColorSuccess;
        case u.NotificationType.warning:
          return e.theme.colors.notificationBackgroundColorWarning;
        case u.NotificationType.error:
          return e.theme.colors.notificationBackgroundColorError;
        default:
          return e.theme.colors.notificationBackgroundColorInformation;
      }
    }), t.BottomBorder = p.styled("div")(a || (a = r(["\n    position: absolute;\n    height: 1px;\n    width: 100%;\n    left: 0px;\n    background: ", ";\n    bottom: 0px;\n"], ["\n    position: absolute;\n    height: 1px;\n    width: 100%;\n    left: 0px;\n    background: ", ";\n    bottom: 0px;\n"])), function (e) {
      return e.theme.colors.buttonHoverColor;
    }), t.MessageContainer = p.styled("div")(l || (l = r(["\n    margin-left: 4px;\n    margin-right: 4px;\n    flex-grow: 2;\n    align-self: center;\n    font-size: 12px;\n"], ["\n    margin-left: 4px;\n    margin-right: 4px;\n    flex-grow: 2;\n    align-self: center;\n    font-size: 12px;\n"]))), t.ActionsContainer = p.styled("div")(s || (s = r(["\n    display: flex;\n    margin-right: ", ";\n    & > .Twilio-NotificationBar-ActionItemContainer:last-child {\n        &:after {\n            ", ";\n        }\n        padding-right: ", ";\n    }\n"], ["\n    display: flex;\n    margin-right: ", ";\n    & > .Twilio-NotificationBar-ActionItemContainer:last-child {\n        &:after {\n            ", ";\n        }\n        padding-right: ", ";\n    }\n"])), function (e) {
      return e.closeButton ? "8px" : "12px";
    }, function (e) {
      return e.closeButton && 'content: ""';
    }, function (e) {
      return !e.closeButton && 0;
    }), t.ActionItemContainer = p.styled("div")(c || (c = r(['\n    display: flex;\n    align-items: center;\n    padding: 0 12px;\n    position: relative;\n    &:before,\n    &:after {\n        height: 16px;\n        width: 1px;\n        position: absolute;\n        left: 0;\n        /* Hard coded the color here as we don\'t have notification theme object.\n        Will need to update it once we have it. */\n        background: #000;\n        opacity: 0.2;\n    }\n    &:after {\n        left: auto;\n        right: 0;\n    }\n    & + &:before {\n        content: "";\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    padding: 0 12px;\n    position: relative;\n    &:before,\n    &:after {\n        height: 16px;\n        width: 1px;\n        position: absolute;\n        left: 0;\n        /* Hard coded the color here as we don\'t have notification theme object.\n        Will need to update it once we have it. */\n        background: #000;\n        opacity: 0.2;\n    }\n    &:after {\n        left: auto;\n        right: 0;\n    }\n    & + &:before {\n        content: "";\n    }\n'])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NotificationBarActionProps = t.NotificationBarAction = void 0;
    var r = n(422);
    Object.defineProperty(t, "NotificationBarAction", {
      enumerable: !0,
      get: function get() {
        return r.NotificationBarAction;
      }
    });
    var o = n(423);
    Object.defineProperty(t, "NotificationBarActionProps", {
      enumerable: !0,
      get: function get() {
        return o.NotificationBarActionProps;
      }
    });
  }, function (e, t) {
    e.exports = require("uuid");
  }, function (e, t, n) {
    "use strict";

    var _r14,
      o = this && this.__extends || (_r14 = function r(e, t) {
        return (_r14 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r14(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InAppNotificationHandler = t.InAppNotificationHandlerImpl = void 0;
    var i = n(13),
      a = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.id = i.DefaultNotificationHandlerType.InApp, t.activeNotifications = [], t;
        }
        return o(t, e), t.prototype.canHandleNotification = function (e) {
          var t = !e.isApplicable || e.isApplicable(e);
          return !!e.content && t;
        }, t.prototype.handleNotification = function (e) {
          this.activeNotifications.push(e), this.notifyChanged();
        }, t.prototype.dismissNotification = function (e) {
          this.activeNotifications = this.activeNotifications.filter(function (t) {
            return t !== e;
          }), this.notifyChanged();
        }, t.prototype.getActiveNotifications = function () {
          return this.activeNotifications;
        }, t.prototype.notifyChanged = function () {
          t.onChange && t.onChange();
        }, t;
      }(n(102).BaseNotificationHandler);
    t.InAppNotificationHandlerImpl = a, t.InAppNotificationHandler = new a(), i.Notifications.registerHandler(t.InAppNotificationHandler);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__spreadArrays || function () {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
      var r = Array(e),
        o = 0;
      for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, l = i.length; a < l; a++, o++) r[o] = i[a];
      return r;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.BaseNotificationHandler = void 0;
    var o = n(13),
      i = n(2),
      a = n(8),
      l = n(14),
      s = function () {
        function e() {
          var e = this;
          this.handledNotifications = new Set(), this._enabled = !0, this._filters = [], this.handleNotificationAdded = function (t) {
            e.shouldProcess(t) && (e.handledNotifications.add(t), e.handleNotification(t));
          }, this.handleNotificationDismissed = function (t) {
            e.handledNotifications.has(t) && (e.handledNotifications.delete(t), e.dismissNotification(t));
          }, o.Notifications.addListener(o.NotificationEvent.notificationAdded, this.handleNotificationAdded), o.Notifications.addListener(o.NotificationEvent.notificationDismissed, this.handleNotificationDismissed);
        }
        return Object.defineProperty(e.prototype, "enabled", {
          get: function get() {
            return this._enabled;
          },
          set: function set(e) {
            i.log.debug("Notification handler " + this.id + " enabled=" + e), this._enabled = e;
          },
          enumerable: !1,
          configurable: !0
        }), e.prototype.getFilters = function () {
          return r(this._filters);
        }, e.prototype.clearFilters = function () {
          i.log.debug("Notification handler " + this.id + " clearFilters"), this._filters = [];
        }, e.prototype.addFilter = function (e) {
          var t = this;
          if ("function" != typeof e) throw a.ErrorManager.createAndProcessError(l.ErrorMessages.NOTIFICATION_INVALID_FILTER, {
            context: "NotificationsFramework"
          });
          return i.log.debug("Adding new filter to " + this.id), this._filters.push(e), function () {
            t._filters = t._filters.filter(function (t) {
              return t !== e;
            });
          };
        }, e.prototype.isFiltered = function (e) {
          return this._filters.length > 0 && this._filters.some(function (t) {
            return !t(e);
          });
        }, e.prototype.shouldProcess = function (e) {
          return !!this.enabled && !!this.canHandleNotification(e) && !this.isFiltered(e);
        }, e;
      }();
    t.BaseNotificationHandler = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Strings = t.languages = void 0;
    var r = n(443),
      o = n(444);
    Object.defineProperty(t, "Strings", {
      enumerable: !0,
      get: function get() {
        return o.Strings;
      }
    });
    var i = {
      default: r.default
    };
    t.languages = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ErrorCode = void 0, function (e) {
      e[e.NotAllowed = 0] = "NotAllowed", e[e.InvalidMedia = 1] = "InvalidMedia", e[e.Other = 2] = "Other";
    }(t.ErrorCode || (t.ErrorCode = {}));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TelemetryBridgeMessageType = t.TelemetryBridge = t.ErrorManager = t.ChatManager = t.CountryManager = t.FrameConstants = t.ChatStateCallback = t.ChatModule = void 0, o(n(30), t);
    var i = n(5);
    Object.defineProperty(t, "ChatModule", {
      enumerable: !0,
      get: function get() {
        return i.ChatModule;
      }
    }), Object.defineProperty(t, "ChatStateCallback", {
      enumerable: !0,
      get: function get() {
        return i.ChatStateCallback;
      }
    }), o(n(108), t), o(n(9), t), o(n(111), t), o(n(112), t), o(n(113), t), o(n(10), t), o(n(11), t), o(n(22), t), o(n(36), t), o(n(114), t), o(n(279), t), o(n(13), t), o(n(54), t), o(n(28), t), o(n(31), t);
    var a = n(32);
    t.FrameConstants = a, o(n(37), t), o(n(283), t), o(n(103), t), o(n(445), t), o(n(448), t), o(n(453), t);
    var l = n(454);
    o(n(455), t);
    var s = n(45);
    Object.defineProperty(t, "CountryManager", {
      enumerable: !0,
      get: function get() {
        return s.CountryManager;
      }
    });
    var c = n(57);
    Object.defineProperty(t, "ChatManager", {
      enumerable: !0,
      get: function get() {
        return c.ChatManager;
      }
    }), o(n(460), t);
    var u = n(8);
    Object.defineProperty(t, "ErrorManager", {
      enumerable: !0,
      get: function get() {
        return u.ErrorManager;
      }
    }), o(n(19), t), n(464);
    var p = n(25);
    Object.defineProperty(t, "TelemetryBridge", {
      enumerable: !0,
      get: function get() {
        return p.TelemetryBridge;
      }
    }), Object.defineProperty(t, "TelemetryBridgeMessageType", {
      enumerable: !0,
      get: function get() {
        return p.TelemetryBridgeMessageType;
      }
    });
    var d = n(466);
    l.ChatActions.registerActions(), d.registerNotifications();
  }, function (e, t) {
    e.exports = require("react-redux");
  }, function (e, t) {
    e.exports = require("loglevel");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.chatReducer = void 0;
    var r = n(109),
      o = n(47),
      i = n(26),
      a = n(48),
      l = n(34),
      s = n(49),
      c = r.combineReducers({
        channels: o.reduce,
        session: i.reduce,
        users: a.reduce,
        channelInput: l.reduce,
        messageList: s.reduce
      });
    t.chatReducer = c;
  }, function (e, t) {
    e.exports = require("redux");
  }, function (e, t, n) {
    "use strict";

    var _r15,
      o = this && this.__extends || (_r15 = function r(e, t) {
        return (_r15 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r15(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FlexBoxColumn = void 0;
    var l = n(0),
      s = n(50),
      c = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.children,
            n = a(e, ["children"]),
            r = i(i({}, n), {
              vertical: !0
            });
          return l.createElement(s.FlexBox, i({}, r), t);
        }, t;
      }(l.PureComponent);
    t.FlexBoxColumn = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.resetCSS = t.registerGlobalStyles = t.registerStyles = void 0;
    var o,
      i = n(12);
    function a() {
      var e, t;
      e = "https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700", (t = document.createElement("link")).rel = "stylesheet", t.href = e, document.head.appendChild(t), i.injectGlobal(o || (o = r(['\n        .Twilio-CommonStyles,\n        .Twilio-RootContainer {\n            font-family: "Open Sans";\n            font-size: 12px;\n            -webkit-font-smoothing: antialiased;\n            -moz-osx-font-smoothing: grayscale;\n            line-height: normal;\n        }\n\n        .Twilio-Template-Icon {\n            vertical-align: middle;\n        }\n\n        [class^="Twilio"] {\n            a&, a:active&, a:hover&, a:link&, a:visited& {\n                color: inherit;\n            }\n\n            button&,\n            & > button:not([class]),\n            & > button[class=""] {\n                font-family: inherit;\n            }\n\n            button:enabled&,\n            & > button:enabled:not([class]),\n            & > button:enabled[class=""] {\n                cursor: pointer;\n            }\n\n            h1&,\n            & > h1:not([class]),\n            & > h1[class=""] {\n                font-size: 12px;\n                margin-top: 6px;\n                margin-bottom: 6px;\n                font-weight: bold;\n                line-height: 1.67;\n                text-transform: uppercase;\n            }\n\n            h2&,\n            & > h2:not([class]),\n            & > h2[class=""] {\n                font-size: 10px;\n                font-weight: bold;\n                line-height: 1.6;\n                margin-top: 6px;\n                margin-bottom: 0px;\n            }\n\n            h6&,\n            & > h6:not([class]),\n            & > h6[class=""] {\n                font-size: 18px;\n                font-weight: normal;\n                margin: 0px;\n            }\n\n            hr&,\n            & > hr:not([class]),\n            & > hr[class=""] {\n                margin-top: 6px;\n                margin-bottom: 6px;\n                border-width: 1px 0px 0px 0px;\n                border-style: solid;\n            }\n\n            p&,\n            & > p:not([class]),\n            & > p[class=""] {\n                font-size: 12px;\n                margin: 0px;\n                padding-bottom: 6px;\n            }\n        }\n    '], ['\n        .Twilio-CommonStyles,\n        .Twilio-RootContainer {\n            font-family: "Open Sans";\n            font-size: 12px;\n            -webkit-font-smoothing: antialiased;\n            -moz-osx-font-smoothing: grayscale;\n            line-height: normal;\n        }\n\n        .Twilio-Template-Icon {\n            vertical-align: middle;\n        }\n\n        [class^="Twilio"] {\n            a&, a:active&, a:hover&, a:link&, a:visited& {\n                color: inherit;\n            }\n\n            button&,\n            & > button:not([class]),\n            & > button[class=""] {\n                font-family: inherit;\n            }\n\n            button:enabled&,\n            & > button:enabled:not([class]),\n            & > button:enabled[class=""] {\n                cursor: pointer;\n            }\n\n            h1&,\n            & > h1:not([class]),\n            & > h1[class=""] {\n                font-size: 12px;\n                margin-top: 6px;\n                margin-bottom: 6px;\n                font-weight: bold;\n                line-height: 1.67;\n                text-transform: uppercase;\n            }\n\n            h2&,\n            & > h2:not([class]),\n            & > h2[class=""] {\n                font-size: 10px;\n                font-weight: bold;\n                line-height: 1.6;\n                margin-top: 6px;\n                margin-bottom: 0px;\n            }\n\n            h6&,\n            & > h6:not([class]),\n            & > h6[class=""] {\n                font-size: 18px;\n                font-weight: normal;\n                margin: 0px;\n            }\n\n            hr&,\n            & > hr:not([class]),\n            & > hr[class=""] {\n                margin-top: 6px;\n                margin-bottom: 6px;\n                border-width: 1px 0px 0px 0px;\n                border-style: solid;\n            }\n\n            p&,\n            & > p:not([class]),\n            & > p[class=""] {\n                font-size: 12px;\n                margin: 0px;\n                padding-bottom: 6px;\n            }\n        }\n    '])));
    }
    t.registerStyles = a, t.registerGlobalStyles = a, t.resetCSS = function () {
      var e = document.createElement("style");
      e.type = "text/css", e.appendChild(document.createTextNode("\n        /* http://meyerweb.com/eric/tools/css/reset/\n        v2.0 | 20110126\n        License: none (public domain)\n        */\n        html, body, div, span, applet, object, iframe,\n        h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n        a, abbr, acronym, address, big, cite, code,\n        del, dfn, em, img, ins, kbd, q, s, samp,\n        small, strike, strong, sub, sup, tt, var,\n        b, u, i, center,\n        dl, dt, dd, ol, ul, li,\n        fieldset, form, label, legend,\n        table, caption, tbody, tfoot, thead, tr, th, td,\n        article, aside, canvas, details, embed,\n        figure, figcaption, footer, header, hgroup,\n        menu, nav, output, ruby, section, summary,\n        time, mark, audio, video {\n            margin: 0;\n            padding: 0;\n            border: 0;\n            font-size: 100%;\n            font: inherit;\n            vertical-align: baseline;\n        }\n        /* HTML5 display-role reset for older browsers */\n        article, aside, details, figcaption, figure,\n        footer, header, hgroup, menu, nav, section {\n            display: block;\n        }\n        body {\n            line-height: normal;\n        }\n        ol, ul {\n            list-style: none;\n        }\n        blockquote, q {\n            quotes: none;\n        }\n        blockquote:before, blockquote:after,\n        q:before, q:after {\n            content: '';\n            content: none;\n        }\n        table {\n            border-collapse: collapse;\n            border-spacing: 0;\n        }\n    "));
      var t = document.querySelector("link[rel='stylesheet'], style, title");
      t && t.parentNode === document.head ? document.head.insertBefore(e, t) : document.head.appendChild(e);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StateMachine = void 0;
    var r = n(2),
      o = function () {
        function e(e) {
          this._handlers = {
            enter: {},
            leave: {},
            change: []
          }, this._name = e;
        }
        return Object.defineProperty(e.prototype, "state", {
          get: function get() {
            return this._state;
          },
          enumerable: !1,
          configurable: !0
        }), e.prototype.onChange = function (e) {
          var t = this;
          return this._handlers.change.push(e), function () {
            t._handlers.change = t._handlers.change.filter(function (t) {
              return t !== e;
            });
          };
        }, e.prototype.onEnter = function (e, t) {
          var n = this,
            r = e.toString();
          return this._handlers.enter[r] || (this._handlers.enter[r] = []), this._handlers.enter[r].push(t), function () {
            n._handlers.enter[r] = n._handlers.enter[r].filter(function (e) {
              return e !== t;
            });
          };
        }, e.prototype.onLeave = function (e, t) {
          var n = this,
            r = e.toString();
          return this._handlers.leave[r] || (this._handlers.leave[r] = []), this._handlers.leave[r].push(t), function () {
            n._handlers.leave[r] = n._handlers.leave[r].filter(function (e) {
              return e !== t;
            });
          };
        }, e.prototype.transitionTo = function (e) {
          r.log.debug("StateMachine", this._name, "transitionTo:", e);
          var t = this._state;
          if (void 0 !== t) {
            var n = this._handlers.leave[t.toString()];
            n && n.forEach(function (n) {
              return n(e, t);
            });
          }
          this._state = e, this._handlers.change.forEach(function (n) {
            return n(e, t);
          });
          var o = this._handlers.enter[e.toString()];
          o && o.forEach(function (n) {
            return n(e, t);
          });
        }, e;
      }();
    t.StateMachine = o;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              s(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            try {
              s(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, l);
          }
          s((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: l(0),
          throw: l(1),
          return: l(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function l(i) {
          return function (l) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, l]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.initialize = void 0;
    var i = n(115),
      a = n(27);
    t.initialize = function () {
      return r(this, void 0, Promise, function () {
        return o(this, function (e) {
          return function () {
            if (void 0 !== window.Handlebars) return;
            window.Handlebars = i;
          }(), i.registerHelper("unsafeString", function (e) {
            return e;
          }), i.registerHelper("icon", function (e) {
            if (!e || !e.hash || !e.hash.name) return "";
            var t = "Icn" + e.hash.name,
              n = a[t];
            return n && n._raw ? n._raw.replace("<svg", '<svg class="Twilio-Template-Icon Twilio-Icon-' + e.hash.name + '"') : "";
          }), [2, Promise.resolve()];
        });
      });
    };
  }, function (e, t) {
    e.exports = require("handlebars");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M10.081 14.568l5.898-6.38a.576.576 0 01.845 0 .671.671 0 010 .912l-6.009 6.485a1 1 0 01-1.467 0l-2.172-2.343a.672.672 0 01-.004-.91.567.567 0 01.835-.003l2.074 2.239z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M9.852 15.21l7.372-7.975a.72.72 0 011.056 0 .84.84 0 010 1.14l-7.695 8.305a1 1 0 01-1.467 0L6.22 13.552a.84.84 0 01-.005-1.136.709.709 0 011.044-.005l2.593 2.798z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M16.51 12.573h-3.937v3.937a.573.573 0 11-1.147 0v-3.937H7.49a.573.573 0 110-1.147h3.937V7.49a.573.573 0 011.147 0v3.937h3.936a.573.573 0 010 1.147z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M4.344 8.719a.452.452 0 01-.196-.188.534.534 0 01-.07-.265c0-.094.026-.18.078-.258a.52.52 0 01.203-.18l7.5-3.766A.45.45 0 0112.086 4a.45.45 0 01.226.063l7.422 3.765a.465.465 0 01.196.18c.047.078.07.164.07.258a.534.534 0 01-.25.453l-7.516 4.047a.25.25 0 01-.109.039 1.007 1.007 0 01-.125.008.425.425 0 01-.117-.016 3.65 3.65 0 00-.117-.031L4.344 8.719zm7.734-3.656L5.656 8.296 12 11.75l6.422-3.453-6.344-3.235zm7.563 6.437a.501.501 0 01.203.188.468.468 0 01.078.25.534.534 0 01-.07.265.452.452 0 01-.196.188l-7.5 4.046a.686.686 0 01-.117.047.514.514 0 01-.367-.047L4.25 12.392a.534.534 0 01-.25-.453c0-.094.023-.18.07-.258a.465.465 0 01.196-.18l1.578-.781 1.062.578-1.328.672 6.344 3.453 6.422-3.453-1.25-.64 1.062-.579 1.485.75zm0 3.5a.501.501 0 01.203.188.468.468 0 01.078.25.534.534 0 01-.07.265.452.452 0 01-.196.188l-7.5 4.046a.686.686 0 01-.117.047.514.514 0 01-.367-.047L4.25 15.892a.534.534 0 01-.25-.453c0-.094.023-.18.07-.258a.465.465 0 01.196-.18l1.484-.672 1.063.578-1.235.563 6.344 3.453 6.422-3.453-1.172-.578 1.062-.579 1.407.688z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M4.344 8.719a.452.452 0 01-.196-.188.534.534 0 01-.07-.265c0-.094.026-.18.078-.258a.52.52 0 01.203-.18l7.5-3.766A.45.45 0 0112.086 4a.45.45 0 01.226.063l7.422 3.765a.465.465 0 01.196.18c.047.078.07.164.07.258a.534.534 0 01-.25.453l-7.516 4.047a.25.25 0 01-.109.039 1.007 1.007 0 01-.125.008.425.425 0 01-.117-.016 3.65 3.65 0 00-.117-.031L4.344 8.719zM19.64 11.5a.501.501 0 01.203.188.468.468 0 01.078.25.534.534 0 01-.07.265.452.452 0 01-.196.188l-7.5 4.046a.686.686 0 01-.117.047.514.514 0 01-.367-.047L4.25 12.392a.534.534 0 01-.25-.453c0-.094.023-.18.07-.258a.465.465 0 01.196-.18l1.578-.781 5.43 3.002c.301.149.517.227.648.235.13.008.31-.047.54-.164l4.632-2.464 1.062-.578 1.485.75zm0 3.5a.501.501 0 01.203.188.468.468 0 01.078.25.534.534 0 01-.07.265.452.452 0 01-.196.188l-7.5 4.046a.686.686 0 01-.117.047.514.514 0 01-.367-.047L4.25 15.892a.534.534 0 01-.25-.453c0-.094.023-.18.07-.258a.465.465 0 01.196-.18l1.484-.672 5.67 3.188c.175.105.342.158.502.16.16.003.32-.045.483-.145l5.83-3.218L19.64 15z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M4.344 8.719a.452.452 0 01-.196-.188.534.534 0 01-.07-.265c0-.094.026-.18.078-.258a.52.52 0 01.203-.18l7.5-3.766A.45.45 0 0112.086 4a.45.45 0 01.226.063l7.422 3.765a.465.465 0 01.196.18c.047.078.07.164.07.258a.534.534 0 01-.25.453l-7.516 4.047a.25.25 0 01-.109.039 1.007 1.007 0 01-.125.008.425.425 0 01-.117-.016 3.65 3.65 0 00-.117-.031L4.344 8.719zm7.734-3.656L5.656 8.296 12 11.75l6.422-3.453-6.344-3.235zm7.563 6.437a.501.501 0 01.203.188.468.468 0 01.078.25.534.534 0 01-.07.265.452.452 0 01-.196.188l-7.5 4.046a.686.686 0 01-.117.047.514.514 0 01-.367-.047L4.25 12.392a.534.534 0 01-.25-.453c0-.094.023-.18.07-.258a.465.465 0 01.196-.18l1.578-.781 1.062.578-1.328.672 6.344 3.453 6.422-3.453-1.25-.64 1.062-.579 1.485.75zm0 3.5a.501.501 0 01.203.188.468.468 0 01.078.25.534.534 0 01-.07.265.452.452 0 01-.196.188l-7.5 4.046a.686.686 0 01-.117.047.514.514 0 01-.367-.047L4.25 15.892a.534.534 0 01-.25-.453c0-.094.023-.18.07-.258a.465.465 0 01.196-.18l1.484-.672 1.063.578-1.235.563 6.344 3.453 6.422-3.453-1.172-.578 1.062-.579 1.407.688z",
        fill: "currentColor"
      }), o.createElement("circle", {
        stroke: "currentColor",
        fill: "#EA1010",
        cx: 19,
        cy: 5,
        r: 4.5
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M4.344 8.719a.452.452 0 01-.196-.188.534.534 0 01-.07-.265c0-.094.026-.18.078-.258a.52.52 0 01.203-.18l7.5-3.766A.45.45 0 0112.086 4a.45.45 0 01.226.063l7.422 3.765a.465.465 0 01.196.18c.047.078.07.164.07.258a.534.534 0 01-.25.453l-7.516 4.047a.25.25 0 01-.109.039 1.007 1.007 0 01-.125.008.425.425 0 01-.117-.016 3.65 3.65 0 00-.117-.031L4.344 8.719zM19.64 11.5a.501.501 0 01.203.188.468.468 0 01.078.25.534.534 0 01-.07.265.452.452 0 01-.196.188l-7.5 4.046a.686.686 0 01-.117.047.514.514 0 01-.367-.047L4.25 12.392a.534.534 0 01-.25-.453c0-.094.023-.18.07-.258a.465.465 0 01.196-.18l1.578-.781 5.43 3.002c.301.149.517.227.648.235.13.008.31-.047.54-.164l4.632-2.464 1.062-.578 1.485.75zm0 3.5a.501.501 0 01.203.188.468.468 0 01.078.25.534.534 0 01-.07.265.452.452 0 01-.196.188l-7.5 4.046a.686.686 0 01-.117.047.514.514 0 01-.367-.047L4.25 15.892a.534.534 0 01-.25-.453c0-.094.023-.18.07-.258a.465.465 0 01.196-.18l1.484-.672 5.67 3.188c.175.105.342.158.502.16.16.003.32-.045.483-.145l5.83-3.218L19.64 15z",
        fill: "currentColor"
      }), o.createElement("circle", {
        stroke: "currentColor",
        fill: "#EA1010",
        cx: 19,
        cy: 5,
        r: 4.5
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M15.656 17.05l.422.234c.281.156.422.359.422.609v1.264c0 .24-.083.44-.25.601a.825.825 0 01-.594.242H4.844a.825.825 0 01-.594-.242.803.803 0 01-.25-.6v-1.265c0-.23.14-.427.422-.593l.422-.25L8.078 15.3c-.594-.468-1.005-1.092-1.234-1.873-.23-.78-.344-1.4-.344-1.857V9.463c0-.353.11-.705.328-1.053.219-.349.505-.664.86-.945a4.66 4.66 0 011.21-.686 3.734 3.734 0 011.368-.266c.468 0 .927.089 1.375.266.448.176.846.405 1.195.686.349.281.63.596.844.945.213.348.32.7.32 1.053v2.108c0 .51-.102 1.144-.305 1.904s-.596 1.374-1.18 1.842l3.141 1.733zM15.5 19v-.89a.417.417 0 00-.11-.078l-.124-.062a.076.076 0 01-.04-.016.51.51 0 00-.054-.031l-3.14-1.733a1.056 1.056 0 01-.36-.335.92.92 0 01-.156-.46.911.911 0 01.07-.485.973.973 0 01.305-.39c.427-.333.718-.81.875-1.428.156-.62.234-1.127.234-1.522V9.463c0-.364-.273-.78-.82-1.248a2.852 2.852 0 00-1.914-.703c-.709 0-1.347.234-1.914.703-.568.468-.852.884-.852 1.248v2.108c0 .395.094.902.281 1.522.188.619.495 1.095.922 1.428.125.104.221.234.29.39a.911.911 0 01.07.484.92.92 0 01-.157.46.922.922 0 01-.36.32L5.314 17.94a.07.07 0 00-.032.007.122.122 0 00-.031.024.433.433 0 00-.133.062L5 18.111v.89h10.5zm3.656-4.433l.422.234c.281.156.422.359.422.609v1.249c0 .239-.083.44-.25.6a.825.825 0 01-.594.242H17.5a5.72 5.72 0 00-.195-.577 1.015 1.015 0 00-.32-.422H19v-.89a4.483 4.483 0 00-.11-.07.436.436 0 00-.124-.054.098.098 0 00-.04-.024.429.429 0 01-.054-.023l-3.188-1.733a1.056 1.056 0 01-.359-.335.92.92 0 01-.156-.46.911.911 0 01.07-.485.973.973 0 01.305-.39c.427-.343.726-.825.898-1.444.172-.62.258-1.121.258-1.506V6.98c0-.374-.281-.796-.844-1.264a2.941 2.941 0 00-1.937-.702 3.181 3.181 0 00-1.906.64 2.457 2.457 0 00-.626-.11 270.4 270.4 0 01-.64-.03 4.506 4.506 0 011.406-1.078A3.852 3.852 0 0113.72 4c.469 0 .93.091 1.383.273.453.182.856.414 1.21.695.355.28.641.598.86.952.219.354.328.708.328 1.061V9.09c0 .5-.11 1.131-.328 1.896-.219.765-.62 1.377-1.203 1.835l3.187 1.748z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M15.656 17.05l.422.234c.281.156.422.359.422.609v1.264c0 .24-.083.44-.25.601a.825.825 0 01-.594.242H4.844a.825.825 0 01-.594-.242.803.803 0 01-.25-.6v-1.265c0-.23.14-.427.422-.593l.422-.25L8.078 15.3c-.594-.468-1.005-1.092-1.234-1.873-.23-.78-.344-1.4-.344-1.857V9.463c0-.353.11-.705.328-1.053.219-.349.505-.664.86-.945a4.66 4.66 0 011.21-.686 3.734 3.734 0 011.368-.266c.468 0 .927.089 1.375.266.448.176.846.405 1.195.686.349.281.63.596.844.945.213.348.32.7.32 1.053v2.108c0 .51-.102 1.144-.305 1.904s-.596 1.374-1.18 1.842l3.141 1.733zm3.5-2.482l.422.234c.281.156.422.359.422.609v1.249c0 .239-.083.44-.25.6a.825.825 0 01-.594.242H17.5a5.72 5.72 0 00-.195-.577 1.015 1.015 0 00-.32-.422c-1.337-.622-2.26-1.1-2.768-1.434 1.136-1.12.913-3.81.942-5.089.023-1.054-.265-2.137-1.1-2.999-1.41-1.456-3.304-1.456-3.512-1.467a4.506 4.506 0 011.406-1.077A3.852 3.852 0 0113.72 4c.469 0 .93.091 1.383.273.453.182.856.414 1.21.695.355.28.641.598.86.952.219.354.328.708.328 1.061V9.09c0 .5-.11 1.131-.328 1.896-.219.765-.62 1.377-1.203 1.835l3.187 1.748z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.557 15.067a4.5 4.5 0 014.5 4.5.5.5 0 11-1 0 3.5 3.5 0 00-3.5-3.5H8.51a3.5 3.5 0 00-3.5 3.5.5.5 0 11-1 0 4.5 4.5 0 014.5-4.5zM12 3a5 5 0 110 10 5 5 0 010-10zm0 1a4 4 0 100 8 4 4 0 000-8z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.007 15.213a4 4 0 014 4V20H3.978v-.787a4 4 0 014-4h8.029zM12 3a5 5 0 110 10 5 5 0 010-10z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M12 4c1.462 0 2.814.365 4.058 1.096a7.582 7.582 0 012.846 2.846A7.868 7.868 0 0120 12a7.868 7.868 0 01-1.096 4.058 7.582 7.582 0 01-2.846 2.846A7.868 7.868 0 0112 20a7.868 7.868 0 01-4.058-1.096 7.726 7.726 0 01-2.846-2.866A7.833 7.833 0 014 12c0-1.449.365-2.795 1.096-4.038a7.873 7.873 0 012.866-2.866A7.833 7.833 0 0112 4zm0 13a1 1 0 100-2 1 1 0 000 2zm0-10a1 1 0 00-1 1v5a1 1 0 002 0V8a1 1 0 00-1-1z",
        fill: "currentcolor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M12.446 4.07a1 1 0 01.448.45l6.992 14.034A1 1 0 0118.991 20H4.996a1 1 0 01-.894-1.446l7.002-14.035a1 1 0 011.342-.448zM12 15a1 1 0 100 2 1 1 0 000-2zm0-6a1 1 0 00-1 1v3a1 1 0 002 0v-3a1 1 0 00-1-1z",
        fill: "currentcolor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        stroke: "currentColor",
        d: "M19 4.5h-9a.5.5 0 00-.5.5v1.5H5a.5.5 0 00-.5.5v12a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-1.5H19a.5.5 0 00.5-.5V5a.5.5 0 00-.5-.5z"
      }), o.createElement("path", {
        fill: "currentColor",
        d: "M12 11h2v4h-2zM15 7h2v8h-2z"
      }), o.createElement("path", {
        fill: "currentColor",
        fillRule: "nonzero",
        d: "M10 4h9a1 1 0 011 1v12a1 1 0 01-1 1h-9a1 1 0 01-1-1V5a1 1 0 011-1zm0 13h9V5h-9v12z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        stroke: "currentColor",
        d: "M7.5 6.5H5a.5.5 0 00-.5.5v12a.5.5 0 00.5.5h9a.51.51 0 00.008 0H9.982l-.168-.007A2.5 2.5 0 017.5 17V6.5zm11.5-2h-9a.5.5 0 00-.5.5v12a.5.5 0 00.5.5h9a.5.5 0 00.5-.5V5a.5.5 0 00-.5-.5zm-7.5 6h3v5h-3v-5zm6-4v9h-3v-9h3z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M13.797 15.887c.27.255.27.668 0 .922a.723.723 0 01-.979 0l-4.615-4.35a.626.626 0 010-.923l4.61-4.345a.723.723 0 01.978 0c.27.254.271.667 0 .922l-4.12 3.884 4.126 3.89z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M9.203 8.113a.626.626 0 010-.922.723.723 0 01.979 0l4.615 4.35c.27.255.27.668 0 .923l-4.61 4.345a.723.723 0 01-.978 0 .626.626 0 010-.922l4.12-3.884-4.126-3.89z",
        fill: "currentColor",
        fillRule: "nonzero"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M20.125 10c.237 0 .442.088.615.264.173.176.26.384.26.625v8.222c0 .24-.087.45-.26.625a.833.833 0 01-.615.264H7.875a.833.833 0 01-.615-.264.862.862 0 01-.26-.625V10.89c0-.24.087-.45.26-.625a.833.833 0 01.615-.264h12.25zM20 11H8v8h12v-8zM9 18l2.5-3 1.974 2.368L16 14l3 4H9zm3.043-15c.27 0 .496.096.68.29A.984.984 0 0113 4v5h-1V4H8v4H4v8h2v1H3.957a.898.898 0 01-.68-.29A.977.977 0 013 16V7l4-4zM7 4.5L4.5 7H7V4.5z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        fill: "currentColor",
        fillRule: "nonzero",
        d: "M12.797 15.887c.27.255.27.668 0 .922a.723.723 0 01-.979 0l-4.615-4.35a.626.626 0 010-.923l4.61-4.345a.723.723 0 01.978 0 .625.625 0 010 .922l-4.12 3.884 4.126 3.89z"
      }), o.createElement("path", {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: 1.25,
        d: "M8 12h10"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M12.011 20.011c1.41 0 2.54-.773 2.86-2h3.402c.55 0 .893-.52.683-1.002l-.267-.577a18.124 18.124 0 01-1.677-7.349c0-2.845-2.187-5.083-5-5.083C9.2 4 7.026 6.236 7.026 9.1a18.181 18.181 0 01-1.692 7.33l-.268.576c-.223.454.138 1.005.682 1.005h3.403c.32 1.227 1.45 2 2.86 2zm-5.844-3l.074-.16A19.19 19.19 0 008.027 9.11C8.027 6.782 9.759 5 12.01 5c2.256 0 4 1.785 4 4.09a19.132 19.132 0 001.771 7.762l.074.159h-3.758l-.195.747c-.2.762-.916 1.253-1.892 1.253-.976 0-1.693-.49-1.892-1.253l-.195-.747H6.167z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M12.011 20.011c1.41 0 2.54-.773 2.86-2h3.402c.55 0 .893-.52.683-1.002l-.267-.577a18.124 18.124 0 01-1.677-7.349c0-2.845-2.187-5.083-5-5.083C9.2 4 7.026 6.236 7.026 9.1a18.181 18.181 0 01-1.692 7.33l-.268.576c-.223.454.138 1.005.682 1.005h3.403c.32 1.227 1.45 2 2.86 2z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M12 4c.839 0 1.623.148 2.354.445a6.11 6.11 0 011.904 1.203 5.62 5.62 0 011.275 1.782c.311.682.467 1.409.467 2.18 0 1.093-.227 1.926-.68 2.5a9.269 9.269 0 01-1.41 1.453c-.363.291-.652.544-.868.757a1.05 1.05 0 00-.322.774v.844c0 .01-.003.02-.009.03a.065.065 0 00-.008.032h.017v1.453c0 .76-.25 1.375-.748 1.844-.499.469-1.15.703-1.955.703-.827 0-1.49-.234-1.989-.703-.498-.469-.748-1.083-.748-1.844V16h.017c0-.01-.002-.02-.008-.031a.065.065 0 01-.009-.031v-.844c0-.198-.096-.388-.288-.57a14.88 14.88 0 00-.765-.665c-.488-.406-.98-.924-1.48-1.554C6.25 11.675 6 10.776 6 9.609c0-.77.156-1.497.467-2.18a5.62 5.62 0 011.275-1.78 6.11 6.11 0 011.904-1.204A6.195 6.195 0 0112 4zm-.017 15c.521 0 .926-.135 1.215-.406.29-.271.434-.651.434-1.14v-.688a5.093 5.093 0 01-.697.164A5.55 5.55 0 0112 17a6.19 6.19 0 01-.943-.063 4.52 4.52 0 01-.689-.156v.672c0 .48.142.857.425 1.133.283.276.68.414 1.19.414zm3.212-6.188a7.083 7.083 0 001.199-1.226c.345-.453.518-1.112.518-1.977 0-.635-.124-1.231-.374-1.789a4.62 4.62 0 00-1.037-1.468 4.829 4.829 0 00-1.563-.993C13.338 5.12 12.69 5 12 5c-.691 0-1.337.12-1.938.36-.6.239-1.121.57-1.563.992A4.62 4.62 0 007.462 7.82a4.331 4.331 0 00-.374 1.79c0 .947.195 1.674.586 2.18.391.504.819.95 1.284 1.335.34.281.66.573.96.875.3.302.45.667.45 1.094v.64c.114.063.295.125.544.188.25.062.606.094 1.071.094.453 0 .807-.034 1.062-.102a3.83 3.83 0 00.587-.195v-.625c0-.542.167-.985.501-1.328.334-.344.689-.662 1.062-.954z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M12 4c.839 0 1.623.148 2.354.445a6.11 6.11 0 011.904 1.203 5.62 5.62 0 011.275 1.782c.311.682.467 1.409.467 2.18 0 1.093-.227 1.926-.68 2.5a9.269 9.269 0 01-1.41 1.453c-.363.291-.652.544-.868.757a1.05 1.05 0 00-.322.774v.844c0 .01-.003.02-.009.03a.065.065 0 00-.008.032h.017v1.453c0 .76-.25 1.375-.748 1.844-.499.469-1.15.703-1.955.703-.827 0-1.49-.234-1.989-.703-.498-.469-.748-1.083-.748-1.844V16h.017c0-.01-.002-.02-.008-.031a.065.065 0 01-.009-.031v-.844c0-.198-.096-.388-.288-.57a14.88 14.88 0 00-.765-.665c-.488-.406-.98-.924-1.48-1.554C6.25 11.675 6 10.776 6 9.609c0-.77.156-1.497.467-2.18a5.62 5.62 0 011.275-1.78 6.11 6.11 0 011.904-1.204A6.195 6.195 0 0112 4zm-.017 15c.521 0 .926-.135 1.215-.406.29-.271.434-.651.434-1.14v-.688a5.093 5.093 0 01-.697.164A5.55 5.55 0 0112 17a6.19 6.19 0 01-.943-.063 4.52 4.52 0 01-.689-.156v.672c0 .48.142.857.425 1.133.283.276.68.414 1.19.414z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M6.924 4.57a.29.29 0 00-.116.023.621.621 0 00-.1.054c-.431.308-.84.652-1.225 1.032-.385.38-.608.658-.67.832.02.463.136.969.347 1.518.21.55.51 1.132.901 1.749.39.616.866 1.263 1.425 1.941a32.29 32.29 0 001.903 2.095c.72.72 1.42 1.359 2.103 1.918.683.56 1.333 1.033 1.95 1.418.615.385 1.198.685 1.748.901.55.216 1.055.334 1.517.355.175-.072.452-.3.832-.686.38-.385.724-.794 1.033-1.225a.292.292 0 00.069-.139.817.817 0 00.008-.092 28.76 28.76 0 00-.601-.4c-.298-.196-.617-.406-.956-.632l-1.525-1.017h-.015a.65.65 0 00-.108.015.654.654 0 00-.2.093 27.775 27.775 0 00-1.371.77l-.555.308-.509-.37c-.184-.133-.485-.37-.9-.708a21.965 21.965 0 01-1.565-1.449 28.089 28.089 0 01-1.456-1.571c-.344-.41-.583-.714-.716-.909l-.354-.508.308-.54c.195-.349.362-.644.5-.886.14-.241.229-.403.27-.485a.813.813 0 00.092-.323c-.061-.103-.19-.303-.385-.601a97.481 97.481 0 00-.624-.94 97.48 97.48 0 01-.624-.94 11.001 11.001 0 00-.4-.585c0-.01-.005-.016-.016-.016h-.015zm.01-.96c.165 0 .319.03.463.092a.753.753 0 01.338.277l.378.554c.21.309.436.645.678 1.01.241.364.467.703.678 1.016.21.314.341.511.393.594a.999.999 0 01.123.57c-.01.226-.077.462-.2.708-.072.124-.196.34-.37.648-.175.308-.313.56-.416.754.113.165.331.442.655.832.323.39.788.889 1.394 1.495.616.616 1.12 1.086 1.51 1.41.39.323.667.541.832.654.185-.102.434-.244.747-.423.313-.18.532-.3.655-.362.133-.072.264-.126.393-.162.128-.036.254-.054.377-.054.093 0 .18.013.262.038.082.026.16.06.231.1l.609.393a373.833 373.833 0 012.041 1.348c.308.206.493.334.555.386.205.133.331.352.377.655.046.303-.038.613-.254.932l-.277.362c-.185.241-.411.506-.678.793a7.786 7.786 0 01-.855.794c-.303.241-.573.362-.81.362h-.015c-.677-.02-1.376-.185-2.095-.493a13.117 13.117 0 01-2.126-1.164 19.865 19.865 0 01-2.026-1.556 36.632 36.632 0 01-1.795-1.671 34.26 34.26 0 01-1.664-1.795 20.545 20.545 0 01-1.548-2.026A13.27 13.27 0 014.33 8.562c-.309-.713-.473-1.404-.493-2.072-.01-.246.105-.519.346-.816.242-.298.506-.58.794-.848.287-.267.552-.493.793-.678.241-.185.367-.282.378-.292.123-.083.251-.144.385-.185.133-.041.267-.062.4-.062z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M6.934 3.61c.165 0 .319.03.463.092a.753.753 0 01.338.277l.378.554c.21.309.436.645.678 1.01.241.364.467.703.678 1.016.21.314.341.511.393.594a.999.999 0 01.123.57c-.01.226-.077.462-.2.708-.072.124-.196.34-.37.648-.175.308-.313.56-.416.754.113.165.331.442.655.832.323.39.788.889 1.394 1.495.616.616 1.12 1.086 1.51 1.41.39.323.667.541.832.654.185-.102.434-.244.747-.423.313-.18.532-.3.655-.362.133-.072.264-.126.393-.162.128-.036.254-.054.377-.054.093 0 .18.013.262.038.082.026.16.06.231.1l.609.393a373.833 373.833 0 012.041 1.348c.308.206.493.334.555.386.205.133.331.352.377.655.046.303-.038.613-.254.932l-.277.362c-.185.241-.411.506-.678.793a7.786 7.786 0 01-.855.794c-.303.241-.573.362-.81.362h-.015c-.677-.02-1.376-.185-2.095-.493a13.117 13.117 0 01-2.126-1.164 19.865 19.865 0 01-2.026-1.556 36.632 36.632 0 01-1.795-1.671 34.26 34.26 0 01-1.664-1.795 20.545 20.545 0 01-1.548-2.026A13.27 13.27 0 014.33 8.562c-.309-.713-.473-1.404-.493-2.072-.01-.246.105-.519.346-.816.242-.298.506-.58.794-.848.287-.267.552-.493.793-.678.241-.185.367-.282.378-.292.123-.083.251-.144.385-.185.133-.041.267-.062.4-.062z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("defs", null, o.createElement("path", {
        d: "M7.388 5.055a1.296 1.296 0 00-.34.164c-.01.009-.121.096-.335.26-.214.163-.447.365-.702.6-.255.239-.49.489-.703.753-.214.265-.316.506-.307.724.018.593.164 1.205.437 1.839.272.633.615 1.26 1.029 1.88.414.62.87 1.22 1.37 1.798.502.58.992 1.11 1.474 1.592.483.484 1.012.978 1.59 1.484.576.505 1.175.965 1.793 1.38.618.415 1.246.76 1.882 1.033.637.272 1.255.42 1.856.438h.013c.21 0 .448-.108.716-.322a6.91 6.91 0 00.757-.704c.236-.255.436-.49.6-.704l.246-.322c.19-.282.266-.558.225-.826-.04-.27-.152-.463-.334-.582a8.825 8.825 0 00-.492-.341l-.893-.595c-.322-.214-.628-.415-.915-.602-.285-.186-.464-.303-.538-.348a.977.977 0 00-.204-.089.758.758 0 00-.231-.034c-.11 0-.222.016-.335.047-.114.032-.23.08-.349.144-.108.055-.3.162-.579.321-.277.16-.497.285-.661.377-.146-.1-.391-.295-.737-.581a20.684 20.684 0 01-1.337-1.252c-.536-.537-.948-.98-1.235-1.326a12.18 12.18 0 01-.579-.737c.09-.174.214-.397.369-.67.154-.275.264-.465.327-.574.11-.22.168-.43.177-.63a.879.879 0 00-.11-.505 25.962 25.962 0 00-.346-.527c-.187-.277-.387-.578-.6-.902a72.02 72.02 0 00-.6-.895l-.336-.493a.673.673 0 00-.299-.246A1.037 1.037 0 007.742 5c-.117 0-.236.019-.354.055z",
        id: "IcnCallSmall_svg__a"
      })), o.createElement("use", {
        fill: "currentColor",
        xlinkHref: "#IcnCallSmall_svg__a",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.5 4a2.5 2.5 0 012.49 2.283l.827.236a.5.5 0 01.084.929l-.084.033-.818.233L20 12a6 6 0 01-6 6v2h1.5a.5.5 0 01.492.41l.008.09a.5.5 0 01-.41.492L15.5 21h-2a.5.5 0 01-.492-.41L13 20.5V18h-3v2h1.5a.5.5 0 01.492.41l.008.09a.5.5 0 01-.41.492L11.5 21h-2a.5.5 0 01-.492-.41L9 20.5V18H4.733a1 1 0 01-.745-1.666L14.105 5.002A3.002 3.002 0 0116.343 4H17.5zm0 1h-1.157a2 2 0 00-1.373.546l-.119.122L4.733 17H14a4.999 4.999 0 004.995-4.783L19 12V6.5a1.5 1.5 0 00-1.356-1.493L17.5 5zM17 6a1 1 0 110 2 1 1 0 010-2z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        fill: "currentColor",
        d: "M12 3a9 9 0 110 18 9 9 0 010-18zm0 1a8 8 0 100 16 8 8 0 000-16zm0 3a.5.5 0 01.492.41l.008.09v4.293l3.354 3.353a.5.5 0 01-.638.765l-.07-.057-3.5-3.5-.011-.013a.503.503 0 01-.033-.039l.044.052a.502.502 0 01-.138-.264l-.003-.016a.503.503 0 01-.005-.062V7.5A.5.5 0 0112 7z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M15.595 9.216L12.81 12l2.784 2.784a.573.573 0 11-.811.811L12 12.81l-2.784 2.784a.573.573 0 11-.811-.811L11.19 12 8.405 9.216a.573.573 0 11.811-.811L12 11.19l2.784-2.784a.573.573 0 01.811.811z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M17.392 7.825L13.216 12l4.176 4.175a.86.86 0 11-1.216 1.216L12 13.217l-4.175 4.176a.86.86 0 01-1.216-1.216L10.783 12 6.608 7.825a.86.86 0 011.216-1.216L12 10.783l4.175-4.176a.86.86 0 111.216 1.216z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M20.164 12.356l-.021-.004-1.264-.278-.075-.3a1.642 1.642 0 00-.094-.275 8.251 8.251 0 00-.15-.314l-.122-.245.14-.235.526-.884a.736.736 0 00.11-.324c.006-.05-.003-.075-.044-.116l-.527-.527a.18.18 0 00-.158-.06.611.611 0 00-.31.092l-1.082.692-.254-.127a4.647 4.647 0 00-.614-.254l-.271-.09-.06-.28-.21-.978a.652.652 0 00-.157-.279.176.176 0 00-.152-.07h-.75c-.059 0-.08.01-.11.048a.783.783 0 00-.156.326l-.315 1.231-.266.083a3.671 3.671 0 00-.64.269l-.258.137-.246-.156-.881-.56a.556.556 0 00-.29-.084c-.07-.004-.105.01-.156.063l-.526.514c-.039.041-.049.07-.042.126a.834.834 0 00.107.339l.688 1.14-.111.241c-.045.098-.09.199-.135.304-.039.09-.07.18-.096.269l-.082.287-.292.064-.982.215a.53.53 0 00-.26.142c-.057.05-.076.094-.076.162v.75c0 .05.01.068.048.098a.895.895 0 00.32.166l1.255.303.08.28c.026.088.055.17.089.247.04.09.08.178.124.265l.123.246-.142.235-.55.913a.834.834 0 00-.108.34c-.007.056.003.085.029.112l.552.541c.038.04.073.054.143.05a.567.567 0 00.304-.093l1.113-.707.258.137c.101.055.207.104.316.148.112.046.224.086.336.12l.27.085.066.275.233.953c.03.112.084.22.168.328.03.039.049.048.098.048h.75c.069 0 .112-.02.162-.075a.543.543 0 00.146-.281l.273-1.257.278-.087c.109-.034.21-.071.303-.111.1-.043.201-.09.302-.14l.254-.127.239.153.847.54c.08.053.18.084.306.09a.18.18 0 00.158-.059l.527-.527c.041-.041.05-.066.044-.116a.76.76 0 00-.12-.341l-.66-1.11.134-.25c.046-.086.087-.173.123-.262.039-.095.076-.196.112-.304l.088-.263.27-.065.963-.232a.901.901 0 00.328-.168c.039-.03.048-.049.048-.098v-.75c0-.068-.02-.112-.075-.162a.53.53 0 00-.26-.142zm.086-.493c.18.032.35.12.51.264a.69.69 0 01.24.533v.75c0 .203-.08.367-.24.492a1.4 1.4 0 01-.51.258l-.973.235c-.039.117-.08.228-.123.334a3.206 3.206 0 01-.146.31l.515.867c.102.157.164.336.188.54a.613.613 0 01-.188.527l-.527.527a.677.677 0 01-.539.205 1.104 1.104 0 01-.55-.17l-.845-.539c-.109.055-.218.106-.328.152-.109.047-.226.09-.351.13l-.211.972c-.031.18-.12.35-.264.51a.69.69 0 01-.533.24h-.75a.595.595 0 01-.492-.24 1.4 1.4 0 01-.258-.51l-.234-.96a4.801 4.801 0 01-.375-.136 3.853 3.853 0 01-.364-.17l-.867.551c-.148.102-.33.158-.545.17a.65.65 0 01-.533-.205l-.539-.527a.628.628 0 01-.176-.528 1.33 1.33 0 01.176-.539l.55-.914a6.454 6.454 0 01-.134-.287 2.423 2.423 0 01-.111-.31l-.973-.235a1.4 1.4 0 01-.51-.258.595.595 0 01-.24-.492v-.75c0-.21.08-.389.24-.533.16-.145.33-.232.51-.264l.96-.21c.032-.11.071-.22.118-.329.047-.11.094-.215.14-.316l-.55-.914a1.33 1.33 0 01-.176-.54.628.628 0 01.176-.527l.539-.527a.65.65 0 01.533-.205c.215.012.397.068.545.17l.867.55a4.26 4.26 0 01.727-.304l.246-.961c.04-.18.121-.35.246-.51a.606.606 0 01.504-.24h.75c.21 0 .387.08.527.24.141.16.23.326.27.498l.21.985a5.226 5.226 0 01.68.28l.844-.538c.157-.102.34-.158.551-.17.211-.012.39.057.54.205l.526.527c.149.149.211.325.188.528a1.233 1.233 0 01-.188.539l-.515.867c.055.11.107.22.158.334.05.113.092.232.123.357l.961.211zm-5.386-.71c-.474 0-.868.162-1.209.5-.339.338-.503.734-.503 1.217 0 .483.164.878.503 1.216.34.338.735.501 1.209.501.482 0 .88-.163 1.22-.501.339-.338.503-.733.503-1.216s-.164-.88-.503-1.216a1.65 1.65 0 00-1.22-.502zm0-.5a2.15 2.15 0 011.572.646c.434.431.651.955.651 1.57 0 .617-.217 1.14-.65 1.571a2.15 2.15 0 01-1.573.647 2.136 2.136 0 01-1.561-.647 2.132 2.132 0 01-.65-1.57c0-.616.216-1.14.65-1.571a2.136 2.136 0 011.56-.647z",
        fill: "currentColor",
        fillRule: "nonzero"
      }), o.createElement("path", {
        d: "M7.895 5.655c-.012-.007-.01-.007-.024-.002a.27.27 0 00-.123.074l-.548.6-.216-.044a2.656 2.656 0 00-.377-.05l-.222-.013-.1-.198-.27-.525a.296.296 0 00-.102-.102c-.012-.008-.01-.007-.021-.004l-.426.114a.372.372 0 00-.028.164l.009.804-.184.116a2.078 2.078 0 00-.31.24l-.166.155-.217-.068-.592-.186a.24.24 0 00-.128 0c-.015.003-.01 0-.019.017l-.22.37c.025.063.056.11.091.145l.603.58-.035.204a7.06 7.06 0 00-.03.191 1.24 1.24 0 00-.013.157l-.003.232-.207.107-.532.275a.224.224 0 00-.088.087c-.01.015-.01.016-.006.03l.112.418a.43.43 0 00.16.035l.819-.02.117.194c.025.043.052.082.08.117.036.044.072.087.11.129l.141.16-.06.206-.174.605a.401.401 0 00-.007.171l.389.22c.004.002-.003.001.011-.004a.246.246 0 00.12-.074l.565-.614.22.051a2.451 2.451 0 00.396.051l.22.01.106.192.278.508a.435.435 0 00.114.128l.42-.112c.013-.004.013-.004.022-.02a.233.233 0 00.03-.137l-.04-.814.192-.12c.055-.035.104-.07.149-.105.049-.04.098-.08.146-.123l.165-.146.21.066.568.18a.269.269 0 00.141.002c.014-.003.013-.002.02-.014l.22-.38a.36.36 0 00-.098-.138l-.585-.57.05-.214c.013-.053.023-.106.03-.16.007-.058.012-.12.016-.184l.013-.215.19-.103.513-.28a.435.435 0 00.128-.113l-.112-.42c-.004-.013-.004-.013-.02-.022a.224.224 0 00-.12-.031l-.018.001-.822.038-.117-.211a.878.878 0 00-.086-.129 4.787 4.787 0 00-.131-.154l-.141-.159.058-.204.166-.59a.339.339 0 00.01-.153l-.38-.22zm1.426 1.393a.604.604 0 01.331.072.408.408 0 01.22.268l.114.428a.352.352 0 01-.062.318.828.828 0 01-.252.226l-.52.283c-.004.073-.01.142-.019.21-.008.066-.02.133-.036.2l.428.416a.73.73 0 01.19.279.363.363 0 01-.027.33l-.22.382a.4.4 0 01-.277.2.653.653 0 01-.341-.013l-.565-.179a3.642 3.642 0 01-.164.137 2.174 2.174 0 01-.18.128l.028.588a.604.604 0 01-.073.331.408.408 0 01-.268.22l-.428.114a.352.352 0 01-.318-.062.828.828 0 01-.226-.252l-.28-.513a2.84 2.84 0 01-.47-.06l-.41.447a.619.619 0 01-.286.18.385.385 0 01-.336-.035l-.388-.22a.371.371 0 01-.181-.274.787.787 0 01.017-.335l.175-.606a3.817 3.817 0 01-.12-.143 1.433 1.433 0 01-.112-.16l-.592.014a.828.828 0 01-.33-.07.352.352 0 01-.213-.244l-.115-.428a.408.408 0 01.056-.341.604.604 0 01.25-.23l.518-.267c0-.067.006-.135.016-.205.01-.07.021-.137.032-.202l-.454-.438a.787.787 0 01-.183-.281.371.371 0 01.02-.329l.227-.383a.385.385 0 01.273-.2.619.619 0 01.337.014l.58.182a2.52 2.52 0 01.368-.285l-.006-.587a.745.745 0 01.062-.329.359.359 0 01.252-.214l.428-.115a.398.398 0 01.338.057c.105.07.182.15.23.243l.272.53a3.091 3.091 0 01.43.057l.4-.437a.653.653 0 01.29-.182.4.4 0 01.338.035l.382.22c.108.063.17.153.188.273a.73.73 0 01-.024.337l-.162.574c.048.054.095.11.141.167.047.057.088.118.125.185l.582-.026zm-2.848.51a.875.875 0 00-.65.27.873.873 0 00-.27.653c0 .261.088.472.27.654.184.182.394.269.65.269.26 0 .472-.087.655-.27a.873.873 0 00.27-.653.873.873 0 00-.27-.653.883.883 0 00-.655-.27zm0-.388c.363 0 .673.127.93.382.256.255.385.565.385.93 0 .364-.129.673-.385.928a1.271 1.271 0 01-.93.383c-.36 0-.667-.128-.924-.383a1.26 1.26 0 01-.385-.929c0-.364.129-.674.385-.929.257-.255.565-.382.924-.382z",
        fill: "currentColor",
        fillRule: "nonzero",
        opacity: .25
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M12 16a2 2 0 110 4 2 2 0 010-4zm5.2-.764l-.74.764A5.185 5.185 0 0015 14.326l.001-1.23a6.197 6.197 0 012.2 2.14zM9 13.096v1.23a5.185 5.185 0 00-1.459 1.673l-.74-.764a6.197 6.197 0 012.198-2.14zM13 4v10h-2V4h2zm7.114 8.232l-.724.747a9.216 9.216 0 00-4.389-3.283V8.605a10.221 10.221 0 015.113 3.627zM9 8.604v1.091a9.216 9.216 0 00-4.39 3.283l-.723-.747A10.22 10.22 0 019 8.604zm14.001.654L22.28 10A13.237 13.237 0 0015 5.384V4.32c3.193.694 5.99 2.472 8.001 4.937zm-14-4.937L9 5.384A13.237 13.237 0 001.72 9.999L1 9.257c2.01-2.465 4.808-4.243 8-4.936z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M15.453 8.375a.525.525 0 01.297-.04c.104.017.193.06.266.134a.516.516 0 01.117.265.456.456 0 01-.055.297l-2.36 4.64a.348.348 0 01-.085.11.574.574 0 01-.117.078l-4.782 1.985a.24.24 0 01-.093.039.673.673 0 01-.11.008.43.43 0 01-.18-.04.5.5 0 01-.148-.101.458.458 0 01-.133-.258.504.504 0 01.04-.289l2.25-4.515a.452.452 0 01.203-.203l4.89-2.11zm-5.86 6.016l2.735-1.063-1.375-1.719-1.36 2.782zm3.548-1.641l1.375-2.828L11.75 11l1.39 1.75zM12 4c1.104 0 2.143.208 3.117.625a8.028 8.028 0 012.547 1.71 8.028 8.028 0 011.711 2.548c.417.974.625 2.013.625 3.117a7.841 7.841 0 01-.625 3.117 8.028 8.028 0 01-1.71 2.547 8.028 8.028 0 01-2.548 1.711A7.841 7.841 0 0112 20a7.841 7.841 0 01-3.117-.625 8.028 8.028 0 01-2.547-1.71 8.028 8.028 0 01-1.711-2.548A7.841 7.841 0 014 12c0-1.104.208-2.143.625-3.117a8.028 8.028 0 011.71-2.547 8.028 8.028 0 012.548-1.711A7.841 7.841 0 0112 4zm0 15.016c.969 0 1.878-.185 2.727-.555a7.064 7.064 0 002.218-1.508 7.228 7.228 0 001.5-2.226c.37-.85.555-1.758.555-2.727 0-.969-.185-1.878-.555-2.727a7.131 7.131 0 00-1.5-2.218 7.131 7.131 0 00-2.218-1.5A6.753 6.753 0 0012 5c-.969 0-1.878.185-2.727.555-.849.37-1.588.87-2.218 1.5-.63.63-1.13 1.37-1.5 2.218A6.753 6.753 0 005 12c0 .969.185 1.878.555 2.727.37.849.87 1.59 1.5 2.226a7.064 7.064 0 002.218 1.508c.85.37 1.758.555 2.727.555z",
        fill: "currentColor"
      }), o.createElement("circle", {
        stroke: "currentColor",
        strokeWidth: .2,
        opacity: .198,
        cx: 12,
        cy: 12,
        r: 7.9
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M15.453 8.375a.525.525 0 01.297-.04c.104.017.193.06.266.134a.516.516 0 01.117.265.456.456 0 01-.055.297l-2.36 4.64a.348.348 0 01-.085.11.574.574 0 01-.117.078l-4.782 1.985a.24.24 0 01-.093.039.673.673 0 01-.11.008.43.43 0 01-.18-.04.5.5 0 01-.148-.101.458.458 0 01-.133-.258.504.504 0 01.04-.289l2.25-4.515a.452.452 0 01.203-.203l4.89-2.11zm-5.86 6.016l2.735-1.063-1.375-1.719-1.36 2.782zm3.548-1.641l1.375-2.828L11.75 11l1.39 1.75zM12 4c1.104 0 2.143.208 3.117.625a8.028 8.028 0 012.547 1.71 8.028 8.028 0 011.711 2.548c.417.974.625 2.013.625 3.117a7.841 7.841 0 01-.625 3.117 8.028 8.028 0 01-1.71 2.547 8.028 8.028 0 01-2.548 1.711A7.841 7.841 0 0112 20a7.841 7.841 0 01-3.117-.625 8.028 8.028 0 01-2.547-1.71 8.028 8.028 0 01-1.711-2.548A7.841 7.841 0 014 12c0-1.104.208-2.143.625-3.117a8.028 8.028 0 011.71-2.547 8.028 8.028 0 012.548-1.711A7.841 7.841 0 0112 4z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 4a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h12zm0 1H6a1 1 0 00-1 1v7.74l1.278-1.278a1.3 1.3 0 011.839 0l2.118 2.119a.3.3 0 00.424 0L15.24 10h-1.75a.5.5 0 010-1h3.017a.5.5 0 01.5.5v3.018a.5.5 0 11-1 0l-.001-1.869-4.638 4.639a1.3 1.3 0 01-1.839 0L7.41 13.169a.3.3 0 00-.424 0L5 15.154V18a1 1 0 001 1h12a1 1 0 001-1V6a1 1 0 00-1-1z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.985 13.17a.3.3 0 01.424 0l2.12 2.118a1.3 1.3 0 001.838 0l4.638-4.639v1.869a.5.5 0 101 0V9.5a.5.5 0 00-.5-.5H13.49a.5.5 0 000 1h1.749l-4.58 4.58a.3.3 0 01-.424 0l-2.118-2.118a1.3 1.3 0 00-1.839 0L4 14.74V6a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2v-1.994z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M6 9v10h2V9H6zm0-1h2a1 1 0 011 1v10a1 1 0 01-1 1H6a1 1 0 01-1-1V9a1 1 0 011-1zm5 5v6h2v-6h-2zm0-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6a1 1 0 011-1zm5-7v14h2V5h-2zm0-1h2a1 1 0 011 1v14a1 1 0 01-1 1h-2a1 1 0 01-1-1V5a1 1 0 011-1z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M6 8h2a1 1 0 011 1v10a1 1 0 01-1 1H6a1 1 0 01-1-1V9a1 1 0 011-1zm5 4h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6a1 1 0 011-1zm5-8h2a1 1 0 011 1v14a1 1 0 01-1 1h-2a1 1 0 01-1-1V5a1 1 0 011-1z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "currentColor",
        strokeWidth: 1.2,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("circle", {
        cx: 12,
        cy: 7.896,
        r: 5.26
      }), o.createElement("path", {
        d: "M9.662 9.638c.778.78 1.557 1.17 2.338 1.17.782 0 1.564-.39 2.348-1.17M4.499 21.337c.04-2.067.774-3.756 2.199-5.067C8.123 14.958 9.89 14.31 12 14.325M19.501 21.338c-.04-2.067-.774-3.757-2.199-5.068-1.425-1.312-3.192-1.96-5.302-1.945",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "currentColor",
        fillRule: "nonzero"
      }, o.createElement("path", {
        d: "M12 13.756a5.86 5.86 0 110-11.72 5.86 5.86 0 010 11.72zm-2.762-3.694c.881.884 1.804 1.345 2.762 1.345s1.883-.46 2.771-1.343a.6.6 0 10-.846-.851c-.68.676-1.32.994-1.925.994-.604 0-1.24-.318-1.913-.992a.6.6 0 10-.85.847z"
      }), o.createElement("path", {
        d: "M12.01 13.725c2.252-.013 4.162.69 5.699 2.103 1.547 1.425 2.348 3.27 2.392 5.498a.6.6 0 01-.62.611c-5.075.007-7.155.003-7.485 0-1.961-.014-7.178.007-7.51 0a.6.6 0 01-.587-.611c.044-2.228.845-4.073 2.392-5.498 1.54-1.417 3.455-2.12 5.713-2.103h.006z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M8 7a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm-8 4a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm-8 4a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm-4 4a1 1 0 110-2 1 1 0 010 2z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M8 7a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm-8 4a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm-8 4a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm-4 4a1 1 0 110-2 1 1 0 010 2z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M17.448 4c.431 0 .798.146 1.1.438.301.291.452.645.452 1.062v13c0 .417-.15.77-.453 1.063a1.523 1.523 0 01-1.099.437H7.118c-.194 0-.418-.062-.671-.188-.253-.125-.38-.395-.38-.812v-2.016h-.534a.487.487 0 01-.347-.148.473.473 0 010-.695.501.501 0 01.347-.141h.534v-2h-.534a.487.487 0 01-.347-.148.473.473 0 010-.696.501.501 0 01.347-.14h.534v-2.032H5.55a.492.492 0 01-.502-.484.492.492 0 01.501-.484h.518V8h-.566A.492.492 0 015 7.516c0-.136.048-.253.145-.352a.479.479 0 01.356-.148h.566V5.03c0-.25.086-.484.259-.703.172-.219.442-.328.808-.328h10.314zM7.031 19h8V5h-8v2.016h.485c.135 0 .25.05.343.148.094.099.141.216.141.352 0 .135-.047.25-.14.343A.468.468 0 017.515 8H7.03v2.016h.532c.135 0 .25.046.343.14.094.094.14.209.14.344 0 .135-.046.25-.14.344a.468.468 0 01-.343.14H7.03v2.032h.516c.135 0 .252.046.351.14a.455.455 0 01.149.344.48.48 0 01-.149.352.48.48 0 01-.351.148H7.03v2h.516c.135 0 .252.047.351.14a.455.455 0 01.149.344.48.48 0 01-.149.352.48.48 0 01-.351.148H7.03V19zM18 18.5v-13c0-.135-.065-.253-.195-.352A.74.74 0 0017.344 5H16.03v14h1.313a.74.74 0 00.461-.148c.13-.1.195-.217.195-.352z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M17.031 4c.417 0 .771.146 1.063.438.291.291.437.645.437 1.062v13c0 .417-.146.77-.437 1.063A1.447 1.447 0 0117.03 20H7.047c-.188 0-.404-.062-.649-.188-.244-.125-.367-.395-.367-.812v-2.016h-.515a.463.463 0 01-.336-.148.48.48 0 01-.149-.352c0-.135.05-.25.149-.343A.476.476 0 015.516 16h.515v-2h-.515a.463.463 0 01-.336-.148.48.48 0 01-.149-.352c0-.135.05-.25.149-.344a.476.476 0 01.336-.14h.515v-2.032h-.5a.468.468 0 01-.343-.14.468.468 0 01-.141-.344c0-.135.047-.25.14-.344a.468.468 0 01.344-.14h.5V8h-.547a.468.468 0 01-.343-.14A.468.468 0 015 7.515c0-.136.047-.253.14-.352a.455.455 0 01.344-.148h.547V5.03c0-.25.084-.484.25-.703.167-.219.427-.328.782-.328h9.968zm.5 14.5v-13a.48.48 0 00-.148-.352A.48.48 0 0017.03 5h-1v14h1a.48.48 0 00.352-.148.48.48 0 00.148-.352z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M16.5 19a.5.5 0 110 1h-12a.5.5 0 110-1h12zm3-3a.5.5 0 110 1h-9a.5.5 0 110-1h9zM13.396 5.103l2.5 2.5L6.72 16.78a.75.75 0 01-.53.22H4.75a.75.75 0 01-.75-.75v-1.44a.75.75 0 01.22-.53l9.176-9.177zM16.53 3.03l1.44 1.44a.75.75 0 010 1.06l-1.367 1.366-2.5-2.5L15.47 3.03a.75.75 0 011.06 0z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M19 6a1 1 0 011 1v10a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h14zm0 3.543l-6.41 2.748a1.5 1.5 0 01-1.18 0L5 9.544V17h14V9.543zM19 7H5v1.456l6.803 2.916a.5.5 0 00.394 0L19 8.455V7z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M20 7.441l-7.776 3.888a.5.5 0 01-.448 0L4 7.441V7a1 1 0 011-1h14a1 1 0 011 1v.441zm0 1.118V17a1 1 0 01-1 1H5a1 1 0 01-1-1V8.559l7.33 3.665a1.5 1.5 0 001.34 0L20 8.559z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 64 64"
      }, e), o.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "currentColor"
      }, o.createElement("path", {
        d: "M54 18.278H10c-.414 0-.79.168-1.06.44a1.49 1.49 0 00-.44 1.06v5.5h47v-5.5c0-.414-.168-.79-.44-1.06a1.49 1.49 0 00-1.06-.44zm1.5 7.111h-47V54c0 .414.168.79.44 1.06.27.272.646.44 1.06.44h44c.414 0 .79-.168 1.06-.44.272-.27.44-.646.44-1.06V25.389z"
      }), o.createElement("path", {
        strokeLinecap: "round",
        d: "M30.222 39.556h19.556"
      }), o.createElement("rect", {
        width: 13.222,
        height: 13.222,
        x: 13.833,
        y: 34.278,
        rx: 1
      }), o.createElement("path", {
        strokeLinecap: "round",
        d: "M30.222 36.889h8.889M13.778 21.778h17.778M50.092 20.76l1.886 1.885M50.092 22.645l1.886-1.886M30.222 42.222h19.556m-19.556 2.667h16"
      }), o.createElement("circle", {
        cx: 20.444,
        cy: 39.556,
        r: 2.722
      }), o.createElement("path", {
        d: "M22.889 44.056H18c-.414 0-.79.167-1.06.439-.272.271-.44.646-.44 1.06V47.5h7.889v-1.944c0-.415-.168-.79-.44-1.061a1.49 1.49 0 00-1.06-.44z"
      }), o.createElement("path", {
        d: "M59.997.5H4.003c-.966 0-1.842.393-2.476 1.027A3.49 3.49 0 00.5 4.003v55.994c0 .966.393 1.842 1.027 2.476A3.493 3.493 0 004.003 63.5h55.994c.966 0 1.842-.393 2.476-1.027a3.493 3.493 0 001.027-2.476V4.003c0-.966-.393-1.842-1.027-2.476A3.49 3.49 0 0059.997.5zM.444 10.222h63.112"
      }), o.createElement("path", {
        d: "M5.333 4.056c-.353 0-.672.143-.903.374a1.275 1.275 0 00.903 2.181 1.275 1.275 0 001.278-1.278 1.273 1.273 0 00-1.278-1.277zm5.334 0a1.275 1.275 0 00-1.278 1.277 1.275 1.275 0 001.278 1.278 1.273 1.273 0 001.277-1.278c0-.353-.143-.672-.374-.903a1.273 1.273 0 00-.903-.374zm5.333 0a1.277 1.277 0 100 2.555 1.277 1.277 0 100-2.555z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 72 72"
      }, e), o.createElement("path", {
        d: "M68.998 0A3 3 0 0172 2.997v65.999A3.002 3.002 0 0168.998 72H3.002A3.003 3.003 0 010 68.996V2.997A2.999 2.999 0 013.002 0h65.996zM71 12H1v56.996c0 1.056.817 1.922 1.853 1.999l.15.005h65.995c1.056 0 1.92-.817 1.997-1.855l.005-.15V12zm-14.146 8.146a.5.5 0 01.057.638l-.057.07-42 42a.5.5 0 01-.765-.638l.057-.07L17.292 59H12a2 2 0 01-2-2V26a2 2 0 012-2h40.292l3.854-3.854a.5.5 0 01.708 0zM60 24a2 2 0 012 2v31a2 2 0 01-2 2H20.706l1-1H60a1 1 0 00.993-.883L61 57V33H46.707l1-1H61v-6a1 1 0 00-.883-.993L60 25h-5.293l1-1H60zm-16.708 9H11v24a1 1 0 00.883.993L12 58h6.292l8-8H16a1 1 0 01-1-1V38a1 1 0 011-1h11a1 1 0 011 1v10.292L34.292 42H32.5a.5.5 0 01-.09-.992L32.5 41h2.792l3-3H32.5a.5.5 0 01-.09-.992L32.5 37h6.792l4-4zM50.5 53a.5.5 0 01.09.992L50.5 54h-18a.5.5 0 01-.09-.992L32.5 53h18zm6-4a.5.5 0 01.09.992L56.5 50h-24a.5.5 0 01-.09-.992L32.5 49h24zM27 38H16v11h11V38zm-1.717 2.589l.069.057a.5.5 0 01.058.638l-.058.07-4.998 5a.5.5 0 01-.638.057l-.07-.057-2-2a.5.5 0 01.638-.765l.07.057L20 45.292l4.645-4.645a.5.5 0 01.638-.058zM56.5 45a.5.5 0 01.09.992L56.5 46H33.706l1-1H56.5zm0-4a.5.5 0 01.09.992L56.5 42H37.706l1.001-1H56.5zm-13-4a.5.5 0 01.09.992L43.5 38h-1.793l1-1h.793zm7.792-12H12a1 1 0 00-.993.883L11 26v6h33.292l7-7zm4.992 1.589l.07.057 1.146 1.147 1.146-1.147a.5.5 0 01.765.638l-.057.07-1.147 1.146 1.147 1.146a.5.5 0 01-.638.765l-.07-.057-1.146-1.147-1.146 1.147a.5.5 0 01-.765-.638l.057-.07 1.147-1.146-1.147-1.146a.5.5 0 01.638-.765zM33.5 28a.5.5 0 01.09.992L33.5 29h-18a.5.5 0 01-.09-.992L15.5 28h18zM68.998 1H3.002c-1.057 0-1.92.814-1.997 1.848L1 2.998V11h70V2.997a2 2 0 00-1.853-1.992L68.997 1zM6 4a2 2 0 01.15 3.995L6 8a2 2 0 01-.15-3.995L6 4zm6 0a2 2 0 01.15 3.995L12 8a2 2 0 01-.15-3.995L12 4zm6 0a2 2 0 01.15 3.995L18 8a2 2 0 01-.15-3.995L18 4zM6 5a1 1 0 100 2 1 1 0 000-2zm6 0a1 1 0 100 2 1 1 0 000-2zm6 0a1 1 0 100 2 1 1 0 000-2z",
        fill: "#222",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48"
      }, e), o.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M24.45 8.202a1 1 0 01.444.445L39.92 38.551A1 1 0 0139.026 40H9a1 1 0 01-.894-1.448l15-29.904a1 1 0 011.342-.446zM24 31a2 2 0 100 4 2 2 0 000-4zm0-13a2 2 0 00-2 2v7a2 2 0 104 0v-7a2 2 0 00-2-2z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M12.031 9.008c.832 0 1.539.294 2.121.88.582.588.873 1.291.873 2.112 0 .83-.29 1.537-.873 2.119a2.889 2.889 0 01-2.12.872c-.822 0-1.527-.29-2.114-.872A2.87 2.87 0 019.037 12c0-.82.294-1.524.881-2.111a2.883 2.883 0 012.113-.88zm0 4.986c.551 0 1.019-.197 1.404-.592a1.96 1.96 0 00.577-1.418c0-.55-.195-1.02-.585-1.41-.39-.39-.86-.584-1.411-.584s-1.022.195-1.412.584c-.39.39-.585.86-.585 1.41 0 .55.2 1.024.6 1.418.401.395.872.592 1.412.592zm7.938-2.119c0 .021.002.042.008.063.005.02.007.041.007.062a.36.36 0 01-.007.07.36.36 0 00-.008.07c-.01.01-.016.021-.016.031v.047l-.015.016v.023c0 .005-.006.013-.016.023a8.259 8.259 0 01-1.372 2.213 8.613 8.613 0 01-1.887 1.628 8.788 8.788 0 01-2.238 1.013 8.612 8.612 0 01-2.44.35 8.612 8.612 0 01-2.441-.35 8.788 8.788 0 01-2.238-1.013 8.574 8.574 0 01-3.275-3.84v-.047l-.008-.008c-.005-.005-.007-.013-.007-.023v-.032A.12.12 0 004 12.125a.256.256 0 00-.008-.063.256.256 0 01-.008-.062.36.36 0 01.008-.07.36.36 0 00.008-.07c.01-.01.016-.021.016-.031v-.047l.015-.016v-.046A8.591 8.591 0 015.427 9.5a8.85 8.85 0 011.895-1.645 8.693 8.693 0 017.135-1.02 8.382 8.382 0 012.221 1.02A8.86 8.86 0 0118.55 9.5a8.385 8.385 0 011.372 2.22c.01.01.016.019.016.024v.023l.007.008c.006.005.008.013.008.023v.032c0 .01.005.026.016.046zm-7.985 4.612a8 8 0 002.098-.28 7.382 7.382 0 003.618-2.244A7.423 7.423 0 0018.955 12a7.535 7.535 0 00-2.908-3.373 7.45 7.45 0 00-1.942-.857 7.713 7.713 0 00-2.09-.288c-.706 0-1.406.096-2.097.288a7.55 7.55 0 00-1.957.857 7.84 7.84 0 00-1.684 1.41c-.51.56-.93 1.215-1.263 1.963a7.316 7.316 0 001.263 1.963 7.737 7.737 0 001.676 1.402 7.406 7.406 0 001.942.842c.686.187 1.382.28 2.09.28z",
        fill: "currentColor",
        fillRule: "nonzero"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M19.969 11.875c0 .021.002.042.008.063.005.02.007.041.007.062a.36.36 0 01-.007.07.36.36 0 00-.008.07c-.01.01-.016.021-.016.031v.047l-.015.016v.023c0 .005-.006.013-.016.023a8.259 8.259 0 01-1.372 2.213 8.613 8.613 0 01-1.887 1.628 8.788 8.788 0 01-2.238 1.013 8.612 8.612 0 01-2.44.35 8.612 8.612 0 01-2.441-.35 8.788 8.788 0 01-2.238-1.013 8.574 8.574 0 01-3.275-3.84v-.047l-.008-.008c-.005-.005-.007-.013-.007-.023v-.032A.12.12 0 004 12.125a.256.256 0 00-.008-.063.256.256 0 01-.008-.062.36.36 0 01.008-.07.36.36 0 00.008-.07c.01-.01.016-.021.016-.031v-.047l.015-.016v-.046A8.591 8.591 0 015.427 9.5a8.85 8.85 0 011.895-1.645 8.693 8.693 0 017.135-1.02 8.382 8.382 0 012.221 1.02A8.86 8.86 0 0118.55 9.5a8.385 8.385 0 011.372 2.22c.01.01.016.019.016.024v.023l.007.008c.006.005.008.013.008.023v.032c0 .01.005.026.016.046zM12.03 9.008c-.821 0-1.526.294-2.113.88A2.878 2.878 0 009.037 12c0 .83.294 1.537.881 2.119a2.896 2.896 0 002.113.872c.832 0 1.539-.29 2.121-.872A2.884 2.884 0 0015.025 12c0-.82-.29-1.524-.873-2.111a2.876 2.876 0 00-2.12-.88z",
        fill: "currentColor",
        fillRule: "nonzero"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M13 10V8.016c0-.478.103-.855.346-1.12.266-.29.702-.396 1.326-.396h.828V5h-1.688c-1.153 0-1.939.241-2.376.69-.446.456-.678 1.157-.678 2.13V10H9v1.5h1.758V19H13v-7.5h2.246l.188-1.5H13zm1-1h2.566l-.437 3.5H14V20H9.758v-7.5H8V9h1.758V7.82c0-1.214.315-2.166.962-2.83.657-.671 1.694-.99 3.092-.99H16.5v3.5h-1.828c-.366 0-.568.05-.589.072-.043.048-.083.192-.083.444V9z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M14 9h2.566l-.437 3.5H14V20H9.758v-7.5H8V9h1.758V7.82c0-1.214.315-2.166.962-2.83.657-.671 1.694-.99 3.092-.99H16.5v3.5h-1.828c-.366 0-.568.05-.589.072-.043.048-.083.192-.083.444V9z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        fill: "currentColor",
        fillRule: "nonzero",
        d: "M8 11h8l-4 4z",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        transform: "translate(0 -4)",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }, o.createElement("rect", {
        x: 6,
        y: 12,
        width: 12,
        height: 1,
        rx: .5
      }), o.createElement("rect", {
        x: 8,
        y: 15,
        width: 8,
        height: 1,
        rx: .5
      }), o.createElement("rect", {
        x: 10,
        y: 18,
        width: 4,
        height: 1,
        rx: .5
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        fill: "currentColor",
        fillRule: "nonzero",
        d: "M16 14H8l4-4z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 148 32"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M16 0c8.853 0 16 7.147 16 16s-7.147 16-16 16S0 24.853 0 16 7.147 0 16 0zm0 1C7.7 1 1 7.7 1 16s6.7 15 15 15 15-6.7 15-15S24.3 1 16 1zm-4.328 14.431l.057.047 3.208 3.21a.37.37 0 01.101.189l.007.072v3.39a.37.37 0 01-.575.308l-.057-.047-3.208-3.209a.37.37 0 01-.101-.189l-.007-.072v-3.39a.37.37 0 01.575-.309zM100.137 11c2.673 0 4.5 2.035 4.5 4.987S102.784 21 100.11 21s-4.5-2.048-4.5-4.987c0-2.965 1.853-5.013 4.526-5.013zm41.114.106l2.713 3.963 2.646-3.896h1.099l-3.176 4.6L148 20.682l-1.006.213-3.043-4.389-2.938 4.309h-1.099l3.468-5.013-3.124-4.482.993-.213zm-81.746-.026l2.474 8.178 2.74-8.085h1.019l2.779 8.085 2.435-8.085h1.032l-3.017 9.68h-.874l-2.885-8.284-2.871 8.285h-.847l-2.991-9.548 1.006-.226zm-4.16.093l.145.93h-3.282v8.71h-.992v-8.71H48v-.93h7.345zm21.633 0v9.64h-1.006v-9.64h1.006zm5.668 0v8.71h3.838l.146.93h-4.976v-9.64h.992zm8.752 0v9.64h-1.005v-9.64h1.005zm27.633 0v.93h-4.01v3.365h3.203l.145.918h-3.348v4.428h-.992v-9.641h5.002zm4.795 0v8.71h3.838l.145.93h-4.975v-9.64h.992zm12.841 0v.93h-4.195v3.206h3.322l.146.93h-3.468v3.657h4.341v.918h-5.333v-9.641h5.187zm-36.556.731c-2.091 0-3.467 1.65-3.467 4.083 0 2.46 1.39 4.095 3.48 4.095 2.104 0 3.467-1.635 3.467-4.082s-1.376-4.096-3.48-4.096zM19.389 10.84a.37.37 0 01.205.062l.056.046 3.209 3.21a.37.37 0 01-.189.625l-.073.006h-7.552a.362.362 0 00-.072.718l.072.008h2.453a.37.37 0 01.205.062l.056.046 3.209 3.21a.37.37 0 01-.189.624l-.073.007h-3.784a.37.37 0 01-.205-.062l-.057-.046-5.455-5.446a.37.37 0 01-.101-.189l-.007-.073v-2.435c0-.18.128-.33.298-.366l.075-.007h7.919z",
        fill: "#FFF"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.986 6H6a1 1 0 00-1 1v10a1 1 0 001 1h12a1 1 0 001-1V9a1 1 0 00-1-1h-6.414l-1.6-2zm.414-1L12 7h6a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V7a2 2 0 012-2h4.4z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M5 20a.5.5 0 01-.5-.5v-5a.5.5 0 011 0v3.794l4.646-4.648a.5.5 0 01.638-.057l.07.057a.5.5 0 010 .708L6.208 19H10a.5.5 0 010 1H5zM20 4a.5.5 0 01.5.5v5a.5.5 0 01-1 0V5.706l-4.646 4.648a.5.5 0 01-.638.057l-.07-.057a.5.5 0 010-.708L18.792 5H15a.5.5 0 010-1h5z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M21 13h10a2 2 0 012 2v18a2 2 0 01-2 2H17a2 2 0 01-2-2V19l6-6z",
        fill: "currentColor"
      }), o.createElement("path", {
        d: "M21.5 14L16 19.5V33a1 1 0 001 1h14a1 1 0 001-1V15a1 1 0 00-1-1h-9.5z",
        fill: "#FFF"
      }), o.createElement("path", {
        d: "M21.5 29a.5.5 0 110 1h-2a.5.5 0 110-1h2zm5-2a.5.5 0 110 1h-7a.5.5 0 110-1h7zm-1-2a.5.5 0 110 1h-6a.5.5 0 110-1h6zm3-2a.5.5 0 110 1h-9a.5.5 0 110-1h9zm0-2a.5.5 0 110 1h-3a.5.5 0 110-1h3zm0-2a.5.5 0 110 1h-3a.5.5 0 110-1h3zM22 13v7h-7v-1h6v-6z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M15 15h18a2 2 0 012 2v14a2 2 0 01-2 2H15a2 2 0 01-2-2V17a2 2 0 012-2z",
        fill: "currentColor"
      }), o.createElement("path", {
        d: "M15 16a1 1 0 00-1 1v14a1 1 0 001 1h18a1 1 0 001-1V17a1 1 0 00-1-1H15z",
        fill: "#FFF"
      }), o.createElement("path", {
        d: "M27 23l5 7H16l3.5-4 2.949 3.371L27 23zm-8.5-4a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M16.544 5.607c.384 0 .722.145 1.016.435.293.29.44.625.44 1.005V17.56c0 .38-.147.715-.44 1.005-.294.29-.632.435-1.016.435H6.456c-.384 0-.722-.145-1.016-.435-.293-.29-.44-.625-.44-1.005V7.047c0-.38.147-.714.44-1.005.294-.29.632-.435 1.016-.435H9.4c.113-.469.367-.854.762-1.155.395-.301.84-.452 1.337-.452s.942.15 1.337.452c.395.301.65.686.762 1.155h2.945zm.59 11.951V7.109c-.004-.181-.063-.304-.175-.367a.75.75 0 00-.373-.095h-1.802V7a1 1 0 01-1 1H9.216a1 1 0 01-1-1v-.353H6.483c-.21-.02-.366.022-.468.129a.507.507 0 00-.148.377v10.46c0 .168.08.295.24.381.16.087.371.128.635.124h9.53c.226.003.418-.03.577-.101.16-.07.254-.223.284-.459zM11.5 5.654a.683.683 0 00-.508.207.708.708 0 00-.203.517c0 .207.068.385.203.534.136.15.305.224.508.224a.657.657 0 00.508-.224.768.768 0 00.203-.534.708.708 0 00-.203-.517.683.683 0 00-.508-.207zm-1.428 9.38l-1.542-1.57a.433.433 0 00-.621.003.457.457 0 00.003.637l1.447 1.473a1 1 0 001.427 0l4.3-4.378a.457.457 0 000-.64.44.44 0 00-.629 0l-4.385 4.475z",
        fill: "currentcolor",
        fillRule: "nonzero"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M16.544 5.607c.384 0 .722.145 1.016.435.293.29.44.625.44 1.005V17.56c0 .38-.147.715-.44 1.005-.294.29-.632.435-1.016.435H6.456c-.384 0-.722-.145-1.016-.435-.293-.29-.44-.625-.44-1.005V7.047c0-.38.147-.714.44-1.005.294-.29.632-.435 1.016-.435H9.4c.113-.469.367-.854.762-1.155.395-.301.84-.452 1.337-.452s.942.15 1.337.452c.395.301.65.686.762 1.155h2.945zm-5.044.047a.683.683 0 00-.508.207.708.708 0 00-.203.517c0 .207.068.385.203.534.136.15.305.224.508.224a.657.657 0 00.508-.224.768.768 0 00.203-.534.708.708 0 00-.203-.517.683.683 0 00-.508-.207zm-1.428 9.38l-1.542-1.57a.433.433 0 00-.621.003.457.457 0 00.003.637l1.447 1.473a1 1 0 001.427 0l4.3-4.378a.457.457 0 000-.64.44.44 0 00-.629 0l-4.385 4.475z",
        fill: "currentcolor",
        fillRule: "nonzero"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0),
      i = function i(e) {
        return o.createElement("svg", r({
          width: "1em",
          height: "1em",
          viewBox: "0 0 12 12"
        }, e), o.createElement("circle", {
          cx: 4,
          cy: "50%",
          r: 4,
          fill: "#19BD3A",
          stroke: "none",
          strokeWidth: 1,
          fillRule: "evenodd"
        }));
      };
    t.default = i, i._raw = '\n<svg width="1em" height="1em" viewBox="0 0 12 12" >\n        <circle cx="4" cy="50%" r="4" fill="#19BD3A" stroke="none" strokeWidth="1" fillRule="evenodd" />\n    </svg>';
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0),
      i = function i(e) {
        return o.createElement("svg", r({
          width: "1em",
          height: "1em",
          viewBox: "0 0 12 12"
        }, e), o.createElement("circle", {
          cx: 4,
          cy: "50%",
          r: 4,
          fill: "#ABABAB",
          stroke: "none",
          strokeWidth: 1,
          fillRule: "evenodd"
        }));
      };
    t.default = i, i._raw = '\n<svg width="1em" height="1em" viewBox="0 0 12 12" >\n        <circle cx="4" cy="50%" r="4" fill="#ABABAB" stroke="none" strokeWidth="1" fillRule="evenodd" />\n    </svg>';
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "currentColor",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M12 14a3 3 0 110-6 3 3 0 010 6zm0-1a2 2 0 110-4 2 2 0 010 4zm2.6 2c1.655 0 3.4 1.5 3.4 3.997v.503a.5.5 0 01-1 0v-.503C17 17.4 15.7 16 14.5 16h-5C8.3 16 7 17.3 7 18.997v.503a.5.5 0 01-1 0v-.503C6 16.5 7.745 15 9.4 15h5.2zM17 8a2 2 0 110-4 2 2 0 010 4zm0-1a1 1 0 110-2 1 1 0 010 2zm2.003 2A2.997 2.997 0 0122 11.997v.503a.5.5 0 01-1 0v-.503A2 2 0 0019.003 10H16.5c-.497 0-.5-.5-.5-.5s.003-.5.5-.5h2.503zM7 8a2 2 0 100-4 2 2 0 000 4zm0-1a1 1 0 100-2 1 1 0 000 2zM4.997 9A2.997 2.997 0 002 11.997v.503a.5.5 0 001 0v-.503A2 2 0 014.997 10H7.5c.497 0 .5-.5.5-.5S7.997 9 7.5 9H4.997z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M17 8a2 2 0 110-4 2 2 0 010 4zm2.003 1A2.997 2.997 0 0122 11.997v.503a.5.5 0 01-.5.5H16c.227-.573.34-1.24.34-2 0-.83-.34-1.5-.34-1.5s.003-.5.5-.5h2.503zM7 8a2 2 0 110-4 2 2 0 010 4zM4.997 9H7.5c.497 0 .5.5.5.5s-.34.67-.34 1.5c0 .76.113 1.427.34 2H2.5a.5.5 0 01-.5-.5v-.503A2.997 2.997 0 014.997 9zM12 14a3 3 0 110-6 3 3 0 010 6zm2.404 1C16.39 15 18 16.677 18 18.746v.629a.613.613 0 01-.6.625H6.6c-.331 0-.6-.28-.6-.625v-.629C6 16.677 7.61 15 9.596 15h4.808z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M7.12 7.862a.619.619 0 01-.09-.167.611.611 0 01-.03-.2c0-.07.01-.135.03-.196a.459.459 0 01.09-.161.388.388 0 01.14-.104A.426.426 0 017.43 7h9.14c.06 0 .116.011.17.034.053.023.1.058.14.104.04.046.07.1.09.16.02.062.03.127.03.196 0 .077-.01.144-.03.201a.619.619 0 01-.09.167.388.388 0 01-.14.104.426.426 0 01-.17.034H7.43a.426.426 0 01-.17-.034.388.388 0 01-.14-.104zm0 4a.619.619 0 01-.09-.167.611.611 0 01-.03-.2c0-.07.01-.135.03-.196a.459.459 0 01.09-.161.388.388 0 01.14-.104.426.426 0 01.17-.034h9.14c.06 0 .116.011.17.034.053.023.1.058.14.104.04.046.07.1.09.16.02.062.03.127.03.196 0 .077-.01.144-.03.201a.619.619 0 01-.09.167.388.388 0 01-.14.104.426.426 0 01-.17.034H7.43a.426.426 0 01-.17-.034.388.388 0 01-.14-.104zm0 4a.619.619 0 01-.09-.167.611.611 0 01-.03-.2c0-.07.01-.135.03-.196a.459.459 0 01.09-.161.388.388 0 01.14-.104.426.426 0 01.17-.034h9.14c.06 0 .116.011.17.034.053.023.1.058.14.104.04.046.07.1.09.16.02.062.03.127.03.196 0 .077-.01.144-.03.201a.619.619 0 01-.09.167.388.388 0 01-.14.104.426.426 0 01-.17.034H7.43a.426.426 0 01-.17-.034.388.388 0 01-.14-.104z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M7.12 7.862a.619.619 0 01-.09-.167.611.611 0 01-.03-.2c0-.07.01-.135.03-.196a.459.459 0 01.09-.161.388.388 0 01.14-.104A.426.426 0 017.43 7h9.14c.06 0 .116.011.17.034.053.023.1.058.14.104.04.046.07.1.09.16.02.062.03.127.03.196 0 .077-.01.144-.03.201a.619.619 0 01-.09.167.388.388 0 01-.14.104.426.426 0 01-.17.034H7.43a.426.426 0 01-.17-.034.388.388 0 01-.14-.104zm0 4a.619.619 0 01-.09-.167.611.611 0 01-.03-.2c0-.07.01-.135.03-.196a.459.459 0 01.09-.161.388.388 0 01.14-.104.426.426 0 01.17-.034h9.14c.06 0 .116.011.17.034.053.023.1.058.14.104.04.046.07.1.09.16.02.062.03.127.03.196 0 .077-.01.144-.03.201a.619.619 0 01-.09.167.388.388 0 01-.14.104.426.426 0 01-.17.034H7.43a.426.426 0 01-.17-.034.388.388 0 01-.14-.104zm0 4a.619.619 0 01-.09-.167.611.611 0 01-.03-.2c0-.07.01-.135.03-.196a.459.459 0 01.09-.161.388.388 0 01.14-.104.426.426 0 01.17-.034h9.14c.06 0 .116.011.17.034.053.023.1.058.14.104.04.046.07.1.09.16.02.062.03.127.03.196 0 .077-.01.144-.03.201a.619.619 0 01-.09.167.388.388 0 01-.14.104.426.426 0 01-.17.034H7.43a.426.426 0 01-.17-.034.388.388 0 01-.14-.104z",
        fill: "currentColor"
      }), o.createElement("circle", {
        stroke: "currentColor",
        fill: "#EA1010",
        cx: 19,
        cy: 5,
        r: 4.5
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M19.862 14.102a.275.275 0 00.062-.093.588.588 0 00.031-.103c.083-.495.126-1 .13-1.512.003-.512-.034-.848-.11-1.006-.323-.296-.739-.557-1.248-.785a9.456 9.456 0 00-1.775-.567 18.266 18.266 0 00-2.255-.346 30.59 30.59 0 00-2.679-.129c-.963 0-1.86.041-2.693.124-.833.082-1.585.201-2.256.356-.67.155-1.262.344-1.775.568-.512.223-.93.483-1.254.779-.069.165-.101.504-.098 1.016.004.513.047 1.017.13 1.512a.276.276 0 00.046.14.774.774 0 00.056.067c.117-.02.341-.065.671-.134.33-.07.685-.141 1.063-.217l1.703-.34.01-.01a.615.615 0 00.062-.083.62.62 0 00.073-.197 26.313 26.313 0 00.403-1.435l.164-.577.589-.093c.213-.034.572-.077 1.078-.13a20.81 20.81 0 012.018-.076 26.61 26.61 0 012.028.077c.506.045.869.088 1.089.129l.578.103.155.568c.103.364.189.674.258.929.068.254.117.423.144.505a.77.77 0 00.155.28c.11.027.33.075.66.144.33.068.68.139 1.048.211.368.072.717.143 1.048.212.33.069.55.11.66.124.007.006.014.006.02 0l.011-.01zm.637.651a1.1 1.1 0 01-.371.248.714.714 0 01-.413.041 89.21 89.21 0 00-.625-.119c-.347-.065-.724-.139-1.13-.222-.406-.082-.784-.158-1.135-.227-.351-.068-.571-.113-.66-.134a.946.946 0 01-.465-.3 1.675 1.675 0 01-.34-.608l-.186-.681c-.09-.324-.166-.585-.228-.785a13.12 13.12 0 00-.996-.118 21.859 21.859 0 00-1.935-.067c-.825 0-1.477.022-1.956.067-.478.044-.81.084-.995.118-.056.193-.128.454-.217.785-.09.33-.155.557-.196.681a1.826 1.826 0 01-.155.372c-.062.11-.134.206-.217.288a.827.827 0 01-.201.15 1.103 1.103 0 01-.222.088 150.187 150.187 0 01-1.816.382l-1.125.227a9.179 9.179 0 01-.63.113c-.227.048-.458-.013-.692-.185-.233-.172-.385-.437-.454-.795l-.056-.428a10.562 10.562 0 01-.078-.986c-.014-.372 0-.74.041-1.104.042-.365.141-.627.3-.785l.01-.01c.468-.44 1.046-.798 1.734-1.074.688-.275 1.423-.49 2.203-.645a18.82 18.82 0 012.4-.314 34.704 34.704 0 012.322-.083c.73 0 1.502.03 2.317.088.816.058 1.614.165 2.395.32.78.155 1.514.368 2.198.64.685.271 1.258.624 1.719 1.058.172.158.277.418.314.779.038.361.05.727.036 1.099-.013.371-.04.7-.077.986-.038.285-.057.435-.057.449a1.397 1.397 0 01-.134.381c-.062.117-.137.22-.227.31z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M20.5 14.753a1.1 1.1 0 01-.372.248.714.714 0 01-.413.041 89.21 89.21 0 00-.625-.119c-.347-.065-.724-.139-1.13-.222-.406-.082-.784-.158-1.135-.227-.351-.068-.571-.113-.66-.134a.946.946 0 01-.465-.3 1.675 1.675 0 01-.34-.608l-.186-.681c-.09-.324-.166-.585-.228-.785a13.12 13.12 0 00-.996-.118 21.859 21.859 0 00-1.935-.067c-.825 0-1.477.022-1.956.067-.478.044-.81.084-.995.118-.056.193-.128.454-.217.785-.09.33-.155.557-.196.681a1.826 1.826 0 01-.155.372c-.062.11-.134.206-.217.288a.827.827 0 01-.201.15 1.103 1.103 0 01-.222.088 150.187 150.187 0 01-1.816.382l-1.125.227a9.179 9.179 0 01-.63.113c-.227.048-.458-.013-.692-.185-.233-.172-.385-.437-.454-.795l-.056-.428a10.562 10.562 0 01-.078-.986c-.014-.372 0-.74.041-1.104.042-.365.141-.627.3-.785l.01-.01c.468-.44 1.046-.798 1.734-1.074.688-.275 1.423-.49 2.203-.645a18.82 18.82 0 012.4-.314 34.704 34.704 0 012.322-.083c.73 0 1.502.03 2.317.088.816.058 1.614.165 2.395.32.78.155 1.514.368 2.198.64.685.271 1.258.624 1.719 1.058.172.158.277.418.314.779.038.361.05.727.036 1.099-.013.371-.04.7-.077.986-.038.285-.057.435-.057.449a1.397 1.397 0 01-.134.381c-.062.117-.137.22-.227.31z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M21.61 14.315a.336.336 0 00.075-.113.72.72 0 00.038-.126c.1-.606.153-1.222.158-1.848.004-.627-.04-1.037-.133-1.23-.395-.362-.904-.681-1.526-.959a11.557 11.557 0 00-2.17-.694 22.325 22.325 0 00-2.756-.422 37.389 37.389 0 00-3.274-.158c-1.177 0-2.274.05-3.292.151-1.018.101-1.936.246-2.756.436-.82.189-1.543.42-2.17.693-.626.274-1.137.591-1.533.953-.084.202-.124.616-.12 1.242.005.627.057 1.243.158 1.848a.338.338 0 00.057.17c.03.039.053.066.07.083.142-.026.416-.08.82-.164.403-.084.836-.173 1.299-.265l2.081-.417.013-.012a.752.752 0 00.075-.101.757.757 0 00.089-.24 32.16 32.16 0 00.492-1.753l.201-.707.72-.113c.26-.042.7-.095 1.318-.158.618-.063 1.44-.094 2.466-.094 1.034.008 1.86.04 2.478.094.619.055 1.062.107 1.331.158l.707.126.189.694c.126.446.231.824.315 1.135.084.311.143.517.177.618a.942.942 0 00.19.34c.134.035.403.093.806.177.404.085.83.17 1.28.26.45.087.877.174 1.281.258.404.084.673.134.807.151.009.008.017.008.026 0l.012-.013zm.778.796a1.344 1.344 0 01-.454.303.872.872 0 01-.505.05 109.03 109.03 0 00-.763-.145c-.425-.08-.885-.17-1.381-.271-.497-.101-.96-.194-1.388-.278a34.85 34.85 0 01-.807-.164c-.202-.05-.391-.172-.568-.366a2.047 2.047 0 01-.416-.744c-.042-.16-.118-.437-.227-.832-.11-.396-.202-.715-.278-.96-.227-.041-.633-.09-1.217-.144-.585-.055-1.373-.082-2.365-.082-1.01 0-1.806.027-2.39.082-.585.054-.991.103-1.218.145-.067.235-.156.555-.265.959-.11.403-.19.68-.24.832-.05.168-.113.32-.189.454a1.617 1.617 0 01-.265.353 1.011 1.011 0 01-.246.183 1.348 1.348 0 01-.27.108 183.566 183.566 0 01-2.22.467l-1.376.277c-.42.084-.677.13-.77.139-.277.058-.559-.017-.845-.227-.286-.21-.47-.534-.555-.972l-.07-.523c-.045-.35-.077-.75-.094-1.205-.017-.454 0-.904.05-1.35.051-.445.173-.765.367-.958l.012-.013c.572-.538 1.278-.976 2.12-1.312.84-.336 1.738-.6 2.693-.788.954-.19 1.932-.318 2.932-.385 1.001-.067 1.947-.1 2.839-.1.891 0 1.835.035 2.832.106.996.072 1.972.202 2.926.391.955.19 1.85.45 2.687.782.837.333 1.537.764 2.1 1.293.21.194.339.511.385.953.046.441.061.89.044 1.343-.017.454-.048.856-.094 1.205-.047.349-.07.532-.07.549a1.707 1.707 0 01-.164.466 1.57 1.57 0 01-.277.379z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M12 4c1.104 0 2.143.208 3.117.625a8.028 8.028 0 012.547 1.71 8.028 8.028 0 011.711 2.548c.417.974.625 2.013.625 3.117a7.841 7.841 0 01-.625 3.117 8.028 8.028 0 01-1.71 2.547 8.028 8.028 0 01-2.548 1.711A7.841 7.841 0 0112 20a7.841 7.841 0 01-3.117-.625 8.028 8.028 0 01-2.547-1.71 8.028 8.028 0 01-1.711-2.548A7.841 7.841 0 014 12c0-1.104.208-2.143.625-3.117a8.028 8.028 0 011.71-2.547 8.028 8.028 0 012.548-1.711A7.841 7.841 0 0112 4zm0 15.016c.969 0 1.878-.185 2.727-.555a7.064 7.064 0 002.218-1.508 7.228 7.228 0 001.5-2.226c.37-.85.555-1.758.555-2.727 0-.969-.185-1.878-.555-2.727a7.131 7.131 0 00-1.5-2.218 7.131 7.131 0 00-2.218-1.5A6.753 6.753 0 0012 5c-.969 0-1.878.185-2.727.555-.849.37-1.588.87-2.218 1.5-.63.63-1.13 1.37-1.5 2.218A6.753 6.753 0 005 12c0 .969.185 1.878.555 2.727.37.849.87 1.59 1.5 2.226a7.064 7.064 0 002.218 1.508c.85.37 1.758.555 2.727.555zm-.734-2.516v-1.266h1.25V16.5h-1.25zm.718-9c.407 0 .763.05 1.07.148.308.1.576.253.805.461.22.198.383.44.493.727.109.286.164.612.164.976 0 .271-.037.527-.11.766-.073.24-.177.469-.312.688a8.285 8.285 0 01-.508.648c-.193.224-.404.45-.633.68a2.31 2.31 0 00-.273.32.872.872 0 00-.133.274c-.021.083-.037.195-.047.335-.01.141-.016.3-.016.477h-1.203c0-.292.013-.54.04-.742.025-.203.064-.362.117-.477.041-.114.127-.247.257-.398.13-.151.3-.32.508-.508.198-.24.37-.45.516-.633.146-.182.26-.336.344-.46.083-.136.145-.28.187-.43a1.91 1.91 0 00.063-.508c0-.209-.03-.396-.086-.563a1.085 1.085 0 00-.258-.422 1.18 1.18 0 00-.414-.265 1.577 1.577 0 00-.57-.094c-.188 0-.36.026-.516.078a1.29 1.29 0 00-.422.235c-.136.093-.234.26-.297.5-.063.24-.094.458-.094.656H9.5l-.016-.047c-.01-.323.042-.662.157-1.016.114-.354.291-.63.53-.828.24-.198.511-.344.813-.437.302-.094.636-.141 1-.141z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M12 4c1.104 0 2.143.208 3.117.625a8.028 8.028 0 012.547 1.71 8.028 8.028 0 011.711 2.548c.417.974.625 2.013.625 3.117a7.841 7.841 0 01-.625 3.117 8.028 8.028 0 01-1.71 2.547 8.028 8.028 0 01-2.548 1.711A7.841 7.841 0 0112 20a7.841 7.841 0 01-3.117-.625 8.028 8.028 0 01-2.547-1.71 8.028 8.028 0 01-1.711-2.548A7.841 7.841 0 014 12c0-1.104.208-2.143.625-3.117a8.028 8.028 0 011.71-2.547 8.028 8.028 0 012.548-1.711A7.841 7.841 0 0112 4zm-.734 12.5v-1.266h1.25V16.5h-1.25zm.718-9c.407 0 .763.05 1.07.148.308.1.576.253.805.461.22.198.383.44.493.727.109.286.164.612.164.976 0 .271-.037.527-.11.766-.073.24-.177.469-.312.688a8.285 8.285 0 01-.508.648c-.193.224-.404.45-.633.68a2.31 2.31 0 00-.273.32.872.872 0 00-.133.274c-.021.083-.037.195-.047.335-.01.141-.016.3-.016.477h-1.203c0-.292.013-.54.04-.742.025-.203.064-.362.117-.477.041-.114.127-.247.257-.398.13-.151.3-.32.508-.508.198-.24.37-.45.516-.633.146-.182.26-.336.344-.46.083-.136.145-.28.187-.43a1.91 1.91 0 00.063-.508c0-.209-.03-.396-.086-.563a1.085 1.085 0 00-.258-.422 1.18 1.18 0 00-.414-.265 1.577 1.577 0 00-.57-.094c-.188 0-.36.026-.516.078a1.29 1.29 0 00-.422.235c-.136.093-.234.26-.297.5-.063.24-.094.458-.094.656H9.5l-.016-.047c-.01-.323.042-.662.157-1.016.114-.354.291-.63.53-.828.24-.198.511-.344.813-.437.302-.094.636-.141 1-.141z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "currentColor",
        fillRule: "nonzero"
      }, o.createElement("path", {
        d: "M8 5h2a1 1 0 011 1v12a1 1 0 01-1 1H8a1 1 0 01-1-1V6a1 1 0 011-1zm0 1v12h2V6H8zM14 5h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V6a1 1 0 011-1zm0 1v12h2V6h-2z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M8 5h2a1 1 0 011 1v12a1 1 0 01-1 1H8a1 1 0 01-1-1V6a1 1 0 011-1zm6 0h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V6a1 1 0 011-1z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M7.667 5h2.666c.369 0 .667.348.667.778v12.444c0 .43-.298.778-.667.778H7.667C7.298 19 7 18.652 7 18.222V5.778c0-.43.298-.778.667-.778zM13.667 5h2.666c.369 0 .667.348.667.778v12.444c0 .43-.298.778-.667.778h-2.666c-.369 0-.667-.348-.667-.778V5.778c0-.43.298-.778.667-.778z",
        fill: "currentColor",
        fillRule: "nonzero"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "currentColor",
        strokeWidth: 1.3,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("rect", {
        x: 4.65,
        y: 3.65,
        width: 4.7,
        height: 16.7,
        rx: 1
      }), o.createElement("rect", {
        x: 13.65,
        y: 3.65,
        width: 4.7,
        height: 16.7,
        rx: 1
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "currentColor",
        fillRule: "nonzero"
      }, o.createElement("path", {
        d: "M5 3h4a1 1 0 011 1v16a1 1 0 01-1 1H5a1 1 0 01-1-1V4a1 1 0 011-1zM14 3h4a1 1 0 011 1v16a1 1 0 01-1 1h-4a1 1 0 01-1-1V4a1 1 0 011-1z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M5.186 15.856l13.128-7.578c.2-.117.476-.017.614.222.138.24.087.527-.114.644L5.686 16.722c-.2.117-.476.017-.614-.222-.138-.24-.087-.527.114-.644zM11 15.45V18a1 1 0 01-1 1H8a1 1 0 01-1-1v-.256l4-2.294zm6-3.486V18a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3.708l4-2.328zM8 5h2a1 1 0 011 1v4.96l-4 2.293V6a1 1 0 011-1zm6 0h2a1 1 0 011 1v1.5l-4 2.311V6a1 1 0 011-1z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M11 15.5v4.092C11 20.369 10.44 21 9.75 21h-2.5C6.56 21 6 20.37 6 19.592V18.5l5-3zm7-4v8.22c0 .707-.56 1.28-1.25 1.28h-2.5c-.69 0-1.25-.573-1.25-1.28V14.5l5-3zM7.25 3h2.5c.69 0 1.25.597 1.25 1.333V11l-5 3V4.333C6 3.597 6.56 3 7.25 3zm7 0h2.5c.69 0 1.25.558 1.25 1.247V7l-5 3V4.247C13 3.558 13.56 3 14.25 3zM3.59 17.067l16.454-9.5a.5.5 0 01.5.866l-16.454 9.5a.5.5 0 11-.5-.866z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M4.68 8.979c-.079.06-.171.128-.278.206L4.1 9.41c-.09.07-.198.165-.323.286-.134.13-.289.292-.463.485-.144.158-.243.289-.298.386-.013.023-.015.025-.016-.01.02.353.104.762.258 1.206.164.473.409.98.736 1.516a15.83 15.83 0 001.259 1.754 26.835 26.835 0 001.78 1.956 30.243 30.243 0 001.961 1.79c.611.506 1.19.924 1.737 1.255a8.56 8.56 0 001.507.74c.442.159.849.242 1.213.256-.083 0-.102.007-.08-.006.087-.05.206-.143.366-.295.191-.175.355-.333.49-.472.125-.13.223-.242.32-.367.099-.116.182-.217.251-.304.046-.058.075-.099.12-.172a.523.523 0 00.074-.155 82.97 82.97 0 00-1.407-.969c-.438-.294-.854-.56-1.231-.789a.767.767 0 00-.188.084c-.077.04-.22.116-.418.227-.203.113-.461.262-.774.446l-.577.341-.542-.393a12.988 12.988 0 01-1-.818c-.357-.32-.748-.692-1.173-1.12-.418-.418-.786-.81-1.106-1.175-.327-.373-.6-.715-.818-1.03l-.336-.48.278-.515.437-.806c.108-.198.183-.34.247-.465a.727.727 0 00.08-.187c-.35-.549-.676-1.05-.978-1.5-.281-.422-.541-.8-.78-1.135a.176.176 0 00-.026.005zm.78-.654c.263.367.552.785.866 1.256.314.47.654.992 1.02 1.566a.82.82 0 01.12.508c-.015.188-.083.39-.205.607a16.19 16.19 0 01-.239.452l-.436.804c.197.282.448.598.753.946.304.348.658.724 1.062 1.129.412.414.79.774 1.132 1.08.342.305.65.557.922.754.318-.188.583-.34.794-.458.211-.118.364-.2.458-.247.112-.066.227-.115.344-.148.117-.033.228-.05.33-.05a.851.851 0 01.436.113c.423.254.868.539 1.337.854.47.315.971.66 1.506 1.037.093.066.168.15.225.254.056.104.093.217.112.339a1.19 1.19 0 01-.042.402 1.453 1.453 0 01-.197.417 1.964 1.964 0 01-.169.24c-.075.094-.164.202-.267.324a4.953 4.953 0 01-.366.416c-.15.156-.328.327-.534.515-.197.189-.378.33-.542.424-.164.094-.307.141-.429.141a5.101 5.101 0 01-1.562-.318 9.556 9.556 0 01-1.688-.825c-.59-.358-1.21-.805-1.857-1.34a31.221 31.221 0 01-2.025-1.85 27.841 27.841 0 01-1.85-2.032c-.53-.65-.975-1.27-1.337-1.863a8.907 8.907 0 01-.823-1.7A5.323 5.323 0 012 10.54c0-.131.047-.28.14-.444a3.29 3.29 0 01.423-.558c.187-.207.356-.383.506-.529a4.86 4.86 0 01.408-.36l.324-.24c.103-.075.192-.14.267-.197.103-.076.21-.13.323-.163.113-.033.235-.049.366-.049.15 0 .284.026.401.078a.758.758 0 01.303.247zM16 12.5a.5.5 0 11-1 0A3.5 3.5 0 0011.5 9a.5.5 0 110-1 4.5 4.5 0 014.5 4.5zm3 0a.5.5 0 11-1 0A6.5 6.5 0 0011.5 6a.5.5 0 110-1 7.5 7.5 0 017.5 7.5zm3 0a.5.5 0 11-1 0A9.5 9.5 0 0011.5 3a.5.5 0 110-1C17.299 2 22 6.701 22 12.5z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M5.46 8.325c.263.367.552.785.866 1.256.314.47.654.992 1.02 1.566a.82.82 0 01.12.508c-.015.188-.083.39-.205.607a16.19 16.19 0 01-.239.452l-.436.804c.197.282.448.598.753.946.304.348.658.724 1.062 1.129.412.414.79.774 1.132 1.08.342.305.65.557.922.754.318-.188.583-.34.794-.458.211-.118.364-.2.458-.247.112-.066.227-.115.344-.148.117-.033.228-.05.33-.05a.851.851 0 01.436.113c.423.254.868.539 1.337.854.47.315.971.66 1.506 1.037.093.066.168.15.225.254.056.104.093.217.112.339a1.19 1.19 0 01-.042.402 1.453 1.453 0 01-.197.417 1.964 1.964 0 01-.169.24c-.075.094-.164.202-.267.324a4.953 4.953 0 01-.366.416c-.15.156-.328.327-.534.515-.197.189-.378.33-.542.424-.164.094-.307.141-.429.141a5.101 5.101 0 01-1.562-.318 9.556 9.556 0 01-1.688-.825c-.59-.358-1.21-.805-1.857-1.34a31.221 31.221 0 01-2.025-1.85 27.841 27.841 0 01-1.85-2.032c-.53-.65-.975-1.27-1.337-1.863a8.907 8.907 0 01-.823-1.7A5.323 5.323 0 012 10.54c0-.131.047-.28.14-.444a3.29 3.29 0 01.423-.558c.187-.207.356-.383.506-.529a4.86 4.86 0 01.408-.36l.324-.24c.103-.075.192-.14.267-.197.103-.076.21-.13.323-.163.113-.033.235-.049.366-.049.15 0 .284.026.401.078a.758.758 0 01.303.247zM16 12.5a.5.5 0 11-1 0A3.5 3.5 0 0011.5 9a.5.5 0 110-1 4.5 4.5 0 014.5 4.5zm3 0a.5.5 0 11-1 0A6.5 6.5 0 0011.5 6a.5.5 0 110-1 7.5 7.5 0 017.5 7.5zm3 0a.5.5 0 11-1 0A9.5 9.5 0 0011.5 3a.5.5 0 110-1C17.299 2 22 6.701 22 12.5z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M5.68 6.979l-.278.207-.303.223a4.085 4.085 0 00-.322.286c-.134.13-.289.292-.463.485a2.38 2.38 0 00-.298.385C4.003 8.588 4 8.591 4 8.556c.02.353.103.762.258 1.206.164.473.408.979.735 1.516a15.83 15.83 0 001.26 1.754 26.464 26.464 0 001.78 1.955 29.655 29.655 0 001.961 1.79c.611.507 1.19.925 1.736 1.256a8.56 8.56 0 001.508.739c.442.16.85.243 1.212.257-.082 0-.1.006-.079-.007.087-.048.206-.142.365-.294.193-.175.356-.332.49-.472.126-.13.224-.241.322-.367.097-.116.181-.217.25-.304.047-.058.075-.099.12-.172a.481.481 0 00.07-.141l.004-.014a86.256 86.256 0 00-1.407-.969c-.439-.294-.855-.56-1.232-.789a.871.871 0 00-.187.084c-.077.039-.219.116-.419.227-.203.113-.46.262-.773.446l-.578.341-.54-.393c-.302-.22-.635-.491-1-.818a29.297 29.297 0 01-2.28-2.294c-.327-.374-.6-.717-.818-1.031l-.336-.48.278-.515.437-.806c.108-.198.183-.34.247-.465a.761.761 0 00.08-.187 91.63 91.63 0 00-.978-1.5 48.63 48.63 0 00-.779-1.135.146.146 0 00-.027.005zm.78-.654c.263.366.552.785.866 1.256.314.47.654.992 1.02 1.566.093.151.133.32.12.508a1.473 1.473 0 01-.205.607c-.047.094-.126.245-.239.452l-.436.804c.197.282.448.598.753.946.304.348.658.724 1.062 1.129.412.414.79.773 1.132 1.08.342.306.65.556.921.755.32-.189.584-.342.795-.459.211-.117.364-.2.457-.247.113-.066.228-.116.345-.149.118-.032.227-.049.331-.049a.847.847 0 01.436.113c.422.255.867.539 1.336.854.47.315.971.661 1.505 1.037a.747.747 0 01.226.254c.056.104.093.217.112.339.01.132-.005.266-.042.402a1.478 1.478 0 01-.197.416 1.899 1.899 0 01-.169.241c-.075.093-.164.202-.267.324a5.023 5.023 0 01-.366.416c-.15.155-.328.327-.534.516a2.894 2.894 0 01-.542.422c-.164.095-.307.142-.429.142a5.136 5.136 0 01-1.562-.317 9.568 9.568 0 01-1.688-.827 15.603 15.603 0 01-1.857-1.339 31.755 31.755 0 01-2.025-1.85 27.415 27.415 0 01-1.85-2.032c-.53-.649-.976-1.27-1.337-1.863a8.941 8.941 0 01-.823-1.7A5.32 5.32 0 013 8.541c0-.132.047-.281.14-.445.094-.165.235-.351.422-.558.188-.206.357-.383.507-.529.15-.146.286-.266.408-.36.113-.085.22-.165.324-.24l.267-.197c.103-.076.211-.129.323-.163.113-.032.235-.049.366-.049a.98.98 0 01.401.078.749.749 0 01.302.247zm12.52 2.147c.189.094.366.192.532.294a3.269 3.269 0 00-.36-.548 2.88 2.88 0 00-.518-.504 3.178 3.178 0 00-.651-.377 4.29 4.29 0 00-.822-.26 5.393 5.393 0 00-.975-.113l-.964-.03-.006-1.08-1.855 1.61 1.854 1.63.002-.15.005-.994h.995c1.125 0 2.044.165 2.764.522zm-1.765.534h-.998l-.008 1.654a.31.31 0 01-.16.27.285.285 0 01-.157.028.246.246 0 01-.14-.065l-3.647-3.199a.301.301 0 01-.104-.233.301.301 0 01.104-.232l3.646-3.162a.246.246 0 01.14-.065.277.277 0 01.274.135c.029.046.044.1.044.162l.008 1.665c.41.012.795.057 1.155.135.36.078.697.185 1.01.321a3.957 3.957 0 011.551 1.172 4.1 4.1 0 01.724 1.334c.15.474.247.916.294 1.325.047.41.06.755.04 1.037-.021.283-.032.436-.032.461a.316.316 0 01-.087.181.243.243 0 01-.175.07h-.01a.214.214 0 01-.17-.079.331.331 0 01-.075-.19 5.84 5.84 0 00-.11-.48c-.073-.294-.25-.612-.532-.953-.28-.34-.703-.65-1.265-.93-.355-.177-.78-.362-1.32-.362z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M6.46 6.325c.263.366.552.785.866 1.256.314.47.654.992 1.02 1.566.093.151.133.32.12.508a1.473 1.473 0 01-.205.607c-.047.094-.126.245-.239.452l-.436.804c.197.282.448.598.753.946.304.348.658.724 1.062 1.129.412.414.79.773 1.132 1.08.342.306.65.556.921.755.32-.189.584-.342.795-.459.211-.117.364-.2.457-.247.113-.066.228-.116.345-.149.118-.032.227-.049.331-.049a.847.847 0 01.436.113c.422.255.867.539 1.336.854.47.315.971.661 1.505 1.037a.747.747 0 01.226.254c.056.104.093.217.112.339.01.132-.005.266-.042.402a1.478 1.478 0 01-.197.416 1.899 1.899 0 01-.169.241c-.075.093-.164.202-.267.324a5.023 5.023 0 01-.366.416c-.15.155-.328.327-.534.516a2.894 2.894 0 01-.542.422c-.164.095-.307.142-.429.142a5.136 5.136 0 01-1.562-.317 9.568 9.568 0 01-1.688-.827 15.603 15.603 0 01-1.857-1.339 31.755 31.755 0 01-2.025-1.85 27.415 27.415 0 01-1.85-2.032c-.53-.649-.976-1.27-1.337-1.863a8.941 8.941 0 01-.823-1.7A5.32 5.32 0 013 8.541c0-.132.047-.281.14-.445.094-.165.235-.351.422-.558.188-.206.357-.383.507-.529.15-.146.286-.266.408-.36.113-.085.22-.165.324-.24l.267-.197c.103-.076.211-.129.323-.163.113-.032.235-.049.366-.049a.98.98 0 01.401.078.749.749 0 01.302.247zm10.755 2.681h-.998l-.008 1.654a.31.31 0 01-.16.27.285.285 0 01-.157.028.246.246 0 01-.14-.065l-3.647-3.199a.301.301 0 01-.104-.233.301.301 0 01.104-.232l3.646-3.162a.246.246 0 01.14-.065.277.277 0 01.274.135c.029.046.044.1.044.162l.008 1.665c.41.012.795.057 1.155.135.36.078.697.185 1.01.321a3.957 3.957 0 011.551 1.172 4.1 4.1 0 01.724 1.334c.15.474.247.916.294 1.325.047.41.06.755.04 1.037-.021.283-.032.436-.032.461a.316.316 0 01-.087.181.243.243 0 01-.175.07h-.01a.214.214 0 01-.17-.079.331.331 0 01-.075-.19 5.84 5.84 0 00-.11-.48c-.073-.294-.25-.612-.532-.953-.28-.34-.703-.65-1.265-.93-.355-.177-.78-.362-1.32-.362z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "currentColor",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("circle", {
        cx: 12,
        cy: 6,
        r: 1.5
      }), o.createElement("rect", {
        x: 10.5,
        y: 10.5,
        width: 3,
        height: 9,
        rx: 1.5
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "currentColor",
        fillRule: "evenodd"
      }, o.createElement("circle", {
        cx: 12,
        cy: 6,
        r: 2
      }), o.createElement("rect", {
        x: 10,
        y: 10,
        width: 4,
        height: 10,
        rx: 2
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        fill: "currentColor",
        d: "M14 4a1 1 0 011 1l.001 2.1A5.023 5.023 0 0014 7V5H5v14h9v-2c.343 0 .678-.035 1.001-.1L15 19a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h9zm0 4a4 4 0 013.16 6.453l2.694 2.693a.5.5 0 01-.638.765l-.07-.057-2.693-2.694A4 4 0 1114 8zm0 1a3 3 0 100 6 3 3 0 000-6z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        fill: "currentColor",
        d: "M14 4a1 1 0 011 1l.001 2.1a5 5 0 100 9.8L15 19a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h9zm0 4a4 4 0 013.16 6.453l2.694 2.693a.5.5 0 01-.638.765l-.07-.057-2.693-2.694A4 4 0 1114 8zm0 1a3 3 0 100 6 3 3 0 000-6z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M17 7.707l-4.146 4.147a.5.5 0 01-.708-.708L16.293 7H13.5a.5.5 0 110-1h4a.5.5 0 01.5.5v4a.5.5 0 11-1 0V7.707zm.655 8.84c.182.119.293.312.334.58.041.269-.034.544-.225.826l-.245.32a9.873 9.873 0 01-.6.704 6.895 6.895 0 01-.758.702c-.268.214-.507.321-.716.321h-.013c-.6-.018-1.219-.164-1.856-.437a11.613 11.613 0 01-1.882-1.03A17.589 17.589 0 019.9 17.155a32.437 32.437 0 01-1.589-1.48 30.338 30.338 0 01-1.473-1.59c-.5-.578-.957-1.176-1.371-1.795a11.754 11.754 0 01-1.03-1.876c-.273-.632-.418-1.244-.436-1.835-.01-.218.093-.462.306-.73a7.4 7.4 0 01.703-.764c.255-.241.489-.444.702-.607.214-.164.326-.25.335-.26.109-.072.222-.127.34-.163A1.2 1.2 0 016.743 6c.146 0 .282.027.41.082a.667.667 0 01.3.245l.334.499c.186.277.386.577.6.9l.6.908c.187.282.303.459.348.532a.885.885 0 01.11.505c-.01.2-.069.409-.178.627-.064.11-.173.3-.327.573-.155.273-.278.496-.369.669.1.146.293.391.58.737.286.345.698.787 1.234 1.323.546.546.992.962 1.337 1.249.346.286.591.48.737.58.164-.091.384-.216.661-.375.278-.16.471-.266.58-.321.118-.064.234-.111.348-.143.114-.032.225-.048.334-.048.082 0 .16.011.232.034.073.023.141.052.205.089a140.36 140.36 0 011.453.948l.893.594c.273.182.436.295.491.34zm-.6.888a.258.258 0 00.061-.123.724.724 0 00.007-.082c-.091-.064-.268-.182-.532-.355s-.546-.36-.846-.56l-1.35-.9h-.014a.575.575 0 00-.095.014.579.579 0 00-.178.082 24.589 24.589 0 00-1.214.682l-.49.273-.45-.328c-.165-.118-.43-.327-.799-.627-.368-.3-.83-.728-1.384-1.283a24.874 24.874 0 01-1.29-1.392 11.95 11.95 0 01-.634-.805l-.313-.45.272-.478c.173-.309.32-.57.444-.784.122-.214.202-.357.238-.43a.72.72 0 00.082-.287 19.89 19.89 0 00-.34-.532 86.337 86.337 0 00-.553-.832c-.196-.291-.38-.569-.553-.833a9.743 9.743 0 00-.354-.518c0-.01-.005-.014-.014-.014h-.014a.257.257 0 00-.102.02.55.55 0 00-.089.049 8.948 8.948 0 00-1.084.914c-.341.336-.539.582-.593.737.018.409.12.857.306 1.344.187.486.453 1.003.798 1.548.346.546.767 1.12 1.262 1.72.496.6 1.057 1.219 1.685 1.855a25.587 25.587 0 001.862 1.7c.605.495 1.18.913 1.725 1.255a9.091 9.091 0 001.549.791c.486.187.934.293 1.343.32.155-.063.4-.265.737-.607a8.95 8.95 0 00.914-1.084z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M19 5.707l-4.146 4.147a.5.5 0 01-.708-.708L18.293 5H15.5a.5.5 0 110-1h4a.5.5 0 01.5.5v4a.5.5 0 11-1 0V5.707zm.556 11.854c.234.152.377.401.43.746.053.345-.044.699-.29 1.061l-.315.413c-.21.275-.468.576-.772.903a8.865 8.865 0 01-.973.904c-.345.275-.652.412-.92.412h-.018c-.772-.023-1.567-.21-2.386-.561a14.93 14.93 0 01-2.42-1.325 22.614 22.614 0 01-2.306-1.772 41.704 41.704 0 01-2.043-1.903 39.006 39.006 0 01-1.894-2.044 23.393 23.393 0 01-1.763-2.307c-.532-.796-.973-1.6-1.324-2.413-.35-.812-.538-1.599-.561-2.36-.012-.28.12-.593.394-.938.275-.345.576-.672.904-.982.327-.31.628-.57.903-.781.275-.21.418-.322.43-.333.14-.094.286-.164.438-.21.152-.048.304-.071.456-.071.187 0 .362.035.526.105.164.07.292.176.386.316l.43.64c.24.357.496.743.771 1.158l.772 1.167c.24.363.389.59.447.684.105.176.152.392.14.65a2.013 2.013 0 01-.228.806c-.081.14-.222.386-.42.737-.2.351-.357.638-.474.86.129.187.377.503.745.947.369.445.898 1.012 1.588 1.702.701.702 1.274 1.237 1.718 1.605.445.369.76.617.947.746.21-.117.494-.278.851-.483.357-.204.605-.342.745-.412.152-.082.301-.143.448-.184.146-.041.289-.062.43-.062.104 0 .204.015.297.044.094.03.182.068.263.114a180.466 180.466 0 011.868 1.22l1.149.763c.35.234.561.38.631.438zm-.771 1.14a.332.332 0 00.079-.157.931.931 0 00.008-.105 32.737 32.737 0 00-.684-.457c-.339-.222-.701-.462-1.087-.719l-1.736-1.158h-.018a.739.739 0 00-.123.018.744.744 0 00-.228.105 31.614 31.614 0 00-1.56.877l-.632.351-.579-.42c-.21-.153-.552-.422-1.026-.808-.473-.386-1.066-.936-1.78-1.65a31.98 31.98 0 01-1.657-1.789 15.364 15.364 0 01-.816-1.035l-.403-.579.35-.614c.223-.397.413-.734.57-1.008.159-.275.261-.46.308-.553a.926.926 0 00.105-.368c-.07-.117-.216-.345-.438-.685-.223-.339-.46-.696-.71-1.07-.252-.374-.489-.73-.711-1.07-.222-.34-.374-.561-.456-.667 0-.011-.006-.017-.018-.017h-.017a.33.33 0 00-.132.026.707.707 0 00-.114.062c-.49.35-.955.742-1.394 1.175-.438.433-.693.749-.763.947.024.527.155 1.103.395 1.728.24.626.581 1.29 1.026 1.992.444.701.985 1.438 1.622 2.21.637.772 1.36 1.567 2.166 2.386a32.898 32.898 0 002.394 2.184 21.586 21.586 0 002.219 1.614c.701.439 1.365.778 1.99 1.018.626.24 1.201.377 1.728.412.198-.082.514-.342.947-.78.432-.44.824-.904 1.175-1.395z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none"
      }, o.createElement("path", {
        d: "M11.551 20.505c3.298-1.593 5.611-3.32 7.093-5.106.24-.29 1.003-1.365 1.138-1.609.318-.574.531-1.18.631-1.806l.003-.015c.033-.177.054-.338.063-.483.01-.16.004-.41-.009-.637-.202-3.517-3.916-6.347-8.48-6.347-4.71 0-8.489 3.006-8.489 6.65 0 3.317 3.148 6.15 7.357 6.591a.989.989 0 01.879 1.093l-.186 1.67z",
        stroke: "currentColor"
      }), o.createElement("path", {
        d: "M7.047 12.6V9.59a.46.46 0 00-.92 0v3.471c0 .254.207.46.46.46h1.84a.46.46 0 000-.92h-1.38zM9.884 13.52h-.201a.36.36 0 01-.36-.36V9.489c0-.198.161-.359.36-.359h.2c.2 0 .36.161.36.36v3.672a.36.36 0 01-.36.36zM13.6 9.589v2.12s-1.837-2.394-1.865-2.426a.458.458 0 00-.36-.154.472.472 0 00-.442.479v3.452a.46.46 0 00.92 0v-2.108s1.863 2.416 1.89 2.442c.082.077.191.125.312.126.255.002.464-.223.464-.479V9.59a.46.46 0 00-.92 0zM17.967 9.589a.46.46 0 00-.46-.46h-1.839a.46.46 0 00-.46.46v3.471c0 .254.207.46.46.46h1.84a.46.46 0 000-.92h-1.38v-.816h1.38a.46.46 0 000-.92h-1.38v-.815h1.38a.46.46 0 00.46-.46z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M20.907 12.063a6.018 6.018 0 01-.687 1.97c-.161.29-.95 1.394-1.191 1.686-1.33 1.6-3.555 3.448-7.276 5.244a.49.49 0 01-.7-.494l.187-1.688a.489.489 0 00-.434-.54c-4.405-.462-7.805-3.46-7.805-7.089 0-3.948 4.025-7.15 8.99-7.15 4.824 0 8.76 3.024 8.978 6.818.007.11.024.462.009.699-.01.143-.03.326-.071.544zm-13.86.538V9.589a.46.46 0 00-.92 0v3.471c0 .254.207.46.46.46h1.84a.46.46 0 000-.92h-1.38zm2.837.92a.36.36 0 00.359-.36V9.488a.36.36 0 00-.36-.359h-.2a.36.36 0 00-.36.36v3.672c0 .198.161.36.36.36h.2zm3.715-3.932v2.12s-1.836-2.394-1.864-2.426a.458.458 0 00-.36-.154.472.472 0 00-.442.479v3.452a.46.46 0 00.92 0v-2.108s1.863 2.416 1.89 2.442c.082.077.191.125.312.126.255.002.464-.223.464-.479V9.59a.46.46 0 00-.92 0zm4.368 0a.46.46 0 00-.46-.46h-1.839a.46.46 0 00-.46.46v3.471c0 .254.207.46.46.46h1.84a.46.46 0 000-.92h-1.38v-.816h1.38a.46.46 0 000-.92h-1.38v-.815h1.38a.46.46 0 00.46-.46z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("defs", null, o.createElement("path", {
        d: "M11.767 18.051l.093.141a.27.27 0 01.055.133.378.378 0 01-.008.133.287.287 0 01-.062.118.68.68 0 01-.109.102l-.155.078-2.313 1.205a.32.32 0 01-.248.024.364.364 0 01-.202-.164l-.046-.126a.323.323 0 01-.039-.266.309.309 0 01.163-.203l1.257-.658h-.03c-.011 0-.022-.005-.032-.016a6.056 6.056 0 01-1.335-.5 7.225 7.225 0 01-1.195-.776 6.57 6.57 0 01-1.009-1.002c-.3-.37-.563-.775-.791-1.213a7.082 7.082 0 01-.497-1.26 6.758 6.758 0 01-.24-1.316 7.239 7.239 0 01.015-1.338c.047-.45.143-.893.287-1.331.135-.439.313-.853.536-1.245.222-.391.478-.76.768-1.104.29-.344.61-.657.962-.939a6.545 6.545 0 011.149-.736.428.428 0 01.357-.031.481.481 0 01.31.61.483.483 0 01-.233.282 6.146 6.146 0 00-1.808 1.44 5.703 5.703 0 00-1.125 2.02 5.855 5.855 0 00-.256 2.294c.067.778.277 1.516.629 2.216.196.365.424.707.682 1.025a5.866 5.866 0 001.886 1.527c.367.187.753.334 1.156.438.042.01.08.02.117.031l.116.032-.916-1.44a.478.478 0 01-.07-.283c.006-.104.05-.177.133-.219l.124-.078a.363.363 0 01.497.125l1.427 2.255v.015zm6.472-9.05c.207.408.373.828.497 1.261.124.433.204.872.24 1.315.036.444.031.89-.015 1.339a6.305 6.305 0 01-.287 1.33 6.785 6.785 0 01-2.227 3.288 6.545 6.545 0 01-1.126.737.678.678 0 01-.116.047.459.459 0 01-.357-.055.465.465 0 01-.179-.196.479.479 0 01-.03-.376.483.483 0 01.232-.282 5.898 5.898 0 002.887-3.46 5.888 5.888 0 00-.372-4.51 6.008 6.008 0 00-1.522-1.893 5.506 5.506 0 00-2.157-1.096 1.74 1.74 0 00-.295-.07 4.27 4.27 0 01-.295-.056l.916 1.44a.438.438 0 01.062.283c-.01.104-.057.177-.14.219l-.124.078a.315.315 0 01-.263.04.363.363 0 01-.218-.165l-1.428-2.255h-.015l-.078-.156a.27.27 0 01-.054-.133.378.378 0 01.008-.133.287.287 0 01.062-.118.68.68 0 01.108-.102l.156-.078L14.42 4.04a.372.372 0 01.272-.024c.098.026.173.08.225.164l.046.126a.27.27 0 01.016.266.482.482 0 01-.186.22l-1.242.625a2.491 2.491 0 01.404.094c.465.126.91.295 1.334.51.424.213.818.469 1.18.766.362.298.693.632.993 1.002.3.37.559.775.776 1.214z",
        id: "IcnLoading_svg__a"
      })), o.createElement("g", {
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }, o.createElement("use", {
        xlinkHref: "#IcnLoading_svg__a"
      }), o.createElement("use", {
        xlinkHref: "#IcnLoading_svg__a"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M4.432 12.5l1.844 1.828c.094.104.14.224.14.36a.521.521 0 01-.14.359.712.712 0 01-.172.101.484.484 0 01-.375 0 .712.712 0 01-.172-.101l-2.273-2.334a1 1 0 010-1.395l2.273-2.334a.494.494 0 01.719 0c.094.094.14.211.14.352 0 .14-.046.258-.14.351L4.463 11.5h8.625c.146 0 .266.047.36.14.093.094.14.214.14.36a.494.494 0 01-.5.5H4.432zM18.558 4c.283 0 .528.096.735.29.207.192.31.429.31.71v14a.933.933 0 01-.31.71c-.207.194-.452.29-.735.29H9.666c-.295 0-.542-.096-.744-.29A.945.945 0 018.62 19v-4.024a.492.492 0 11.984 0v3.415c0 .166.062.31.187.43s.275.179.45.179h7.736a.6.6 0 00.442-.18c.12-.12.18-.263.18-.43l-.017-12.78c0-.167-.06-.31-.18-.43a.6.6 0 00-.441-.18h-7.72a.628.628 0 00-.45.18.574.574 0 00-.188.43v3.398a.492.492 0 11-.984 0V5c0-.281.101-.518.303-.71.202-.194.45-.29.744-.29h8.892z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M4.432 12.5l1.844 1.828c.094.104.14.224.14.36a.521.521 0 01-.14.359.712.712 0 01-.172.101.484.484 0 01-.375 0 .712.712 0 01-.172-.101l-2.273-2.334a1 1 0 010-1.395l2.273-2.334a.494.494 0 01.719 0c.094.094.14.211.14.352 0 .14-.046.258-.14.351L4.463 11.5h8.625c.146 0 .266.047.36.14.093.094.14.214.14.36a.494.494 0 01-.5.5H4.432zM18.558 4c.283 0 .528.096.735.29.207.192.31.429.31.71v14a.933.933 0 01-.31.71c-.207.194-.452.29-.735.29H9.666c-.295 0-.542-.096-.744-.29A.945.945 0 018.62 19v-4.024c0-.271.22-.492.491-.492h5c2.508 0 2.639-4.984 0-4.984H9.144a.523.523 0 01-.523-.523V5c0-.281.1-.518.302-.71.202-.194.45-.29.744-.29h8.892z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M10.64 14.984h-.343a4.147 4.147 0 01-.719-.047 4.527 4.527 0 01-.476.422c-.245.198-.534.407-.868.625a9.02 9.02 0 01-1.054.594c-.37.177-.716.292-1.04.344h-.015l-.031.008a.337.337 0 01-.32-.102.376.376 0 01-.102-.265.305.305 0 01.031-.14l-.015-.001c.125-.208.299-.529.523-.961.224-.432.336-.83.336-1.195v-.032a4.44 4.44 0 01-1.125-.812 4.576 4.576 0 01-.797-1.063A5.327 5.327 0 014 9.875c0-.677.17-1.312.508-1.906a4.982 4.982 0 011.398-1.547 7.194 7.194 0 012.078-1.04A8.254 8.254 0 0110.531 5c.896 0 1.737.128 2.524.383a6.988 6.988 0 012.054 1.039 5.059 5.059 0 011.383 1.547c.339.594.508 1.229.508 1.906.01.76-.146 1.456-.469 2.086a4.83 4.83 0 01-1.343 1.617c-.573.448-1.25.794-2.032 1.04a8.37 8.37 0 01-2.515.366zm-1.468-1.078l.547.047c.24.031.458.047.656.047h.297c.76 0 1.466-.102 2.117-.305a5.26 5.26 0 001.688-.86 4.13 4.13 0 001.117-1.312c.27-.505.406-1.054.406-1.648 0-.542-.143-1.047-.43-1.516a4.189 4.189 0 00-1.164-1.226 5.953 5.953 0 00-1.734-.828A7.308 7.308 0 0010.532 6c-.761 0-1.477.102-2.15.305-.671.203-1.26.479-1.765.828A4.082 4.082 0 005.43 8.359c-.287.47-.43.974-.43 1.516 0 .646.161 1.297.484 1.953.323.656.828 1.162 1.516 1.516l.547.281-.047.61-.031.273c-.021.182-.12.513-.297.992.281-.167.56-.362.836-.586.276-.224.45-.383.523-.476l.64-.532zm10.828 0c0 .73-.177 1.373-.531 1.93-.354.557-.901 1.023-1.64 1.398v.032c0 .323.062.698.187 1.125.125.427.24.729.343.906a.305.305 0 01.032.125.318.318 0 01-.328.328h-.094c-.552-.094-1.11-.375-1.672-.844-.563-.469-.901-.776-1.016-.922-.125.01-.234.019-.328.024a5.362 5.362 0 01-.297.008h-.297a7.53 7.53 0 01-1.445-.133 6.147 6.147 0 01-1.273-.39 5.142 5.142 0 01-1.938-1.445c.021-.022.294-.032.82-.032s.732.005.618.015c.427.334.9.581 1.421.742.521.162 1.12.243 1.797.243h.305c.203 0 .357-.01.461-.032l.531-.078.29.39c.192.261.533.569 1.023.923-.042-.157-.073-.464-.094-.922l-.031-.688.484-.234c.594-.302 1.021-.654 1.281-1.055.26-.4.391-.872.391-1.414 0-.437-.076-.817-.227-1.14-.15-.323-.44-.636-.867-.938.052-.167.102-.344.149-.531.047-.188.08-.37.101-.547.657.385 1.128.839 1.414 1.36.287.52.43 1.12.43 1.796z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M10.64 14.984h-.343a4.147 4.147 0 01-.719-.047 4.527 4.527 0 01-.476.422c-.245.198-.534.407-.868.625a9.02 9.02 0 01-1.054.594c-.37.177-.716.292-1.04.344l-.046.008a.337.337 0 01-.32-.102.376.376 0 01-.102-.265.305.305 0 01.031-.14c.11-.21.284-.53.508-.962.224-.432.336-.83.336-1.195a5.475 5.475 0 01-1.125-.844 4.576 4.576 0 01-.797-1.063A5.327 5.327 0 014 9.875c0-.677.17-1.312.508-1.906a4.982 4.982 0 011.398-1.547 7.194 7.194 0 012.078-1.04A8.254 8.254 0 0110.531 5c.896 0 1.737.128 2.524.383a6.988 6.988 0 012.054 1.039 5.059 5.059 0 011.383 1.547c.339.594.508 1.229.508 1.906.01.76-.146 1.456-.469 2.086a4.83 4.83 0 01-1.343 1.617c-.573.448-1.25.794-2.032 1.04a8.37 8.37 0 01-2.515.366zM20 13.906c0 .73-.177 1.373-.531 1.93-.354.557-.901 1.023-1.64 1.398v.032c0 .323.062.698.187 1.125.125.427.24.729.343.906a.305.305 0 01.032.125.318.318 0 01-.328.328h-.094c-.552-.094-1.11-.375-1.672-.844-.563-.469-.901-.776-1.016-.922-.125.01-.234.019-.328.024a5.362 5.362 0 01-.297.008h-.297a7.53 7.53 0 01-1.445-.133 6.147 6.147 0 01-1.273-.39 5.142 5.142 0 01-1.938-1.445c.021-.022 6.804.702 8.352-4.751.047-.188.08-.37.101-.547.657.385 1.128.839 1.414 1.36.287.52.43 1.12.43 1.796z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 5a2 2 0 012 2v9a2 2 0 01-2 2H8l-2.388 1.847A1 1 0 014 19.056V7a2 2 0 012-2h12zm0 1H6a1 1 0 00-1 1v12.056L7.658 17H18a1 1 0 001-1V7a1 1 0 00-1-1zm-4.5 7a.5.5 0 010 1h-6a.5.5 0 010-1h6zm3-2a.5.5 0 010 1h-9a.5.5 0 010-1h9zm0-2a.5.5 0 010 1h-9a.5.5 0 010-1h9z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M11 12.5a.5.5 0 01.5.5v5a.5.5 0 01-1 0v-3.794l-4.646 4.648a.5.5 0 01-.638.057l-.07-.057a.5.5 0 010-.708L9.792 13.5H6a.5.5 0 010-1h5zM12.5 12a.5.5 0 01-.5-.5v-5a.5.5 0 011 0v3.794l4.646-4.648a.5.5 0 01.638-.057l.07.057a.5.5 0 010 .708L13.708 11H17.5a.5.5 0 010 1h-5z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M17.1 12a.6.6 0 01-.601.6H7.501a.6.6 0 110-1.2h8.998a.6.6 0 01.601.6z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M13.229 3.071c.107.054.19.13.251.23.06.1.09.21.09.33V20.36c0 .12-.03.23-.09.33a.597.597 0 01-.251.23.447.447 0 01-.14.06.543.543 0 01-.331-.01.6.6 0 01-.172-.09l-6.428-5.043h-2.13c-.548 0-1.017-.17-1.405-.51-.389-.34-.583-.75-.583-1.23L2 9.875c0-.48.194-.888.583-1.221.388-.334.857-.5 1.406-.5h2.129l6.468-5.043a.6.6 0 01.322-.11.572.572 0 01.321.07zm5.504 9.08c0 .817-.261 1.547-.783 2.19a3.335 3.335 0 01-2.04 1.215.223.223 0 01-.07.01.612.612 0 01-.401-.15.616.616 0 01-.221-.372.587.587 0 01.09-.482.662.662 0 01.412-.282 1.996 1.996 0 001.245-.753c.322-.408.482-.867.482-1.376 0-.549-.157-1.024-.472-1.426a1.89 1.89 0 00-1.235-.723.588.588 0 01-.412-.261.652.652 0 01-.11-.483.633.633 0 01.25-.421.576.576 0 01.493-.1A3.155 3.155 0 0117.95 9.9c.522.643.783 1.393.783 2.25zm-.844-5.906a5.978 5.978 0 011.668.934c.495.395.924.85 1.285 1.366a6.31 6.31 0 01.834 5.494 6.164 6.164 0 01-.834 1.698c-.361.515-.79.97-1.285 1.366a5.978 5.978 0 01-1.668.934.929.929 0 01-.11.03.623.623 0 01-.472-.1.683.683 0 01-.241-.292.623.623 0 01.01-.502.576.576 0 01.371-.321 4.98 4.98 0 002.34-1.859 4.9 4.9 0 00.895-2.842 4.93 4.93 0 00-.894-2.862 4.859 4.859 0 00-2.34-1.838.645.645 0 01-.372-.342.578.578 0 01-.01-.482.573.573 0 01.331-.372.601.601 0 01.492-.01z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M13.229 3.071c.107.054.19.13.251.23.06.1.09.21.09.33V20.36c0 .12-.03.23-.09.33a.597.597 0 01-.251.23.447.447 0 01-.14.06.543.543 0 01-.331-.01.6.6 0 01-.172-.09l-6.428-5.043h-2.13c-.548 0-1.017-.17-1.405-.51-.389-.34-.583-.75-.583-1.23L2 9.875c0-.48.194-.888.583-1.221.388-.334.857-.5 1.406-.5h2.129l6.468-5.043a.6.6 0 01.322-.11.572.572 0 01.321.07zm-.944 16.15V4.84L6.68 9.34a.6.6 0 01-.361.12h-2.33c-.215 0-.385.047-.513.14-.127.095-.19.195-.19.302l.04 4.239c0 .107.063.21.19.311.128.1.299.15.513.15h2.33c.067 0 .13.007.19.02.061.014.118.041.172.081l5.564 4.52zM20.696 9.912L18.608 12l2.088 2.088a.43.43 0 11-.608.608L18 12.608l-2.088 2.088a.43.43 0 11-.608-.608L17.392 12l-2.088-2.088a.43.43 0 11.608-.608L18 11.392l2.088-2.088a.43.43 0 11.608.608z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M12.734 5.055a.465.465 0 01.195.18c.047.077.07.163.07.256v13.011a.488.488 0 01-.07.257.465.465 0 01-.195.179.348.348 0 01-.11.046.422.422 0 01-.258-.008.467.467 0 01-.132-.07l-5-3.921H5.578c-.427 0-.792-.133-1.094-.397-.302-.265-.453-.584-.453-.957L4 10.347c0-.374.151-.69.453-.95.302-.259.667-.389 1.094-.389h1.656l5.03-3.922a.467.467 0 01.25-.085.445.445 0 01.25.054zm4.28 7.062c0 .636-.203 1.204-.609 1.703a2.594 2.594 0 01-1.64.954.476.476 0 01-.313-.118.479.479 0 01-.172-.289.457.457 0 01.07-.375.515.515 0 01.321-.218c.396-.073.719-.269.969-.586.25-.318.375-.675.375-1.07 0-.428-.123-.797-.368-1.11a1.47 1.47 0 00-.96-.562.457.457 0 01-.32-.203.507.507 0 01-.087-.375.492.492 0 01.196-.328.448.448 0 01.383-.079c.624.105 1.14.407 1.546.907.406.5.61 1.083.61 1.75zm-.656-4.593c.48.177.912.42 1.297.727a5.09 5.09 0 011 1.062 4.908 4.908 0 01.648 4.273c-.15.48-.367.92-.648 1.32a5.09 5.09 0 01-1 1.063 4.65 4.65 0 01-1.297.726.439.439 0 01-.172.031.485.485 0 01-.28-.085.531.531 0 01-.188-.227.485.485 0 01.008-.39.448.448 0 01.289-.25 3.873 3.873 0 001.82-1.446 3.81 3.81 0 00.695-2.21c0-.813-.232-1.555-.695-2.227a3.78 3.78 0 00-1.82-1.43.502.502 0 01-.29-.265.45.45 0 01-.007-.375.446.446 0 01.258-.29.468.468 0 01.382-.007z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "currentColor",
        fillRule: "evenodd"
      }, o.createElement("circle", {
        cx: 8,
        cy: 12,
        r: 1
      }), o.createElement("circle", {
        cx: 12,
        cy: 12,
        r: 1
      }), o.createElement("circle", {
        cx: 16,
        cy: 12,
        r: 1
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M11.984 15c-.708 0-1.3-.232-1.773-.695-.474-.464-.711-1.045-.711-1.742V6.609c0-.718.242-1.333.727-1.843.484-.51 1.07-.766 1.757-.766h.11c.677 0 1.247.253 1.71.758.464.505.696 1.122.696 1.851v5.954c0 .708-.227 1.291-.68 1.75-.453.458-1.028.687-1.726.687h-.11zM10.5 6.61v5.952c0 .428.138.774.414 1.04.276.265.633.398 1.07.398h.11c.427 0 .768-.133 1.023-.398.255-.266.383-.612.383-1.04V6.61c0-.458-.133-.84-.398-1.148A1.275 1.275 0 0012.094 5h-.11c-.406 0-.755.156-1.046.469a1.61 1.61 0 00-.438 1.14zm6 2.89a.48.48 0 01.352.148A.48.48 0 0117 10v2.078c0 1.125-.13 2.04-.39 2.742-.261.703-.597 1.253-1.008 1.649a3.288 3.288 0 01-1.368.812c-.5.146-.994.219-1.484.219h-.25V19H15a.48.48 0 01.352.148.48.48 0 01.148.352.48.48 0 01-.148.352A.48.48 0 0115 20H9a.48.48 0 01-.352-.148.48.48 0 01-.148-.352.48.48 0 01.148-.352A.48.48 0 019 19h2.5v-1.5h-.234c-.709 0-1.328-.12-1.86-.36a3.474 3.474 0 01-1.336-1.054c-.36-.464-.627-1.031-.804-1.703C7.089 13.71 7 12.943 7 12.078V10a.48.48 0 01.148-.352A.48.48 0 017.5 9.5a.48.48 0 01.352.148A.48.48 0 018 10v2.078c0 .5.036 1.013.11 1.54.072.525.223 1.002.453 1.429.229.427.56.776.992 1.047.432.27 1.002.406 1.71.406h1.485c.552 0 1.031-.091 1.438-.273a2.489 2.489 0 001.007-.82c.266-.365.466-.826.602-1.384.135-.557.203-1.205.203-1.945V10a.48.48 0 01.148-.352.48.48 0 01.352-.148z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "currentColor",
        fillRule: "evenodd"
      }, o.createElement("rect", {
        transform: "rotate(-45 12.071 11.071)",
        x: 2.571,
        y: 10.571,
        width: 19,
        height: 1,
        rx: .5
      }), o.createElement("path", {
        d: "M8.73 16.74l.717-.717c.035.024.071.048.108.07.432.272 1.002.407 1.71.407h1.485c.552 0 1.031-.091 1.438-.273a2.489 2.489 0 001.007-.82c.266-.365.466-.826.602-1.384.135-.557.203-1.205.203-1.945V10a.48.48 0 01.148-.352.48.48 0 01.352-.148.48.48 0 01.352.148A.48.48 0 0117 10v2.078c0 1.125-.13 2.04-.39 2.742-.261.703-.597 1.253-1.008 1.649a3.288 3.288 0 01-1.368.812c-.5.146-.994.219-1.484.219h-.25V19H15a.48.48 0 01.352.148.48.48 0 01.148.352.48.48 0 01-.148.352A.48.48 0 0115 20H9a.48.48 0 01-.352-.148.48.48 0 01-.148-.352.48.48 0 01.148-.352A.48.48 0 019 19h2.5v-1.5h-.234c-.709 0-1.328-.12-1.86-.36a3.506 3.506 0 01-.676-.4zm-1.545-2.697A9.578 9.578 0 017 12.078V10a.48.48 0 01.148-.352A.48.48 0 017.5 9.5a.48.48 0 01.352.148A.48.48 0 018 10v2.078c0 .358.019.723.056 1.094l-.87.87zm3.575.668l3.74-3.74v1.591c0 .709-.227 1.292-.68 1.75-.453.459-1.028.688-1.726.688h-.11c-.457 0-.865-.096-1.224-.29zM9.5 11.728V6.609c0-.718.242-1.333.727-1.843.484-.51 1.07-.766 1.757-.766h.11c.677 0 1.247.253 1.71.758.464.505.696 1.122.696 1.851v.119l-5 5z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M11.981 15.75c-.85 0-1.56-.29-2.128-.87C9.284 14.302 9 13.577 9 12.704V5.262c0-.899.29-1.667.872-2.305.581-.638 1.284-.957 2.11-.957h.13c.813 0 1.497.316 2.054.947.556.632.834 1.403.834 2.315v7.441c0 .886-.272 1.615-.816 2.188-.543.573-1.234.859-2.071.859h-.132zM10.2 5.262v7.441c0 .534.166.967.497 1.299.331.332.76.498 1.284.498h.132c.512 0 .921-.166 1.228-.498.306-.332.459-.765.459-1.299V5.262c0-.573-.16-1.052-.478-1.436a1.505 1.505 0 00-1.21-.576h-.13c-.488 0-.907.195-1.257.586-.35.39-.525.866-.525 1.426zm7.2 3.613c.163 0 .303.062.422.186.119.123.178.27.178.439v2.598c0 1.406-.156 2.548-.469 3.427-.312.88-.715 1.566-1.21 2.06-.493.496-1.04.834-1.64 1.017-.6.182-1.193.273-1.781.273h-.3v1.875h3c.163 0 .303.062.422.186.119.123.178.27.178.439 0 .17-.06.316-.178.44A.566.566 0 0115.6 22H8.4a.566.566 0 01-.422-.186.613.613 0 01-.178-.439c0-.17.06-.316.178-.44a.566.566 0 01.422-.185h3v-1.875h-.281c-.85 0-1.594-.15-2.232-.45a4.2 4.2 0 01-1.603-1.318c-.43-.579-.753-1.289-.965-2.128-.213-.84-.319-1.8-.319-2.881V9.5c0-.17.06-.316.178-.44a.566.566 0 01.422-.185c.163 0 .303.062.422.186.119.123.178.27.178.439v2.598c0 .625.044 1.266.131 1.923.088.658.269 1.254.544 1.788.275.533.672.97 1.19 1.308.52.339 1.204.508 2.054.508H12.9c.663 0 1.237-.114 1.725-.342.488-.228.89-.57 1.21-1.025.318-.456.559-1.032.721-1.729.163-.696.244-1.507.244-2.431V9.5c0-.17.06-.316.178-.44a.566.566 0 01.422-.185z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "currentColor",
        fillRule: "evenodd"
      }, o.createElement("rect", {
        transform: "rotate(-45 12.041 11.24)",
        x: 1.294,
        y: 10.593,
        width: 21.494,
        height: 1.293,
        rx: .646
      }), o.createElement("path", {
        d: "M8.076 17.926l.86-.897c.043.03.086.06.13.088.518.339 1.203.508 2.053.508H12.9c.663 0 1.237-.114 1.725-.342.488-.228.89-.57 1.21-1.025.318-.456.559-1.032.721-1.729.163-.696.244-1.507.244-2.431V9.5c0-.17.06-.316.178-.44a.566.566 0 01.422-.185c.163 0 .303.062.422.186.119.123.178.27.178.439v2.598c0 1.406-.156 2.548-.469 3.427-.312.88-.715 1.566-1.21 2.06-.493.496-1.04.834-1.64 1.017-.6.182-1.193.273-1.781.273h-.3v1.875h3c.163 0 .303.062.422.186.119.123.178.27.178.439 0 .17-.06.316-.178.44A.566.566 0 0115.6 22H8.4a.566.566 0 01-.422-.186.613.613 0 01-.178-.439c0-.17.06-.316.178-.44a.566.566 0 01.422-.185h3v-1.875h-.281c-.85 0-1.594-.15-2.232-.45a4.174 4.174 0 01-.811-.5zm-1.854-3.373A12.455 12.455 0 016 12.098V9.5c0-.17.06-.316.178-.44a.566.566 0 01.422-.185c.163 0 .303.062.422.186.119.123.178.27.178.439v2.598c0 .447.022.903.067 1.367l-1.045 1.088zm4.29.835L15 10.713v1.99c0 .886-.272 1.615-.816 2.188-.543.573-1.234.859-2.071.859h-.132a2.96 2.96 0 01-1.47-.362zM9 11.66V5.262c0-.899.29-1.667.872-2.305.581-.638 1.284-.957 2.11-.957h.13c.813 0 1.497.316 2.054.947.556.632.834 1.403.834 2.315v.148l-6 6.25z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 72 72"
      }, e), o.createElement("defs", null, o.createElement("circle", {
        id: "IcnNoCRM_svg__a",
        cx: 9,
        cy: 9,
        r: 9
      })), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("g", {
        transform: "translate(10 22)"
      }, o.createElement("g", {
        fill: "currentColor",
        fillRule: "nonzero"
      }, o.createElement("path", {
        d: "M23.51 7h25.98c.282 0 .51-.224.51-.5s-.228-.5-.51-.5H23.51a.505.505 0 00-.51.5c0 .276.228.5.51.5zM23.5 12h18a.5.5 0 100-1h-18a.5.5 0 000 1z"
      })), o.createElement("circle", {
        stroke: "currentColor",
        cx: 9,
        cy: 9,
        r: 8.5
      }), o.createElement("mask", {
        id: "IcnNoCRM_svg__b",
        fill: "#fff"
      }, o.createElement("use", {
        xlinkHref: "#IcnNoCRM_svg__a"
      })), o.createElement("g", {
        mask: "url(#IcnNoCRM_svg__b)",
        fillRule: "nonzero",
        stroke: "currentColor"
      }, o.createElement("g", {
        transform: "translate(3.75 4.75)"
      }, o.createElement("circle", {
        cx: 5.25,
        cy: 2.75,
        r: 3
      }), o.createElement("rect", {
        x: .75,
        y: 7.75,
        width: 9,
        height: 7,
        rx: 2
      })))), o.createElement("path", {
        d: "M.5 4v64c0 1.929 1.57 3.5 3.5 3.5h64c1.929 0 3.5-1.57 3.5-3.5V4C71.5 2.07 69.93.5 68 .5H4C2.07.5.5 2.07.5 4zM.5 11.5h71",
        stroke: "currentColor"
      }), o.createElement("path", {
        d: "M7.5 6a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM13.5 6a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM19.5 6a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z",
        stroke: "currentColor"
      }), o.createElement("circle", {
        stroke: "currentColor",
        cx: 12,
        cy: 50,
        r: 2
      }), o.createElement("circle", {
        stroke: "currentColor",
        cx: 36,
        cy: 58,
        r: 2
      }), o.createElement("circle", {
        stroke: "currentColor",
        cx: 60,
        cy: 45,
        r: 2
      }), o.createElement("path", {
        d: "M.5 58l9.5-7M38 57.5l20-12M14 51l20 6.5M61.5 45.5l10 4",
        stroke: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 42 38"
      }, e), o.createElement("path", {
        d: "M9.703 27.262l-2.164 2.164c-.68.261-1.326.44-1.94.535l-.123.02a.897.897 0 01-.838-.255.925.925 0 01-.266-.668c0-.079.007-.144.02-.197a.749.749 0 01.062-.157c.286-.523.743-1.328 1.328-2.415.586-1.086.879-2.087.879-3.004-1.117-.628-2.098-1.309-2.942-2.12a11.55 11.55 0 01-2.084-2.67 12.486 12.486 0 01-1.226-3.063A12.892 12.892 0 010 12.252c0-1.702.443-3.3 1.328-4.791.885-1.492 2.105-2.788 3.657-3.888 1.553-1.1 3.365-1.97 5.435-2.611C12.49.321 14.711 0 17.081 0c2.343 0 4.543.32 6.6.962 2.056.641 3.848 1.512 5.373 2.611a13.674 13.674 0 012.282 2.055l-.708.709a12.645 12.645 0 00-2.158-1.952c-1.436-1.035-3.13-1.858-5.087-2.468C21.425 1.307 19.325 1 17.08 1c-2.272 0-4.392.306-6.365.917-1.973.611-3.689 1.436-5.153 2.472C4.123 5.41 3 6.602 2.188 7.971 1.394 9.31 1 10.731 1 12.251c0 .963.126 1.94.378 2.935.25.988.626 1.927 1.128 2.818a10.55 10.55 0 001.905 2.44c.74.71 1.627 1.344 2.74 1.97a1 1 0 01.51.871c0 1.097-.34 2.256-.999 3.479-.306.57-.952 1.737-1.213 2.208.747-.116 1.563-.376 2.449-.784a23.26 23.26 0 001.805-.926zm10.394-3.323a20.451 20.451 0 003.56-.728c1.935-.582 3.6-1.4 5-2.453 1.384-1.039 2.458-2.282 3.233-3.735.764-1.432 1.134-3.013 1.109-4.772 0-.386-.026-.765-.076-1.138l.861-.862c.143.65.215 1.317.215 2 .027 1.911-.382 3.659-1.226 5.242-.845 1.584-2.016 2.939-3.514 4.065-1.499 1.125-3.27 1.996-5.313 2.61-1.563.471-3.213.762-4.951.873l1.102-1.102zm-4.677 4.677l.451-.452c3.628.128 17.504-.078 21.028-12.706.123-.5.212-.986.266-1.458 1.721 1.028 2.957 2.236 3.708 3.625.751 1.389 1.127 2.986 1.127 4.792 0 1.944-.464 3.66-1.393 5.145-.929 1.487-2.363 2.73-4.302 3.73v.083c0 .861.164 1.861.492 3 .327 1.139.628 1.944.901 2.417a.823.823 0 01.061.166.856.856 0 01-.225.792.827.827 0 01-.614.25h-.246c-1.448-.25-2.91-1-4.384-2.25-1.475-1.25-2.363-2.07-2.663-2.458-.328.027-.615.048-.86.062-.247.014-.506.021-.78.021h-.778c-1.338 0-2.601-.118-3.79-.354a15.92 15.92 0 01-3.339-1.042 13.614 13.614 0 01-2.827-1.666 13.704 13.704 0 01-1.833-1.697zm2.444.905a12.615 12.615 0 002.62 1.543c.97.429 2.013.754 3.13.976 1.123.223 2.32.335 3.595.335h.779c.255 0 .495-.006.722-.02.236-.013.513-.033.832-.06a1 1 0 01.876.385c.24.31 1.104 1.109 2.518 2.307 1.285 1.089 2.529 1.747 3.732 1.994-.27-.553-.543-1.323-.832-2.33-.352-1.222-.531-2.313-.531-3.276v-.083a1 1 0 01.542-.89c1.787-.92 3.085-2.045 3.912-3.37C40.585 25.71 41 24.18 41 22.418c0-1.645-.337-3.079-1.006-4.316-.474-.876-1.179-1.682-2.122-2.414l-.01.04c-1.67 5.987-5.642 9.81-11.16 11.83-3.121 1.144-6.27 1.594-9.256 1.628.136.114.276.226.418.336zM36.677 37c.043.086.085.168.127.243a.304.304 0 01-.024-.118c0-.008.018-.052.041-.076a.136.136 0 01.02-.016l.003-.018a5.62 5.62 0 01-.081-.015h-.086zm-20.732-7.832l.01.01c.648.038.651.038.461.002a34.013 34.013 0 01-.471-.012zM40.123.354c.195.195.216.49.047.66L4.014 37.17c-.17.17-.465.148-.66-.047-.196-.195-.217-.49-.048-.66L39.463.306c.17-.169.465-.148.66.048z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 72 72"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M1 11h70V4c0-1.653-1.346-3-3-3H4C2.346 1 1 2.346 1 4v7zm0 1v56c0 1.653 1.346 3 3 3h64c1.653 0 3-1.346 3-3V12H1zM0 4c0-2.21 1.798-4 4-4h64c2.21 0 4 1.798 4 4v64c0 2.21-1.798 4-4 4H4c-2.21 0-4-1.798-4-4V4zm7 2a1 1 0 10-2 0 1 1 0 002 0zm1 0a2 2 0 11-4 0 2 2 0 014 0zm5 0a1 1 0 10-2 0 1 1 0 002 0zm1 0a2 2 0 11-4 0 2 2 0 014 0zm5 0a1 1 0 10-2 0 1 1 0 002 0zm1 0a2 2 0 11-4 0 2 2 0 014 0z",
        fill: "currentColor",
        fillRule: "nonzero"
      }), o.createElement("g", {
        transform: "translate(0 43)",
        fillRule: "nonzero",
        stroke: "currentColor"
      }, o.createElement("circle", {
        cx: 12,
        cy: 7,
        r: 2
      }), o.createElement("circle", {
        cx: 36,
        cy: 15,
        r: 2
      }), o.createElement("circle", {
        cx: 60,
        cy: 2,
        r: 2
      }), o.createElement("path", {
        d: "M.5 15L10 8M38 14.5l20-12M14 8l20 6.5M61.5 2.5l10 4"
      })), o.createElement("g", {
        transform: "translate(11 22)",
        stroke: "currentColor"
      }, o.createElement("circle", {
        cx: 8,
        cy: 8,
        r: 3.5
      }), o.createElement("path", {
        d: "M20.5 6.5h24",
        strokeLinecap: "round"
      }), o.createElement("path", {
        d: "M15.5 0v16"
      }), o.createElement("path", {
        d: "M20.5 9.5h17",
        strokeLinecap: "round"
      }), o.createElement("rect", {
        x: .5,
        y: .5,
        width: 49,
        height: 15,
        rx: 3
      }))));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("defs", null, o.createElement("path", {
        d: "M12.5 5a.5.5 0 110 1h-6a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-6a.5.5 0 111 0v6a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 015 17.5v-11A1.5 1.5 0 016.5 5h6zm8-2a.5.5 0 01.5.5v6a.5.5 0 11-1 0V4.706l-8.146 8.148a.5.5 0 01-.708-.708L19.292 4H14.5a.5.5 0 110-1h6z",
        id: "IcnOpen_svg__a"
      })), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("use", {
        fill: "#ABABAB",
        xlinkHref: "#IcnOpen_svg__a"
      }), o.createElement("use", {
        fillOpacity: .8,
        fill: "currentColor",
        xlinkHref: "#IcnOpen_svg__a"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z",
        fill: "currentColor"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M18 6.707l-4.146 4.147a.5.5 0 01-.708-.708L17.293 6H14.5a.5.5 0 110-1h4a.5.5 0 01.5.5v4a.5.5 0 11-1 0V6.707zm.655 8.84c.182.119.293.312.334.58.041.269-.034.544-.225.826l-.245.32a9.873 9.873 0 01-.6.704 6.895 6.895 0 01-.758.702c-.268.214-.507.321-.716.321h-.013c-.6-.018-1.219-.164-1.856-.437a11.613 11.613 0 01-1.882-1.03 17.589 17.589 0 01-1.794-1.378 32.437 32.437 0 01-1.589-1.48 30.338 30.338 0 01-1.473-1.59c-.5-.578-.957-1.176-1.371-1.795a11.754 11.754 0 01-1.03-1.876c-.273-.632-.418-1.244-.436-1.835-.01-.218.093-.462.306-.73a7.4 7.4 0 01.703-.764c.255-.241.489-.444.702-.607.214-.164.326-.25.335-.26.109-.072.222-.127.34-.163A1.2 1.2 0 017.743 5c.146 0 .282.027.41.082a.667.667 0 01.3.245l.334.499c.186.277.386.577.6.9l.6.908c.187.282.303.459.348.532a.885.885 0 01.11.505c-.01.2-.069.409-.178.627-.064.11-.173.3-.327.573-.155.273-.278.496-.369.669.1.146.293.391.58.737.286.345.698.787 1.234 1.323.546.546.992.962 1.337 1.249.346.286.591.48.737.58.164-.091.384-.216.661-.375.278-.16.471-.266.58-.321.118-.064.234-.111.348-.143.114-.032.225-.048.334-.048.082 0 .16.011.232.034.073.023.141.052.205.089a140.36 140.36 0 011.453.948l.893.594c.273.182.436.295.491.34zm-.6.888a.258.258 0 00.061-.123.724.724 0 00.007-.082c-.091-.064-.268-.182-.532-.355s-.546-.36-.846-.56l-1.35-.9h-.014a.575.575 0 00-.095.014.579.579 0 00-.178.082 24.589 24.589 0 00-1.214.682l-.49.273-.45-.328c-.165-.118-.43-.327-.799-.627-.368-.3-.83-.728-1.384-1.283a24.874 24.874 0 01-1.29-1.392 11.95 11.95 0 01-.634-.805l-.313-.45.272-.478c.173-.309.32-.57.444-.784.122-.214.202-.357.238-.43a.72.72 0 00.082-.287 19.89 19.89 0 00-.34-.532 86.337 86.337 0 00-.553-.832c-.196-.291-.38-.569-.553-.833a9.743 9.743 0 00-.354-.518c0-.01-.005-.014-.014-.014h-.014a.257.257 0 00-.102.02.55.55 0 00-.089.049 8.948 8.948 0 00-1.084.914c-.341.336-.539.582-.593.737.018.409.12.857.306 1.344.187.486.453 1.003.798 1.548.346.546.767 1.12 1.262 1.72.496.6 1.057 1.219 1.685 1.855a25.587 25.587 0 001.862 1.7c.605.495 1.18.913 1.725 1.255a9.091 9.091 0 001.549.791c.486.187.934.293 1.343.32.155-.063.4-.265.737-.607a8.95 8.95 0 00.914-1.084z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M18 6.707l-4.146 4.147a.5.5 0 01-.708-.708L17.293 6H14.5a.5.5 0 110-1h4a.5.5 0 01.5.5v4a.5.5 0 11-1 0V6.707zm.655 8.84c.182.119.293.312.334.58.041.269-.034.544-.225.826l-.245.32a9.873 9.873 0 01-.6.704 6.895 6.895 0 01-.758.702c-.268.214-.507.321-.716.321h-.013c-.6-.018-1.219-.164-1.856-.437a11.613 11.613 0 01-1.882-1.03 17.589 17.589 0 01-1.794-1.378 32.437 32.437 0 01-1.589-1.48 30.338 30.338 0 01-1.473-1.59c-.5-.578-.957-1.176-1.371-1.795a11.754 11.754 0 01-1.03-1.876c-.273-.632-.418-1.244-.436-1.835-.01-.218.093-.462.306-.73a7.4 7.4 0 01.703-.764c.255-.241.489-.444.702-.607.214-.164.326-.25.335-.26.109-.072.222-.127.34-.163A1.2 1.2 0 017.743 5c.146 0 .282.027.41.082a.667.667 0 01.3.245l.334.499c.186.277.386.577.6.9l.6.908c.187.282.303.459.348.532a.885.885 0 01.11.505c-.01.2-.069.409-.178.627-.064.11-.173.3-.327.573-.155.273-.278.496-.369.669.1.146.293.391.58.737.286.345.698.787 1.234 1.323.546.546.992.962 1.337 1.249.346.286.591.48.737.58.164-.091.384-.216.661-.375.278-.16.471-.266.58-.321.118-.064.234-.111.348-.143.114-.032.225-.048.334-.048.082 0 .16.011.232.034.073.023.141.052.205.089a140.36 140.36 0 011.453.948l.893.594c.273.182.436.295.491.34z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0),
      i = function i(e) {
        return o.createElement("svg", r({
          width: "1em",
          height: "1em",
          viewBox: "0 0 10 10"
        }, e), o.createElement("path", {
          d: "M5 5a2 2 0 100-4 2 2 0 000 4zm0 1a3 3 0 110-6 3 3 0 010 6zM.974 9.658A.468.468 0 01.501 10c-.427 0-.563-.396-.475-.658C.763 7.13 2.458 6 5 6c2.542 0 4.237 1.13 4.974 3.342.088.262-.031.657-.474.658-.28 0-.407-.14-.474-.342C8.429 7.87 7.126 7 5 7 2.875 7 1.57 7.87.974 9.658z",
          fill: "currentColor",
          fillRule: "nonzero",
          stroke: "none",
          strokeWidth: 1
        }));
      };
    t.default = i, i._raw = '\n<svg width="1em" height="1em" viewBox="0 0 10 10" >\n        <path\n            d="M5 5a2 2 0 100-4 2 2 0 000 4zm0 1a3 3 0 110-6 3 3 0 010 6zM.974 9.658A.468.468 0 01.501 10c-.427 0-.563-.396-.475-.658C.763 7.13 2.458 6 5 6c2.542 0 4.237 1.13 4.974 3.342.088.262-.031.657-.474.658-.28 0-.407-.14-.474-.342C8.429 7.87 7.126 7 5 7 2.875 7 1.57 7.87.974 9.658z"\n            fill="currentColor"\n            fillRule="nonzero"\n            stroke="none"\n            strokeWidth="1"\n        />\n    </svg>';
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 10 16"
      }, e), o.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 0a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h2zm6 0a1 1 0 011 1v14a1 1 0 01-1 1H7a1 1 0 01-1-1V1a1 1 0 011-1h2z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M21 13h10a2 2 0 012 2v18a2 2 0 01-2 2H17a2 2 0 01-2-2V19l6-6z",
        fill: "#EA1010"
      }), o.createElement("path", {
        d: "M21.5 14L16 19.5V33a1 1 0 001 1h14a1 1 0 001-1V15a1 1 0 00-1-1h-9.5z",
        fill: "#FFF"
      }), o.createElement("path", {
        d: "M23.495 21c.709-.006.927.538.95 1.481.024.943-.477 2.448-.477 2.448.413.913 1.546 2.092 1.546 2.092s.372-.097 1.89-.133c1.523-.036 1.588.84 1.594.913.006.072.065.767-1.146.816-1.1.044-2.234-1.021-2.431-1.215l-.03-.03s-.52.084-.945.187c-.425.103-1.8.49-1.8.49s-.408.755-1.306 1.964c-.903 1.21-1.907 1.119-2.196.72-.33-.466-.07-.931.561-1.536.632-.604 2.096-1.106 2.096-1.106s.295-.544.726-1.584c.437-1.04.762-2.08.762-2.08s-.431-.997-.514-1.843c-.089-.943.012-1.578.72-1.584zm.313 4.37s-.319.968-.626 1.675l-.307.707c.06-.03.436-.213 1.134-.386.756-.194 1.075-.218 1.075-.218s-.85-.961-1.276-1.777zM22 13v7h-7v-1h6v-6z",
        fill: "#EA1010"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 11 14"
      }, e), o.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.588.155l8.3 6.036a1 1 0 010 1.618l-8.3 6.036A1 1 0 010 13.036V.964A1 1 0 011.588.155z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        fill: "currentColor",
        d: "M15 4a1 1 0 011 1v2.212l-1 1.005V5H5v14h10v-2.305l1-1V19a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h10zm-5 9v3H7v-3h3zm8.36-5.37l.091.08 1.27 1.275a1 1 0 01.004 1.407L14.207 16h-2.755l-.034-2.65 5.616-5.639a1 1 0 011.327-.08zm-.617.787l-5.32 5.342.016 1.24h1.349l5.224-5.308-1.27-1.274zM13 7v3H7V7h6z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        fill: "currentColor",
        d: "M15 4a1 1 0 011 1v2.212l-5.887 5.914.05 4.249h4.158L16 15.695V19a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h10zm-6 9H7v3h2v-3zm9.36-5.37l.091.08 1.27 1.275a1 1 0 01.004 1.407L14.207 16h-2.755l-.034-2.65 5.616-5.639a1 1 0 011.327-.08zm-.617.787l-5.32 5.342.016 1.24h1.349l5.224-5.308-1.27-1.274zM12 7H7v3h5V7z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M6 10c1.271 0 2.305.38 3.071 1.146.467.467.722.773.888 1.156a.5.5 0 01-.918.396c-.098-.225-.3-.469-.677-.844C7.797 11.287 7.021 11 6.005 11c-.87.009-1.578.296-2.152.869-.563.563-.853 1.43-.852 2.632a.5.5 0 11-1 0c-.001-1.446.374-2.569 1.146-3.34.76-.76 1.719-1.15 2.846-1.161h.002a3 3 0 11.006 0zm9.502 3c2.122 0 3.748.542 4.853 1.646C21.46 15.751 22.002 17.378 22 19.5a.5.5 0 01-1 0c.001-1.878-.456-3.25-1.352-4.146-.896-.896-2.27-1.354-4.146-1.354H15.5c-1.877 0-3.25.458-4.147 1.354-.896.895-1.353 2.268-1.351 4.146a.5.5 0 01-1 0c-.002-2.122.54-3.75 1.645-4.854C11.75 13.542 13.378 13 15.5 13zm-.002-1a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm0 1a4.5 4.5 0 110-9 4.5 4.5 0 010 9zM6 9a2 2 0 100-4 2 2 0 000 4z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "currentColor",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("rect", {
        x: 3.5,
        y: 4.5,
        width: 17,
        height: 14,
        rx: 1
      }), o.createElement("path", {
        d: "M6.5 20.5h11M12.5 13.5h5M12.5 7.5h5M12.5 15.5H16M12.5 9.5H16",
        strokeLinecap: "round"
      }), o.createElement("circle", {
        cx: 8.5,
        cy: 8.5,
        r: 2
      }), o.createElement("circle", {
        cx: 8.5,
        cy: 14.5,
        r: 2
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M5 4h14a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2zm7.5 10h5a.5.5 0 100-1h-5a.5.5 0 100 1zm0-6h5a.5.5 0 100-1h-5a.5.5 0 100 1zm0 8H16a.5.5 0 100-1h-3.5a.5.5 0 100 1zm0-6H16a.5.5 0 100-1h-3.5a.5.5 0 100 1zm-4 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 1a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0 5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 1a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
        fill: "currentColor"
      }), o.createElement("path", {
        d: "M6.5 20.5h11",
        stroke: "currentColor",
        strokeLinecap: "round"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M12 17a5 5 0 100-10 5 5 0 000 10zm0 1a6 6 0 110-12 6 6 0 010 12zm-.781-4.38l2.94-3.422a.371.371 0 01.559-.005.483.483 0 01.004.637l-3.354 3.874a.2.2 0 01-.3.002L9.28 12.7a.476.476 0 01-.003-.63.372.372 0 01.558-.003l1.384 1.554z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M6.144 9.862A.519.519 0 016 9.494a.53.53 0 01.036-.195.47.47 0 01.276-.264A.6.6 0 016.517 9h10.966a.6.6 0 01.205.034.47.47 0 01.276.265.53.53 0 01.036.195.519.519 0 01-.144.368.47.47 0 01-.168.104.6.6 0 01-.205.034H6.517a.6.6 0 01-.205-.034.47.47 0 01-.168-.104zm0 3A.519.519 0 016 12.494a.53.53 0 01.036-.195.47.47 0 01.276-.264.6.6 0 01.205-.035h10.966a.6.6 0 01.205.034.47.47 0 01.276.265.53.53 0 01.036.195.519.519 0 01-.144.368.47.47 0 01-.168.104.6.6 0 01-.205.034H6.517a.6.6 0 01-.205-.034.47.47 0 01-.168-.104zm0 3A.519.519 0 016 15.494a.53.53 0 01.036-.195.47.47 0 01.276-.264.6.6 0 01.205-.035h10.966a.6.6 0 01.205.034.47.47 0 01.276.265.53.53 0 01.036.195.519.519 0 01-.144.368.47.47 0 01-.168.104.6.6 0 01-.205.034H6.517a.6.6 0 01-.205-.034.47.47 0 01-.168-.104z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M15.742 14.153l3.091 3.091a.417.417 0 11-.589.59l-3.091-3.092a5.833 5.833 0 11.59-.59zm-4.409 1.18a5 5 0 100-10 5 5 0 000 10z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M19.641 4c.164 0 .27.064.317.193.047.13.023.305-.07.528l-7.19 16.77a.761.761 0 01-.237.36.501.501 0 01-.308.114.494.494 0 01-.281-.097.989.989 0 01-.264-.29L8.76 16.92a4.609 4.609 0 00-.73-.905 5.269 5.269 0 00-.904-.747L2.38 12.314c-.27-.175-.396-.372-.378-.588.017-.217.172-.39.465-.519l16.788-7.12c.07-.023.137-.043.202-.06A.701.701 0 0119.64 4zM7.723 14.266c.117.07.238.155.36.255.124.1.25.208.379.325l8.314-8.455-12.902 5.484 3.85 2.39zm4.342 5.818l5.52-12.92-8.332 8.473c.105.117.202.234.29.351.088.117.16.235.22.352l2.302 3.744z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M19 10.484c.24.042.466.16.68.352a.92.92 0 01.32.71v1c0 .272-.107.49-.32.657-.214.167-.44.281-.68.344l-1.297.312a7.295 7.295 0 01-.164.446c-.057.14-.122.278-.195.414l.687 1.156c.136.208.219.448.25.719a.817.817 0 01-.25.703l-.703.703a.903.903 0 01-.719.273 1.472 1.472 0 01-.734-.226l-1.125-.719a8.21 8.21 0 01-.438.203c-.145.063-.302.12-.468.172L13.563 19a1.36 1.36 0 01-.352.68.92.92 0 01-.711.32h-1a.793.793 0 01-.656-.32A1.865 1.865 0 0110.5 19l-.313-1.281a6.402 6.402 0 01-.5-.18 5.137 5.137 0 01-.484-.227l-1.156.735c-.198.135-.44.21-.727.226A.867.867 0 016.61 18l-.72-.703a.837.837 0 01-.234-.703c.032-.271.11-.51.235-.719l.734-1.219a8.606 8.606 0 01-.18-.383 3.23 3.23 0 01-.148-.414L5 13.547a1.865 1.865 0 01-.68-.344.793.793 0 01-.32-.656v-1a.92.92 0 01.32-.711c.214-.193.44-.31.68-.352l1.281-.28a3.67 3.67 0 01.157-.438c.062-.146.124-.287.187-.422l-.734-1.219a1.775 1.775 0 01-.235-.719.837.837 0 01.235-.703L6.609 6a.867.867 0 01.711-.273c.287.015.529.09.727.226l1.156.734a5.68 5.68 0 01.969-.406L10.5 5c.052-.24.161-.466.328-.68A.808.808 0 0111.5 4h1c.281 0 .516.107.703.32.188.214.307.435.36.664l.28 1.313a6.968 6.968 0 01.907.375l1.125-.719c.208-.135.453-.21.734-.226a.903.903 0 01.72.273l.702.703a.817.817 0 01.25.703c-.031.271-.114.51-.25.719l-.687 1.156c.073.146.143.295.21.446.068.15.123.31.165.476l1.281.281zm0 1.985l.016-.89a.55.55 0 00-.22-.11l-1.858-.422-.172-.547a2.639 2.639 0 00-.125-.375 4.382 4.382 0 00-.188-.39l-.25-.5.985-1.641a.505.505 0 00.07-.125.3.3 0 00.023-.094l-.656-.64a.371.371 0 00-.203.062l-1.61 1.031-.515-.266c-.125-.062-.25-.122-.375-.18a2.031 2.031 0 00-.39-.132l-.548-.188-.406-1.89a.46.46 0 00-.047-.117L12.5 5h-.922a.364.364 0 00-.062.094.555.555 0 00-.047.156l-.453 1.813-.532.171a4.812 4.812 0 00-.813.344l-.515.266L7.484 6.78l-.078-.039a.716.716 0 00-.093-.039l-.657.656c0 .032.008.068.024.11a.88.88 0 00.07.14l1.016 1.688-.25.484c-.063.136-.118.26-.164.375-.047.115-.086.23-.118.344l-.171.547-1.891.422a.573.573 0 00-.102.047.212.212 0 01-.07.03v.923c.02.02.052.039.094.054a.85.85 0 00.156.04l1.828.468.172.531c.031.105.07.211.117.32.047.11.102.222.164.337l.235.484-1.016 1.703a.505.505 0 00-.07.125.318.318 0 00-.024.11l.657.64a.26.26 0 00.101-.023.63.63 0 00.102-.055l1.64-1.047.516.266c.135.073.27.138.406.195.136.057.271.107.406.149l.532.172.468 1.843c.01.052.024.097.04.133a.271.271 0 00.054.086h.906a.55.55 0 00.11-.203l.406-1.86.547-.187a5.483 5.483 0 00.75-.313l.515-.265 1.641 1.047.078.039a.716.716 0 00.094.039l.656-.656a.318.318 0 00-.023-.11.88.88 0 00-.07-.14l-.985-1.625.25-.5a3.07 3.07 0 00.164-.352c.047-.12.091-.242.133-.367l.172-.516 1.86-.469a.677.677 0 00.132-.039.271.271 0 00.086-.054zM12 9c.833 0 1.544.292 2.133.875A2.88 2.88 0 0115.016 12a2.88 2.88 0 01-.883 2.125c-.589.583-1.3.875-2.133.875a2.9 2.9 0 01-2.117-.875A2.88 2.88 0 019 12c0-.833.294-1.542.883-2.125A2.9 2.9 0 0112 9zm0 5c.552 0 1.023-.195 1.414-.586.39-.39.586-.862.586-1.414 0-.552-.195-1.023-.586-1.414A1.927 1.927 0 0012 10c-.552 0-1.023.195-1.414.586-.39.39-.586.862-.586 1.414 0 .552.195 1.023.586 1.414.39.39.862.586 1.414.586z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M19 10.484c.24.042.466.16.68.352a.92.92 0 01.32.71v1c0 .272-.107.49-.32.657-.214.167-.44.281-.68.344l-1.297.312a7.295 7.295 0 01-.164.446c-.057.14-.122.278-.195.414l.687 1.156c.136.208.219.448.25.719a.817.817 0 01-.25.703l-.703.703a.903.903 0 01-.719.273 1.472 1.472 0 01-.734-.226l-1.125-.719a8.21 8.21 0 01-.438.203c-.145.063-.302.12-.468.172L13.563 19a1.36 1.36 0 01-.352.68.92.92 0 01-.711.32h-1a.793.793 0 01-.656-.32A1.865 1.865 0 0110.5 19l-.313-1.281a6.402 6.402 0 01-.5-.18 5.137 5.137 0 01-.484-.227l-1.156.735c-.198.135-.44.21-.727.226A.867.867 0 016.61 18l-.72-.703a.837.837 0 01-.234-.703c.032-.271.11-.51.235-.719l.734-1.219a8.606 8.606 0 01-.18-.383 3.23 3.23 0 01-.148-.414L5 13.547a1.865 1.865 0 01-.68-.344.793.793 0 01-.32-.656v-1a.92.92 0 01.32-.711c.214-.193.44-.31.68-.352l1.281-.28a3.67 3.67 0 01.157-.438c.062-.146.124-.287.187-.422l-.734-1.219a1.775 1.775 0 01-.235-.719.837.837 0 01.235-.703L6.609 6a.867.867 0 01.711-.273c.287.015.529.09.727.226l1.156.734a5.68 5.68 0 01.969-.406L10.5 5c.052-.24.161-.466.328-.68A.808.808 0 0111.5 4h1c.281 0 .516.107.703.32.188.214.307.435.36.664l.28 1.313a6.968 6.968 0 01.907.375l1.125-.719c.208-.135.453-.21.734-.226a.903.903 0 01.72.273l.702.703a.817.817 0 01.25.703c-.031.271-.114.51-.25.719l-.687 1.156c.073.146.143.295.21.446.068.15.123.31.165.476l1.281.281zM12 9c.833 0 1.544.292 2.133.875A2.88 2.88 0 0115.016 12a2.88 2.88 0 01-.883 2.125c-.589.583-1.3.875-2.133.875a2.9 2.9 0 01-2.117-.875A2.88 2.88 0 019 12c0-.833.294-1.542.883-2.125A2.9 2.9 0 0112 9z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M6 7a1 1 0 00-1 1v8a1 1 0 001 1h12a1 1 0 001-1V8a1 1 0 00-1-1H6zm0-1h12a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2z",
        fill: "currentColor",
        fillRule: "nonzero"
      }), o.createElement("path", {
        fill: "currentColor",
        d: "M5 7h3v10H5z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M6 7a1 1 0 00-1 1v8a1 1 0 001 1h12a1 1 0 001-1V8a1 1 0 00-1-1H6zm0-1h12a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2z",
        fill: "currentColor",
        fillRule: "nonzero"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M8.667 4.8c-.46 0-.834.358-.834.8v12.8c0 .442.373.8.834.8h6.666c.46 0 .834-.358.834-.8V5.6c0-.442-.373-.8-.834-.8H8.667zm0-.8h6.666C16.253 4 17 4.716 17 5.6v12.8c0 .884-.746 1.6-1.667 1.6H8.667C7.747 20 7 19.284 7 18.4V5.6C7 4.716 7.746 4 8.667 4zm2.066 1.6a.4.4 0 100 .8h2.534a.4.4 0 100-.8h-2.534zm1.234 11.2a.8.8 0 100 1.6h.066a.8.8 0 100-1.6h-.066z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 4a1 1 0 01.993.883L14 5v2.999L19 8a1 1 0 011 1v7a1 1 0 01-1 1h-9l-1.445.964A1 1 0 017 17.131V9a1 1 0 011-1l5-.001V5H5v14h8v-2h1v2a1 1 0 01-.883.993L13 20H5a1 1 0 01-.993-.883L4 19V5a1 1 0 01.883-.993L5 4h8zm0 4.999L8 9v8.131L9.697 16H19V9l-5-.001V9h-1v-.001zM14.5 13a.5.5 0 010 1h-4a.5.5 0 010-1h4zm2-2a.5.5 0 010 1h-6a.5.5 0 010-1h6zm-8-5a.5.5 0 010 1h-1a.5.5 0 010-1h1zm2 0a.5.5 0 110 1 .5.5 0 010-1z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M8.667 4h6.666C16.253 4 17 4.716 17 5.6v12.8c0 .884-.746 1.6-1.667 1.6H8.667C7.747 20 7 19.284 7 18.4V5.6C7 4.716 7.746 4 8.667 4zm2.066 1.6a.4.4 0 100 .8h2.534a.4.4 0 100-.8h-2.534zm1.234 11.2a.8.8 0 100 1.6h.066a.8.8 0 100-1.6h-.066z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 9a4 4 0 013.16 6.453l2.694 2.693a.5.5 0 01-.638.765l-.07-.057-2.693-2.694A4 4 0 1114 9zm0 1a3 3 0 100 6 3 3 0 000-6zm-.377-5C14.383 5 15 5.619 15 6.382l.001 1.718a5.003 5.003 0 00-.689-.09V6.382a.69.69 0 00-.69-.691H5.378a.69.69 0 00-.688.691v8.927l2.148-2.035h2.17c.013.235.042.466.086.691H7.111l-1.95 1.847A.687.687 0 014 15.309V6.382A1.38 1.38 0 015.377 5h8.246zM6.5 11h2.916a4.962 4.962 0 00-.316 1H6.5a.5.5 0 010-1h2.916zm0-2H11a5.03 5.03 0 00-1 1H6.5a.5.5 0 010-1H11zm6-2a.5.5 0 010 1h-6a.5.5 0 010-1h6z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 9a4 4 0 013.16 6.453l2.694 2.693a.5.5 0 01-.638.765l-.07-.057-2.693-2.694A4 4 0 1114 9zm0 1a3 3 0 100 6 3 3 0 000-6zm-.377-5C14.383 5 15 5.619 15 6.382l.001 1.718A5.023 5.023 0 0014 8a4.978 4.978 0 00-3 1H6.5a.5.5 0 00-.09.992L6.5 10H10a4.996 4.996 0 00-.584 1H6.5a.5.5 0 00-.09.992L6.5 12h2.6a5.023 5.023 0 00-.007 1.965H7.111l-1.95 1.847A.687.687 0 014 15.309V6.382A1.38 1.38 0 015.377 5h8.246zM12.5 7h-6a.5.5 0 00-.09.992L6.5 8h6a.5.5 0 000-1z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M12 6a9.25 9.25 0 00-2.727.39c-.849.261-1.588.618-2.218 1.07-.63.454-1.13.985-1.5 1.595A3.688 3.688 0 005 11c0 .417.062.82.188 1.21.125.392.307.759.546 1.102.24.344.532.665.875.961.344.297.74.555 1.188.774l.547.281v.703l-.016.032c0 .27-.031.539-.094.804a4.963 4.963 0 01-.25.774c.47-.22.891-.472 1.266-.758.375-.287.604-.477.688-.57l.359-.438.547.078a4.193 4.193 0 00.734.047H12a9.25 9.25 0 002.727-.39c.849-.261 1.588-.618 2.218-1.07a5.434 5.434 0 001.5-1.595 3.688 3.688 0 000-3.89c-.37-.61-.87-1.14-1.5-1.594-.63-.453-1.37-.81-2.218-1.07A9.25 9.25 0 0012 6zm0-1c1.104 0 2.143.156 3.117.469.974.312 1.823.742 2.547 1.289a6.365 6.365 0 011.711 1.906c.417.724.625 1.503.625 2.336s-.208 1.612-.625 2.336a6.365 6.365 0 01-1.71 1.906c-.725.547-1.574.977-2.548 1.29-.974.312-2.013.468-3.117.468H11.578c-.146 0-.284-.003-.414-.008a3.512 3.512 0 01-.46-.055 3.813 3.813 0 01-.493.461 9.306 9.306 0 01-1.953 1.219c-.39.182-.784.31-1.18.383h-.125a.437.437 0 01-.32-.133.437.437 0 01-.133-.32.57.57 0 01.008-.094.278.278 0 01.023-.078c.146-.26.315-.612.508-1.055.193-.442.29-.888.29-1.336 0-.01.002-.018.007-.023.005-.005.008-.013.008-.024A7.31 7.31 0 015.922 15a5.623 5.623 0 01-1.047-1.164 5.33 5.33 0 01-.648-1.344A4.885 4.885 0 014 11c0-.833.208-1.612.625-2.336a6.365 6.365 0 011.71-1.906c.725-.547 1.574-.977 2.548-1.29A10.144 10.144 0 0112 5z",
        fill: "currentColor"
      }), o.createElement("path", {
        d: "M12.116 8c.09 0 .17.022.243.067a.42.42 0 01.164.182l.706 1.466 1.623.237a.447.447 0 01.359.298.437.437 0 01-.11.444l-1.185 1.185.273 1.648a.383.383 0 01-.027.238.453.453 0 01-.283.249.506.506 0 01-.243.006.407.407 0 01-.11-.043l-1.41-.76-1.417.76a.328.328 0 01-.103.043.503.503 0 01-.247-.006.453.453 0 01-.28-.25.383.383 0 01-.027-.237l.274-1.648-1.186-1.185a.429.429 0 01.03-.642.434.434 0 01.22-.1l1.623-.237.706-1.466a.42.42 0 01.164-.182.457.457 0 01.243-.067z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M20.016 14.433c.01.031.013.06.007.085a.72.72 0 01-.023.086c0 .02.003.044.008.07a.438.438 0 01.008.086c0 .478-.091.927-.273 1.347a3.526 3.526 0 01-1.853 1.853c-.42.182-.875.273-1.363.273-.478 0-.93-.09-1.355-.273a3.57 3.57 0 01-1.884-1.853 3.28 3.28 0 01-.28-1.347c0-.156.007-.304.023-.444.015-.14.044-.278.085-.413a3.041 3.041 0 00-1.09-.187c-.26 0-.48.024-.662.07-.182.047-.324.091-.428.133.031.135.057.272.078.413a3.36 3.36 0 01-.241 1.775 3.526 3.526 0 01-1.854 1.853c-.42.182-.875.273-1.363.273-.477 0-.929-.09-1.355-.273a3.57 3.57 0 01-1.884-1.853 3.28 3.28 0 01-.28-1.347v-.218a.36.36 0 00-.008-.07.106.106 0 01.007-.07c0-.052.042-.343.125-.872l.28-1.776a301.203 301.203 0 01.499-3.053.827.827 0 01.03-.233c.042-.384.196-.846.46-1.386.265-.54.969-.81 2.11-.81.136 0 .252.05.351.148a.479.479 0 01.148.35c0 .135-.05.252-.148.35a.479.479 0 01-.35.149c-.706 0-1.135.127-1.285.381-.15.255-.252.569-.304.942a.611.611 0 01-.016.133.611.611 0 00-.015.132l-.218 1.207c-.114.628-.229 1.29-.343 1.986a3.718 3.718 0 011.013-.568c.373-.14.768-.21 1.183-.21.644 0 1.228.158 1.752.474.525.317.943.73 1.254 1.238a3.63 3.63 0 01.584-.179c.244-.057.537-.085.88-.085.332 0 .626.028.88.085.254.057.454.117.6.18a3.627 3.627 0 011.269-1.239 3.376 3.376 0 011.752-.475c.395 0 .77.065 1.13.195.357.13.682.304.973.522-.115-.696-.226-1.348-.335-1.955a541.3 541.3 0 01-.234-1.308 1.202 1.202 0 01-.008-.133 2.518 2.518 0 00-.303-.942c-.151-.254-.58-.381-1.285-.381a.492.492 0 01-.498-.498.492.492 0 01.498-.5c1.142 0 1.843.27 2.102.81.26.54.416 1.003.467 1.387a.827.827 0 01.031.234l.203 1.183c.104.602.21 1.23.32 1.885l.295 1.783c.089.535.133.828.133.88zm-12.46 2.803c.685 0 1.272-.241 1.76-.724a2.374 2.374 0 00.732-1.752A2.4 2.4 0 009.316 13a2.4 2.4 0 00-1.76-.732c-.685 0-1.277.247-1.775.74-.499.493-.748 1.077-.748 1.752 0 .664.25 1.243.748 1.736.498.494 1.09.74 1.775.74zm8.971 0c.685 0 1.272-.241 1.76-.724a2.374 2.374 0 00.732-1.752.328.328 0 00-.008-.078.256.256 0 01-.008-.062.256.256 0 00-.03-.125c0-.041-.003-.086-.009-.132a1.341 1.341 0 01-.007-.148 2.467 2.467 0 00-.865-1.386 2.383 2.383 0 00-1.565-.561c-.685 0-1.277.247-1.775.74-.499.493-.748 1.077-.748 1.752 0 .664.25 1.243.748 1.736.498.494 1.09.74 1.775.74z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M20.016 14.433c.01.031.013.06.007.085a.72.72 0 01-.023.086c0 .02.003.044.008.07a.438.438 0 01.008.086c0 .478-.091.927-.273 1.347a3.526 3.526 0 01-1.853 1.853c-.42.182-.875.273-1.363.273-.478 0-.93-.09-1.355-.273a3.57 3.57 0 01-1.884-1.853 3.28 3.28 0 01-.28-1.347c0-.156.007-.304.023-.444.015-.14.044-.278.085-.413a3.041 3.041 0 00-1.09-.187c-.26 0-.48.024-.662.07-.182.047-.324.091-.428.133.031.135.057.272.078.413a3.36 3.36 0 01-.241 1.775 3.526 3.526 0 01-1.854 1.853c-.42.182-.875.273-1.363.273-.477 0-.929-.09-1.355-.273a3.57 3.57 0 01-1.884-1.853 3.28 3.28 0 01-.28-1.347v-.218a.36.36 0 00-.008-.07.106.106 0 01.007-.07c0-.052.042-.343.125-.872l.28-1.776a301.203 301.203 0 01.499-3.053.827.827 0 01.03-.233c.042-.384.196-.846.46-1.386.265-.54.969-.81 2.11-.81.136 0 .252.05.351.148a.479.479 0 01.148.35c0 .135-.05.252-.148.35a.479.479 0 01-.35.149c-.706 0-1.135.127-1.285.381-.15.255-.252.569-.304.942a.611.611 0 01-.016.133.611.611 0 00-.015.132l-.218 1.207c-.114.628-.229 1.29-.343 1.986a3.718 3.718 0 011.013-.568c.373-.14.768-.21 1.183-.21.644 0 1.228.158 1.752.474.525.317.943.73 1.254 1.238a3.63 3.63 0 01.584-.179c.244-.057.537-.085.88-.085.332 0 .626.028.88.085.254.057.454.117.6.18a3.627 3.627 0 011.269-1.239 3.376 3.376 0 011.752-.475c.395 0 .77.065 1.13.195.357.13.682.304.973.522-.115-.696-.226-1.348-.335-1.955a541.3 541.3 0 01-.234-1.308 1.202 1.202 0 01-.008-.133 2.518 2.518 0 00-.303-.942c-.151-.254-.58-.381-1.285-.381a.492.492 0 01-.498-.498.492.492 0 01.498-.5c1.142 0 1.843.27 2.102.81.26.54.416 1.003.467 1.387a.827.827 0 01.031.234l.203 1.183c.104.602.21 1.23.32 1.885l.295 1.783c.089.535.133.828.133.88z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        fill: "#FFF",
        fillRule: "nonzero",
        d: "M4 4.01v3.463a.5.5 0 11-1 0V3.51a.5.5 0 01.5-.5h3.959a.5.5 0 010 1H4z"
      }), o.createElement("path", {
        stroke: "#FFF",
        d: "M10.576 9.905a2 2 0 112.848 0c.734.799 1.197 2.182 1.197 3.595 0 2.173-1.107 4-2.621 4s-2.621-1.827-2.621-4c0-1.413.463-2.796 1.197-3.595z"
      }), o.createElement("path", {
        fill: "#FFF",
        fillRule: "nonzero",
        d: "M9.051 13.5a.5.5 0 100-1h-2.9a.5.5 0 100 1h2.9zm8.256 0a.5.5 0 000-1H14.52a.5.5 0 100 1h2.786zM10.13 10a.5.5 0 110 1H7.974a.5.5 0 01-.435-.253l-.853-1.5a.5.5 0 01.87-.494L8.264 10h1.865zm3.77 0a.5.5 0 000 1h2.156a.5.5 0 00.434-.253l.853-1.5a.5.5 0 00-.869-.494L15.764 10H13.9zm-6.05 7.786a.5.5 0 11-.781-.625l1.575-1.966a.5.5 0 01.384-.188L9.65 15a.5.5 0 11.012 1l-.386.004-1.427 1.782zm8.254-.008a.5.5 0 10.792-.61l-1.514-1.966a.5.5 0 00-.39-.195L14.359 15a.5.5 0 00-.011 1l.39.004 1.366 1.774zM19.959 4.01v3.463a.5.5 0 101 0V3.51a.5.5 0 00-.5-.5H16.5a.5.5 0 100 1h3.459zM4 19.973V16.51a.5.5 0 10-1 0v3.963a.5.5 0 00.5.5h3.959a.5.5 0 000-1H4zm15.959-3.463a.5.5 0 111 0v3.963a.5.5 0 01-.5.5H16.5a.5.5 0 010-1h3.459V16.51z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        fill: "currentcolor",
        fillRule: "nonzero"
      }, o.createElement("path", {
        d: "M4 4v3.463a.5.5 0 01-1 0V3.5a.5.5 0 01.5-.5h3.959a.5.5 0 010 1H4zm7.138 6.218c.25.176.548.272.862.272.314 0 .612-.096.862-.272l.382-.27.294.364c.607.747.962 1.917.962 3.178 0 2.173-1.044 4-2.5 4s-2.5-1.827-2.5-4c0-1.26.355-2.43.962-3.178l.294-.363.382.269z"
      }), o.createElement("path", {
        d: "M12 10.49a2 2 0 110-4 2 2 0 010 4zm-2.235 3a.5.5 0 000-1H6.48a.5.5 0 100 1h3.286zm7.755 0a.5.5 0 000-1h-3.274a.5.5 0 100 1h3.275z"
      }), o.createElement("path", {
        d: "M10.697 9.99a.5.5 0 110 1H7.974a.5.5 0 01-.435-.253l-.853-1.5a.5.5 0 01.87-.494l.709 1.247h2.432zm2.457 0a.5.5 0 000 1h2.902a.5.5 0 00.434-.253l.853-1.5a.5.5 0 00-.869-.494l-.71 1.247h-2.61zM7.85 17.776a.5.5 0 01-.781-.625l1.575-1.966a.5.5 0 01.387-.188l1.467-.007a.5.5 0 01.004 1l-1.227.006-1.426 1.78zm8.254-.007a.5.5 0 10.792-.61l-1.514-1.967a.5.5 0 00-.393-.195l-1.467-.007a.5.5 0 00-.004 1l1.221.006 1.365 1.773zM19.959 4v3.463a.5.5 0 101 0V3.5a.5.5 0 00-.5-.5H16.5a.5.5 0 100 1h3.459zM4 16.5a.5.5 0 10-1 0v3.963a.5.5 0 00.5.5h3.959a.5.5 0 100-1H4V16.5zm15.959 0a.5.5 0 111 0v3.963a.5.5 0 01-.5.5H16.5a.5.5 0 110-1h3.459V16.5z"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M6 6h12a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2zm.5 4a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
        fill: "currentColor",
        fillRule: "nonzero"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M6 6h12a2 2 0 012 2v1a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2zm.5 4a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM6 13h12a2 2 0 012 2v1a2 2 0 01-2 2H6a2 2 0 01-2-2v-1a2 2 0 012-2zm.5 4a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
        fill: "currentColor",
        fillRule: "nonzero"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M10.5 5c2.281 0 3.64.05 4.078.148.438.1.797.253 1.078.461.146.115.412.214.797.297.386.084 1.089.157 2.11.219.083.01.158.029.226.055a.34.34 0 01.164.133c.021.03.206.398.555 1.101.349.703.523 1.654.523 2.852 0 1.187-.125 2.06-.375 2.617-.25.557-.38.851-.39.883a.588.588 0 01-.188.171.495.495 0 01-.25.063c-.417 0-.87.13-1.36.39-.489.261-.981.644-1.476 1.15a11.78 11.78 0 00-1.453 1.858 16.067 16.067 0 00-1.305 2.524 5.414 5.414 0 01-.39.781c-.125.198-.438.297-.938.297-.291 0-.58-.091-.867-.273a2.022 2.022 0 01-.664-.665c-.156-.26-.26-.588-.313-.984a6.949 6.949 0 01-.046-1.242c.02-.432.065-.857.132-1.273.068-.417.138-.777.211-1.079-.51 0-1.156.003-1.937.008-.781.005-1.396.008-1.844.008-.614 0-1.112-.167-1.492-.5-.38-.333-.576-.77-.586-1.313 0-.177.01-.364.031-.562.021-.198.058-.36.11-.484a3.685 3.685 0 01-.414-.508A1.286 1.286 0 014 11.438c-.01-.344.07-.641.242-.891s.33-.453.477-.61a6.245 6.245 0 00-.125-.335.97.97 0 01-.063-.43c.021-.386.146-.703.375-.953a4.3 4.3 0 01.625-.578 2.648 2.648 0 01-.039-.422 1.734 1.734 0 01.055-.5 1.38 1.38 0 01.476-.782c.256-.218.594-.395 1.016-.53a7.999 7.999 0 011.508-.305A17.05 17.05 0 0110.5 5zm7.797 2.14c-.896-.072-1.6-.163-2.11-.273-.51-.11-.89-.258-1.14-.445-.198-.156-.477-.266-.836-.328C13.85 6.03 12.615 6 10.5 6c-.313 0-.688.008-1.125.023-.438.016-.86.055-1.266.118-.406.062-.76.156-1.062.28-.302.126-.48.298-.531.516a.588.588 0 00.125.485l.171.219a.488.488 0 010 .382.481.481 0 01-.25.274c-.01 0-.182.083-.515.25-.333.167-.505.39-.516.672-.01.177.026.315.11.414a.91.91 0 01.125.164.453.453 0 01.07.36.536.536 0 01-.195.327l-.32.266a.82.82 0 00-.321.656c.01.219.11.396.297.531.187.136.286.204.297.204a.608.608 0 01.25.343.583.583 0 01-.094.406l-.125.243a1.158 1.158 0 00-.125.539c.01.406.17.646.477.719.307.073.507.109.601.109h2.727c.484 0 .9-.003 1.25-.008l.523-.008c.094 0 .177.021.25.063.073.042.13.099.172.172.052.062.08.135.086.219a.599.599 0 01-.04.25 9.04 9.04 0 00-.32 1.171c-.088.427-.15.847-.187 1.258-.036.412-.042.79-.016 1.133.026.344.097.61.211.797.073.114.141.219.204.312.062.094.218.141.468.141.031 0 .084-.026.156-.078.073-.052.157-.182.25-.39.417-1 .878-1.894 1.383-2.68a11.952 11.952 0 011.578-2c.547-.547 1.097-.977 1.649-1.29.552-.312 1.083-.494 1.594-.546.093-.198.203-.516.328-.954.125-.437.187-1.036.187-1.796 0-.771-.09-1.435-.273-1.993-.182-.557-.336-.934-.461-1.132z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M10.5 5c2.281 0 3.64.05 4.078.148.438.1.797.253 1.078.461.146.115.412.214.797.297.386.084 1.089.157 2.11.219.083.01.158.029.226.055a.34.34 0 01.164.133c.021.03.206.398.555 1.101.349.703.523 1.654.523 2.852 0 1.187-.125 2.06-.375 2.617-.25.557-.38.851-.39.883a.588.588 0 01-.188.171.495.495 0 01-.25.063c-.417 0-.87.13-1.36.39-.489.261-.981.644-1.476 1.15a11.78 11.78 0 00-1.453 1.858 16.067 16.067 0 00-1.305 2.524 5.414 5.414 0 01-.39.781c-.125.198-.438.297-.938.297-.291 0-.58-.091-.867-.273a2.022 2.022 0 01-.664-.665c-.156-.26-.26-.588-.313-.984a6.949 6.949 0 01-.046-1.242c.02-.432.065-.857.132-1.273.068-.417.138-.777.211-1.079-.51 0-1.156.003-1.937.008-.781.005-1.396.008-1.844.008-.614 0-1.112-.167-1.492-.5-.38-.333-.576-.77-.586-1.313 0-.177.01-.364.031-.562.021-.198.058-.36.11-.484a3.685 3.685 0 01-.414-.508A1.286 1.286 0 014 11.438c-.01-.344.07-.641.242-.891s.33-.453.477-.61a6.245 6.245 0 00-.125-.335.97.97 0 01-.063-.43c.021-.386.146-.703.375-.953a4.3 4.3 0 01.625-.578 2.648 2.648 0 01-.039-.422 1.734 1.734 0 01.055-.5 1.38 1.38 0 01.476-.782c.256-.218.594-.395 1.016-.53a7.999 7.999 0 011.508-.305A17.05 17.05 0 0110.5 5z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M13.53 21c-2.28 0-3.64-.05-4.078-.148-.437-.1-.797-.253-1.078-.461-.146-.115-.411-.214-.797-.297-.385-.084-1.088-.157-2.11-.219a.963.963 0 01-.226-.055.34.34 0 01-.164-.133c-.02-.03-.205-.398-.554-1.101-.35-.703-.524-1.654-.524-2.852 0-1.187.125-2.06.375-2.617.25-.557.38-.851.39-.883a.588.588 0 01.188-.172.495.495 0 01.25-.062c.417 0 .87-.13 1.36-.39.49-.261.981-.644 1.476-1.15a11.78 11.78 0 001.453-1.858c.474-.735.91-1.576 1.305-2.524.135-.323.266-.583.39-.781.126-.198.438-.297.938-.297.292 0 .58.091.867.273.287.183.508.404.664.664.157.26.26.589.313.985.052.396.068.81.047 1.242-.021.432-.065.857-.133 1.273-.068.417-.138.777-.211 1.079.51 0 1.156-.003 1.937-.008.782-.005 1.396-.008 1.844-.008.615 0 1.112.167 1.492.5.38.333.576.77.586 1.312 0 .178-.01.365-.03.563-.022.198-.058.36-.11.484.135.136.273.305.414.508.14.203.216.435.226.695.01.344-.07.641-.242.891s-.33.453-.476.61c.03.093.073.205.125.335a.97.97 0 01.062.43c-.02.386-.146.703-.375.953a4.3 4.3 0 01-.625.578c.02.105.034.245.04.422.004.177-.014.344-.056.5a1.38 1.38 0 01-.476.782c-.255.218-.594.395-1.016.53a7.999 7.999 0 01-1.508.305A17.05 17.05 0 0113.53 21zm-7.797-2.14c.896.072 1.6.163 2.11.273.51.11.89.258 1.14.445.198.156.477.266.836.328.36.063 1.597.094 3.711.094.313 0 .688-.008 1.125-.023.438-.016.86-.055 1.266-.118.406-.062.76-.156 1.062-.28.303-.126.48-.298.532-.517a.588.588 0 00-.125-.484l-.172-.219a.488.488 0 010-.382.481.481 0 01.25-.274c.01 0 .182-.083.515-.25.334-.167.506-.39.516-.672.01-.177-.026-.315-.11-.414a.91.91 0 01-.124-.164.453.453 0 01-.07-.36.536.536 0 01.195-.327l.32-.266a.82.82 0 00.32-.656.669.669 0 00-.297-.531 2.878 2.878 0 00-.296-.204.608.608 0 01-.25-.343.583.583 0 01.094-.406l.124-.243c.084-.161.125-.341.125-.539-.01-.406-.169-.646-.476-.719-.308-.073-.508-.109-.602-.109h-2.726c-.485 0-.901.003-1.25.008l-.524.008a.495.495 0 01-.25-.063.454.454 0 01-.172-.172.369.369 0 01-.086-.218.599.599 0 01.04-.25 9.04 9.04 0 00.32-1.172c.088-.427.15-.847.187-1.258.037-.412.042-.79.016-1.133-.026-.344-.096-.61-.211-.797-.073-.114-.14-.219-.203-.312-.063-.094-.219-.141-.469-.141-.031 0-.083.026-.156.078-.073.052-.156.182-.25.39-.417 1-.878 1.894-1.383 2.68a11.952 11.952 0 01-1.578 2c-.547.547-1.096.977-1.649 1.29-.552.312-1.083.494-1.593.546-.094.198-.203.516-.328.954-.125.437-.188 1.036-.188 1.796 0 .771.091 1.435.274 1.993.182.557.335.934.46 1.132z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M13.53 21c-2.28 0-3.64-.05-4.078-.148-.437-.1-.797-.253-1.078-.461-.146-.115-.411-.214-.797-.297-.385-.084-1.088-.157-2.11-.219a.963.963 0 01-.226-.055.34.34 0 01-.164-.133c-.02-.03-.205-.398-.554-1.101-.35-.703-.524-1.654-.524-2.852 0-1.187.125-2.06.375-2.617.25-.557.38-.851.39-.883a.588.588 0 01.188-.172.495.495 0 01.25-.062c.417 0 .87-.13 1.36-.39.49-.261.981-.644 1.476-1.15a11.78 11.78 0 001.453-1.858c.474-.735.91-1.576 1.305-2.524.135-.323.266-.583.39-.781.126-.198.438-.297.938-.297.292 0 .58.091.867.273.287.183.508.404.664.664.157.26.26.589.313.985.052.396.068.81.047 1.242-.021.432-.065.857-.133 1.273-.068.417-.138.777-.211 1.079.51 0 1.156-.003 1.937-.008.782-.005 1.396-.008 1.844-.008.615 0 1.112.167 1.492.5.38.333.576.77.586 1.312 0 .178-.01.365-.03.563-.022.198-.058.36-.11.484.135.136.273.305.414.508.14.203.216.435.226.695.01.344-.07.641-.242.891s-.33.453-.476.61c.03.093.073.205.125.335a.97.97 0 01.062.43c-.02.386-.146.703-.375.953a4.3 4.3 0 01-.625.578c.02.105.034.245.04.422.004.177-.014.344-.056.5a1.38 1.38 0 01-.476.782c-.255.218-.594.395-1.016.53a7.999 7.999 0 01-1.508.305A17.05 17.05 0 0113.53 21z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M4.531 18.719a.44.44 0 01-.312-.117.522.522 0 01-.157-.305c0-.042-.018-.3-.054-.774-.037-.474-.013-1.054.07-1.742.083-.687.258-1.43.524-2.226a6.74 6.74 0 011.289-2.242 6.89 6.89 0 011.234-1.133 7.514 7.514 0 011.523-.836 9.899 9.899 0 011.797-.54c.64-.13 1.326-.205 2.055-.226l.016-2.797c0-.104.026-.195.078-.273a.52.52 0 01.203-.18.537.537 0 01.281-.047c.094.01.177.047.25.11l6.485 5.312a.513.513 0 01.187.39.498.498 0 01-.188.391l-6.484 5.375a.453.453 0 01-.25.11.537.537 0 01-.281-.047.501.501 0 01-.203-.188.493.493 0 01-.078-.265l-.016-2.875c-1.75 0-3.125.234-4.125.703s-1.75.99-2.25 1.562c-.5.573-.815 1.107-.945 1.602-.13.495-.196.763-.196.805a.538.538 0 01-.132.32.387.387 0 01-.305.133H4.53zm8.485-6.125c.062 0 .125.013.187.039.063.026.12.06.172.101a.777.777 0 01.102.164c.026.058.039.123.039.196v2.312l5.203-4.312-5.203-4.266v2.25a.48.48 0 01-.149.352.48.48 0 01-.351.148c-.709 0-1.375.05-2 .149a8.793 8.793 0 00-1.743.453 7.012 7.012 0 00-1.46.75 5.65 5.65 0 00-1.157 1.039 6.162 6.162 0 00-1.148 1.89 8.291 8.291 0 00-.492 1.922c.27-.375.604-.752 1-1.133.395-.38.903-.72 1.523-1.023.62-.302 1.375-.55 2.266-.742.89-.193 1.96-.29 3.21-.29z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M4.531 18.719a.44.44 0 01-.312-.117.522.522 0 01-.157-.305c0-.042-.018-.3-.054-.774-.037-.474-.013-1.054.07-1.742.083-.687.258-1.43.524-2.226a6.74 6.74 0 011.289-2.242 6.89 6.89 0 011.234-1.133 7.514 7.514 0 011.523-.836 9.899 9.899 0 011.797-.54c.64-.13 1.326-.205 2.055-.226l.016-2.797c0-.104.026-.195.078-.273a.52.52 0 01.203-.18.537.537 0 01.281-.047c.094.01.177.047.25.11l6.485 5.312a.513.513 0 01.187.39.498.498 0 01-.188.391l-6.484 5.375a.453.453 0 01-.25.11.537.537 0 01-.281-.047.501.501 0 01-.203-.188.493.493 0 01-.078-.265l-.016-2.875c-1.75 0-3.125.234-4.125.703s-1.75.99-2.25 1.562c-.5.573-.815 1.107-.945 1.602-.13.495-.196.763-.196.805a.538.538 0 01-.132.32.387.387 0 01-.305.133H4.53z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M2.675 20a.545.545 0 01-.39-.148.662.662 0 01-.196-.386c0-.052-.023-.378-.068-.978-.046-.6-.016-1.334.088-2.203.104-.87.322-1.809.654-2.817.331-1.008.868-1.953 1.61-2.836.455-.54.97-1.017 1.542-1.432a9.354 9.354 0 011.903-1.058c.697-.29 1.445-.517 2.245-.682.8-.164 1.656-.26 2.567-.286l.02-3.538c0-.131.032-.247.097-.345a.652.652 0 01.254-.228.663.663 0 01.351-.059c.118.013.222.06.313.138l8.1 6.72a.648.648 0 01.235.494.636.636 0 01-.234.494l-8.101 6.798a.563.563 0 01-.313.139.663.663 0 01-.35-.06.63.63 0 01-.255-.237.629.629 0 01-.097-.336l-.02-3.636c-2.186 0-3.904.296-5.153.89-1.25.592-2.187 1.25-2.811 1.975-.625.725-1.018 1.4-1.181 2.026-.163.626-.244.965-.244 1.018a.685.685 0 01-.166.405.481.481 0 01-.38.168h-.02zm1.233-4.27c.726-.841 1.774-1.578 3.14-2.226 1.402-.666 3.26-.986 5.582-.986h.995l.005.994.015 2.847 7.152-6.002-7.152-5.932-.02 3.72-.966.028a13.87 13.87 0 00-2.394.267c-.74.152-1.426.36-2.062.625a8.356 8.356 0 00-1.701.944c-.507.368-.961.79-1.363 1.267-.662.787-1.135 1.62-1.427 2.505-.312.948-.515 1.822-.61 2.622a16.76 16.76 0 00-.054.51c.228-.39.516-.783.86-1.183z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("g", {
        fill: "currentColor"
      }, o.createElement("path", {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10c5.524 0 10-4.477 10-10S17.524 2 12 2m0 17.365a7.365 7.365 0 11.001-14.73A7.365 7.365 0 0112 19.365"
      }), o.createElement("path", {
        d: "M12.625 9.5a2.083 2.083 0 114.166 0 2.083 2.083 0 01-4.166 0M12.625 14.5a2.083 2.083 0 114.166 0 2.083 2.083 0 01-4.166 0M7.625 14.5a2.083 2.083 0 114.166 0 2.083 2.083 0 01-4.166 0M7.625 9.5a2.083 2.083 0 114.167 0 2.083 2.083 0 01-4.167 0"
      }))));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M13.969 7.284H5.03c-.01 0-.018.006-.023.016A.07.07 0 005 7.331v8.938c0 .01.003.02.008.031.005.01.013.016.023.016h8.938c.01 0 .018-.006.023-.016a.07.07 0 00.008-.031v-1.953c0-.188.05-.362.148-.524a.966.966 0 01.399-.367.752.752 0 01.226-.086 1.155 1.155 0 01.532.016c.099.026.19.07.273.133L19 15.363V8.222l-3.406 1.922a.778.778 0 01-.281.133c-.105.026-.209.039-.313.039-.073 0-.148-.008-.227-.024a.968.968 0 01-.242-.086.994.994 0 01-.383-.367.984.984 0 01-.148-.523V7.33a.07.07 0 00-.008-.031c-.005-.01-.013-.016-.023-.016zm5.5-.5c.062 0 .112.008.148.024.037.015.06.023.07.023a.511.511 0 01.313.484V16.3a.485.485 0 01-.086.281.531.531 0 01-.227.188.254.254 0 00-.07.023.337.337 0 01-.133.024c-.062 0-.125-.003-.187-.008a.308.308 0 01-.188-.102L15 14.316v1.953c0 .291-.102.539-.305.742a.992.992 0 01-.726.305H5.03a.992.992 0 01-.726-.305A1.01 1.01 0 014 16.269V7.33c0-.291.102-.539.305-.742a.992.992 0 01.726-.305h8.938c.291 0 .536.102.734.305.198.203.297.45.297.742v1.985l4.031-2.375a.464.464 0 01.227-.125.977.977 0 01.21-.032z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M19.469 6.784c.062 0 .112.008.148.024.037.015.06.023.07.023a.511.511 0 01.313.484V16.3a.485.485 0 01-.086.281.531.531 0 01-.227.188.254.254 0 00-.07.023.337.337 0 01-.133.024c-.062 0-.125-.003-.187-.008a.308.308 0 01-.188-.102L15 14.316v1.953c0 .291-.102.539-.305.742a.992.992 0 01-.726.305H5.03a.992.992 0 01-.726-.305A1.01 1.01 0 014 16.269V7.33c0-.291.102-.539.305-.742a.992.992 0 01.726-.305h8.938c.291 0 .536.102.734.305.198.203.297.45.297.742v1.985l4.031-2.375a.464.464 0 01.227-.125.977.977 0 01.21-.032z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M7 6a.5.5 0 01.5.5v11a.5.5 0 11-1 0v-11A.5.5 0 017 6zm5-3a.5.5 0 01.5.5v17a.5.5 0 11-1 0v-17A.5.5 0 0112 3zm5 5a.5.5 0 01.5.5v7a.5.5 0 11-1 0v-7A.5.5 0 0117 8zM9.5 8a.5.5 0 01.5.5v7a.5.5 0 11-1 0v-7a.5.5 0 01.5-.5zm5 2a.5.5 0 01.5.5v3a.5.5 0 11-1 0v-3a.5.5 0 01.5-.5zm-10 0a.5.5 0 01.5.5v3a.5.5 0 11-1 0v-3a.5.5 0 01.5-.5zm15 1a.5.5 0 01.5.5v1a.5.5 0 11-1 0v-1a.5.5 0 01.5-.5z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M7 6a.5.5 0 01.5.5v11a.5.5 0 11-1 0v-11A.5.5 0 017 6zm5-3a.5.5 0 01.5.5v17a.5.5 0 11-1 0v-17A.5.5 0 0112 3zm5 5a.5.5 0 01.5.5v7a.5.5 0 11-1 0v-7A.5.5 0 0117 8zM9.5 8a.5.5 0 01.5.5v7a.5.5 0 11-1 0v-7a.5.5 0 01.5-.5zm5 2a.5.5 0 01.5.5v3a.5.5 0 11-1 0v-3a.5.5 0 01.5-.5zm-10 0a.5.5 0 01.5.5v3a.5.5 0 11-1 0v-3a.5.5 0 01.5-.5zm15 1a.5.5 0 01.5.5v1a.5.5 0 11-1 0v-1a.5.5 0 01.5-.5z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("g", {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      }, o.createElement("path", {
        d: "M0 0h24v24H0z"
      }), o.createElement("path", {
        d: "M7.5 6a.5.5 0 01.5.5v11a.5.5 0 11-1 0v-11a.5.5 0 01.5-.5zm4-2a.5.5 0 01.5.5v15a.5.5 0 11-1 0v-15a.5.5 0 01.5-.5zm4 4a.5.5 0 01.5.5v7a.5.5 0 11-1 0v-7a.5.5 0 01.5-.5zm-6 0a.5.5 0 01.5.5v7a.5.5 0 11-1 0v-7a.5.5 0 01.5-.5zm4 2a.5.5 0 01.5.5v3a.5.5 0 11-1 0v-3a.5.5 0 01.5-.5zm-8 0a.5.5 0 01.5.5v3a.5.5 0 11-1 0v-3a.5.5 0 01.5-.5zm12 1a.5.5 0 01.5.5v1a.5.5 0 11-1 0v-1a.5.5 0 01.5-.5z",
        fill: "currentColor"
      })));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M12.998 4.063a.502.502 0 01.201.205.605.605 0 01.073.293v14.87a.605.605 0 01-.073.293.502.502 0 01-.201.205.341.341 0 01-.113.053.396.396 0 01-.266-.009.467.467 0 01-.136-.08l-5.151-4.482H5.626c-.44 0-.816-.151-1.127-.453a1.47 1.47 0 01-.467-1.094L4 10.11c0-.427.156-.789.467-1.085a1.575 1.575 0 011.127-.445H7.3l5.183-4.482A.45.45 0 0112.74 4a.422.422 0 01.258.062zm-.757 14.3V5.629l-4.49 3.985a.439.439 0 01-.29.107H5.594a.63.63 0 00-.41.124c-.103.083-.154.172-.154.267l.032 3.753c0 .094.051.186.153.275a.602.602 0 00.41.134h1.868a.64.64 0 01.153.018.341.341 0 01.137.07l4.458 4.003zm5.167-6.26c0 .723-.209 1.37-.627 1.939-.419.569-.95.924-1.594 1.067a.121.121 0 00-.04.009.163.163 0 01-.056.008.464.464 0 01-.322-.133.558.558 0 01-.177-.329.565.565 0 01.072-.427c.08-.13.19-.213.33-.249.408-.083.74-.305.998-.667a2.05 2.05 0 00.386-1.218c0-.486-.126-.907-.378-1.263a1.493 1.493 0 00-.99-.64.469.469 0 01-.33-.232.625.625 0 01-.088-.426.574.574 0 01.2-.374.427.427 0 01.395-.089c.644.119 1.175.462 1.594 1.032.418.569.627 1.233.627 1.992zm-.676-5.23c.494.202.94.478 1.336.828.397.35.74.753 1.03 1.21.29.456.513.957.669 1.502a6.13 6.13 0 01.233 1.69c0 .569-.078 1.126-.233 1.672a5.71 5.71 0 01-.668 1.503c-.29.456-.634.86-1.03 1.21-.398.349-.843.625-1.337.826a.689.689 0 01-.088.027.467.467 0 01-.378-.089.595.595 0 01-.186-.703.479.479 0 01.298-.284c.773-.332 1.398-.88 1.876-1.645a4.66 4.66 0 00.716-2.517 4.69 4.69 0 00-.716-2.535c-.478-.765-1.103-1.307-1.876-1.627a.541.541 0 01-.298-.303.56.56 0 01-.008-.427.494.494 0 01.266-.329.44.44 0 01.394-.008z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M12.998 4.063a.502.502 0 01.201.205.605.605 0 01.073.293v14.87a.605.605 0 01-.073.293.502.502 0 01-.201.205.341.341 0 01-.113.053.396.396 0 01-.266-.009.467.467 0 01-.136-.08l-5.151-4.482H5.626c-.44 0-.816-.151-1.127-.453a1.47 1.47 0 01-.467-1.094L4 10.11c0-.427.156-.789.467-1.085a1.575 1.575 0 011.127-.445H7.3l5.183-4.482A.45.45 0 0112.74 4a.422.422 0 01.258.062zm4.41 8.04c0 .723-.209 1.37-.627 1.939-.419.569-.95.924-1.594 1.067a.121.121 0 00-.04.009.163.163 0 01-.056.008.464.464 0 01-.322-.133.558.558 0 01-.177-.329.565.565 0 01.072-.427c.08-.13.19-.213.33-.249.408-.083.74-.305.998-.667a2.05 2.05 0 00.386-1.218c0-.486-.126-.907-.378-1.263a1.493 1.493 0 00-.99-.64.469.469 0 01-.33-.232.625.625 0 01-.088-.426.574.574 0 01.2-.374.427.427 0 01.395-.089c.644.119 1.175.462 1.594 1.032.418.569.627 1.233.627 1.992zm-.676-5.23c.494.202.94.478 1.336.828.397.35.74.753 1.03 1.21.29.456.513.957.669 1.502a6.13 6.13 0 01.233 1.69c0 .569-.078 1.126-.233 1.672a5.71 5.71 0 01-.668 1.503c-.29.456-.634.86-1.03 1.21-.398.349-.843.625-1.337.826a.689.689 0 01-.088.027.467.467 0 01-.378-.089.595.595 0 01-.186-.703.479.479 0 01.298-.284c.773-.332 1.398-.88 1.876-1.645a4.66 4.66 0 00.716-2.517 4.69 4.69 0 00-.716-2.535c-.478-.765-1.103-1.307-1.876-1.627a.541.541 0 01-.298-.303.56.56 0 01-.008-.427.494.494 0 01.266-.329.44.44 0 01.394-.008z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M20 11.794c0 4.304-3.516 7.794-7.855 7.794a7.868 7.868 0 01-3.796-.97L4 20l1.418-4.182a7.712 7.712 0 01-1.127-4.024C4.29 7.489 7.807 4 12.145 4 16.485 4 20 7.49 20 11.794zm-7.855-6.553c-3.641 0-6.603 2.94-6.603 6.553 0 1.434.467 2.762 1.258 3.842l-.825 2.433 2.537-.806a6.6 6.6 0 003.634 1.084c3.64 0 6.603-2.94 6.603-6.553s-2.962-6.553-6.604-6.553zm3.967 8.348c-.049-.08-.177-.127-.37-.223-.192-.095-1.139-.558-1.315-.621-.176-.064-.305-.096-.433.095s-.497.622-.61.749c-.112.128-.225.144-.417.048-.193-.095-.813-.297-1.548-.948a5.76 5.76 0 01-1.071-1.323c-.113-.19-.012-.294.084-.39.087-.085.193-.222.289-.334.096-.112.128-.191.192-.319.065-.127.033-.239-.016-.334-.048-.096-.433-1.036-.594-1.419-.16-.382-.53-.346-.659-.346-.128 0-.48.06-.656.25-.177.192-.674.654-.674 1.594 0 .94.69 1.849.786 1.976.096.127 1.44 2.24 3.29 2.884 1.849.644 2.037.53 2.31.478.272-.052 1.004-.37 1.232-.83.228-.46.228-.907.18-.987z",
        fill: "currentColor",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(0);
    t.default = function (e) {
      return o.createElement("svg", r({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
      }, e), o.createElement("path", {
        d: "M20 11.794c0 4.304-3.516 7.794-7.855 7.794a7.868 7.868 0 01-3.796-.97L4 20l1.418-4.182a7.712 7.712 0 01-1.127-4.024C4.29 7.489 7.807 4 12.145 4 16.485 4 20 7.49 20 11.794zm-3.888 1.795c-.049-.08-.177-.127-.37-.223-.192-.095-1.139-.558-1.315-.621-.176-.064-.305-.096-.433.095s-.497.622-.61.749c-.112.128-.225.144-.417.048-.193-.095-.813-.297-1.548-.948a5.76 5.76 0 01-1.071-1.323c-.113-.19-.012-.294.084-.39.087-.085.193-.222.289-.334.096-.112.128-.191.192-.319.065-.127.033-.239-.016-.334-.048-.096-.433-1.036-.594-1.419-.16-.382-.53-.346-.659-.346-.128 0-.48.06-.656.25-.177.192-.674.654-.674 1.594 0 .94.69 1.849.786 1.976.096.127 1.44 2.24 3.29 2.884 1.849.644 2.037.53 2.31.478.272-.052 1.004-.37 1.232-.83.228-.46.228-.907.18-.987z",
        fill: "currentColor",
        stroke: "none",
        strokeWidth: 1,
        fillRule: "evenodd"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__assign || function () {
        return (o = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Markdown = void 0;
    var i,
      a,
      l,
      s,
      c,
      u,
      p,
      d,
      f,
      h,
      m,
      g,
      v,
      y,
      b = n(0),
      _ = n(3),
      O = n(281),
      C = n(10),
      w = {
        h1: _.default("h1")(i || (i = r(["\n        font-size: 24px;\n        font-weight: bold;\n        line-height: 36px;\n        margin: 0;\n    "], ["\n        font-size: 24px;\n        font-weight: bold;\n        line-height: 36px;\n        margin: 0;\n    "]))),
        h2: _.default("h2")(a || (a = r(["\n        font-size: 20px;\n        font-weight: bold;\n        line-height: 32px;\n        margin: 0;\n    "], ["\n        font-size: 20px;\n        font-weight: bold;\n        line-height: 32px;\n        margin: 0;\n    "]))),
        h3: _.default("h3")(l || (l = r(["\n        font-size: 18px;\n        font-weight: bold;\n        line-height: 28px;\n        margin: 0;\n    "], ["\n        font-size: 18px;\n        font-weight: bold;\n        line-height: 28px;\n        margin: 0;\n    "]))),
        h4: _.default("h4")(s || (s = r(["\n        font-size: 16px;\n        font-weight: bold;\n        line-height: 24px;\n        margin: 0;\n    "], ["\n        font-size: 16px;\n        font-weight: bold;\n        line-height: 24px;\n        margin: 0;\n    "]))),
        h5: _.default("h5")(c || (c = r(["\n        font-size: 14px;\n        font-weight: bold;\n        line-height: 20px;\n        margin: 0;\n    "], ["\n        font-size: 14px;\n        font-weight: bold;\n        line-height: 20px;\n        margin: 0;\n    "]))),
        h6: _.default("h6")(u || (u = r(["\n        font-size: 12px;\n        font-weight: bold;\n        line-height: 16px;\n        margin: 0;\n    "], ["\n        font-size: 12px;\n        font-weight: bold;\n        line-height: 16px;\n        margin: 0;\n    "]))),
        a: _.default("a")(p || (p = r(["\n        color: ", ";\n        &:hover {\n            text-decoration: none;\n        }\n    "], ["\n        color: ", ";\n        &:hover {\n            text-decoration: none;\n        }\n    "])), function (e) {
          return e.theme.colors.flexBlueColor;
        }),
        p: _.default("p")(d || (d = r(["\n        margin: 0;\n    "], ["\n        margin: 0;\n    "]))),
        pre: _.default("pre")(f || (f = r(["\n        margin: 0;\n        white-space: pre-wrap;\n    "], ["\n        margin: 0;\n        white-space: pre-wrap;\n    "]))),
        em: _.default("em")(h || (h = r(["\n        font-style: italic;\n    "], ["\n        font-style: italic;\n    "]))),
        strong: _.default("strong")(m || (m = r(["\n        font-weight: bold;\n    "], ["\n        font-weight: bold;\n    "]))),
        code: _.default("code")(g || (g = r(["\n        font-family: Courier;\n    "], ["\n        font-family: Courier;\n    "]))),
        ul: _.default("ul")(v || (v = r(["\n        padding: 0;\n        margin: 0.6em 0;\n\n        & > li {\n            list-style: disc;\n            margin-left: 1.5em;\n        }\n    "], ["\n        padding: 0;\n        margin: 0.6em 0;\n\n        & > li {\n            list-style: disc;\n            margin-left: 1.5em;\n        }\n    "]))),
        ol: _.default("ol")(y || (y = r(["\n        padding: 0;\n        margin: 0.6em 0;\n\n        & > li {\n            list-style: decimal;\n            margin-left: 1.5em;\n        }\n    "], ["\n        padding: 0;\n        margin: 0.6em 0;\n\n        & > li {\n            list-style: decimal;\n            margin-left: 1.5em;\n        }\n    "])))
      },
      x = {
        img: function img() {
          return null;
        }
      };
    t.Markdown = function (e) {
      var t = e.enableImages || !1,
        n = o({}, w);
      t || Object.assign(n, x);
      var r = C.Utils.merge({
        overrides: n,
        disableParsingRawHTML: !0
      }, e.options || {});
      return b.createElement(O.default, {
        options: r
      }, e.children);
    };
  }, function (e, t) {
    e.exports = require("markdown-to-jsx");
  }, function (e, t) {
    e.exports = require("hoist-non-react-statics");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NotificationBarItem = t.NotificationBar = t.BadgeVariants = t.BadgeThemeProps = t.BadgeProps = t.BadgeChildrenProps = t.Badge = void 0, o(n(284), t), o(n(29), t), o(n(55), t), o(n(287), t);
    var i = n(294);
    Object.defineProperty(t, "Badge", {
      enumerable: !0,
      get: function get() {
        return i.Badge;
      }
    }), Object.defineProperty(t, "BadgeChildrenProps", {
      enumerable: !0,
      get: function get() {
        return i.BadgeChildrenProps;
      }
    }), Object.defineProperty(t, "BadgeProps", {
      enumerable: !0,
      get: function get() {
        return i.BadgeProps;
      }
    }), Object.defineProperty(t, "BadgeThemeProps", {
      enumerable: !0,
      get: function get() {
        return i.BadgeThemeProps;
      }
    }), Object.defineProperty(t, "BadgeVariants", {
      enumerable: !0,
      get: function get() {
        return i.BadgeVariants;
      }
    }), o(n(23), t), o(n(56), t), o(n(63), t), o(n(349), t), o(n(352), t), o(n(353), t), o(n(360), t), o(n(375), t), o(n(376), t), o(n(379), t), o(n(6), t), o(n(388), t), o(n(18), t), o(n(7), t), o(n(401), t), o(n(405), t), o(n(96), t), o(n(411), t);
    var a = n(414);
    Object.defineProperty(t, "NotificationBar", {
      enumerable: !0,
      get: function get() {
        return a.NotificationBar;
      }
    }), Object.defineProperty(t, "NotificationBarItem", {
      enumerable: !0,
      get: function get() {
        return a.NotificationBarItem;
      }
    }), o(n(425), t), o(n(428), t), o(n(431), t), o(n(434), t), o(n(1), t), o(n(440), t);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AggregatedDataTile = void 0;
    var r = n(285);
    Object.defineProperty(t, "AggregatedDataTile", {
      enumerable: !0,
      get: function get() {
        return r.AggregatedDataTile;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r16,
      o = this && this.__extends || (_r16 = function r(e, t) {
        return (_r16 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r16(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AggregatedDataTile = void 0;
    var i = n(0),
      a = n(286),
      l = n(12),
      s = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.title,
            n = e.content,
            r = e.description,
            o = e.children,
            s = e.className;
          return i.createElement(a.TileWrapper, {
            className: l.cx("Twilio-AggregatedDataTile", s)
          }, i.createElement(a.Title, {
            className: "Twilio-AggregatedDataTile-Title"
          }, t), o || i.createElement(a.Content, {
            className: "Twilio-AggregatedDataTile-Content"
          }, n), r && i.createElement(a.Description, {
            className: "Twilio-AggregatedDataTile-Description"
          }, r));
        }, t;
      }(i.PureComponent);
    t.AggregatedDataTile = s;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Content = t.Description = t.Title = t.TileWrapper = void 0;
    var o,
      i,
      a,
      l,
      s = n(3);
    t.TileWrapper = s.default("div")(o || (o = r(["\n    background-color: ", ";\n    color: ", ";\n    padding: 12px;\n    box-shadow: ", " 0 -1px 0 inset;\n    display: flex;\n    flex-direction: column;\n"], ["\n    background-color: ", ";\n    color: ", ";\n    padding: 12px;\n    box-shadow: ", " 0 -1px 0 inset;\n    display: flex;\n    flex-direction: column;\n"])), function (e) {
      return e.theme.colors.base2;
    }, function (e) {
      return e.theme.calculated.textColor;
    }, function (e) {
      return e.theme.colors.base4;
    }), t.Title = s.default("h3")(i || (i = r(["\n    margin-top: 0;\n    margin-bottom: 4px;\n    letter-spacing: 2px;\n    font-size: 10px;\n    min-height: 30px;\n    text-transform: uppercase;\n    font-weight: bold;\n"], ["\n    margin-top: 0;\n    margin-bottom: 4px;\n    letter-spacing: 2px;\n    font-size: 10px;\n    min-height: 30px;\n    text-transform: uppercase;\n    font-weight: bold;\n"]))), t.Description = s.default("div")(a || (a = r(["\n    font-size: 10px;\n    line-height: 18px;\n"], ["\n    font-size: 10px;\n    line-height: 18px;\n"]))), t.Content = s.default("div")(l || (l = r(["\n    font-size: 48px;\n    font-weight: 600;\n    line-height: 1.2;\n    letter-spacing: 1px;\n"], ["\n    font-size: 48px;\n    font-weight: 600;\n    line-height: 1.2;\n    letter-spacing: 1px;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AvatarProps = t.Avatar = void 0;
    var r = n(288);
    Object.defineProperty(t, "Avatar", {
      enumerable: !0,
      get: function get() {
        return r.Avatar;
      }
    }), Object.defineProperty(t, "AvatarProps", {
      enumerable: !0,
      get: function get() {
        return r.AvatarProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r17,
      o = this && this.__extends || (_r17 = function r(e, t) {
        return (_r17 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r17(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Avatar = void 0;
    var a = n(0),
      l = n(12),
      s = n(289),
      c = function (e) {
        function t(t) {
          var n = e.call(this, t) || this;
          return n.state = {
            verifiedImages: {}
          }, n.validateImageUrl(t.imageUrl), n;
        }
        return o(t, e), t.prototype.componentDidUpdate = function (e) {
          e.imageUrl !== this.props.imageUrl && this.validateImageUrl(this.props.imageUrl);
        }, t.prototype.validateImageUrl = function (e) {
          var t = this;
          if (e && !this.state.verifiedImages[e]) {
            var n = new Image();
            n.src = e, n.onload = function () {
              t.setState(function (t) {
                var n;
                return {
                  verifiedImages: i(i({}, t.verifiedImages), (n = {}, n[e] = !0, n))
                };
              });
            };
          }
        }, t.prototype.render = function () {
          var e = this.props,
            t = e.available,
            n = e.large,
            r = e.showAvailabilityIcon,
            o = e.noStyling,
            i = this.state.verifiedImages[this.props.imageUrl] && this.props.imageUrl,
            c = o ? s.UnstyledAvatarContainer : s.AvatarContainer;
          return a.createElement(c, {
            className: l.cx("Twilio-Avatar", this.props.className),
            large: n
          }, a.createElement(s.StyledAvatarWrapper, null, i ? a.createElement(s.StyledAvatarImage, {
            src: i
          }) : a.createElement(s.StyledDefaultAvatarIcon, {
            sizeMultiplier: n ? 2 : 1,
            icon: "DefaultAvatar"
          })), r && a.createElement(s.StyledAvailabilityIcon, {
            className: "Twilio-Avatar-AvailabilityIcon",
            available: t,
            large: n
          }));
        }, t.defaultProps = {
          showAvailabilityIcon: !0
        }, t;
      }(a.PureComponent);
    t.Avatar = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledAvailabilityIcon = t.StyledDefaultAvatarIcon = t.StyledAvatarImage = t.StyledAvatarWrapper = t.UnstyledAvatarContainer = t.AvatarContainer = void 0;
    var o,
      i,
      a,
      l,
      s,
      c,
      u = n(1),
      p = n(7);
    t.AvatarContainer = u.styled("div")(o || (o = r(["\n    display: flex;\n    flex: 0 0 auto;\n    position: relative;\n    border-radius: 1000px;\n    border-style: solid;\n    border-width: ", "px;\n    ", "\n"], ["\n    display: flex;\n    flex: 0 0 auto;\n    position: relative;\n    border-radius: 1000px;\n    border-style: solid;\n    border-width: ", "px;\n    ", "\n"])), function (e) {
      return e.large ? 2 : 1;
    }, function (e) {
      return e.theme.Avatar.Container;
    }), t.UnstyledAvatarContainer = u.styled("div")(i || (i = r(["\n    display: flex;\n    flex: 0 0 auto;\n    position: relative;\n"], ["\n    display: flex;\n    flex: 0 0 auto;\n    position: relative;\n"]))), t.StyledAvatarWrapper = u.styled("div")(a || (a = r(["\n    display: flex;\n    width: 100%;\n    height: 100%;\n    border-radius: 1000px;\n    overflow: hidden;\n"], ["\n    display: flex;\n    width: 100%;\n    height: 100%;\n    border-radius: 1000px;\n    overflow: hidden;\n"]))), t.StyledAvatarImage = u.styled("img")(l || (l = r(["\n    margin: auto;\n    display: block;\n    width: 100%;\n    height: 100%;\n"], ["\n    margin: auto;\n    display: block;\n    width: 100%;\n    height: 100%;\n"]))), t.StyledDefaultAvatarIcon = u.styled(p.Icon)(s || (s = r(["\n    margin: auto;\n"], ["\n    margin: auto;\n"]))), t.StyledAvailabilityIcon = u.styled("div")(c || (c = r(["\n    display: flex;\n    position: absolute;\n    top: auto;\n    left: auto;\n    right: -", "px;\n    bottom: -", "px;\n    width: ", "px;\n    height: ", "px;\n    border-radius: 100px;\n    border-style: solid;\n    border-width: ", "px;\n    background-color: ", ";\n    ", "\n"], ["\n    display: flex;\n    position: absolute;\n    top: auto;\n    left: auto;\n    right: -", "px;\n    bottom: -", "px;\n    width: ", "px;\n    height: ", "px;\n    border-radius: 100px;\n    border-style: solid;\n    border-width: ", "px;\n    background-color: ", ";\n    ", "\n"])), function (e) {
      return e.large ? 2 : 1;
    }, function (e) {
      return e.large ? 2 : 1;
    }, function (e) {
      return e.large ? 16 : 14;
    }, function (e) {
      return e.large ? 16 : 14;
    }, function (e) {
      return e.large ? 2 : 1;
    }, function (e) {
      return e.available ? e.theme.colors.userAvailableColor : e.theme.colors.userUnavailableColor;
    }, function (e) {
      return e.theme.Avatar.AvailabilityIcon;
    });
  }, function (e, t) {
    e.exports = require("create-emotion-styled");
  }, function (e, t, n) {
    "use strict";

    var _r18,
      o = this && this.__extends || (_r18 = function r(e, t) {
        return (_r18 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r18(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Icon = void 0;
    var i = n(0),
      a = n(27),
      l = n(2),
      s = n(292),
      c = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e,
            t = this.props,
            n = t.icon,
            r = t.className,
            o = t.sizeMultiplier;
          "string" == typeof n ? e = n : i.isValidElement(n) && (e = n.props.className);
          var c = "Twilio-Icon Twilio-Icon-" + (e || "Custom") + " " + (r || ""),
            u = o || 1;
          if (i.isValidElement(n)) return i.createElement(s.SvgContainer, {
            className: c,
            contentSize: 24 * u
          }, n);
          var p = a["Icn" + n];
          return p || (l.log.error("Icon " + n + " missing"), p = a.IcnHelp), i.createElement(s.SvgContainer, {
            className: c,
            contentSize: 24 * u
          }, i.createElement(p, {
            className: "Twilio-Icon-Content"
          }));
        }, t;
      }(i.PureComponent);
    t.Icon = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SvgContainer = void 0;
    var o,
      i = n(3);
    t.SvgContainer = i.default("div")(o || (o = r(["\n    display: flex;\n    & > * {\n        width: ", "px;\n        height: ", "px;\n        flex: 0 0 auto;\n        margin: auto;\n    }\n"], ["\n    display: flex;\n    & > * {\n        width: ", "px;\n        height: ", "px;\n        flex: 0 0 auto;\n        margin: auto;\n    }\n"])), function (e) {
      return e.contentSize;
    }, function (e) {
      return e.contentSize;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.BadgeVariants = t.BadgeThemeProps = t.BadgeChildrenProps = t.BadgeProps = t.Badge = void 0;
    var r = n(295);
    Object.defineProperty(t, "Badge", {
      enumerable: !0,
      get: function get() {
        return r.Badge;
      }
    });
    var o = n(38);
    Object.defineProperty(t, "BadgeProps", {
      enumerable: !0,
      get: function get() {
        return o.BadgeProps;
      }
    }), Object.defineProperty(t, "BadgeChildrenProps", {
      enumerable: !0,
      get: function get() {
        return o.BadgeChildrenProps;
      }
    }), Object.defineProperty(t, "BadgeThemeProps", {
      enumerable: !0,
      get: function get() {
        return o.BadgeThemeProps;
      }
    }), Object.defineProperty(t, "BadgeVariants", {
      enumerable: !0,
      get: function get() {
        return o.BadgeVariants;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r19,
      o = this && this.__extends || (_r19 = function r(e, t) {
        return (_r19 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r19(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Badge = void 0;
    var l = n(0),
      s = n(296),
      c = n(2),
      u = n(38),
      p = n(9),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            n = e.children,
            r = e.showZero,
            o = e.invisible,
            a = e.variant,
            u = e.position,
            d = e.themeOverride,
            f = this.getWrapperComponent();
          return "number" != typeof n && void 0 !== n ? (c.log.error("Badge component received a non-numeric content."), null) : o || void 0 === n || 0 === n && !r && a !== t.variants.danger ? null : l.createElement(f.Component, i({}, f.props), l.createElement(p.ContentFragment, null, l.createElement(s.OuterCircle, {
            key: "defaultCircle",
            className: "Twilio-Badge-OuterCircle",
            themeOverride: d.OuterCircle,
            variant: a,
            position: u
          }, l.createElement(s.InnerCircle, {
            className: "Twilio-Badge-InnerCircle",
            variant: a,
            themeOverride: d.InnerCircle
          }, l.createElement(s.TextContainer, {
            className: "Twilio-Badge-TextContainer"
          }, this.renderContent())))));
        }, t.prototype.renderContent = function () {
          var e = this.props,
            n = e.children,
            r = e.variant,
            o = e.max;
          return r === t.variants.standard ? Math.min(n, o) + (n > o ? "+" : "") : r === t.variants.dot ? null : r === t.variants.danger ? "!" : (c.log.error("Badge component received an invalid variant"), null);
        }, t.prototype.getWrapperComponent = function () {
          var e = this.props,
            n = e.programmable,
            r = (e.themeOverride, a(e, ["programmable", "themeOverride"]));
          return n ? {
            Component: p.DynamicComponent,
            props: {
              name: t.displayName,
              contentStore: t.Content,
              noContainers: !0,
              childProps: r
            }
          } : {
            Component: l.Fragment,
            props: {}
          };
        }, t.variants = u.BadgeVariants, t.displayName = "Badge", t.Content = new p.DynamicContentStore(t.displayName), t.defaultProps = {
          invisible: !1,
          showZero: !1,
          variant: t.variants.standard,
          programmable: !0,
          themeOverride: {},
          max: 9
        }, t;
      }(l.PureComponent);
    t.Badge = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TextContainer = t.InnerCircle = t.OuterCircle = void 0;
    var o,
      i,
      a,
      l = n(1),
      s = n(38),
      c = function c(e, t, n) {
        return function (r) {
          switch (r.variant) {
            case s.BadgeVariants.standard:
              return e;
            case s.BadgeVariants.danger:
              return n;
            default:
              return t;
          }
        };
      };
    t.OuterCircle = l.styled("div")(o || (o = r(["\n    padding: 2px;\n    border-radius: 1em;\n    font-size: 10px;\n    position: absolute;\n    right: ", ";\n    top: ", ";\n    z-index: 2;\n    animation: popIn forwards 0.5s cubic-bezier(0.28, 0.84, 0.42, 1);\n    backface-visibility: hidden;\n\n    @keyframes popIn {\n        0% {\n            opacity: 0;\n            transform: scale(0) translateZ(0);\n        }\n        50% {\n            opacity: 1;\n            transform: scale(1.1) translateZ(0);\n        }\n\n        70% {\n            transform: scale(0.9) translateZ(0);\n        }\n\n        100% {\n            transform: scale(1) translateZ(0);\n        }\n    }\n\n    ", "\n    ", "\n"], ["\n    padding: 2px;\n    border-radius: 1em;\n    font-size: 10px;\n    position: absolute;\n    right: ", ";\n    top: ", ";\n    z-index: 2;\n    animation: popIn forwards 0.5s cubic-bezier(0.28, 0.84, 0.42, 1);\n    backface-visibility: hidden;\n\n    @keyframes popIn {\n        0% {\n            opacity: 0;\n            transform: scale(0) translateZ(0);\n        }\n        50% {\n            opacity: 1;\n            transform: scale(1.1) translateZ(0);\n        }\n\n        70% {\n            transform: scale(0.9) translateZ(0);\n        }\n\n        100% {\n            transform: scale(1) translateZ(0);\n        }\n    }\n\n    ", "\n    ", "\n"])), function (e) {
      return e.position && e.position.right ? e.position.right : c("4px", "8px", "4px");
    }, function (e) {
      return e.position && e.position.top ? e.position.top : c("4px", "8px", "4px");
    }, function (e) {
      return e.theme.Badge.OuterCircle;
    }, function (e) {
      return e.themeOverride;
    }), t.InnerCircle = l.styled("div")(i || (i = r(["\n    line-height: ", ";\n    min-width: ", ";\n    width: ", ";\n    height: ", ";\n    padding-left: 3px;\n    padding-right: 3px;\n    text-align: center;\n    border-radius: 16px;\n    font-weight: bold;\n    box-sizing: border-box;\n\n    ", "\n    ", "\n"], ["\n    line-height: ", ";\n    min-width: ", ";\n    width: ", ";\n    height: ", ";\n    padding-left: 3px;\n    padding-right: 3px;\n    text-align: center;\n    border-radius: 16px;\n    font-weight: bold;\n    box-sizing: border-box;\n\n    ", "\n    ", "\n"])), c("15px", "8px", "15px"), c("15px", "8px", "15px"), c("auto", "8px", "auto"), c("15px", "8px", "15px"), function (e) {
      return e.theme.Badge.InnerCircle;
    }, function (e) {
      return e.themeOverride;
    }), t.TextContainer = l.styled("span")(a || (a = r(["\n    margin-left: auto;\n    margin-right: auto;\n    align-self: center;\n"], ["\n    margin-left: auto;\n    margin-right: auto;\n    align-self: center;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r20,
      o = this && this.__extends || (_r20 = function r(e, t) {
        return (_r20 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r20(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Button = void 0;
    var l = n(0),
      s = n(3),
      c = n(39),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.className,
            n = e.disabled,
            r = e.roundCorners,
            o = e.themeOverride,
            u = e.children,
            p = a(e, ["className", "disabled", "roundCorners", "themeOverride", "children"]);
          return l.createElement(c.StyledButton, i({
            className: s.cx("Twilio-Button", t),
            disabled: n || !1,
            override: o,
            roundCorners: r,
            isLink: !1
          }, p), u);
        }, t.displayName = "Button", t.defaultProps = {
          className: "",
          disabled: !1,
          roundCorners: !0,
          themeOverride: {}
        }, t;
      }(l.PureComponent);
    t.Button = u;
  }, function (e, t, n) {
    "use strict";

    var _r21,
      o = this && this.__extends || (_r21 = function r(e, t) {
        return (_r21 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r21(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Link = void 0;
    var l = n(0),
      s = n(3),
      c = n(39),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.className,
            n = e.roundCorners,
            r = e.themeOverride,
            o = e.children,
            u = a(e, ["className", "roundCorners", "themeOverride", "children"]),
            p = c.StyledButton.withComponent("a");
          return l.createElement(p, i({
            className: s.cx("Twilio-Link", t),
            override: r,
            roundCorners: n,
            isLink: !0
          }, u), o);
        }, t.displayName = "Link", t.defaultProps = {
          className: "",
          roundCorners: !0,
          themeOverride: {}
        }, t;
      }(l.PureComponent);
    t.Link = u;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r22,
      o = this && this.__extends || (_r22 = function r(e, t) {
        return (_r22 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r22(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var l = e.length - 1; l >= 0; l--) (o = e[l]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessagingCanvas = void 0;
    var l = n(0),
      s = n(5),
      c = n(28),
      u = n(40),
      p = n(42),
      d = n(334),
      f = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.updateAll = function () {}, t.prototype.render = function () {
          return l.createElement(h, i({}, this.props));
        }, t.displayName = d.displayName, t.Content = d.contentStore, t.Input = u.MessageInput, t.MessageList = p.MessageList, t.defaultProps = {
          avatarCallback: void 0,
          memberDisplayOptions: {
            yourDefaultName: "",
            theirDefaultName: "",
            yourFriendlyNameOverride: !0,
            theirFriendlyNameOverride: !0
          },
          messageStyle: "Rounded",
          showTypingIndicator: !0,
          showReadStatus: !0,
          showTrayOnInactive: !1,
          showWelcomeMessage: !0,
          welcomeMessageText: void 0,
          charLimit: 32768,
          autoInitChannel: !1,
          hasMarkdownSupport: !0,
          hideFooterOnInactive: !1
        }, t = a([c.withDefaultPropsUpdate], t);
      }(l.PureComponent);
    t.MessagingCanvas = f;
    var h = s.connect(function (e, t) {
      return {
        channel: e.channels[t.sid]
      };
    })(d.MessagingCanvasImpl);
  }, function (e, t, n) {
    "use strict";

    var _r23,
      o = this && this.__extends || (_r23 = function r(e, t) {
        return (_r23 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r23(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var l = e.length - 1; l >= 0; l--) (o = e[l]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageInput = void 0;
    var l = n(0),
      s = n(5),
      c = n(20),
      u = n(28),
      p = n(302),
      d = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.updateAll = function () {}, t.prototype.render = function () {
          var e = this;
          return l.createElement(c.MessagingCanvasContext.Consumer, null, function (t) {
            return l.createElement(f, i({}, e.props, {
              channelSid: t.sid,
              key: t.sid
            }));
          });
        }, t.displayName = p.displayName, t.Content = p.contentStore, t.defaultProps = {
          areaStyle: "Bubble",
          returnKeySendsMessage: !0,
          useSeparateInputStore: !1,
          sendButtonAriaProps: {
            ariaLabel: "Send Message"
          },
          textAreaAriaProps: {
            ariaLabel: "Enter your message here to get help"
          }
        }, t = a([u.withDefaultPropsUpdate], t);
      }(l.PureComponent);
    t.MessageInput = d;
    var f = s.connect(function (e, t) {
      return {
        channel: e.channels[t.channelSid],
        connectionState: e.session.connectionState,
        messageState: e.channelInput[t.channelSid]
      };
    })(p.MessageInputImpl);
  }, function (e, t, n) {
    "use strict";

    var _r24,
      o = this && this.__extends || (_r24 = function r(e, t) {
        return (_r24 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r24(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var l = e.length - 1; l >= 0; l--) (o = e[l]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      l = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              s(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            try {
              s(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, l);
          }
          s((r = r.apply(e, t || [])).next());
        });
      },
      s = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: l(0),
          throw: l(1),
          return: l(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function l(i) {
          return function (l) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, l]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageInputImpl = t.contentStore = t.displayName = void 0;
    var c = n(0),
      u = n(22),
      p = n(36),
      d = n(9),
      f = n(17),
      h = n(2),
      m = n(41),
      g = n(25),
      v = n(4),
      y = n(303),
      b = n(1),
      _ = n(309),
      O = n(315),
      C = n(59);
    t.displayName = "MessageInput", t.contentStore = new d.DynamicContentStore(t.displayName);
    var w = function (e) {
      function n(t) {
        var n = e.call(this, t) || this;
        n.state = {
          inputText: "",
          selectionStart: 0,
          selectionEnd: 0,
          attachedFiles: []
        }, n._inputElementRef = c.createRef(), n.onMessageChange = function (e) {
          n.setState(e, function () {
            n.debouncedSetInputText();
          });
        }, n.debouncedSetInputText = C(function () {
          var e = n.props,
            t = e.channel,
            r = e.useSeparateInputStore;
          m.tryInvokeAction("SetInputText", {
            channel: t,
            useSeparateInputStore: r,
            body: n.state.inputText,
            selectionStart: n.state.selectionStart,
            selectionEnd: n.state.selectionEnd
          });
        }, 100), n.getInputTextLength = function () {
          var e = n.state.inputText;
          return e && e.trim().length || 0;
        }, n.sendMessage = function () {
          var e = n.props,
            t = e.channel,
            r = e.charLimit,
            o = e.disabledReason,
            i = e.useSeparateInputStore,
            a = e.messageState,
            l = n.state.inputText;
          if (n.getInputTextLength() > r) h.log.warn("The entered character number exceeds the limit");else if (void 0 === o) {
            var s = a.attachedFiles && a.attachedFiles[0];
            s && (m.tryInvokeAction("DetachFile", {
              file: s,
              channel: t
            }), m.tryInvokeAction("SendMediaMessage", {
              body: l,
              channel: t,
              file: s
            }), g.TelemetryBridge.emit(g.TelemetryBridgeMessageType.MEDIA_MESSAGE_SENT, s)), "" !== l && (n.setState({
              inputText: "",
              selectionStart: 0,
              selectionEnd: 0
            }), m.tryInvokeAction("SendMessage", {
              body: l,
              channel: t,
              useSeparateInputStore: i
            })), n._inputElementRef.current && n._inputElementRef.current.focus();
          } else h.log.warn("Message sending is not enabled");
        }, n.handleFileChange = function (e) {
          return l(n, void 0, void 0, function () {
            var t, n;
            return s(this, function (r) {
              switch (r.label) {
                case 0:
                  if (t = this.props.channelSid, !e.target.files[0]) return [3, 4];
                  r.label = 1;
                case 1:
                  return r.trys.push([1, 3,, 4]), [4, u.Actions.invokeAction("AttachFile", {
                    file: e.target.files[0],
                    channelSid: t
                  })];
                case 2:
                  return r.sent(), [3, 4];
                case 3:
                  return n = r.sent(), h.log.error(n), [2, Promise.reject()];
                case 4:
                  return this._inputElementRef.current && this._inputElementRef.current.focus(), [2, Promise.resolve()];
              }
            });
          });
        }, n.removeAttachedFile = function () {
          var e = n.props,
            t = e.channelSid,
            r = e.messageState.attachedFiles[0];
          m.tryInvokeAction("DetachFile", {
            file: r,
            channelSid: t
          });
        }, n.attachFile = function (e) {
          return l(n, void 0, void 0, function () {
            var t;
            return s(this, function (n) {
              switch (n.label) {
                case 0:
                  return e ? (t = this.props.channelSid, [4, m.tryInvokeAction("AttachFile", {
                    file: e,
                    channelSid: t
                  })]) : [2];
                case 1:
                  return n.sent(), [2];
              }
            });
          });
        }, n.getStoredState = n.getStoredState.bind(n), n.resetFromStoredState = n.resetFromStoredState.bind(n);
        var r = n.getStoredState();
        return n.state = r, n;
      }
      return o(n, e), n.prototype.getStoredState = function () {
        return (this.props.useSeparateInputStore ? this.props.messageState : this.props.channel) || this.state;
      }, n.prototype.resetFromStoredState = function () {
        var e = this.getStoredState();
        e.inputText === this.state.inputText && e.selectionStart === this.state.selectionStart && e.selectionEnd === this.state.selectionEnd || this.setState({
          inputText: e.inputText,
          selectionStart: e.selectionStart,
          selectionEnd: e.selectionEnd
        });
      }, n.prototype.componentDidMount = function () {
        u.Actions.addListener("afterSetInputText", this.resetFromStoredState);
      }, n.prototype.componentWillUnmount = function () {
        u.Actions.removeListener("afterSetInputText", this.resetFromStoredState);
      }, n.prototype.render = function () {
        var e = this,
          n = this.props,
          r = n.areaStyle,
          o = n.connectionState,
          a = n.channel,
          l = n.disabledReason,
          s = n.returnKeySendsMessage,
          u = n.charLimit,
          h = n.channelSid,
          m = n.sendButtonAriaProps,
          g = n.textAreaAriaProps,
          b = n.messageState,
          C = n.theme,
          w = this.getInputTextLength(),
          x = "connected" !== o || 0 === w && !b.attachedFiles.length || void 0 !== l || w > u,
          E = l || v.templates.InputPlaceHolder(),
          M = i(i({}, this.state), {
            attachedFiles: b.attachedFiles
          }),
          P = (M.attachedFiles || [])[0];
        return c.createElement(d.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          vertical: !0
        }, c.createElement(O.Container, {
          noGrow: !0,
          noShrink: !0,
          areaStyle: r
        }, c.createElement(O.SeparatorLine, {
          key: "line",
          areaStyle: r
        }), c.createElement(O.TextAreaContainer, {
          key: "textarea"
        }, f.isFileAttachmentEnabled(h) && !f.isFileAttachmentReadOnly() && c.createElement(O.FileUploadButtonWrapper, null, c.createElement(y.AttachFileButton, {
          disabled: void 0 !== l || !!P || !a.messages.length,
          onChange: this.handleFileChange,
          className: "Twilio-MessageInputArea-AttachFileButton",
          themeOverride: C.Chat.MessageInput.AttachFileButton,
          selectedFileName: (P || {}).name
        })), c.createElement(_.MessageInputArea, {
          forwardedInputRef: this._inputElementRef,
          channelSid: a.source.sid,
          channel: a,
          disabled: void 0 !== l,
          placeholder: E,
          onSendMessage: this.sendMessage,
          areaStyle: r,
          returnKeySendsMessage: s,
          charLimit: u,
          inputTextLength: w,
          onChange: this.onMessageChange,
          messageState: M,
          textAreaAriaProps: g,
          onRemoveAttachedFile: this.removeAttachedFile,
          onPasteFile: this.attachFile
        }), c.createElement(O.ButtonsContainer, null, c.createElement(p.ActionStateListener, {
          action: "SendMessage",
          payload: function payload(e) {
            return e.channel.source.sid === h;
          }
        }, function (t) {
          return c.createElement(O.SendButton, {
            className: "Twilio-MessageInput-SendButton",
            icon: "SendLarge",
            onClick: e.sendMessage,
            title: l || v.templates.SendMessageTooltip(),
            disabled: t.disabled || x,
            themeOverride: e.props.theme && e.props.theme.Chat.MessageInput.Button,
            "aria-label": m && m.ariaLabel,
            "aria-live": m && m.ariaLive
          });
        })))));
      }, n = a([b.withTheme], n);
    }(c.PureComponent);
    t.MessageInputImpl = w;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AttachFileButton = t.AttachFileButtonProps = void 0;
    var r = n(304);
    Object.defineProperty(t, "AttachFileButtonProps", {
      enumerable: !0,
      get: function get() {
        return r.AttachFileButtonProps;
      }
    });
    var o = n(305);
    Object.defineProperty(t, "AttachFileButton", {
      enumerable: !0,
      get: function get() {
        return o.AttachFileButton;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r25,
      o = this && this.__extends || (_r25 = function r(e, t) {
        return (_r25 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r25(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              s(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            try {
              s(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, l);
          }
          s((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: l(0),
          throw: l(1),
          return: l(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function l(i) {
          return function (l) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, l]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AttachFileButton = void 0;
    var l = n(0),
      s = n(306),
      c = n(12),
      u = n(17),
      p = n(4),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.inputRef = l.createRef(), t.handleButtonClick = function () {
            t.inputRef.current.click();
          }, t.onChange = function (e) {
            return i(t, void 0, void 0, function () {
              return a(this, function (t) {
                switch (t.label) {
                  case 0:
                    return t.trys.push([0, 2,, 3]), [4, this.props.onChange(e)];
                  case 1:
                    return t.sent(), [3, 3];
                  case 2:
                    return t.sent(), this.inputRef.current.value = "", [3, 3];
                  case 3:
                    return [2];
                }
              });
            });
          }, t;
        }
        return o(t, e), t.prototype.componentDidUpdate = function (e) {
          !this.props.selectedFileName && e.selectedFileName && (this.inputRef.current.value = "");
        }, t.prototype.render = function () {
          var e = this.props,
            t = e.disabled,
            n = e.themeOverride,
            r = e.className;
          return l.createElement(l.Fragment, null, l.createElement("input", {
            disabled: t,
            className: s.hiddenInputClass,
            ref: this.inputRef,
            type: "file",
            onChange: this.onChange,
            accept: u.getAllowedFileExtensions().map(function (e) {
              return "." + e;
            }).join(",")
          }), l.createElement(s.StyledIconButton, {
            disabled: t,
            onClick: this.handleButtonClick,
            className: c.cx("Twilio-AttachFileButton", r),
            icon: "Attachment",
            title: t ? "" : p.templates.AttachFileImageTooltip(),
            themeOverride: n
          }));
        }, t;
      }(l.PureComponent);
    t.AttachFileButton = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledIconButton = t.hiddenInputClass = void 0;
    var o,
      i,
      a = n(12),
      l = n(1),
      s = n(18);
    t.hiddenInputClass = a.css(o || (o = r(["\n    visibility: hidden;\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n"], ["\n    visibility: hidden;\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n"]))), t.StyledIconButton = l.styled(s.IconButton)(i || (i = r(["\n    width: 32px;\n    height: 32px;\n    ", ";\n    ", "\n"], ["\n    width: 32px;\n    height: 32px;\n    ", ";\n    ", "\n"])), function (e) {
      return l.getBackgroundWithHoverCSS(e.theme.Chat.MessageInput.AttachFileButton.background, e.theme.Chat.MessageInput.AttachFileButton.lightHover, !1, e.disabled);
    }, function (e) {
      return e.themeOverride;
    });
  }, function (e, t, n) {
    "use strict";

    var _r26,
      o = this && this.__extends || (_r26 = function r(e, t) {
        return (_r26 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r26(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IconButton = void 0;
    var l = n(0),
      s = n(3),
      c = n(7),
      u = n(308),
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.className,
            n = e.disabled,
            r = e.icon,
            o = e.themeOverride,
            p = e.sizeMultiplier,
            d = a(e, ["className", "disabled", "icon", "themeOverride", "sizeMultiplier"]);
          return l.createElement(u.StyledButton, i({
            className: s.cx("Twilio-IconButton", t),
            disabled: n || !1,
            override: o || {}
          }, d), l.createElement(c.Icon, {
            icon: r,
            sizeMultiplier: p
          }));
        }, t;
      }(l.PureComponent);
    t.IconButton = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledButton = void 0;
    var o,
      i = n(1);
    t.StyledButton = i.styled("button")(o || (o = r(["\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    border: none;\n    background: inherit;\n    outline: none;\n    border-radius: 100px;\n    align-self: center;\n    color: inherit;\n    &:disabled {\n        opacity: 0.5;\n    }\n    border-color: ", ";\n    border-color: ", ";\n    color: ", ";\n    color: ", ";\n    ", ";\n"], ["\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    border: none;\n    background: inherit;\n    outline: none;\n    border-radius: 100px;\n    align-self: center;\n    color: inherit;\n    &:disabled {\n        opacity: 0.5;\n    }\n    border-color: ", ";\n    border-color: ", ";\n    color: ", ";\n    color: ", ";\n    ", ";\n"])), function (e) {
      return e.theme.Button.borderColor;
    }, function (e) {
      return e.override && e.override.borderColor;
    }, function (e) {
      return e.theme.Button.color;
    }, function (e) {
      return e.override && e.override.color;
    }, function (e) {
      return e.override ? i.getBackgroundWithHoverCSS(e.override.background || e.theme.Button.background, e.override ? e.override.lightHover : e.theme.Button.lightHover, !1, e.disabled) : i.getBackgroundWithHoverCSS(e.theme.Button.background, e.theme.Button.lightHover, !1, e.disabled);
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageInputAreaProps = t.MessageInputArea = void 0;
    var r = n(310);
    Object.defineProperty(t, "MessageInputArea", {
      enumerable: !0,
      get: function get() {
        return r.MessageInputArea;
      }
    });
    var o = n(314);
    Object.defineProperty(t, "MessageInputAreaProps", {
      enumerable: !0,
      get: function get() {
        return o.MessageInputAreaProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r27,
      o = this && this.__extends || (_r27 = function r(e, t) {
        return (_r27 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r27(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var l = e.length - 1; l >= 0; l--) (o = e[l]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageInputArea = void 0;
    var a = n(0),
      l = n(5),
      s = n(17),
      c = n(11),
      u = n(4),
      p = n(58),
      d = n(1),
      f = n(313),
      h = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t._inputContainerElement = a.createRef(), t.isComposing = !1, t.handleCompositionEvent = function (e) {
            "compositionstart" === e.type && (t.isComposing = !0), "compositionend" === e.type && (t.isComposing = !1);
          }, t.handleDroppedText = function (e) {
            var n = e.dataTransfer.types;
            if (n && n.includes("text/plain")) {
              var r = t.props,
                o = r.onChange,
                i = r.messageState,
                a = e.dataTransfer.getData("text/plain");
              o({
                inputText: i.inputText + a,
                selectionStart: 0,
                selectionEnd: 0
              });
            }
          }, t.handleInputKeyPress = function (e) {
            13 === e.which && !e.shiftKey && t.props.returnKeySendsMessage && (t.props.onSendMessage(), e.preventDefault());
          }, t.handleInputFocus = function () {
            l.ChatModule.events.emitInputFocus(t.props.channelSid);
          }, t.handleInputBlur = function () {
            l.ChatModule.events.emitInputBlur(t.props.channelSid);
          }, t.handleInputChange = function (e) {
            var n = t.props,
              r = n.messageState,
              o = n.onChange,
              i = e.target,
              a = i.value,
              l = i.selectionStart,
              s = i.selectionEnd;
            !(r.inputText === a && r.selectionStart === l && r.selectionEnd === s) && o && (o({
              inputText: a,
              selectionStart: l,
              selectionEnd: s
            }), t.adjustRowCountStyle());
          }, t.handlePaste = function (e) {
            var n = e.clipboardData || window.clipboardData;
            if (n && n.files && !(n.files.length <= 0)) {
              if (s.canAttachFile(t.props.messageState, t.props.channel)) {
                var r = t.getPastedFile(n);
                r && t.props.onPasteFile(r);
              }
              e.preventDefault();
            }
          }, t.getPastedFile = function (e) {
            var t = e.files.item && e.files.item(0);
            if (t) return new File([t], t.name, {
              type: t.type,
              lastModified: t.lastModified
            });
          }, t.resize = function () {
            var e = t.props.forwardedInputRef;
            e.current.style.height = "", e.current.style.height = e.current.scrollHeight + "px";
          }, t.adjustRowCountStyle = function () {
            var e = t.props,
              n = e.areaStyle,
              r = e.messageState,
              o = e.channelSid,
              i = e.forwardedInputRef,
              a = r.attachedFiles || [],
              s = "intial";
            if (i.current) {
              t.resize();
              var c = Math.round(parseFloat(i.current.style.height)),
                u = window.getComputedStyle(i.current, null),
                p = Math.ceil(i.current.scrollHeight / t.baseInputScrollHeight);
              p = Math.max(Math.min(p, 6), 1);
              var d = i.current.offsetHeight;
              d < c ? "hidden" === u.overflowY && (i.current.style.overflowY = "scroll", t.resize(), d = i.current.offsetHeight) : "hidden" !== u.overflowY && (i.current.style.overflowY = "hidden", t.resize(), d = i.current.offsetHeight), "Bubble" === n && (s = p > 1 || a.length ? "8px" : "18px"), t._inputContainerElement.current.style.borderRadius = s, t.cachedHeight !== d && (t.cachedHeight = d, l.ChatModule.events.emitInputRowsChanged(o));
            }
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.areaStyle,
            n = e.placeholder,
            r = e.disabled,
            o = e.messageState,
            i = e.textAreaAriaProps,
            l = e.forwardedInputRef,
            s = (o.attachedFiles || [])[0];
          return a.createElement(f.TextAreaContainer, {
            className: "Twilio-MessageInputArea-TextArea",
            innerRef: this._inputContainerElement,
            areaStyle: t,
            "aria-label": i && i.ariaLabel,
            "aria-live": i && i.ariaLive
          }, a.createElement(f.TextArea, {
            areaStyle: t,
            innerRef: l,
            rows: 1,
            placeholder: n,
            onKeyPress: this.handleInputKeyPress,
            onChange: this.handleInputChange,
            onFocus: this.handleInputFocus,
            onBlur: this.handleInputBlur,
            value: o.inputText,
            disabled: r,
            onSelect: this.handleInputChange,
            onPaste: this.handlePaste,
            onDrop: this.handleDroppedText,
            onCompositionStart: this.handleCompositionEvent,
            onCompositionUpdate: this.handleCompositionEvent,
            onCompositionEnd: this.handleCompositionEvent
          }), this.renderCharCount(), s && this.renderFileBox());
        }, t.prototype.renderCharCount = function () {
          var e = this.props,
            t = e.charLimit,
            n = e.inputTextLength;
          return n >= .7 * t ? a.createElement(f.CharLimit, {
            areaStyle: this.props.areaStyle,
            inputTextLength: n,
            charLimit: t
          }, n > t ? a.createElement(c.Template, {
            key: "MessageCharacterCountReachedText",
            source: u.templates.MessageCharacterCountReached,
            className: "MessageCharacterCountReached",
            currentCharCount: n,
            maxCharCount: t
          }) : a.createElement(c.Template, {
            key: "MessageCharacterCountStatusText",
            source: u.templates.MessageCharacterCountStatus,
            className: "MessageCharacterCountStatus",
            currentCharCount: n,
            maxCharCount: t
          })) : null;
        }, t.prototype.componentDidMount = function () {
          var e = this;
          setTimeout(function () {
            var t = e.props,
              n = t.forwardedInputRef,
              r = t.channel;
            n.current && (e.baseInputScrollHeight = n.current.scrollHeight, e.adjustRowCountStyle(), n.current.selectionStart = r.selectionStart, n.current.selectionEnd = r.selectionStart);
          }, 0);
        }, t.prototype.componentDidUpdate = function () {
          var e = this.props,
            t = e.messageState,
            n = e.forwardedInputRef,
            r = t.selectionStart,
            o = t.selectionEnd;
          this.adjustRowCountStyle(), this.isComposing || n.current && (n.current.selectionStart = r, n.current.selectionEnd = o);
        }, t.prototype.renderFileBox = function () {
          var e = this.props,
            t = e.messageState.attachedFiles[0],
            n = t.name,
            r = t.size,
            o = t.type,
            i = e.theme,
            l = e.onRemoveAttachedFile;
          return a.createElement(f.FileBox, {
            noGrow: !0,
            overflow: "hidden",
            className: "Twilio-MessageInput-FileBox"
          }, a.createElement(p.FilePreview, {
            media: {
              filename: n,
              contentType: o,
              size: r
            }
          }), a.createElement(f.RemoveFileButton, {
            className: "Twilio-MessageInput-FileBox-RemoveButton",
            sizeMultiplier: 1.2,
            icon: "Close",
            themeOverride: i.Chat.MessageInput.RemoveFileButton,
            onClick: l
          }));
        }, t.defaultProps = {
          returnKeySendsMessage: !0,
          forwardedInputRef: a.createRef()
        }, t.displayName = "MessageInputArea", t = i([d.withTheme], t);
      }(a.PureComponent);
    t.MessageInputArea = h;
  }, function (e, t, n) {
    "use strict";

    var _r28,
      o = this && this.__extends || (_r28 = function r(e, t) {
        return (_r28 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r28(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FilePreview = void 0;
    var i = n(0),
      a = n(7),
      l = n(312),
      s = n(17),
      c = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.renderIcon = function () {
          if (i.isValidElement(this.props.iconOverride)) return this.props.iconOverride;
          var e = this.props.media,
            t = e.contentType,
            n = {
              name: e.filename,
              type: t,
              size: e.size
            };
          return i.createElement(a.Icon, {
            sizeMultiplier: 2,
            icon: s.getFileIcon(n)
          });
        }, t.prototype.render = function () {
          var e = this.props,
            t = e.subTitleLine,
            n = e.media,
            r = e.titleLine,
            o = n.filename,
            a = /^(.+)\.(.+)?/.exec(o) || [],
            s = a[1],
            c = a[2];
          return i.createElement(l.Container, null, i.createElement(l.FileIcon, null, this.renderIcon()), i.createElement(l.FileBody, null, i.createElement(l.Filename, null, r || i.createElement(i.Fragment, null, i.createElement(l.FilenameRaw, {
            "data-test": "MediaMessageBubble-FileName"
          }, s), i.createElement(l.Extension, {
            "data-test": "MediaMessageBubble-FileExtension"
          }, "." + c))), i.createElement(l.Filesize, null, t || Math.ceil(n.size / 1024) + " KB")));
        }, t;
      }(i.PureComponent);
    t.FilePreview = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Filesize = t.Extension = t.FilenameRaw = t.Filename = t.FileIcon = t.FileBody = t.Container = void 0;
    var o,
      i,
      a,
      l,
      s,
      c,
      u,
      p = n(1);
    t.Container = p.styled("div")(o || (o = r(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    overflow: hidden;\n"], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    overflow: hidden;\n"]))), t.FileBody = p.styled("div")(i || (i = r(["\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n"], ["\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n"]))), t.FileIcon = p.styled("div")(a || (a = r(["\n    width: 48px;\n    height: 48px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: initial;\n"], ["\n    width: 48px;\n    height: 48px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: initial;\n"]))), t.Filename = p.styled("div")(l || (l = r(["\n    font-size: 12px;\n    font-weight: bold;\n    display: flex;\n"], ["\n    font-size: 12px;\n    font-weight: bold;\n    display: flex;\n"]))), t.FilenameRaw = p.styled("div")(s || (s = r(["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"], ["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"]))), t.Extension = p.styled("div")(c || (c = r(["\n    flex-shrink: 0;\n"], ["\n    flex-shrink: 0;\n"]))), t.Filesize = p.styled("div")(u || (u = r([""], [""])));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RemoveFileButton = t.FileBox = t.TextAreaInnerContainer = t.CharLimit = t.TextAreaContainer = t.TextArea = void 0;
    var o,
      i,
      a,
      l,
      s,
      c,
      u = n(1),
      p = n(6),
      d = n(18);
    t.TextArea = u.styled("textarea")(o || (o = r(["\n    min-height: 36px;\n    max-height: 82px;\n    border: 0px;\n    display: block;\n    font-size: 12px;\n    font-family: inherit;\n    width: 100%;\n    resize: none;\n    outline: none;\n    box-sizing: border-box;\n    padding-left: ", ";\n    padding-right: ", ";\n    padding-top: 8px;\n    padding-bottom: 8px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    ", ";\n"], ["\n    min-height: 36px;\n    max-height: 82px;\n    border: 0px;\n    display: block;\n    font-size: 12px;\n    font-family: inherit;\n    width: 100%;\n    resize: none;\n    outline: none;\n    box-sizing: border-box;\n    padding-left: ", ";\n    padding-right: ", ";\n    padding-top: 8px;\n    padding-bottom: 8px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    ", ";\n"])), function (e) {
      return "Bubble" === e.areaStyle ? "12px" : "0px";
    }, function (e) {
      return "Bubble" === e.areaStyle ? "12px" : "4px";
    }, function (e) {
      return e.theme.Chat.MessageInput.Container;
    }), t.TextAreaContainer = u.styled("div")(i || (i = r(["\n    display: block;\n    width: 100%;\n    box-sizing: border-box;\n    overflow: hidden;\n    ", "\n    background: ", ";\n"], ["\n    display: block;\n    width: 100%;\n    box-sizing: border-box;\n    overflow: hidden;\n    ", "\n    background: ", ";\n"])), function (e) {
      return e.theme.Chat.MessageInput.Container;
    }, function (e) {
      return "Bubble" === e.areaStyle ? void 0 : "transparent";
    }), t.CharLimit = u.styled("p")(a || (a = r(["\n    padding-bottom: 8px;\n    padding-left: ", ";\n    padding-right: ", ";\n    text-align: left;\n    color: ", ";\n"], ["\n    padding-bottom: 8px;\n    padding-left: ", ";\n    padding-right: ", ";\n    text-align: left;\n    color: ", ";\n"])), function (e) {
      return "Bubble" === e.areaStyle ? "12px" : "0px";
    }, function (e) {
      return "Bubble" === e.areaStyle ? "12px" : "4px";
    }, function (e) {
      return e.inputTextLength >= .9 * e.charLimit ? e.theme.colors.errorColor : e.theme.colors.base8;
    }), t.TextAreaInnerContainer = u.styled("div")(l || (l = r(["\n    flex-grow: 1;\n    min-width: 0;\n"], ["\n    flex-grow: 1;\n    min-width: 0;\n"]))), t.FileBox = u.styled(p.FlexBox)(s || (s = r(["\n    margin: 8px;\n    border-radius: 3px;\n    justify-content: space-between;\n    flex-basis: 260px;\n    align-items: flex-start;\n    padding: 4px;\n    max-width: 252px;\n    ", "\n"], ["\n    margin: 8px;\n    border-radius: 3px;\n    justify-content: space-between;\n    flex-basis: 260px;\n    align-items: flex-start;\n    padding: 4px;\n    max-width: 252px;\n    ", "\n"])), function (e) {
      return e.theme.Chat.MessageInput.FileBox;
    }), t.RemoveFileButton = u.styled(d.IconButton)(c || (c = r(["\n    align-self: flex-start;\n    flex-shrink: 0;\n    margin-left: 12px;\n    width: 32px;\n    height: 32px;\n"], ["\n    align-self: flex-start;\n    flex-shrink: 0;\n    margin-left: 12px;\n    width: 32px;\n    height: 32px;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FileUploadButtonWrapper = t.TextAreaContainer = t.SeparatorLine = t.SendButton = t.ButtonsContainer = t.Container = void 0;
    var o,
      i,
      a,
      l,
      s,
      c,
      u = n(6),
      p = n(18),
      d = n(1);
    t.Container = d.styled(u.FlexBoxColumn)(o || (o = r(["\n    padding-left: 3%;\n    padding-right: 3.75%;\n\n    ", "\n    background: ", ";\n"], ["\n    padding-left: 3%;\n    padding-right: 3.75%;\n\n    ", "\n    background: ", ";\n"])), function (e) {
      return e.theme.Chat.MessageInput.Container;
    }, function (e) {
      return "Boxed" === e.areaStyle ? void 0 : "transparent";
    }), t.ButtonsContainer = d.styled("div")(i || (i = r(["\n    display: flex;\n    flex: 0 1 auto;\n    margin-left: 8px;\n\n    & > *,\n    & > .Twilio-IconButton {\n        align-self: flex-end;\n    }\n"], ["\n    display: flex;\n    flex: 0 1 auto;\n    margin-left: 8px;\n\n    & > *,\n    & > .Twilio-IconButton {\n        align-self: flex-end;\n    }\n"]))), t.SendButton = d.styled(p.IconButton)(a || (a = r(["\n    width: 36px;\n    height: 36px;\n    ", "\n"], ["\n    width: 36px;\n    height: 36px;\n    ", "\n"])), function (e) {
      return e.theme.Chat.MessageInput.Button;
    }), t.SeparatorLine = d.styled("div")(l || (l = r(["\n    display: block;\n    flex: 1 1 auto;\n    border-top: 1px solid;\n    border-color: ", ";\n"], ["\n    display: block;\n    flex: 1 1 auto;\n    border-top: 1px solid;\n    border-color: ", ";\n"])), function (e) {
      return "Line" === e.areaStyle ? e.theme.Chat.MessageInput.Container.borderColor : "transparent";
    }), t.TextAreaContainer = d.styled(u.FlexBox)(s || (s = r(["\n    padding-top: 8px;\n    padding-bottom: 12px;\n    align-items: flex-end;\n"], ["\n    padding-top: 8px;\n    padding-bottom: 12px;\n    align-items: flex-end;\n"]))), t.FileUploadButtonWrapper = d.styled("div")(c || (c = r(["\n    padding-top: 4px;\n    margin-right: 8px;\n"], ["\n    padding-top: 4px;\n    margin-right: 8px;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r29,
      o = this && this.__extends || (_r29 = function r(e, t) {
        return (_r29 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r29(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageList = void 0;
    var a = n(0),
      l = n(61),
      s = n(65),
      c = n(5),
      u = n(20),
      p = n(332),
      d = n(55),
      f = n(37),
      h = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this;
          return a.createElement(f.VisibilityContextProvider.Consumer, null, function (t) {
            return a.createElement(u.MessagingCanvasContext.Consumer, null, function (n) {
              return a.createElement(m, i({}, e.props, {
                channelSid: n.sid,
                memberDisplayOptions: n.memberDisplayOptions,
                messageStyle: n.messageStyle,
                showTypingIndicator: n.showTypingIndicator,
                showReadStatus: n.showReadStatus,
                showWelcomeMessage: n.showWelcomeMessage,
                predefinedMessage: n.predefinedMessage,
                notVisible: !t
              }));
            });
          });
        }, t.friendlyName = p.displayName, t.displayName = p.displayName, t.Content = p.contentStore, t.Item = l.MessageListItem, t.WelcomeMessage = s.WelcomeMessage, t.defaultProps = {
          listContainerAriaProps: {
            ariaLive: d.AriaLive.Off
          }
        }, t;
      }(a.Component);
    t.MessageList = h;
    var m = c.connect(function (e, t) {
      return {
        channel: e.channels[t.channelSid],
        isAppActive: e.session.isActive
      };
    })(p.MessageListImpl);
  }, function (e, t, n) {
    "use strict";

    var _r30,
      o = this && this.__extends || (_r30 = function r(e, t) {
        return (_r30 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r30(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Spike = void 0;
    var i = n(0),
      a = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return i.createElement("svg", {
            width: "8px",
            height: "8px",
            viewBox: "0 0 8 8",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            className: this.props.className
          }, i.createElement("g", {
            id: "Page-1",
            stroke: "none",
            strokeWidth: "1",
            fillRule: "evenodd",
            fill: "currentColor"
          }, this.props.reverse ? i.createElement("polygon", {
            id: "Rectangle",
            transform: "translate(4.000000, 4.000000) scale(-1, 1) translate(-4.000000, -4.000000) ",
            points: "0 0 8 0 4 4 0 8"
          }) : i.createElement("polygon", {
            id: "Rectangle",
            points: "0 0 8 0 4 4 0 8"
          })));
        }, t.displayName = "ChatItem-Spike", t;
      }(i.PureComponent);
    t.Spike = a;
  }, function (e, t, n) {
    "use strict";

    var _r31,
      o = this && this.__extends || (_r31 = function r(e, t) {
        return (_r31 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r31(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageListItem = void 0;
    var l = n(0),
      s = n(20),
      c = n(43),
      u = n(327),
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this;
          return l.createElement(s.MessagingCanvasContext.Consumer, null, function (t) {
            return l.createElement(u.MessageListItemImpl, i({}, e.getChildProps(t)));
          });
        }, t.prototype.getChildProps = function (e) {
          var t = this.props,
            n = (t.children, a(t, ["children"])),
            r = e.avatarCallback,
            o = e.hasMarkdownSupport,
            l = e.sid;
          return i(i({}, n), {
            hasMarkdownSupport: o,
            channelSid: l,
            avatarUrl: this.props.avatarUrl || !!r && r(this.props.message.source.author)
          });
        }, t.displayName = u.displayName, t.Content = u.store, t.Bubble = c.MessageBubble, t.defaultProps = {
          useFriendlyName: !0
        }, t;
      }(l.PureComponent);
    t.MessageListItem = p;
  }, function (e, t, n) {
    "use strict";

    var _r32,
      o = this && this.__extends || (_r32 = function r(e, t) {
        return (_r32 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r32(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageBubble = void 0;
    var a = n(0),
      l = n(5),
      s = n(321),
      c = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = u;
          return a.createElement(e, i({}, this.props));
        }, t.displayName = s.displayName, t.Content = s.contentStore, t;
      }(a.PureComponent);
    t.MessageBubble = c;
    var u = l.connect(function (e, t) {
      var n = t.message.source,
        r = n.author,
        o = n.channel,
        i = n.memberSid,
        a = e.users[r];
      return {
        member: t.member || e.channels[o.sid].members.get(r) || e.channels[o.sid].members.get(i) || {
          friendlyName: !!a && a.friendlyName || r,
          source: void 0
        },
        isMemberOfChannel: Boolean(o) && "joined" === o.status
      };
    })(s.MessageBubbleImpl);
  }, function (e, t, n) {
    "use strict";

    var _r33,
      o = this && this.__extends || (_r33 = function r(e, t) {
        return (_r33 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r33(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageBubbleImpl = t.contentStore = t.displayName = void 0;
    var l = n(0),
      s = n(9),
      c = n(35),
      u = n(17),
      p = n(2),
      d = n(54),
      f = n(11),
      h = n(4),
      m = n(10),
      g = n(44),
      v = n(322);
    t.displayName = "MessageBubble", t.contentStore = new c.DynamicContentStore(t.displayName);
    var y = function y(e) {
        var t = e.children,
          n = a(e, ["children"]);
        return l.createElement("a", i({}, n, {
          target: "_blank"
        }), t);
      },
      b = function b(e) {
        return function (t) {
          var n = t.children,
            r = a(t, ["children"]);
          return l.createElement(g.StyledBlockQuote, i({}, r, {
            message: e
          }), n);
        };
      },
      _ = function (e) {
        function n() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(n, e), n.prototype.renderBody = function (e) {
          var t = this.props,
            n = t.message,
            r = t.messageStyle,
            o = t.hasMarkdownSupport,
            i = t.channelSid;
          if ("media" === n.source.type) return u.isFileAttachmentEnabled(i) ? l.createElement(v.MessageBubbleMedia, {
            key: "media-body",
            message: n,
            disabled: e,
            channelSid: i
          }) : l.createElement(g.MediaMessageErrorContainer, {
            key: "media-error"
          }, l.createElement(f.Template, {
            source: h.templates.MediaMessageError,
            className: "MediaMessageError"
          }));
          var a = n.source.body || "";
          return l.createElement(g.BodyContainer, {
            key: "body",
            className: "Twilio-MessageBubble-Body",
            message: n,
            messageStyle: r
          }, o ? l.createElement(d.Markdown, {
            options: {
              disableParsingRawHTML: !0,
              overrides: {
                a: y,
                blockquote: b(n)
              }
            }
          }, m.Utils.parseMDText(a)) : m.Utils.parseText(a));
        }, n.prototype.render = function () {
          var e = this.props,
            n = e.member,
            r = e.message,
            o = e.messageStyle,
            i = e.useFriendlyName,
            a = e.authorName,
            c = m.Utils.getNameForMember(i, a, n.friendlyName, r.source.author),
            u = r.error,
            d = r.source.timestamp,
            f = d && d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit"
            });
          try {
            this.props.timestampFormatter && d && (f = this.props.timestampFormatter(d));
          } catch (e) {
            p.log.warn("Unable to format timestamp. Falling back to original implementation.", e);
          }
          return l.createElement(s.DynamicComponent, {
            contentStore: t.contentStore,
            childProps: this.props,
            name: t.displayName,
            customChildren: this.props.children,
            vertical: !0
          }, l.createElement(g.Container, {
            message: r,
            messageStyle: o,
            disabled: u
          }, l.createElement(g.HeaderContainer, {
            key: "header",
            className: "Twilio-MessageBubble-Header",
            message: r,
            messageStyle: o
          }, l.createElement(g.UserNameContainer, {
            className: "Twilio-MessageBubble-UserName"
          }, c), f && l.createElement(g.TimeContainer, {
            className: "Twilio-MessageBubble-Time"
          }, f)), this.renderBody(u)));
        }, n.defaultProps = {
          useFriendlyName: !0
        }, n;
      }(l.PureComponent);
    t.MessageBubbleImpl = _;
  }, function (e, t, n) {
    "use strict";

    var _r34,
      o = this && this.__extends || (_r34 = function r(e, t) {
        return (_r34 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r34(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageBubbleMedia = void 0;
    var i = n(0),
      a = n(36),
      l = n(5),
      s = n(41),
      c = n(11),
      u = n(4),
      p = n(63),
      d = n(58),
      f = n(7),
      h = n(44),
      m = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            hover: !1
          }, t.downloadMedia = function (e) {
            return function () {
              var n = t.props,
                r = n.message,
                o = n.channelSid;
              e || r.isSending || (l.ChatModule.events.emitMediaDownloaded(o), s.tryInvokeAction("DownloadMedia", {
                message: r.source,
                channelSid: o
              }));
            };
          }, t.matchDownloadMediaPayload = function (e) {
            return e.message.sid === t.props.message.source.sid;
          }, t.toggleHover = function () {
            t.setState(function (e) {
              return {
                hover: !e.hover
              };
            });
          }, t;
        }
        return o(t, e), t.prototype.getDataStatus = function (e) {
          return e.error ? "MediaMessageBubble-Error" : e.isSending ? "MediaMessageBubble-Sending" : !e.isSending && e.isFromMe ? "MediaMessageBubble-Sent" : "MediaMessageBubble-Received";
        }, t.prototype.render = function () {
          var e = this,
            t = this.props,
            n = t.message,
            r = t.disabled;
          return i.createElement(a.ActionStateListener, {
            action: "DownloadMedia",
            payload: this.matchDownloadMediaPayload
          }, function (t) {
            return i.createElement(h.MediaMessageContainer, {
              className: "Twilio-Media-MessageBubble",
              onClick: e.downloadMedia(t.disabled || r),
              disabled: r,
              message: n,
              "data-test": e.getDataStatus(n),
              onMouseEnter: e.toggleHover,
              onMouseLeave: e.toggleHover
            }, i.createElement(d.FilePreview, {
              media: n.source.media,
              iconOverride: n.isSending && i.createElement(p.CircularProgress, {
                size: 26,
                animating: !0,
                override: {
                  animatingBackgroundBorderColor: "transparent"
                }
              }),
              subTitleLine: e.state.hover && !r && !n.isSending && i.createElement(c.Template, {
                source: u.templates.MediaMessageClickToOpen
              })
            }), i.createElement(h.MediaMessageActions, {
              message: n,
              className: "Twilio-Media-MessageBubble-Action"
            }, i.createElement(f.Icon, {
              icon: "Open"
            })));
          });
        }, t;
      }(i.PureComponent);
    t.MessageBubbleMedia = m;
  }, function (e, t, n) {
    "use strict";

    var _r35,
      o = this && this.__extends || (_r35 = function r(e, t) {
        return (_r35 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r35(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CircularProgress = void 0;
    var l = n(0),
      s = n(3),
      c = n(324),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.className,
            n = a(e, ["className"]);
          return l.createElement(c.StyledCircularProgress, i({
            className: s.cx("Twilio-Progress", t)
          }, n));
        }, t.defaultProps = {
          override: {},
          size: 124,
          borderWidth: 2
        }, t;
      }(l.PureComponent);
    t.CircularProgress = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledCircularProgress = t.getOverriddenPropIfAvailable = void 0;
    var i = n(3),
      a = n(29);
    t.getOverriddenPropIfAvailable = function (e, t) {
      return e.override && e.override[t] || e.theme.Progress.Circular[t];
    };
    var l,
      s = function s(e) {
        return t.getOverriddenPropIfAvailable(e, "animatingForegroundBorderColor");
      };
    t.StyledCircularProgress = i.default("div")(l || (l = r(["\n    display: inline-block;\n    position: relative;\n    width: ", ";\n    height: ", ';\n\n    &:before {\n        content: "";\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        border-width: ', ";\n        border-style: solid;\n        border-radius: 50%;\n        border-color: ", ';\n        box-sizing: border-box;\n    }\n\n    &:after {\n        content: "";\n        border-width: ', ";\n        border-style: solid;\n        border-color: ", " transparent transparent ", ";\n        border-radius: 100% 0 0 0;\n        box-sizing: border-box;\n        display: ", ";\n        width: 50%;\n        height: 50%;\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n\n    ", "\n\n    ", "\n"], ["\n    display: inline-block;\n    position: relative;\n    width: ", ";\n    height: ", ';\n\n    &:before {\n        content: "";\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        border-width: ', ";\n        border-style: solid;\n        border-radius: 50%;\n        border-color: ", ';\n        box-sizing: border-box;\n    }\n\n    &:after {\n        content: "";\n        border-width: ', ";\n        border-style: solid;\n        border-color: ", " transparent transparent ", ";\n        border-radius: 100% 0 0 0;\n        box-sizing: border-box;\n        display: ", ";\n        width: 50%;\n        height: 50%;\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n\n    ", "\n\n    ", "\n"])), function (e) {
      return e.size + "px";
    }, function (e) {
      return e.size + "px";
    }, function (e) {
      return e.borderWidth + "px";
    }, function (e) {
      return e.animating ? t.getOverriddenPropIfAvailable(e, "animatingBackgroundBorderColor") : t.getOverriddenPropIfAvailable(e, "staticBackgroundBorderColor");
    }, function (e) {
      return e.borderWidth + "px";
    }, s, s, function (e) {
      return e.animating ? "initial" : "none";
    }, function (e) {
      var t = e.theme.Progress.Circular;
      t.staticBackgroundBorderColor, t.animatingBackgroundBorderColor, t.animatingForegroundBorderColor;
      return o(t, ["staticBackgroundBorderColor", "animatingBackgroundBorderColor", "animatingForegroundBorderColor"]);
    }, function (e) {
      return e.animating && a.Animations.SpinAnimation(.8);
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r36,
      o = this && this.__extends || (_r36 = function r(e, t) {
        return (_r36 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r36(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageListItemImpl = t.store = t.displayName = void 0;
    var a = n(0),
      l = n(62),
      s = n(6),
      c = n(64),
      u = n(43),
      p = n(11),
      d = n(4),
      f = n(7),
      h = n(9);
    t.displayName = "MessageListItem", t.store = new h.DynamicContentStore(t.displayName);
    var m = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(n, e), n.prototype.render = function () {
        var e = this.props,
          n = e.message,
          r = e.messageStyle,
          o = e.avatarUrl,
          m = e.hasMarkdownSupport,
          g = e.showReadStatus;
        return a.createElement(h.DynamicComponent, {
          contentStore: t.store,
          childProps: i({}, this.props),
          name: t.displayName,
          customChildren: this.props.children,
          vertical: !0
        }, a.createElement(l.Container, {
          className: "Twilio-MessageListItem",
          message: n,
          messageStyle: r
        }, a.createElement(s.FlexBox, {
          key: "content",
          className: "Twilio-MessageListItem-ContentContainer"
        }, "Wide" !== r && a.createElement(s.FlexBox, {
          className: "Twilio-MessageListItem-AvatarContainer",
          noGrow: !0
        }, a.createElement(c.Avatar, {
          avatarUrl: o,
          messageStyle: r,
          message: n
        })), a.createElement(l.BubbleContainer, {
          className: "Twilio-MessageListItem-BubbleContainer",
          isFromMe: n.isFromMe,
          messageStyle: r
        }, a.createElement(u.MessageBubble, i({}, this.props, {
          hasMarkdownSupport: m
        })), "Squared" === r && !n.groupWithNext && a.createElement(l.StyledSpike, {
          reverse: n.isFromMe
        }))), n.error && a.createElement(l.MediaErrorContainer, {
          key: "media-transfer-error",
          className: "Twilio-MessageListItem-MediaMessageError"
        }, a.createElement(f.Icon, {
          icon: "AlertSmall",
          sizeMultiplier: .67
        }), a.createElement(p.Template, {
          source: d.templates.MediaMessageTransferFailed
        })), g && a.createElement(l.MessageReadContainer, {
          key: "read-status",
          className: "Twilio-MessageListItem-ReadStatus"
        }, a.createElement(p.Template, {
          source: d.templates.Read
        }), a.createElement(f.Icon, {
          icon: "Read"
        }))));
      }, n;
    }(a.PureComponent);
    t.MessageListItemImpl = m;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledAvatarDiv = t.AvatarLine = void 0;
    var o,
      i,
      a = n(1);
    t.AvatarLine = a.styled("div")(o || (o = r(["\n    width: 4px;\n    flex: 1 1 auto;\n    margin-left: 12px;\n    margin-right: 0px;\n\n    ", "\n"], ["\n    width: 4px;\n    flex: 1 1 auto;\n    margin-left: 12px;\n    margin-right: 0px;\n\n    ", "\n"])), function (e) {
      return e.message.isFromMe ? e.theme.Chat.MessageListItem.FromMe.Bubble : e.theme.Chat.MessageListItem.FromOthers.Bubble;
    }), t.StyledAvatarDiv = a.styled("div")(i || (i = r(["\n    display: flex;\n    width: 24px;\n    height: 24px;\n    justify-content: center;\n    margin-right: 12px;\n    border-radius: ", ";\n    overflow: hidden;\n\n    img {\n        width: 36px;\n        height: 36px;\n    }\n\n    ", "\n\n    background: ", ";\n"], ["\n    display: flex;\n    width: 24px;\n    height: 24px;\n    justify-content: center;\n    margin-right: 12px;\n    border-radius: ", ";\n    overflow: hidden;\n\n    img {\n        width: 36px;\n        height: 36px;\n    }\n\n    ", "\n\n    background: ", ";\n"])), function (e) {
      return "Rounded" === e.messageStyle || "Wide" === e.messageStyle ? "18px" : "0px";
    }, function (e) {
      return e.theme.Chat.MessageListItem.FromOthers.Avatar;
    }, function (e) {
      return e.message.isFromMe || e.message.groupWithPrevious ? "transparent" : void 0;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r37,
      o = this && this.__extends || (_r37 = function r(e, t) {
        return (_r37 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r37(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var l = e.length - 1; l >= 0; l--) (o = e[l]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WelcomeMessage = void 0;
    var a = n(0),
      l = n(9),
      s = n(35),
      c = n(4),
      u = n(20),
      p = n(66),
      d = n(331),
      f = n(1),
      h = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        var n;
        return o(t, e), n = t, t.prototype.render = function () {
          var e = this;
          return a.createElement(u.MessagingCanvasContext.Consumer, null, function (t) {
            return a.createElement(l.DynamicComponent, {
              contentStore: n.Content,
              childProps: e.props,
              name: n.friendlyName,
              vertical: !0
            }, a.createElement(p.Container, null, a.createElement(p.IconContainer, {
              key: "icon",
              icon: t.welcomeMessageIcon || "MessageBold"
            }), a.createElement(d.TextContainer, {
              key: "text",
              source: t.welcomeMessageText || c.templates.WelcomeMessage
            })));
          });
        }, t.friendlyName = "WelcomeMessage", t.Content = new s.DynamicContentStore("WelcomeMessage"), t = n = i([f.withTheme], t);
      }(a.PureComponent);
    t.WelcomeMessage = h;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TextContainer = void 0;
    var o,
      i = n(11),
      a = n(1),
      l = n(0),
      s = a.styled("div")(o || (o = r(["\n    width: auto;\n    margin-top: auto;\n    margin-right: 20%;\n    margin-bottom: auto;\n    margin-left: 20%;\n    text-align: center;\n"], ["\n    width: auto;\n    margin-top: auto;\n    margin-right: 20%;\n    margin-bottom: auto;\n    margin-left: 20%;\n    text-align: center;\n"])));
    t.TextContainer = function (e) {
      var t = e.source;
      return l.createElement(s, {
        className: "Twilio-WelcomeMessage-TextContainer"
      }, l.createElement(i.Template, {
        source: t
      }));
    };
  }, function (e, t, n) {
    "use strict";

    var _r38,
      o = this && this.__extends || (_r38 = function r(e, t) {
        return (_r38 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r38(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageListImpl = t.contentStore = t.displayName = void 0;
    var i = n(0),
      a = n(56),
      l = n(30),
      s = n(5),
      c = n(9),
      u = n(16),
      p = n(49),
      d = n(4),
      f = n(10),
      h = n(65),
      m = n(60),
      g = n(67),
      v = n(59);
    t.displayName = "MessageList", t.contentStore = new c.DynamicContentStore(t.displayName);
    var y = function (e) {
      function n() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.loadedMessagesInUpdate = !1, t.keepScrolledToBottom = !0, t.keepTopScrollPosition = !1, t.lastScrollHeight = 0, t.lastScrollTop = 0, t.isTouchActive = !1, t.isScrollActive = !1, t.needsForceRenderAfterScroll = !1, t.inputFocused = !1, t.mediaDownloaded = !1, t.handleInputRowCountChanged = function () {
          t.invalidateScrollPosition();
        }, t.handleInputMessagePosted = function () {
          t.scrollToBottom();
        }, t.handleMediaDownloaded = function () {
          t.mediaDownloaded = !0, t.consumeLastMessageIfApplicable();
        }, t.handleInputFocus = function () {
          t.inputFocused = !0, setTimeout(function () {
            t.invalidateScrollPosition();
          }, 200);
        }, t.handleInputBlur = function () {
          t.inputFocused = !1;
        }, t.handleWindowResize = function () {
          t.invalidateScrollPosition();
        }, t.onAfterScrollTimer = function () {
          t.isScrollActive = !1, t.needsForceRenderAfterScroll && !t.isTouchActive && t.forceUpdate();
        }, t.onScroll = function () {
          return t.isScrollActive = !0, t.onDebounceScroll();
        }, t.onDebounceScroll = v(function () {
          var e = t.messageList.scrollTop;
          !t.loadedMessagesInUpdate && e <= t.messageList.clientHeight && t.loadMoreMessages(), t.captureBottomScrollState(), t.consumeLastMessageIfApplicable(), t.onAfterScrollTimer();
        }, 50), t.setMessageListRef = function (e) {
          t.messageList = e;
        }, t.onTouchStart = function () {
          t.isTouchActive = !0;
        }, t.onTouchEnd = function () {
          t.isTouchActive = !1, t.scheduleAfterScrollTimer();
        }, t;
      }
      return o(n, e), n.prototype.render = function () {
        var e = this.props,
          n = e.channel,
          r = e.children,
          o = e.showTypingIndicator,
          a = e.memberDisplayOptions,
          l = e.listContainerAriaProps;
        return i.createElement(m.Container, null, i.createElement(c.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: r,
          noContainers: !0,
          vertical: !0
        }, i.createElement(m.ListContainer, {
          innerRef: this.setMessageListRef,
          onScroll: this.onScroll,
          onTouchEnd: this.onTouchEnd,
          onTouchStart: this.onTouchStart,
          "aria-label": l && l.ariaLabel,
          "aria-live": l && l.ariaLive
        }, this.getListItems(), o && i.createElement(g.TypingIndicator, {
          key: "typing-indicator",
          typers: n.typers,
          memberDisplayOptions: a
        }))));
      }, n.prototype.shouldComponentUpdate = function (e) {
        return this.loadedMessagesInUpdate = this.loadedMessagesInUpdate || this.props.channel.isLoadingMessages && !e.channel.isLoadingMessages, this.captureScrollState(), !this.isTouchActive && !this.isScrollActive || (this.needsForceRenderAfterScroll = !0, !1);
      }, n.prototype.componentDidMount = function () {
        var e = this.props,
          t = e.channelSid,
          n = e.notVisible;
        this.invalidateScrollPosition(), window.addEventListener("resize", this.handleWindowResize), s.ChatModule.events.addListener(l.ChatEvent[l.ChatEvent.chatInputFocus], this.handleInputFocus), s.ChatModule.events.addListener(l.ChatEvent[l.ChatEvent.chatInputBlur], this.handleInputBlur), s.ChatModule.events.addListener(l.ChatEvent[l.ChatEvent.chatInputRowsChanged], this.handleInputRowCountChanged), s.ChatModule.events.addListener(l.ChatEvent[l.ChatEvent.chatMessagePosted], this.handleInputMessagePosted), s.ChatModule.events.addListener(l.ChatEvent[l.ChatEvent.chatMediaDownloaded], this.handleMediaDownloaded), n ? p.Actions.updateActiveChatChannel("") : p.Actions.updateActiveChatChannel(t);
      }, n.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.handleWindowResize), this.onDebounceScroll && this.onDebounceScroll.cancel(), s.ChatModule.events.removeListener(l.ChatEvent[l.ChatEvent.chatInputFocus], this.handleInputFocus), s.ChatModule.events.removeListener(l.ChatEvent[l.ChatEvent.chatInputBlur], this.handleInputBlur), s.ChatModule.events.removeListener(l.ChatEvent[l.ChatEvent.chatInputRowsChanged], this.handleInputRowCountChanged), s.ChatModule.events.removeListener(l.ChatEvent[l.ChatEvent.chatMessagePosted], this.handleInputMessagePosted), s.ChatModule.events.removeListener(l.ChatEvent[l.ChatEvent.chatMediaDownloaded], this.handleMediaDownloaded), p.Actions.updateActiveChatChannel("");
      }, n.prototype.componentDidUpdate = function (e) {
        var t = this.props,
          n = t.channelSid,
          r = t.notVisible,
          o = t.isAppActive;
        this.needsForceRenderAfterScroll = !1, this.loadedMessagesInUpdate = !1, this.invalidateScrollPosition(), r ? p.Actions.updateActiveChatChannel("") : p.Actions.updateActiveChatChannel(n), o && !e.isAppActive && this.consumeLastMessageIfApplicable(), e.channelSid !== n && (this.captureBottomScrollState(), p.Actions.updateActiveChatChannel(n));
      }, n.prototype.invalidateScrollPosition = function () {
        if (this.messageList) if (this.keepScrolledToBottom) this.scrollToBottom(), this.consumeLastMessageIfApplicable();else if (this.keepTopScrollPosition) {
          var e = this.messageList.scrollHeight - this.lastScrollHeight;
          this.messageList.scrollTop = this.lastScrollTop + e;
        }
      }, n.prototype.scrollToBottom = function () {
        if (this.messageList) {
          var e = this.messageList,
            t = e.scrollHeight - e.clientHeight;
          this.messageList.scrollTop = t > 0 ? t : 0, this.captureBottomScrollState();
        }
      }, n.prototype.consumeLastMessageIfApplicable = function () {
        var e = this.props,
          t = e.isAppActive,
          n = e.notVisible,
          r = e.channel;
        if (this.keepScrolledToBottom && t && !n) {
          var o = r.messages,
            i = r.source;
          if (o.length > 0) {
            var a = o.length ? o[o.length - 1].source.index : 0;
            i.lastConsumedMessageIndex !== a && (this.inputFocused || this.mediaDownloaded) && (u.Actions.updateLastConsumedMessageIndex(r, a), this.mediaDownloaded = !1);
          }
        }
      }, n.prototype.captureBottomScrollState = function () {
        if (this.messageList) {
          var e = this.messageList,
            t = e.scrollTop,
            n = e.scrollHeight,
            r = e.clientHeight,
            o = Math.floor(n - r),
            i = Math.ceil(t) >= o;
          n === this.lastScrollHeight && t === this.lastScrollTop && i === this.keepScrolledToBottom || (this.lastScrollHeight = n, this.lastScrollTop = t, this.keepScrolledToBottom = i, p.Actions.updateScrollPosition(this.keepScrolledToBottom));
        }
      }, n.prototype.captureScrollState = function () {
        this.captureBottomScrollState(), this.keepTopScrollPosition = !this.keepScrolledToBottom && this.loadedMessagesInUpdate;
      }, n.prototype.loadMoreMessages = function () {
        var e = this.props.channel;
        e.isLoadingMessages || u.Actions.loadMessagesFromHistory(e);
      }, n.prototype.scheduleAfterScrollTimer = function () {
        this.isScrollActive = !0, clearTimeout(this.afterScrollTimer), this.isTouchActive || (this.afterScrollTimer = setTimeout(this.onAfterScrollTimer, 100));
      }, n.prototype.findMyLastMessageIndex = function () {
        for (var e = this.props.channel, t = e.messages.length - 1; t >= 0; t--) if (e.messages[t].isFromMe) return e.messages[t].source.index;
        return -1;
      }, n.prototype.getListItems = function () {
        var e = this.props,
          t = e.showReadStatus,
          n = e.channel,
          r = e.memberDisplayOptions,
          o = e.messageStyle,
          l = e.predefinedMessage,
          s = e.showWelcomeMessage,
          c = this.findMyLastMessageIndex(),
          u = function u(e) {
            return t && e.source.index <= n.lastConsumedMessageIndex && e.source.index === c && n.members.size > 1;
          },
          p = n.messages.map(function (e) {
            return i.createElement(a.MessageListItem, {
              key: e.source.index,
              authorName: e.isFromMe ? r.yourDefaultName : r.theirDefaultName,
              useFriendlyName: e.isFromMe ? r.yourFriendlyNameOverride : r.theirFriendlyNameOverride,
              message: e,
              messageStyle: o,
              showReadStatus: u(e)
            });
          }),
          d = 0;
        return n.currentPaginator && n.currentPaginator.hasPrevPage || n.isLoadingMessages || (l && (this.injectPredefinedMessage(p), d += 1), s && (this.injectWelcomeMessage(p), d += 1)), this.injectDateSeparatorElements(p, d), p.push.apply(p, this.getPendingMessageElements()), p;
      }, n.prototype.getPendingMessageElements = function () {
        var e = this.props,
          t = e.memberDisplayOptions,
          n = e.messageStyle;
        return e.channel.pendingMessages.map(function (e) {
          return i.createElement(a.MessageListItem, {
            key: "pendingMessage_" + e.index,
            authorName: t.yourDefaultName,
            useFriendlyName: t.yourFriendlyNameOverride,
            message: e,
            messageStyle: n,
            showReadStatus: !1
          });
        });
      }, n.prototype.injectDateSeparatorElements = function (e, t) {
        var n;
        this.props.channel.messages.forEach(function (r, o) {
          0 !== o && f.Utils.isSameDate(n, r.source.timestamp) || (e.splice(o + t, 0, i.createElement(a.InlineMessage, {
            key: r.source.timestamp.getTime(),
            message: r
          }, i.createElement(a.InlineDateSeparator, {
            key: "date-separator",
            message: r
          }))), t += 1), n = r.source.timestamp;
        });
      }, n.prototype.injectWelcomeMessage = function (e) {
        var t = i.createElement(h.WelcomeMessage, {
          key: "Twilio-WelcomeMessage"
        });
        e.unshift(t);
      }, n.prototype.injectPredefinedMessage = function (e) {
        var t = this.props,
          n = t.predefinedMessage,
          r = t.messageStyle,
          o = t.channel,
          l = o.source && o.source.dateCreated,
          s = {
            groupWithNext: !1,
            groupWithPrevious: !1,
            isFromMe: n.isFromMe,
            source: {
              body: b(n.body),
              timestamp: l
            }
          },
          c = i.createElement(a.MessageListItem, {
            key: "predefinedMessage",
            message: s,
            messageStyle: r,
            showReadStatus: !1,
            member: {
              friendlyName: b(n.authorName)
            }
          });
        e.unshift(c);
      }, n;
    }(i.Component);
    t.MessageListImpl = y;
    var b = function b(e) {
      return e in d.templates ? d.templates[e]() : e;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TypingIndicatorDiv = void 0;
    var o,
      i = n(1);
    t.TypingIndicatorDiv = i.styled("div")(o || (o = r(["\n    height: 28px;\n    flex-shrink: 0;\n    display: flex;\n\n    span {\n        font-size: 10px;\n        margin-top: auto;\n        margin-bottom: auto;\n        margin-left: 12px;\n        margin-right: 12px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    ", ";\n"], ["\n    height: 28px;\n    flex-shrink: 0;\n    display: flex;\n\n    span {\n        font-size: 10px;\n        margin-top: auto;\n        margin-bottom: auto;\n        margin-left: 12px;\n        margin-right: 12px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    ", ";\n"])), function (e) {
      return e.theme.Chat.MessageList.TypingIndicator;
    });
  }, function (e, t, n) {
    "use strict";

    var _r39,
      o = this && this.__extends || (_r39 = function r(e, t) {
        return (_r39 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r39(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessagingCanvasImpl = t.contentStore = t.displayName = void 0;
    var a = n(0),
      l = n(5),
      s = n(32),
      c = n(9),
      u = n(17),
      p = n(2),
      d = n(16),
      f = n(4),
      h = n(335),
      m = n(68),
      g = n(40),
      v = n(42),
      y = n(70),
      b = n(71);
    t.displayName = "MessagingCanvas", t.contentStore = new c.DynamicContentStore(t.displayName);
    var _ = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(n, e), n.prototype.componentDidMount = function () {
        this.props.channel || this.loadChannel(this.props.sid);
      }, n.prototype.componentDidUpdate = function (e) {
        e.sid !== this.props.sid && (this.unloadChannel(e.sid), this.loadChannel(this.props.sid));
      }, n.prototype.componentWillUnmount = function () {
        this.unloadChannel(this.props.sid);
      }, n.prototype.loadChannel = function (e) {
        this.props.autoInitChannel && d.Actions.initWithChannelSid(e);
      }, n.prototype.unloadChannel = function (e) {
        var t = l.ChatModule.state.channels[e];
        t && (d.ChannelHelper.isUserMemberOfChannel(t) || d.Actions.unload(e));
      }, n.prototype.render = function () {
        var e = this.props,
          n = e.channel,
          r = e.sid;
        if (!n || !n.source) return p.log.debug("Channel not loaded yet for MessagingCanvas", r), null;
        var o = u.isFileAttachmentEnabled(n.source.sid) ? h.FileAttachmentDropArea : a.Fragment,
          l = u.isFileAttachmentEnabled(n.source.sid) ? {
            channel: n
          } : {};
        return a.createElement(b.MessagingCanvasContext.Provider, {
          value: this.props
        }, a.createElement(y.Container, null, a.createElement(o, i({}, l), a.createElement(c.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          vertical: !0
        }, a.createElement(y.ContentContainer, {
          className: "Twilio-MessagingCanvas-Content"
        }, a.createElement(v.MessageList, {
          key: "list"
        }), this.renderFooter())))));
      }, n.prototype.renderFooter = function () {
        var e = this.props,
          t = e.channel,
          n = e.showTrayOnInactive,
          r = e.hideFooterOnInactive,
          o = t.source.attributes,
          i = d.ChannelHelper.isUserMemberOfChannel(t),
          l = o[s.CHANNEL_STATUS_ATTRIBUTE],
          c = i ? void 0 : f.templates.ChatInputUserNotMemberDisabledText(),
          u = t.source && t.source.state && "active" !== t.source.state.current;
        return r && (l === s.CHANNEL_STATUS_INACTIVE || u) ? null : n && (l === s.CHANNEL_STATUS_INACTIVE || u) ? [a.createElement(m.MessageCanvasTray, {
          key: "tray"
        })] : [a.createElement(g.MessageInput, {
          key: "input",
          disabledReason: this.props.inputDisabledReason || c,
          charLimit: this.props.charLimit
        })];
      }, n;
    }(a.PureComponent);
    t.MessagingCanvasImpl = _;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FileAttachmentDropThemeProps = t.FileAttachmentDropAreaProps = t.FileAttachmentDropArea = void 0;
    var r = n(336);
    Object.defineProperty(t, "FileAttachmentDropArea", {
      enumerable: !0,
      get: function get() {
        return r.FileAttachmentDropArea;
      }
    });
    var o = n(339);
    Object.defineProperty(t, "FileAttachmentDropAreaProps", {
      enumerable: !0,
      get: function get() {
        return o.FileAttachmentDropAreaProps;
      }
    }), Object.defineProperty(t, "FileAttachmentDropThemeProps", {
      enumerable: !0,
      get: function get() {
        return o.FileAttachmentDropThemeProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FileAttachmentDropArea = void 0;
    var r = n(5),
      o = n(337);
    t.FileAttachmentDropArea = r.connect(function (e, t) {
      return {
        messageState: e.channelInput[t.channel.source.sid]
      };
    })(o.FileAttachmentDropAreaImpl);
  }, function (e, t, n) {
    "use strict";

    var _r40,
      o = this && this.__extends || (_r40 = function r(e, t) {
        return (_r40 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r40(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FileAttachmentDropAreaImpl = void 0;
    var a = n(0),
      l = n(338),
      s = n(11),
      c = n(41),
      u = n(17),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            dragging: !1
          }, t.attachFiles = function (e) {
            e.length;
            var n = i(e, ["length"]),
              r = t.props.channel,
              o = Object.values(n || {})[0];
            o && c.tryInvokeAction("AttachFile", {
              file: o,
              channel: r
            });
          }, t.handleDragOver = function (e) {
            if (t.containsFile(e.dataTransfer)) {
              e.preventDefault(), e.persist();
              var n = u.canAttachFile(t.props.messageState, t.props.channel);
              !t.state.dragging && n && t.setState({
                dragging: !0
              });
            }
          }, t.handleDrop = function (e) {
            if (e.preventDefault(), t.containsFile(e.dataTransfer) && t.state.dragging) {
              var n = e.dataTransfer.files;
              n && n.length && t.attachFiles(n), t.setState({
                dragging: !1
              });
            }
          }, t.handleDragLeave = function (e) {
            e.persist();
            var n = e.nativeEvent.relatedTarget;
            e.currentTarget.contains(n) || n.getRootNode() instanceof ShadowRoot || !t.state.dragging || t.setState({
              dragging: !1
            });
          }, t.containsFile = function (e) {
            return Boolean(e && e.types && e.types.find(function (e) {
              return "Files" === e;
            }));
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          return a.createElement(l.Container, {
            onDrop: this.handleDrop,
            onDragLeave: this.handleDragLeave,
            onDragOver: this.handleDragOver
          }, a.createElement(l.MainDropArea, {
            visible: this.state.dragging
          }, a.createElement(l.StyledIcon, {
            icon: "Attachment",
            sizeMultiplier: 2
          }), a.createElement(l.Title, null, a.createElement(s.Template, {
            source: s.templates.FileAttachmentDropAreaTitle
          })), a.createElement(l.Subtitle, null, a.createElement(s.Template, {
            source: s.templates.FileAttachmentDropAreaSubtitle
          }))), this.props.children);
        }, t;
      }(a.Component);
    t.FileAttachmentDropAreaImpl = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Subtitle = t.Title = t.StyledIcon = t.MainDropArea = t.Container = void 0;
    var o,
      i,
      a,
      l,
      s,
      c = n(1),
      u = n(7);
    t.Container = c.styled("div")(o || (o = r(["\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    flex-grow: 1;\n"], ["\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    flex-grow: 1;\n"]))), t.MainDropArea = c.styled("div")(i || (i = r(["\n    position: absolute;\n    top: 8px;\n    bottom: 8px;\n    left: 8px;\n    right: 8px;\n    z-index: 30;\n    border-width: 3px;\n    border-style: dashed;\n    border-radius: 3px;\n    display: ", ";\n    flex-direction: column;\n    align-content: center;\n    justify-content: center;\n    padding: 24px;\n    text-align: center;\n    pointer-events: none;\n    animation: ", ";\n\n    @keyframes popIn {\n        0% {\n            opacity: 0;\n            transform: scale(0.9);\n        }\n        100% {\n            opacity: 1;\n            transform: scale(1);\n        }\n    }\n\n    ", "\n"], ["\n    position: absolute;\n    top: 8px;\n    bottom: 8px;\n    left: 8px;\n    right: 8px;\n    z-index: 30;\n    border-width: 3px;\n    border-style: dashed;\n    border-radius: 3px;\n    display: ", ";\n    flex-direction: column;\n    align-content: center;\n    justify-content: center;\n    padding: 24px;\n    text-align: center;\n    pointer-events: none;\n    animation: ", ";\n\n    @keyframes popIn {\n        0% {\n            opacity: 0;\n            transform: scale(0.9);\n        }\n        100% {\n            opacity: 1;\n            transform: scale(1);\n        }\n    }\n\n    ", "\n"])), function (e) {
      return e.visible ? "flex" : "none";
    }, function (e) {
      return e.visible ? "popIn 0.1s forwards" : "none";
    }, function (e) {
      return e.theme.Chat.FileAttachmentDropArea.MainDropArea;
    }), t.StyledIcon = c.styled(u.Icon)(a || (a = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.Chat.FileAttachmentDropArea.Icon;
    }), t.Title = c.styled("div")(l || (l = r(["\n    font-size: 18px;\n    font-weight: bold;\n    ", "\n"], ["\n    font-size: 18px;\n    font-weight: bold;\n    ", "\n"])), function (e) {
      return e.theme.Chat.FileAttachmentDropArea.Title;
    }), t.Subtitle = c.styled("div")(s || (s = r(["\n    font-size: 14px;\n    ", "\n"], ["\n    font-size: 14px;\n    ", "\n"])), function (e) {
      return e.theme.Chat.FileAttachmentDropArea.SubTitle;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r41,
      o = this && this.__extends || (_r41 = function r(e, t) {
        return (_r41 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r41(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var l = e.length - 1; l >= 0; l--) (o = e[l]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageCanvasTray = void 0;
    var l = n(0),
      s = n(28),
      c = n(341),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return l.createElement(c.MessageCanvasTrayImpl, i({}, this.props));
        }, t.displayName = c.displayName, t.Content = c.contentStore, t.defaultProps = {
          onButtonClick: void 0,
          showButton: !0
        }, t = a([s.withDefaultPropsUpdate], t);
      }(l.PureComponent);
    t.MessageCanvasTray = u;
  }, function (e, t, n) {
    "use strict";

    var _r42,
      o = this && this.__extends || (_r42 = function r(e, t) {
        return (_r42 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r42(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var l = e.length - 1; l >= 0; l--) (o = e[l]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MessageCanvasTrayImpl = t.contentStore = t.displayName = void 0;
    var a = n(1),
      l = n(0),
      s = n(9),
      c = n(69),
      u = n(11),
      p = n(4);
    t.displayName = "MessageCanvasTray", t.contentStore = new s.DynamicContentStore(t.displayName);
    var d = function (e) {
      function n() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(n, e), n.prototype.render = function () {
        return l.createElement(s.DynamicComponent, {
          contentStore: t.contentStore,
          childProps: this.props,
          name: t.displayName,
          customChildren: this.props.children,
          vertical: !0
        }, l.createElement(c.Container, {
          noGrow: !0,
          noShrink: !0
        }, l.createElement(u.Template, {
          key: "text",
          source: p.templates.MessageCanvasTrayContent,
          className: "MessageCanvasTrayContent"
        }), this.props.showButton && l.createElement(c.ActionButton, {
          "data-test": "StartNewChatAreaButton",
          key: "button",
          onClick: this.props.onButtonClick,
          disabled: !1,
          roundCorners: !1,
          themeOverride: this.props.theme.Chat.MessageCanvasTray.Button
        }, l.createElement(u.Template, {
          source: p.templates.MessageCanvasTrayButton
        }))));
      }, n = i([a.withTheme], n);
    }(l.PureComponent);
    t.MessageCanvasTrayImpl = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InlineDateSeparator = void 0;
    var r = n(344);
    Object.defineProperty(t, "InlineDateSeparator", {
      enumerable: !0,
      get: function get() {
        return r.InlineDateSeparator;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r43,
      o = this && this.__extends || (_r43 = function r(e, t) {
        return (_r43 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r43(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InlineDateSeparator = void 0;
    var i = n(0),
      a = n(6),
      l = n(10),
      s = n(345),
      c = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props.message;
          return i.createElement(a.FlexBox, {
            className: "Twilio-InlineDateSeparator",
            key: e.source.timestamp.getTime()
          }, i.createElement(s.SeparatorLine, null), i.createElement(s.TextContainer, null, l.Utils.formatSeparatorDate(e.source.timestamp)), i.createElement(s.SeparatorLine, null));
        }, t.displayName = "InlineDateSeparator", t;
      }(i.PureComponent);
    t.InlineDateSeparator = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TextContainer = t.SeparatorLine = void 0;
    var o,
      i,
      a = n(1);
    t.SeparatorLine = a.styled("hr")(o || (o = r(["\n    flex: 1 1 1px;\n    margin: auto;\n    ", ";\n"], ["\n    flex: 1 1 1px;\n    margin: auto;\n    ", ";\n"])), function (e) {
      return e.theme.Chat.MessageList.DateSeparatorLine;
    }), t.TextContainer = a.styled("div")(i || (i = r(["\n    flex: 0 1 auto;\n    margin-left: 12px;\n    margin-right: 12px;\n    font-size: 10px;\n    letter-spacing: 2px;\n    ", ";\n"], ["\n    flex: 0 1 auto;\n    margin-left: 12px;\n    margin-right: 12px;\n    font-size: 10px;\n    letter-spacing: 2px;\n    ", ";\n"])), function (e) {
      return e.theme.Chat.MessageList.DateSeparatorText;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InlineMessage = void 0;
    var i = n(347);
    Object.defineProperty(t, "InlineMessage", {
      enumerable: !0,
      get: function get() {
        return i.InlineMessage;
      }
    }), o(n(72), t), o(n(348), t);
  }, function (e, t, n) {
    "use strict";

    var _r44,
      o = this && this.__extends || (_r44 = function r(e, t) {
        return (_r44 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r44(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InlineMessage = void 0;
    var i = n(0),
      a = n(9),
      l = n(20),
      s = n(72),
      c = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this,
            n = this.props,
            r = n.message,
            o = n.children;
          return i.createElement(l.MessagingCanvasContext.Consumer, null, function (n) {
            return i.createElement(a.DynamicComponent, {
              contentStore: t.Content,
              childProps: e.props,
              name: t.friendlyName,
              customChildren: e.props.children,
              vertical: !0
            }, i.createElement(s.Container, {
              message: r,
              messageStyle: n.messageStyle
            }, o));
          });
        }, t.friendlyName = "InlineMessage", t.displayName = t.friendlyName, t.Content = new a.DynamicContentStore(t.friendlyName), t;
      }(i.PureComponent);
    t.InlineMessage = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConnectingAnimationProps = t.ConnectingAnimation = void 0;
    var r = n(350);
    Object.defineProperty(t, "ConnectingAnimation", {
      enumerable: !0,
      get: function get() {
        return r.ConnectingAnimation;
      }
    }), Object.defineProperty(t, "ConnectingAnimationProps", {
      enumerable: !0,
      get: function get() {
        return r.ConnectingAnimationProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r45,
      o = this && this.__extends || (_r45 = function r(e, t) {
        return (_r45 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r45(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConnectingAnimation = void 0;
    var i = n(0),
      a = n(351),
      l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.color,
            n = e.sizeMultiplier;
          return i.createElement(a.ConnectingAnimationImpl, {
            className: "Twilio-StyledConnectingAnimation",
            color: t,
            bubbleSize: 4 * n
          }, i.createElement("div", {
            className: "elipsis-1"
          }), i.createElement("div", {
            className: "elipsis-2"
          }), i.createElement("div", {
            className: "elipsis-3"
          }), i.createElement("div", {
            className: "elipsis-4"
          }));
        }, t.defaultProps = {
          color: "#FFFFFF",
          sizeMultiplier: 1
        }, t;
      }(i.PureComponent);
    t.ConnectingAnimation = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ConnectingAnimationImpl = void 0;
    var o,
      i = n(1);
    t.ConnectingAnimationImpl = i.styled("div")(o || (o = r(["\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    div {\n        position: absolute;\n        top: calc(50% - ", "px);\n        width: ", "px;\n        height: ", "px;\n        border-radius: 50%;\n        background-color: ", ";\n        animation-timing-function: cubic-bezier(0, 1, 1, 0);\n    }\n    div.elipsis-1 {\n        animation: loading-connection1 0.7s infinite;\n        left: 15%;\n    }\n    div.elipsis-2 {\n        animation: loading-connection2 0.7s infinite;\n        left: 15%;\n    }\n    div.elipsis-3 {\n        animation: loading-connection3 0.7s infinite;\n        left: calc(50% - ", "px);\n    }\n    div.elipsis-4 {\n        animation: loading-connection4 0.7s infinite;\n        left: calc(85% - ", "px);\n    }\n    @keyframes loading-connection1 {\n        0% {\n            transform: scale(0);\n        }\n        100% {\n            transform: scale(1);\n        }\n    }\n    @keyframes loading-connection2 {\n        0% {\n            left: 15%;\n        }\n        100% {\n            left: calc(50% - ", "px);\n        }\n    }\n    @keyframes loading-connection3 {\n        0% {\n            left: calc(50% - ", "px);\n        }\n        100% {\n            left: calc(85% - ", "px);\n        }\n    }\n    @keyframes loading-connection4 {\n        0% {\n            transform: scale(1);\n        }\n        100% {\n            transform: scale(0);\n        }\n    }\n"], ["\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    div {\n        position: absolute;\n        top: calc(50% - ", "px);\n        width: ", "px;\n        height: ", "px;\n        border-radius: 50%;\n        background-color: ", ";\n        animation-timing-function: cubic-bezier(0, 1, 1, 0);\n    }\n    div.elipsis-1 {\n        animation: loading-connection1 0.7s infinite;\n        left: 15%;\n    }\n    div.elipsis-2 {\n        animation: loading-connection2 0.7s infinite;\n        left: 15%;\n    }\n    div.elipsis-3 {\n        animation: loading-connection3 0.7s infinite;\n        left: calc(50% - ", "px);\n    }\n    div.elipsis-4 {\n        animation: loading-connection4 0.7s infinite;\n        left: calc(85% - ", "px);\n    }\n    @keyframes loading-connection1 {\n        0% {\n            transform: scale(0);\n        }\n        100% {\n            transform: scale(1);\n        }\n    }\n    @keyframes loading-connection2 {\n        0% {\n            left: 15%;\n        }\n        100% {\n            left: calc(50% - ", "px);\n        }\n    }\n    @keyframes loading-connection3 {\n        0% {\n            left: calc(50% - ", "px);\n        }\n        100% {\n            left: calc(85% - ", "px);\n        }\n    }\n    @keyframes loading-connection4 {\n        0% {\n            transform: scale(1);\n        }\n        100% {\n            transform: scale(0);\n        }\n    }\n"])), function (e) {
      return e.bubbleSize / 2;
    }, function (e) {
      return e.bubbleSize;
    }, function (e) {
      return e.bubbleSize;
    }, function (e) {
      return e.color;
    }, function (e) {
      return e.bubbleSize / 2;
    }, function (e) {
      return e.bubbleSize;
    }, function (e) {
      return e.bubbleSize / 2;
    }, function (e) {
      return e.bubbleSize / 2;
    }, function (e) {
      return e.bubbleSize;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DataTableColumnDefinition = t.ColumnDefinition = t.DataTableProps = t.DataTable = void 0;
    var r = n(354);
    Object.defineProperty(t, "DataTable", {
      enumerable: !0,
      get: function get() {
        return r.DataTable;
      }
    }), Object.defineProperty(t, "DataTableProps", {
      enumerable: !0,
      get: function get() {
        return r.DataTableProps;
      }
    });
    var o = n(359);
    Object.defineProperty(t, "ColumnDefinition", {
      enumerable: !0,
      get: function get() {
        return o.ColumnDefinition;
      }
    }), Object.defineProperty(t, "DataTableColumnDefinition", {
      enumerable: !0,
      get: function get() {
        return o.DataTableColumnDefinition;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r46,
      o = this && this.__extends || (_r46 = function r(e, t) {
        return (_r46 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r46(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, l = i.length; a < l; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DataTable = void 0;
    var l = n(0),
      s = n(355),
      c = n(356),
      u = n(357),
      p = n(73),
      d = n(52),
      f = n(53),
      h = n(358),
      m = n(75),
      g = n(2),
      v = n(12),
      y = function (e) {
        function t(t) {
          var n = e.call(this, t) || this;
          if (n.state = {
            sortingAsc: !1
          }, n.sortingIconProps = {
            style: {
              fontSize: "24px",
              position: "absolute",
              top: "-6px"
            }
          }, n.props.defaultSortColumn) {
            var r = l.Children.toArray(n.props.children),
              o = void 0;
            try {
              o = r.find(function (e) {
                return e.key.match(new RegExp("\\$" + n.props.defaultSortColumn + "$"));
              });
            } catch (e) {
              return n;
            }
            o && o.props.sortingFn && (n.state = {
              sortingFn: o.props.sortingFn,
              sortingAsc: "asc" === o.props.sortDirection || !1,
              sortingKey: o.key
            });
          }
          return n;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this,
            t = this.props,
            n = t.children,
            r = t.items,
            o = t.itemKey,
            i = t.placeholder,
            d = t.hasHoverStyle,
            f = t.columnDataCreationContext;
          if (!this.validateChildren()) return g.log.warn("Invalid column definitions for DataTable"), null;
          if ((!r || 0 === r.length) && i) return i;
          var m = l.Children.toArray(n),
            v = m.filter(function (e) {
              return !!e.props.headerColSpanKey;
            }),
            y = m.some(function (e) {
              return !!e.props.subHeader;
            }),
            b = v.length > 1,
            _ = [];
          b && (_ = this.createHeaderColSpans(m));
          var O = b ? _.map(function (t, n) {
              return e.createHeader(t.column, n, {
                hasSubHeaderRow: y,
                colSpan: t.colSpan
              });
            }) : m.map(function (t, n) {
              return e.createHeader(t, n, {
                hasSubHeaderRow: y
              });
            }),
            C = y ? m.map(function (t, n) {
              return e.createSubHeader(t, n);
            }) : [],
            w = r;
          this.state.sortingFn && (w = a(w).sort(function (t, n) {
            return (e.state.sortingAsc ? 1 : -1) * e.state.sortingFn(t, n);
          }));
          var x = w.map(function (t, n) {
            var r = t.key || (o ? o(t) : n);
            return l.createElement(h.DataTableRow, {
              onClick: e.props.onRowClick && function () {
                return e.props.onRowClick(t);
              },
              key: r,
              selected: r === e.props.selectedItemKey,
              hover: d,
              columnDefinitions: m,
              columnDataCreationContext: f,
              item: t
            });
          });
          return l.createElement(s.default, null, l.createElement(u.default, null, l.createElement(p.default, null, O), C.length > 0 && l.createElement(p.default, null, C)), l.createElement(c.default, null, x));
        }, t.prototype.setSortingFn = function (e, t, n) {
          e === this.state.sortingKey ? this.setState(function (e) {
            return {
              sortingAsc: !e.sortingAsc
            };
          }) : this.setState({
            sortingFn: t,
            sortingKey: e,
            sortingAsc: "asc" === n || !1
          });
        }, t.isValidColumnItem = function (e) {
          return l.isValidElement(e);
        }, t.prototype.validateChildren = function () {
          return !l.Children.toArray(this.props.children).find(function (e) {
            return !t.isValidColumnItem(e);
          });
        }, t.prototype.createHeaderColSpans = function (e) {
          return e.reduce(function (e, t) {
            var n = e.length - 1;
            return void 0 !== e[n] && void 0 !== e[n].column.props.headerColSpanKey && e[n].column.props.headerColSpanKey === t.props.headerColSpanKey ? e[n].colSpan += 1 : e.push({
              colSpan: 1,
              column: t
            }), e;
          }, []);
        }, t.prototype.createHeader = function (e, t, n) {
          var r = this,
            o = n.hasSubHeaderRow ? m.HeaderCellWithSubheader : m.TableCell;
          return l.createElement(o, {
            colSpan: n.colSpan,
            className: v.cx("Twilio-DataTable-Header", e.props.headerColSpanKey && "Twilio-DataTable-Header-" + e.props.headerColSpanKey, !e.props.headerColSpanKey && e.props.name && "Twilio-DataTable-Header-" + e.props.name),
            key: e.key || t,
            style: e.props.style,
            onClick: function onClick() {
              return e.props.sortingFn && r.setSortingFn(e.key, e.props.sortingFn, e.props.sortDirection);
            }
          }, l.createElement(m.HeaderCellContentWrapper, {
            clickable: !!e.props.sortingFn,
            hasSubHeader: !!e.props.subHeader
          }, e.props.header, this.state.sortingKey === e.key && !e.props.subHeader && (this.state.sortingAsc ? l.createElement(f.default, i({}, this.sortingIconProps)) : l.createElement(d.default, i({}, this.sortingIconProps)))));
        }, t.prototype.createSubHeader = function (e, t) {
          var n = this;
          return l.createElement(m.TableCell, {
            className: v.cx("Twilio-DataTable-SubHeader", e.props.name && "Twilio-DataTable-SubHeader-" + e.props.name),
            key: "subheader-" + (e.key || t),
            onClick: function onClick() {
              return e.props.sortingFn && n.setSortingFn(e.key, e.props.sortingFn, e.props.sortDirection);
            }
          }, l.createElement(m.SubHeaderCellContentWrapper, {
            clickable: !!e.props.sortingFn
          }, e.props.subHeader, this.state.sortingKey === e.key && e.props.subHeader && (this.state.sortingAsc ? l.createElement(f.default, i({}, this.sortingIconProps)) : l.createElement(d.default, i({}, this.sortingIconProps)))));
        }, t.defaultProps = {
          hasHoverStyle: !0
        }, t;
      }(l.Component);
    t.DataTable = y;
  }, function (e, t) {
    e.exports = require("@material-ui/core/Table");
  }, function (e, t) {
    e.exports = require("@material-ui/core/TableBody");
  }, function (e, t) {
    e.exports = require("@material-ui/core/TableHead");
  }, function (e, t, n) {
    "use strict";

    var _r47,
      o = this && this.__extends || (_r47 = function r(e, t) {
        return (_r47 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r47(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DataTableRow = void 0;
    var l = n(74),
      s = n(12),
      c = n(0),
      u = n(75),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.ref = c.createRef(), t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.item,
            n = e.columnDataCreationContext,
            r = e.columnDefinitions,
            o = a(e, ["item", "columnDataCreationContext", "columnDefinitions"]),
            p = r.map(function (e) {
              var r = e.props.content,
                o = "function" == typeof r ? r(t, n) : r;
              return c.createElement(l.default, {
                key: e.key,
                style: e.props.style,
                "data-column-name": e.props.name,
                className: s.cx("Twilio-DataTable-Cell", e.props.name && "Twilio-DataTable-Cell-" + e.props.name)
              }, o);
            });
          return c.createElement(u.StyledTableRow, i({}, o, {
            ref: this.ref
          }), p);
        }, t.defaultProps = {
          selected: !1,
          hover: !0
        }, t;
      }(c.Component);
    t.DataTableRow = p;
  }, function (e, t, n) {
    "use strict";

    var _r48,
      o = this && this.__extends || (_r48 = function r(e, t) {
        return (_r48 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r48(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ColumnDefinition = void 0;
    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.render = function () {
        return null;
      }, t;
    }(n(0).Component);
    t.ColumnDefinition = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DialerThemeProps = t.DialerProps = t.Dialer = void 0;
    var r = n(361);
    Object.defineProperty(t, "Dialer", {
      enumerable: !0,
      get: function get() {
        return r.Dialer;
      }
    }), Object.defineProperty(t, "DialerProps", {
      enumerable: !0,
      get: function get() {
        return r.DialerProps;
      }
    }), Object.defineProperty(t, "DialerThemeProps", {
      enumerable: !0,
      get: function get() {
        return r.DialerThemeProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r49,
      o = this && this.__extends || (_r49 = function r(e, t) {
        return (_r49 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r49(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              s(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            try {
              s(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, l);
          }
          s((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: l(0),
          throw: l(1),
          return: l(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function l(i) {
          return function (l) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, l]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Dialer = void 0;
    var l = n(0),
      s = n(45),
      c = n(77),
      u = n(79),
      p = n(366),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t._isMounted = !1, t.inputRef = l.createRef(), t.state = {
            phoneNumber: t.props.defaultPhoneNumber,
            countryAlpha2Code: t.props.defaultCountryAlpha2Code
          }, t.updateListeners = function (e, n) {
            n || t.updateCountryCode(e), t.setState({
              phoneNumber: e
            }), t.props.onPhoneNumberChange(e);
          }, t.onPhoneNumberReset = function (e) {
            t.updateListeners("");
          }, t.onDialpadClick = function (e) {
            t.props.disabled || t.updateListeners(t.state.phoneNumber + e);
          }, t.onDialpadUndo = function () {
            !t.props.disabled && t.state.phoneNumber && t.updateListeners(t.state.phoneNumber.slice(0, -1));
          }, t.onDialerPhoneInputChange = function (e) {
            var n = e.phoneNumber,
              r = e.countryCode,
              o = Boolean(r);
            o && t.setState({
              countryAlpha2Code: r
            }), t.updateListeners(n, o);
          }, t.onKeyPress = function (e) {
            "ENTER" === e.key.toUpperCase() && t.state.phoneNumber.length > 0 && t.onStartOutboundCall();
          }, t.onStartOutboundCall = function () {
            var e = t.state.phoneNumber,
              n = t.props.disabled;
            e && !n && t.props.onDial(e);
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          return i(this, void 0, void 0, function () {
            var e,
              t,
              n = this;
            return a(this, function (r) {
              switch (r.label) {
                case 0:
                  return e = this.props.defaultCountryAlpha2Code, this._isMounted = !0, e ? [4, s.CountryManager.getCountryCodeForRegion(e)] : [3, 2];
                case 1:
                  (t = r.sent()) && this._isMounted && this.setState(function (e) {
                    var r = e.phoneNumber;
                    return "" === r ? {
                      phoneNumber: "+" + t
                    } : (n.updateCountryCode(r), null);
                  }), r.label = 2;
                case 2:
                  return [2];
              }
            });
          });
        }, t.prototype.componentWillUnmount = function () {
          this._isMounted = !1;
        }, t.prototype.render = function () {
          var e = this.props,
            t = e.disabled,
            n = e.defaultCountryAlpha2Code,
            r = e.hideActions,
            o = this.state,
            i = o.phoneNumber,
            a = o.countryAlpha2Code,
            s = t || !i;
          return l.createElement(u.DialerContainer, {
            className: "Twilio-Dialer"
          }, l.createElement(p.DialerPhoneInput, {
            id: "dialer-phone-input",
            ref: this.inputRef,
            value: i,
            onChange: this.onDialerPhoneInputChange,
            onKeyPress: this.onKeyPress,
            onReset: this.onPhoneNumberReset,
            disabled: t,
            defaultCountryAlpha2Code: n,
            countryAlpha2Code: a
          }), l.createElement(c.Dialpad, {
            inputRef: this.inputRef,
            onClick: this.onDialpadClick,
            onUndo: this.onDialpadUndo,
            disabled: t
          }), !r && l.createElement(u.DialerActions, null, l.createElement(u.CallButton, {
            onClick: this.onStartOutboundCall,
            disabled: s
          })));
        }, t.prototype.updateCountryCode = function (e) {
          return i(this, void 0, Promise, function () {
            var t, n, r, o;
            return a(this, function (i) {
              switch (i.label) {
                case 0:
                  return t = this.state.countryAlpha2Code, [4, s.CountryManager.getRegionCodeFromNumber(e)];
                case 1:
                  return n = i.sent(), [4, s.CountryManager.getCountryCodeForRegion(t)];
                case 2:
                  return r = i.sent(), [4, s.CountryManager.getCountryCodeForRegion(n)];
                case 3:
                  return o = i.sent(), r !== o && this.setState({
                    countryAlpha2Code: n
                  }), [2];
              }
            });
          });
        }, t.defaultProps = {
          defaultPhoneNumber: "",
          onPhoneNumberChange: function onPhoneNumberChange() {}
        }, t;
      }(l.PureComponent);
    t.Dialer = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              s(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            try {
              s(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, l);
          }
          s((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: l(0),
          throw: l(1),
          return: l(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function l(i) {
          return function (l) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, l]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CountryManager = void 0;
    var i,
      a = n(363),
      l = [],
      s = function s(e) {
        var t = e.callingCodes;
        return Boolean(t && t.length > 0 && t[0]);
      },
      c = function c(e) {
        return {
          name: e.name,
          key: e.alpha2Code,
          code: e.callingCodes[0]
        };
      };
    t.CountryManager = {
      getAllCountries: function getAllCountries() {
        return r(void 0, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return l.length ? [3, 2] : [4, r(void 0, void 0, Promise, function () {
                  return o(this, function (e) {
                    switch (e.label) {
                      case 0:
                        return e.trys.push([0, 3,, 4]), [4, fetch("https://assets.flex.twilio.com/assets/countries.json")];
                      case 1:
                        return [4, e.sent().json()];
                      case 2:
                        return [2, e.sent()];
                      case 3:
                        return e.sent(), [2, []];
                      case 4:
                        return [2];
                    }
                  });
                })];
              case 1:
                e = t.sent(), l = e.filter(s).map(c), t.label = 2;
              case 2:
                return [2, l];
            }
          });
        });
      },
      getAllCountriesFlagPositions: function getAllCountriesFlagPositions() {
        return r(void 0, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return i ? [3, 2] : [4, r(void 0, void 0, Promise, function () {
                  return o(this, function (e) {
                    switch (e.label) {
                      case 0:
                        return e.trys.push([0, 3,, 4]), [4, fetch("https://assets.flex.twilio.com/assets/flagPositions.json")];
                      case 1:
                        return [4, e.sent().json()];
                      case 2:
                        return [2, e.sent()];
                      case 3:
                        return e.sent(), [2, {}];
                      case 4:
                        return [2];
                    }
                  });
                })];
              case 1:
                i = e.sent(), e.label = 2;
              case 2:
                return [2, i];
            }
          });
        });
      },
      getFlagPositionFromCode: function getFlagPositionFromCode(e) {
        return r(void 0, void 0, Promise, function () {
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, t.CountryManager.getAllCountriesFlagPositions()];
              case 1:
                return [2, n.sent()[e]];
            }
          });
        });
      },
      getCountryCodeForRegion: function getCountryCodeForRegion(e) {
        return r(void 0, void 0, Promise, function () {
          var n, r;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, t.CountryManager.getAllCountries()];
              case 1:
                return n = o.sent(), [2, (r = n.find(function (t) {
                  return t.key === e;
                })) ? Number(r.code) : null];
            }
          });
        });
      },
      getRegionCodeFromNumber: function getRegionCodeFromNumber(e) {
        return r(void 0, void 0, Promise, function () {
          var n, r, i, l, s, c;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return n = a.PhoneNumberUtil.getInstance(), r = t.CountryManager.formatPhoneNumberWithCountryCode(e), [4, t.CountryManager.getAllCountries()];
              case 1:
                return i = o.sent(), r ? (l = i.filter(function (e) {
                  return 0 === r.substr(1).indexOf(e.code);
                }).sort(function (e, t) {
                  var n = Number(e.code && e.code.length) || 0;
                  return (Number(t.code && t.code.length) || 0) - n;
                }).reduce(function (e, t) {
                  var n = Number(e.code && e.code.length) || 0;
                  return (Number(t.code && t.code.length) || 0) > n ? t : e;
                }, {})).code ? (s = Number(l.code), c = n.getRegionCodeForCountryCode(s), Number(n.getCountryCodeForRegion(c)) === s ? [2, c] : [2, l.key]) : [2, null] : [2, null];
            }
          });
        });
      },
      formatPhoneNumberWithCountryCode: function formatPhoneNumberWithCountryCode(e, t) {
        if (!e || e.length <= 1) return e;
        var n = /^(0{2}|\+)(.+)/,
          r = null;
        if (n.test(e)) {
          r = e.replace(n, "+$2");
        }
        try {
          var o = a.PhoneNumberUtil.getInstance(),
            i = o.parseAndKeepRawInput(r || e, t),
            l = i.getExtension();
          return r = o.format(i, a.PhoneNumberFormat.E164), l ? r + "#" + l : r;
        } catch (e) {
          return r;
        }
      }
    };
  }, function (e, t) {
    e.exports = require("google-libphonenumber");
  }, function (e, t, n) {
    "use strict";

    var _r50,
      o = this && this.__extends || (_r50 = function r(e, t) {
        return (_r50 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r50(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DialpadButton = void 0;
    var i = n(0),
      a = n(4),
      l = n(78),
      s = {
        "#": {
          caption: "DialpadHashCaption",
          description: "DialpadHashDescription"
        },
        "*": {
          caption: "DialpadAsteriskCaption",
          description: "DialpadAsteriskDescription"
        }
      },
      c = function (e) {
        function t(t) {
          var n = e.call(this, t) || this;
          return n.longPressDuration = 700, n.onClick = function (e) {
            n.props.onClick(n.props.value);
          }, n.onMouseDown = function (e) {
            n.longPressTimer = window.setTimeout(function () {
              n.props.onClick(n.props.options), n.longPressTimer = null;
            }, n.longPressDuration);
          }, n.onMouseUp = function (e) {
            n.longPressTimer && (window.clearTimeout(n.longPressTimer), n.onClick(e));
          }, n.onMouseLeave = function (e) {
            window.clearTimeout(n.longPressTimer);
          }, n.captionKey = Number.isNaN(Number(t.value)) ? s[t.value].caption : "DialpadNum" + t.value + "Caption", n.descriptionKey = Number.isNaN(Number(t.value)) ? s[t.value].description : "DialpadNum" + t.value + "Description", n;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.animate,
            n = e.compact,
            r = e.value,
            o = e.options,
            s = e.disabled,
            c = e.longPressable;
          return i.createElement(l.Button, {
            compact: n,
            animate: t,
            className: "Twilio-Dialpad-" + r,
            onClick: !c && this.onClick,
            onMouseDown: c && this.onMouseDown,
            onMouseUp: c && this.onMouseUp,
            onMouseLeave: c && this.onMouseLeave,
            disabled: s
          }, i.createElement(l.Caption, {
            compact: n
          }, i.createElement(a.Template, {
            code: this.captionKey
          })), o && i.createElement(l.Description, {
            compact: n
          }, i.createElement(a.Template, {
            code: this.descriptionKey
          })));
        }, t;
      }(i.PureComponent);
    t.DialpadButton = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DialpadButtons = void 0, function (e) {
      e.ZERO = "0", e.ONE = "1", e.TWO = "2", e.THREE = "3", e.FOUR = "4", e.FIVE = "5", e.SIX = "6", e.SEVEN = "7", e.EIGHT = "8", e.NINE = "9", e.ASTERISK = "*", e.HASH = "#";
    }(t.DialpadButtons || (t.DialpadButtons = {}));
  }, function (e, t, n) {
    "use strict";

    var _r51,
      o = this && this.__extends || (_r51 = function r(e, t) {
        return (_r51 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r51(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DialerPhoneInput = void 0;
    var a = n(0),
      l = n(27),
      s = n(367),
      c = n(79),
      u = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.inputRef = a.createRef(), t.onPhoneInputChange = function (e) {
            t.props.onChange({
              phoneNumber: e.target.value
            });
          }, t.onCountryChange = function (e) {
            (0, t.props.onChange)({
              phoneNumber: "+" + e.code,
              countryCode: e.key
            }), t.focusOnInput();
          }, t.focusOnInput = function () {
            t.inputRef.current && t.inputRef.current.focus();
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.id,
            n = e.forwardedRef,
            r = e.value,
            o = e.onKeyPress,
            i = e.onReset,
            u = e.disabled,
            p = e.defaultCountryAlpha2Code,
            d = e.countryAlpha2Code;
          return a.createElement(c.PhoneInputContainer, null, a.createElement(s.CountrySelector, {
            defaultCountry: p,
            selectedCountry: d,
            onCountryChange: this.onCountryChange,
            disabled: u
          }), a.createElement(c.PhoneInput, {
            "data-test": "dialer-input",
            id: t,
            type: "tel",
            className: "Twilio-Dialer-PhoneInput-Input",
            innerRef: n,
            inputRef: this.inputRef,
            value: r,
            onChange: this.onPhoneInputChange,
            onKeyPress: o,
            disabled: u,
            autoComplete: "off",
            autoFocus: !0
          }), a.createElement(c.ClearInputButton, {
            isVisible: r.length > 0,
            onClick: i,
            className: "Twilio-Dialer-PhoneInput-ClearButton"
          }, a.createElement(l.IcnClose, {
            width: 24,
            height: 24
          })));
        }, t.defaultProps = {
          value: "",
          onReset: function onReset() {}
        }, t;
      }(a.PureComponent);
    t.DialerPhoneInput = a.forwardRef(function (e, t) {
      return a.createElement(u, i({}, e, {
        forwardedRef: t
      }));
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CountrySelector = void 0;
    var r = n(368);
    Object.defineProperty(t, "CountrySelector", {
      enumerable: !0,
      get: function get() {
        return r.CountrySelector;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r52,
      o = this && this.__extends || (_r52 = function r(e, t) {
        return (_r52 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r52(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              s(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            try {
              s(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, l);
          }
          s((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: l(0),
          throw: l(1),
          return: l(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function l(i) {
          return function (l) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, l]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CountrySelector = void 0;
    var l = n(0),
      s = n(369),
      c = n(45),
      u = n(370);
    function p(e, t) {
      return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : e.firstChild;
    }
    var d = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.menuRef = l.createRef(), t.state = {
          allCountries: [],
          filteredCountries: [],
          flagPositions: {}
        }, t.handleCountryChange = function (e) {
          var n = t.state.allCountries.find(function (t) {
            return t.key === e.target.value;
          });
          t.props.onCountryChange(n);
        }, t.handleKeyPress = function (e) {
          if (e.preventDefault(), 1 === e.key.length) {
            var n = t.menuRef.current && s.findDOMNode(t.menuRef.current),
              r = n && n.querySelector("ul[role='listbox']");
            if (r) for (var o = p(r, document.activeElement), i = !1; o;) {
              if (o === r.firstChild) {
                if (i) break;
                i = !0;
              }
              var a = o.textContent;
              if (a && "string" == typeof a && a.trim().toLowerCase()[0] === e.key) {
                o.focus();
                break;
              }
              o = p(r, o);
            }
          }
        }, t.renderFlag = function (e) {
          return l.createElement(u.Flag, {
            position: t.state.flagPositions[e]
          });
        }, t.renderCountryDetails = function (e) {
          return l.createElement(u.CountryDetails, null, l.createElement(u.CountryName, null, e.name), l.createElement(u.CountryCode, null, "(+", e.code, ")"));
        }, t.renderDefaultMenuItem = function () {
          var e = t.state.allCountries.find(function (e) {
            return e.key === t.props.defaultCountry;
          });
          return e ? l.createElement(u.StyledMenuItemWithBorder, {
            key: e.key,
            value: e.key
          }, l.createElement(u.DefaultCountry, {
            className: "Twilio-Country-Selector-Default-Country"
          }, t.renderFlag(e.key), t.renderCountryDetails(e))) : null;
        }, t;
      }
      return o(t, e), t.prototype.componentDidMount = function () {
        this._isMounted = !0, this.getCountries(), this.getFlags();
      }, t.prototype.componentWillUnmount = function () {
        this._isMounted = !1;
      }, t.prototype.getCountries = function () {
        return i(this, void 0, void 0, function () {
          var e, t;
          return a(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, c.CountryManager.getAllCountries()];
              case 1:
                return e = n.sent(), t = this.props.defaultCountry, this._isMounted && this.setState({
                  allCountries: e,
                  filteredCountries: t ? e.filter(function (e) {
                    return e.key !== t;
                  }) : e
                }), [2];
            }
          });
        });
      }, t.prototype.getFlags = function () {
        return i(this, void 0, void 0, function () {
          var e;
          return a(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, c.CountryManager.getAllCountriesFlagPositions()];
              case 1:
                return e = t.sent(), this._isMounted && this.setState({
                  flagPositions: e
                }), [2];
            }
          });
        });
      }, t.prototype.render = function () {
        var e = this,
          t = this.state.filteredCountries,
          n = this.props,
          r = n.selectedCountry,
          o = n.defaultCountry,
          i = n.disabled,
          a = {
            PaperProps: {
              component: u.SelectList,
              square: !0,
              elevation: 0
            },
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left"
            },
            MenuListProps: {
              onKeyDown: this.handleKeyPress,
              disablePadding: !0
            },
            getContentAnchorEl: null,
            keepMounted: !0,
            transitionDuration: 0,
            innerRef: this.menuRef
          };
        return l.createElement(u.StyledSelect, {
          value: r || o || "",
          onChange: this.handleCountryChange,
          MenuProps: a,
          renderValue: this.renderFlag,
          className: "Twilio-Country-Selector",
          disabled: i
        }, this.renderDefaultMenuItem(), t.map(function (t) {
          return l.createElement(u.StyledMenuItem, {
            key: t.key,
            value: t.key
          }, e.renderFlag(t.key), e.renderCountryDetails(t));
        }));
      }, t;
    }(l.PureComponent);
    t.CountrySelector = d;
  }, function (e, t) {
    e.exports = require("react-dom");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__assign || function () {
        return (o = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CountryCode = t.CountryName = t.CountryDetails = t.StyledMenuItemWithBorder1 = t.StyledMenuItemWithBorder = t.DefaultCountry = t.StyledMenuItem = t.SelectList = t.StyledSelect = t.Flag = void 0;
    var i,
      a,
      l,
      s,
      c,
      u,
      p = n(80),
      d = n(371),
      f = n(81),
      h = n(372),
      m = n(82),
      g = n(1);
    t.Flag = g.styled("div")(i || (i = r(["\n    box-sizing: content-box;\n    width: 21px;\n    height: 14px;\n    background-repeat: no-repeat;\n    display: block;\n    margin-right: 10px;\n    flex-shrink: 0;\n    background-image: ", ";\n    background-size: 21px auto;\n    background-position: ", ";\n    border: 1px solid;\n    ", ";\n"], ["\n    box-sizing: content-box;\n    width: 21px;\n    height: 14px;\n    background-repeat: no-repeat;\n    display: block;\n    margin-right: 10px;\n    flex-shrink: 0;\n    background-image: ", ";\n    background-size: 21px auto;\n    background-position: ", ";\n    border: 1px solid;\n    ", ";\n"])), function (e) {
      return e.position && 'url("https://assets.flex.twilio.com/assets/img/flag-spritesheet.png")';
    }, function (e) {
      var t = e.position;
      return t && "0px -" + t / 2 + "px";
    }, function (e) {
      return e.theme.CountrySelector && e.theme.CountrySelector.Flag;
    }), t.StyledSelect = h.default({
      root: {
        width: 66,
        flexGrow: 0,
        flexShrink: 0,
        "& .Twilio-Dropdown": {
          height: "100%"
        }
      },
      selectMenu: {
        paddingTop: 7,
        paddingBottom: 7,
        borderRightWidth: 0,
        "&:focus": {
          borderRightWidth: 1
        }
      }
    })(f.default), t.SelectList = h.default(function (e) {
      return {
        root: o({
          boxSizing: "border-box",
          width: 252,
          height: 170,
          overflow: "auto",
          borderStyle: "solid",
          borderWidth: 1,
          marginLeft: 5,
          borderRadius: 0,
          boxShadow: "none",
          borderTopWidth: 0
        }, e.CountrySelector.CountryList)
      };
    })(d.default), t.StyledMenuItem = h.default(function (e) {
      return {
        root: o(o({
          height: 32,
          boxSizing: "border-box",
          display: "flex",
          margin: 0,
          padding: "0 12px",
          minWidth: 0
        }, e.CountrySelector.CountryItem), {
          "&:hover, &:focus": m.getHover(e.CountrySelector.CountryItem.backgroundColor, e.CountrySelector.CountryItem.lightHover),
          "&$selected": o(o({}, e.CountrySelector.CountryItem.Selected), {
            "&:hover, &:focus, &:focus:hover": {
              backgroundColor: e.CountrySelector.CountryItem.Selected.backgroundColor,
              backgroundImage: "initial"
            }
          })
        }),
        selected: {}
      };
    })(p.default), t.DefaultCountry = g.styled("div")(a || (a = r(["\n    display: flex;\n    width: 100%;\n    flex-grow: 1;\n    height: 100%;\n    align-items: center;\n    padding: 0 12px;\n    min-width: 0;\n    height: 32px;\n"], ["\n    display: flex;\n    width: 100%;\n    flex-grow: 1;\n    height: 100%;\n    align-items: center;\n    padding: 0 12px;\n    min-width: 0;\n    height: 32px;\n"]))), t.StyledMenuItemWithBorder = h.default(function (e) {
      return {
        root: {
          padding: 0,
          borderBottom: "1px solid " + e.CountrySelector.CountryList.borderColor,
          paddingBottom: 4,
          marginBottom: 4,
          height: "auto",
          backgroundColor: "initial",
          "&:hover, &:focus": {
            background: "initial",
            "& .Twilio-Country-Selector-Default-Country": m.getHover(e.CountrySelector.CountryItem.backgroundColor, e.CountrySelector.CountryItem.lightHover)
          },
          "&$selected": {
            backgroundColor: "initial",
            "&:hover, &:focus, &:focus:hover": {
              background: "initial"
            },
            "& .Twilio-Country-Selector-Default-Country": o({}, e.CountrySelector.CountryItem.Selected)
          }
        },
        selected: {}
      };
    })(t.StyledMenuItem), t.StyledMenuItemWithBorder1 = g.styled(t.StyledMenuItem)(l || (l = r([""], [""]))), t.CountryDetails = g.styled("div")(s || (s = r(["\n    display: flex;\n    flex-grow: 1;\n    min-width: 0;\n"], ["\n    display: flex;\n    flex-grow: 1;\n    min-width: 0;\n"]))), t.CountryName = g.styled("div")(c || (c = r(["\n    overflow: hidden;\n    text-overflow: ellipsis;\n"], ["\n    overflow: hidden;\n    text-overflow: ellipsis;\n"]))), t.CountryCode = g.styled("div")(u || (u = r(["\n    margin-left: 4px;\n"], ["\n    margin-left: 4px;\n"])));
  }, function (e, t) {
    e.exports = require("@material-ui/core/Paper");
  }, function (e, t) {
    e.exports = require("@material-ui/core/styles/withStyles");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      o = this && this.__assign || function () {
        return (o = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SelectDropDownIcon = void 0;
    var i,
      a = n(0),
      l = n(1),
      s = n(6),
      c = n(374),
      u = l.styled(s.FlexBox)(i || (i = r(["\n    position: absolute;\n    pointer-events: none;\n    top: 0;\n    right: 0;\n    width: 32px;\n    height: 32px;\n"], ["\n    position: absolute;\n    pointer-events: none;\n    top: 0;\n    right: 0;\n    width: 32px;\n    height: 32px;\n"])));
    t.SelectDropDownIcon = function (e) {
      return a.createElement(u, {
        className: "Twilio-Dropdown"
      }, a.createElement(c.default, o({}, e)));
    };
  }, function (e, t) {
    e.exports = require("@material-ui/icons/ArrowDropDown");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DialpadButtonThemeProps = t.DialpadProps = t.Dialpad = void 0;
    var r = n(77);
    Object.defineProperty(t, "Dialpad", {
      enumerable: !0,
      get: function get() {
        return r.Dialpad;
      }
    }), Object.defineProperty(t, "DialpadProps", {
      enumerable: !0,
      get: function get() {
        return r.DialpadProps;
      }
    }), Object.defineProperty(t, "DialpadButtonThemeProps", {
      enumerable: !0,
      get: function get() {
        return r.DialpadButtonThemeProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ErrorMessage = void 0;
    var r = n(377);
    Object.defineProperty(t, "ErrorMessage", {
      enumerable: !0,
      get: function get() {
        return r.ErrorMessage;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r53,
      o = this && this.__extends || (_r53 = function r(e, t) {
        return (_r53 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r53(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var l = e.length - 1; l >= 0; l--) (o = e[l]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ErrorMessage = void 0;
    var a = n(0),
      l = n(23),
      s = n(7),
      c = n(1),
      u = n(378),
      p = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.title,
            n = e.description,
            r = e.primaryAction,
            o = e.primaryActionTitle,
            i = e.secondaryAction,
            c = e.secondaryActionTitle,
            p = e.hideBranding,
            d = e.theme;
          return a.createElement(u.ErrorMessageWrapper, null, a.createElement(s.Icon, {
            icon: "Error",
            sizeMultiplier: 1.4
          }), a.createElement("h2", null, t), n && a.createElement("h3", null, n), a.createElement(u.ActionsWrapper, null, i && c && a.createElement(l.Button, {
            id: "Twilio-error-message-secondary-action-button",
            roundCorners: !1,
            onClick: i,
            themeOverride: {
              background: d.colors.disabledColor,
              color: d.colors.lightTextColor
            }
          }, c), r && o && a.createElement(l.Button, {
            id: "Twilio-error-message-primary-action-button",
            roundCorners: !1,
            onClick: r,
            themeOverride: {
              background: d.colors.defaultButtonColor,
              color: d.colors.lightTextColor
            }
          }, o)), !p && a.createElement(u.ErrorMessageBranding, null, a.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "148",
            height: "32",
            viewBox: "0 0 148 32"
          }, a.createElement("g", {
            fill: "currentColor",
            fillRule: "evenodd"
          }, a.createElement("path", {
            d: "M16,0 C24.8533333,0 32,7.14666667 32,16 C32,24.8533333 24.8533333,32 16,32 C7.14666667,32 0,24.8533333 0,16 C0,7.14666667 7.14666667,0 16,0 Z M16,1.0000029 C7.7,1.0000029 1,7.7000029 1,16.0000029 C1,24.3000029 7.7,31.0000029 16,31.0000029 C24.3,31.0000029 31,24.3000029 31,16.0000029 C31,7.7000029 24.3,1.0000029 16,1.0000029 Z"
          }), a.createElement("path", {
            d: "M11.0968035 15.7399802C11.0968035 15.4100846 11.4955068 15.2448436 11.7287493 15.4781594L11.7287493 15.4781594 14.9369883 18.6872777C15.0063822 18.7567448 15.0454391 18.8509065 15.0454391 18.9490985L15.0454391 18.9490985 15.0454391 22.3386994C15.0454391 22.6685218 14.6466625 22.8337628 14.4134933 22.600447L14.4134933 22.600447 11.205181 19.3913287C11.1357872 19.3219348 11.0968035 19.2276998 11.0968035 19.1295079L11.0968035 19.1295079zM19.3886452 10.8387068C19.4867638 10.8387068 19.5809255 10.8776904 19.6503927 10.9471576L19.6503927 10.9471576 22.8586316 14.1562759C23.0918742 14.3895917 22.9267065 14.7884415 22.5968841 14.7884415L22.5968841 14.7884415 15.0454098 14.7884415C14.8456551 14.7889545 14.6839315 14.9510445 14.6839315 15.151019 14.6839315 15.3509202 14.8456551 15.5130835 15.0454098 15.5135965L15.0454098 15.5135965 17.4977172 15.5135965C17.5959092 15.5135965 17.6899976 15.5525801 17.7593915 15.621974L17.7593915 15.621974 20.9676304 18.8311656C21.200873 19.0644081 21.0357053 19.4632579 20.7058829 19.4632579L20.7058829 19.4632579 16.9220486 19.4632579C16.8239299 19.4632579 16.7296949 19.4242743 16.6603011 19.3548071L16.6603011 19.3548071 11.205225 13.9091839C11.1358311 13.83979 11.0967742 13.7456283 11.0967742 13.6473631L11.0967742 13.6473631 11.0967742 11.2124957C11.0967742 11.0059995 11.2641402 10.8387068 11.4704166 10.8387068L11.4704166 10.8387068zM55.490105 12.1037234L52.2082216 12.1037234 52.2082216 20.8138298 51.2157165 20.8138298 51.2157165 12.1037234 48 12.1037234 48 11.1728723 55.3445376 11.1728723 55.490105 12.1037234zM71.9837349 11.1728723L68.9665195 20.8537234 68.093115 20.8537234 65.2082336 12.5691489 62.3365855 20.8537234 61.4896479 20.8537234 58.4988992 11.3058511 59.5046377 11.0797872 61.9792837 19.2579787 64.7185977 11.1728723 65.7375696 11.1728723 68.5165839 19.2579787 70.9515297 11.1728723 71.9837349 11.1728723zM76.9775393 20.8138298L75.9718008 20.8138298 75.9718008 11.1728723 76.9775393 11.1728723 76.9775393 20.8138298zM86.6295009 20.8138298L81.653742 20.8138298 81.653742 11.1728723 82.6462471 11.1728723 82.6462471 19.8829787 86.4839334 19.8829787 86.6295009 20.8138298zM91.3983374 20.8138298L90.3925989 20.8138298 90.3925989 11.1728723 91.3983374 11.1728723 91.3983374 20.8138298zM104.636551 15.9867021C104.636551 18.9388298 102.783874 21 100.110727 21 97.4375805 21 95.6113711 18.9521277 95.6113711 16.0132979 95.6113711 13.0478723 97.4640473 11 100.137194 11 102.810341 11 104.636551 13.0345745 104.636551 15.9867021zM103.591112 16C103.591112 13.5531915 102.214838 11.9042553 100.110727 11.9042553 98.0198501 11.9042553 96.6435764 13.5531915 96.6435764 15.9867021 96.6435764 18.4468085 98.0330835 20.0824468 100.123961 20.0824468 102.228072 20.0824468 103.591112 18.4468085 103.591112 16zM119.030882 12.1037234L115.021161 12.1037234 115.021161 15.4680851 118.223644 15.4680851 118.369212 16.3856383 115.021161 16.3856383 115.021161 20.8138298 114.028656 20.8138298 114.028656 11.1728723 119.030882 11.1728723 119.030882 12.1037234zM127.809439 20.8138298L122.83368 20.8138298 122.83368 11.1728723 123.826185 11.1728723 123.826185 19.8829787 127.663872 19.8829787 127.809439 20.8138298zM136.812964 20.8138298L131.479903 20.8138298 131.479903 11.1728723 136.667397 11.1728723 136.667397 12.1037234 132.472408 12.1037234 132.472408 15.3085106 135.793992 15.3085106 135.939559 16.2393617 132.472408 16.2393617 132.472408 19.8962766 136.812964 19.8962766 136.812964 20.8138298zM148 20.6808511L146.994262 20.893617 143.950579 16.5053191 141.012764 20.8138298 139.914392 20.8138298 143.381543 15.8005319 140.25846 11.3191489 141.250965 11.106383 143.963813 15.0691489 146.610493 11.1728723 147.708865 11.1728723 144.532849 15.7739362 148 20.6808511z"
          })))));
        }, t.displayName = "ErrorMessage", t.defaultProps = {
          title: "Error",
          hideBranding: !1
        }, t = i([c.withTheme], t);
      }(a.PureComponent);
    t.ErrorMessage = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ActionsWrapper = t.ErrorMessageWrapper = t.ErrorMessageBranding = void 0;
    var o,
      i,
      a,
      l = n(1);
    t.ErrorMessageBranding = l.styled("div")(o || (o = r(["\n    position: absolute;\n    bottom: 40px;\n"], ["\n    position: absolute;\n    bottom: 40px;\n"]))), t.ErrorMessageWrapper = l.styled("div")(i || (i = r(["\n    background-color: ", ";\n    color: ", ";\n    text-align: center;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    padding: 16px;\n    box-sizing: border-box;\n    position: relative;\n\n    h2 {\n        font-size: 18px;\n        font-weight: normal;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 1.78;\n        letter-spacing: normal;\n        margin: 8px;\n        max-width: 640px;\n    }\n\n    h3 {\n        font-size: 14px;\n        font-weight: normal;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 1.71;\n        letter-spacing: normal;\n        margin-bottom: 24px;\n        max-width: 640px;\n    }\n"], ["\n    background-color: ", ";\n    color: ", ";\n    text-align: center;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    padding: 16px;\n    box-sizing: border-box;\n    position: relative;\n\n    h2 {\n        font-size: 18px;\n        font-weight: normal;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 1.78;\n        letter-spacing: normal;\n        margin: 8px;\n        max-width: 640px;\n    }\n\n    h3 {\n        font-size: 14px;\n        font-weight: normal;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 1.71;\n        letter-spacing: normal;\n        margin-bottom: 24px;\n        max-width: 640px;\n    }\n"])), function (e) {
      return e.theme.colors.base1;
    }, function (e) {
      return e.theme.colors.base11;
    }), t.ActionsWrapper = l.styled("div")(a || (a = r(["\n    button {\n        margin: 0 8px;\n    }\n"], ["\n    button {\n        margin: 0 8px;\n    }\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FiltersListItemType = t.FilterDefinition = t.FiltersListProps = t.FiltersList = void 0;
    var r = n(83);
    Object.defineProperty(t, "FiltersList", {
      enumerable: !0,
      get: function get() {
        return r.FiltersList;
      }
    }), Object.defineProperty(t, "FiltersListProps", {
      enumerable: !0,
      get: function get() {
        return r.FiltersListProps;
      }
    }), Object.defineProperty(t, "FilterDefinition", {
      enumerable: !0,
      get: function get() {
        return r.FilterDefinition;
      }
    }), Object.defineProperty(t, "FiltersListItemType", {
      enumerable: !0,
      get: function get() {
        return r.FiltersListItemType;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FiltersListHeaderProps = t.FiltersListHeader = void 0;
    var r = n(381);
    Object.defineProperty(t, "FiltersListHeader", {
      enumerable: !0,
      get: function get() {
        return r.FiltersListHeader;
      }
    }), Object.defineProperty(t, "FiltersListHeaderProps", {
      enumerable: !0,
      get: function get() {
        return r.FiltersListHeaderProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r54,
      o = this && this.__extends || (_r54 = function r(e, t) {
        return (_r54 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r54(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FiltersListHeader = void 0;
    var i = n(0),
      a = n(382),
      l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.headerLabel,
            n = e.resetLabel,
            r = e.applyLabel,
            o = e.handleResetClick,
            l = e.applyButtonDisabled,
            s = e.resetButtonDisabled;
          return i.createElement(a.SubHeader, {
            className: "Twilio-FilterListHeader-SubHeader",
            key: "sub-header",
            noGrow: !0
          }, i.createElement(a.Label, {
            className: "Twilio-FilterListHeader-Label"
          }, t), i.createElement(a.ApplyButton, {
            className: "Twilio-FilterListHeader-ApplyButton",
            roundCorners: !1,
            disabled: l
          }, r), i.createElement(a.ResetButton, {
            className: "Twilio-FilterListHeader-ResetButton",
            roundCorners: !1,
            onClick: o,
            disabled: s,
            type: "button"
          }, n));
        }, t.defaultProps = {
          applyButtonDisabled: !1,
          resetButtonDisabled: !1
        }, t;
      }(i.PureComponent);
    t.FiltersListHeader = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ResetButton = t.ApplyButton = t.Label = t.SubHeader = void 0;
    var o,
      i,
      a,
      l,
      s = n(1),
      c = n(23),
      u = n(6);
    t.SubHeader = s.styled(u.FlexBox)(o || (o = r(["\n    flex-grow: 0;\n    align-items: center;\n    margin-top: 12px;\n    margin-bottom: 12px;\n    padding-left: 16px;\n    padding-right: 8px;\n"], ["\n    flex-grow: 0;\n    align-items: center;\n    margin-top: 12px;\n    margin-bottom: 12px;\n    padding-left: 16px;\n    padding-right: 8px;\n"]))), t.Label = s.styled("div")(i || (i = r(["\n    margin: 0 auto 0 0;\n\n    strong {\n        font-weight: bold;\n    }\n"], ["\n    margin: 0 auto 0 0;\n\n    strong {\n        font-weight: bold;\n    }\n"]))), t.ApplyButton = s.styled(c.Button)(a || (a = r(["\n    color: white;\n    text-transform: uppercase;\n    margin-right: 5px;\n\n    ", ";\n"], ["\n    color: white;\n    text-transform: uppercase;\n    margin-right: 5px;\n\n    ", ";\n"])), function (e) {
      return e.theme.FilterList.ApplyButton;
    }), t.ResetButton = s.styled(c.Button)(l || (l = r(["\n    text-transform: uppercase;\n    font-weight: normal;\n    border: 1px solid;\n\n    ", "\n"], ["\n    text-transform: uppercase;\n    font-weight: normal;\n    border: 1px solid;\n\n    ", "\n"])), function (e) {
      return e.theme.FilterList.ResetButton;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FiltersListItemProps = t.FiltersListItem = void 0;
    var r = n(384);
    Object.defineProperty(t, "FiltersListItem", {
      enumerable: !0,
      get: function get() {
        return r.FiltersListItem;
      }
    }), Object.defineProperty(t, "FiltersListItemProps", {
      enumerable: !0,
      get: function get() {
        return r.FiltersListItemProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r55,
      o = this && this.__extends || (_r55 = function r(e, t) {
        return (_r55 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r55(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FiltersListItem = void 0;
    var i = n(0),
      a = n(2),
      l = n(11),
      s = n(4),
      c = n(84),
      u = n(83),
      p = n(86),
      d = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.handleChange = function (e) {
            t.props.handleChange(e);
          }, t.getOptionFromValue = function (e) {
            return e && t.props.options.find(function (t) {
              return t.value === e;
            });
          }, t.handleExtendClick = function (e) {
            var n = t.props,
              r = n.handleExpandClick,
              o = n.id;
            e.preventDefault(), r(o);
          }, t.provideIdToOption = function (e) {
            return function (t) {
              return t.id = t.value + "___" + e, t;
            };
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.title,
            n = e.showExpandToggle,
            r = e.isExpanded,
            o = e.id;
          return i.createElement(p.Container, {
            className: "Twilio-FilterListItem-Container",
            isExpanded: r,
            showExpandToggle: n
          }, i.createElement(p.Header, {
            className: "Twilio-FilterListItem-Header",
            htmlFor: n ? "filterFor" + o : void 0,
            isExpanded: r,
            showExpandToggle: n
          }, i.createElement(p.InnerHeader, null, i.createElement(p.Title, {
            className: "Twilio-FilterListItem-Title"
          }, t), i.createElement(p.Label, {
            className: "Twilio-FilterListItem-Label"
          }, this.renderLabel())), n && i.createElement(p.ExpandIconButton, {
            icon: r ? "Minus" : "Add",
            type: "button",
            id: "filterFor" + o,
            onClick: this.handleExtendClick
          })), i.createElement(p.FieldContainer, {
            className: "Twilio-FilterListItem-FieldContainer",
            isExpanded: r,
            showExpandToggle: n
          }, this.renderField()));
        }, t.prototype.renderLabel = function () {
          var e = this.props,
            t = e.type,
            n = e.currentValue,
            r = e.customStructure,
            o = e.options,
            c = Array.isArray(n) && o && this.getOptionFromValue(n[0]);
          if (r) return r.label ? i.cloneElement(r.label, {
            currentValue: n,
            activeOption: c
          }) : (a.log.error("Please provide a `filter.customStructure.label` ReactElement."), null);
          if (t === u.FiltersListItemType.multiValue) {
            var p = s.templates.FilterItemAmountSelected;
            return (n || []).length ? 1 === n.length && (p = s.templates.FilterItemOnly) : p = s.templates.FilterItemAny, i.createElement(l.Template, {
              source: p,
              amount: Array.isArray(n) && n.length,
              item: c
            });
          }
        }, t.prototype.renderField = function () {
          var e = this.props,
            t = e.type,
            n = e.fieldName,
            r = e.currentValue,
            o = e.options,
            l = e.customStructure;
          return l ? l.field ? i.cloneElement(l.field, {
            options: o,
            currentValue: r,
            name: n,
            handleChange: this.handleChange
          }) : (a.log.error("Please provide a `filter.customStructure.field` ReactElement."), null) : t === u.FiltersListItemType.multiValue ? i.createElement(c.CheckboxGroup, {
            field: {
              options: o.map(this.provideIdToOption(n)),
              attributes: {
                name: n
              }
            },
            handleChange: this.handleChange,
            error: null,
            stateData: r || [],
            touched: !1
          }) : void 0;
        }, t;
      }(i.Component);
    t.FiltersListItem = d;
  }, function (e, t, n) {
    "use strict";

    var _r56,
      o = this && this.__extends || (_r56 = function r(e, t) {
        return (_r56 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r56(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var l = e.length - 1; l >= 0; l--) (o = e[l]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      },
      a = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, l = i.length; a < l; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CheckboxGroup = void 0;
    var l = n(0),
      s = n(15),
      c = n(1),
      u = n(85),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.value = [], t.handleCheckboxChange = function (e) {
            var n;
            n = e.target.checked ? a(t.props.stateData.filter(function (t) {
              return t !== e.target.value;
            }), [e.target.value]) : a(t.props.stateData.filter(function (t) {
              return t !== e.target.value;
            })), t.props.handleChange(n);
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.field,
            n = e.error,
            r = e.touched,
            o = t.attributes.required ? " *" : "",
            i = t.label ? t.label + o : null;
          return l.createElement(u.Container, {
            vertical: !0
          }, i && l.createElement(s.Label, null, i), this.renderInputs(), r && n && l.createElement(s.FieldErrorMessage, null, n));
        }, t.prototype.renderInputs = function () {
          var e = this,
            t = this.props,
            n = t.field,
            r = t.stateData,
            o = t.handleBlur;
          return n.options.map(function (t) {
            return l.createElement(u.CheckboxContainer, {
              key: t.value
            }, l.createElement(u.StyledCheckbox, {
              id: t.id || t.value,
              value: t.value,
              name: n.attributes.name,
              required: n.attributes.required,
              readOnly: n.attributes.readOnly,
              checked: (r || []).indexOf(t.value) >= 0,
              onChange: e.handleCheckboxChange,
              onBlur: o,
              color: "primary"
            }), l.createElement(u.StyledCheckboxLabel, {
              htmlFor: t.id || t.value
            }, t.label));
          });
        }, t = i([c.withTheme], t);
      }(l.PureComponent);
    t.CheckboxGroup = p;
  }, function (e, t) {
    e.exports = require("@material-ui/core/Checkbox");
  }, function (e, t, n) {
    "use strict";

    var _r57,
      o = this && this.__extends || (_r57 = function r(e, t) {
        return (_r57 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r57(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LegacyFiltersItem = void 0;
    var i = n(0),
      a = n(76),
      l = n(4),
      s = n(86),
      c = n(87),
      u = n(85),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            isSelectOpen: !1
          }, t.handleSelectOpen = function () {
            t.setState({
              isSelectOpen: !0
            });
          }, t.handleSelectClose = function () {
            t.setState({
              isSelectOpen: !1
            });
          }, t.handleSelectChange = function (e) {
            t.props.onSelectLegacyFilterQuery(e.target.value);
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          return i.createElement(s.Container, {
            className: "Twilio-FilterListItem-Container",
            isExpanded: !0,
            showExpandToggle: !1
          }, i.createElement(s.Header, {
            className: "Twilio-FilterListItem-Header",
            isExpanded: !1,
            showExpandToggle: !1
          }, i.createElement(s.InnerHeader, null, i.createElement(s.Title, {
            className: "Twilio-FilterListItem-Title"
          }, i.createElement(l.Template, {
            source: l.templates.LegacyFiltersTitle
          })))), i.createElement(s.FieldContainer, {
            className: "Twilio-FilterListItem-FieldContainer",
            isExpanded: !0,
            showExpandToggle: !1
          }, i.createElement(u.CheckboxContainer, null, i.createElement(c.StyledSelect, {
            open: this.state.isSelectOpen,
            onClose: this.handleSelectClose,
            onOpen: this.handleSelectOpen,
            value: this.props.selectedLegacyFilterQuery,
            onChange: this.handleSelectChange,
            displayEmpty: !0,
            error: !1
          }, i.createElement(a.MenuItem, {
            key: "none",
            value: ""
          }, i.createElement(l.Template, {
            source: l.templates.LegacyFiltersEmptySelectLabel
          })), this.props.filters.map(function (e) {
            return i.createElement(a.MenuItem, {
              key: e.query,
              value: e.query
            }, e.text || e.query);
          })))));
        }, t;
      }(i.Component);
    t.LegacyFiltersItem = p;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CheckboxGroup = t.ThumbsUpOrDownItem = t.TextareaItem = t.SelectItem = t.RadioItem = t.InputItem = t.FormAttributes = t.DynamicForm = void 0;
    var r = n(389);
    Object.defineProperty(t, "DynamicForm", {
      enumerable: !0,
      get: function get() {
        return r.DynamicForm;
      }
    }), Object.defineProperty(t, "FormAttributes", {
      enumerable: !0,
      get: function get() {
        return r.FormAttributes;
      }
    });
    var o = n(88);
    Object.defineProperty(t, "InputItem", {
      enumerable: !0,
      get: function get() {
        return o.InputItem;
      }
    });
    var i = n(91);
    Object.defineProperty(t, "RadioItem", {
      enumerable: !0,
      get: function get() {
        return i.RadioItem;
      }
    });
    var a = n(89);
    Object.defineProperty(t, "SelectItem", {
      enumerable: !0,
      get: function get() {
        return a.SelectItem;
      }
    });
    var l = n(90);
    Object.defineProperty(t, "TextareaItem", {
      enumerable: !0,
      get: function get() {
        return l.TextareaItem;
      }
    });
    var s = n(92);
    Object.defineProperty(t, "ThumbsUpOrDownItem", {
      enumerable: !0,
      get: function get() {
        return s.ThumbsUpOrDownItem;
      }
    });
    var c = n(84);
    Object.defineProperty(t, "CheckboxGroup", {
      enumerable: !0,
      get: function get() {
        return c.CheckboxGroup;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), o(n(390), t), o(n(15), t);
  }, function (e, t, n) {
    "use strict";

    var _r58,
      o = this && this.__extends || (_r58 = function r(e, t) {
        return (_r58 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r58(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.DynamicForm = void 0;
    var a = n(0),
      l = n(88),
      s = n(89),
      c = n(90),
      u = n(91),
      p = n(92),
      d = n(15),
      f = n(4),
      h = {
        InputItem: l.InputItem,
        SelectItem: s.SelectItem,
        TextareaItem: c.TextareaItem,
        RadioItem: u.RadioItem,
        ThumbsUpOrDownItem: p.ThumbsUpOrDownItem
      },
      m = function (e) {
        function t() {
          var n = null !== e && e.apply(this, arguments) || this;
          return n.state = {
            formData: {},
            errors: {},
            touchedFields: {},
            submitDisabled: !1,
            mounted: !1
          }, n.submitForm = function (e) {
            e.preventDefault();
            var r = n.props,
              o = r.formAttributes,
              i = o.fields,
              a = o.name,
              l = r.submitFormCallback,
              s = t.getErrors(i, n.state.formData);
            t.hasErrors(s) ? n.setState({
              errors: s
            }) : l && l(n.state.formData, a);
          }, n.handleChange = function (e) {
            var r = e.target;
            n.setState(function (e) {
              var o,
                a,
                l = n.props.formAttributes.fields.find(function (e) {
                  return e.attributes.name === r.name;
                }),
                s = i(i({}, e.formData), "checkbox" === l.attributes.type ? ((o = {})[r.name] = r.checked, o) : ((a = {})[r.name] = r.value || "", a)),
                c = t.validateField(s, e.errors, l);
              return {
                formData: s,
                errors: c,
                submitDisabled: t.hasErrors(c)
              };
            });
          }, n.handleBlur = function (e) {
            var t = e.target;
            n.state.touchedFields[t.name] || n.setState(function (e) {
              var n;
              return {
                touchedFields: i(i({}, e.touchedFields), (n = {}, n[t.name] = !0, n))
              };
            });
          }, n;
        }
        return o(t, e), t.getDerivedStateFromProps = function (e, n) {
          var r = e.formAttributes,
            o = n.mounted ? n.formData : r.fields.reduce(t.getInitialFieldValue, i({}, n.formData)),
            a = n.mounted ? n.errors : t.getErrors(r.fields, o);
          return i(i({}, n), {
            formData: o,
            errors: a,
            mounted: !0,
            submitDisabled: t.hasErrors(a)
          });
        }, t.getInitialFieldValue = function (e, t) {
          var n = t,
            r = n.options && n.options.find(function (e) {
              return e.selected;
            });
          if (r) e[t.attributes.name] = r.value;else if ("checkbox" === t.attributes.type) e[t.attributes.name] = !1;else {
            var o = t.attributes.value;
            e[t.attributes.name] = void 0 !== o ? o : "";
          }
          return e;
        }, t.validateField = function (e, t, n) {
          var r = n.attributes,
            o = r.required,
            l = r.name,
            s = e[l];
          return o && !s ? t[l] = a.createElement(f.Template, {
            source: f.templates.FieldValidationRequiredField
          }) : "checkbox" === n.attributes.type && o && !s ? t[l] = a.createElement(f.Template, {
            source: f.templates.FieldValidationRequiredField
          }) : "email" === n.attributes.type && s && !s.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) ? t[l] = a.createElement(f.Template, {
            source: f.templates.FieldValidationInvalidEmail
          }) : t[l] = null, i({}, t);
        }, t.prototype.render = function () {
          var e = this,
            t = this.props.formAttributes;
          return a.createElement(d.Form, {
            className: "Twilio-DynamicForm",
            onSubmit: this.submitForm
          }, t.description && a.createElement(d.Description, null, t.description), t.message && a.createElement("div", {
            className: "message"
          }, a.createElement("p", null, t.message)), t.fields.map(function (t, n) {
            var r = h[t.type];
            return r && a.createElement(r, {
              key: n,
              error: e.state.errors[t.attributes.name],
              handleChange: e.handleChange,
              handleBlur: e.handleBlur,
              message: e.props.message,
              stateData: e.state.formData[t.attributes.name],
              touched: e.state.touchedFields[t.attributes.name],
              field: t
            });
          }), a.createElement(d.StyledButton, {
            roundCorners: !0,
            disabled: this.state.submitDisabled,
            className: "Twilio-DynamicForm-submit"
          }, t.submitLabel || "Submit"));
        }, t.getErrors = function (e, n) {
          return e.reduce(t.validateField.bind(null, n), {});
        }, t.hasErrors = function (e) {
          return Object.keys(e).some(function (t) {
            return e[t];
          });
        }, t;
      }(a.Component);
    t.DynamicForm = m;
  }, function (e, t, n) {
    "use strict";

    var _r59,
      o = this && this.__extends || (_r59 = function r(e, t) {
        return (_r59 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r59(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var l = e.length - 1; l >= 0; l--) (o = e[l]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.InputItem = void 0;
    var a = n(0),
      l = n(15),
      s = n(1),
      c = n(392),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.field,
            n = e.error,
            r = e.handleChange,
            o = e.stateData,
            i = e.touched,
            s = e.handleBlur,
            u = a.createElement(c.StyledInput, {
              name: t.attributes.name,
              type: t.attributes.type,
              onChange: r,
              onBlur: s,
              value: o,
              error: i && !!n,
              readOnly: t.attributes.readOnly,
              placeholder: t.attributes.placeholder
            }),
            p = t.attributes.required ? " *" : "",
            d = t.label ? t.label + p : null;
          return a.createElement(c.Container, null, d && a.createElement(l.Label, null, d), u, i && n && a.createElement(l.FieldErrorMessage, null, n));
        }, t = i([s.withTheme], t);
      }(a.PureComponent);
    t.InputItem = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = t.StyledInput = void 0;
    var o,
      i,
      a = n(1),
      l = n(46),
      s = n(15);
    t.StyledInput = a.styled(l.default)(o || (o = r(["\n    width: 100%;\n    box-sizing: border-box;\n    height: 32px;\n    input {\n        padding-left: 6px;\n        padding-right: 6px;\n    }\n"], ["\n    width: 100%;\n    box-sizing: border-box;\n    height: 32px;\n    input {\n        padding-left: 6px;\n        padding-right: 6px;\n    }\n"]))), t.Container = a.styled(s.FieldContainer)(i || (i = r(["\n    ", ";\n"], ["\n    ", ";\n"])), function (e) {
      return e.theme.FormComponents.Input;
    });
  }, function (e, t, n) {
    "use strict";

    var _r60,
      o = this && this.__extends || (_r60 = function r(e, t) {
        return (_r60 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r60(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SelectItem = void 0;
    var i = n(0),
      a = n(15),
      l = n(80),
      s = n(87),
      c = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.field,
            n = e.touched,
            r = e.error,
            o = e.handleBlur,
            c = e.handleChange,
            u = t.attributes.required ? " *" : "",
            p = t.label ? t.label + u : null,
            d = i.createElement(s.StyledSelect, {
              name: t.attributes.name,
              onChange: c,
              value: this.props.stateData,
              onBlur: o,
              error: n && !!r,
              readOnly: t.attributes.readOnly
            }, t.options.map(function (e) {
              return i.createElement(l.default, {
                key: e.label + e.value,
                value: e.value
              }, e.label);
            }));
          return i.createElement(s.Container, null, t.label && i.createElement(a.Label, null, p), d, n && r && i.createElement(a.FieldErrorMessage, null, r));
        }, t;
      }(i.PureComponent);
    t.SelectItem = c;
  }, function (e, t, n) {
    "use strict";

    var _r61,
      o = this && this.__extends || (_r61 = function r(e, t) {
        return (_r61 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r61(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var l = e.length - 1; l >= 0; l--) (o = e[l]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TextareaItem = void 0;
    var a = n(0),
      l = n(15),
      s = n(1),
      c = n(395),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.field,
            n = e.error,
            r = e.handleChange,
            o = e.touched,
            i = e.handleBlur,
            s = e.stateData,
            u = t.attributes.required ? " *" : "",
            p = t.label ? t.label + u : null,
            d = a.createElement(c.StyledTextArea, {
              name: t.attributes.name,
              onChange: r,
              onBlur: i,
              error: o && !!n,
              placeholder: t.attributes.placeholder,
              rows: t.attributes.rows,
              readOnly: t.attributes.readOnly,
              value: s,
              multiline: !0
            });
          return a.createElement(c.Container, null, t.label && a.createElement(l.Label, null, p), d, o && n && a.createElement(l.FieldErrorMessage, null, n));
        }, t = i([s.withTheme], t);
      }(a.PureComponent);
    t.TextareaItem = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = t.StyledTextArea = void 0;
    var o,
      i,
      a = n(1),
      l = n(15),
      s = n(46);
    t.StyledTextArea = a.styled(s.default)(o || (o = r(["\n    box-sizing: border-box;\n    width: 100%;\n    resize: none;\n    outline: 0;\n    height: initial;\n    display: block;\n\n    &::placeholder {\n        opacity: 0.5;\n    }\n\n    textarea {\n        padding-left: 6px;\n        padding-right: 6px;\n    }\n"], ["\n    box-sizing: border-box;\n    width: 100%;\n    resize: none;\n    outline: 0;\n    height: initial;\n    display: block;\n\n    &::placeholder {\n        opacity: 0.5;\n    }\n\n    textarea {\n        padding-left: 6px;\n        padding-right: 6px;\n    }\n"]))), t.Container = a.styled(l.FieldContainer)(i || (i = r(["\n    ", ";\n"], ["\n    ", ";\n"])), function (e) {
      return e.theme.FormComponents.TextArea;
    });
  }, function (e, t, n) {
    "use strict";

    var _r62,
      o = this && this.__extends || (_r62 = function r(e, t) {
        return (_r62 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r62(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.RadioItem = void 0;
    var i = n(0),
      a = n(397),
      l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props.field,
            t = i.createElement("input", {
              name: e.attributes.name,
              type: "radio",
              onChange: this.props.handleChange,
              checked: this.props.stateData === e.attributes.value,
              value: e.attributes.value
            }),
            n = this.props.error ? {
              color: "red"
            } : null;
          return i.createElement(a.Container, null, t, e.label ? i.createElement("label", {
            style: n
          }, e.label) : i.createElement("span", null));
        }, t;
      }(i.PureComponent);
    t.RadioItem = l;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = void 0;
    var o,
      i = n(1);
    t.Container = i.styled("div")(o || (o = r(["\n    display: block;\n    clear: both;\n    margin: 5px 0 5px 0;\n\n    label {\n        font-size: 12px;\n        color: #222222;\n        line-height: 1.5;\n        height: 18px;\n        margin-bottom: 4px;\n        margin-left: 7px;\n    }\n"], ["\n    display: block;\n    clear: both;\n    margin: 5px 0 5px 0;\n\n    label {\n        font-size: 12px;\n        color: #222222;\n        line-height: 1.5;\n        height: 18px;\n        margin-bottom: 4px;\n        margin-left: 7px;\n    }\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r63,
      o = this && this.__extends || (_r63 = function r(e, t) {
        return (_r63 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r63(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ThumbsUpOrDownItem = void 0;
    var i = n(0),
      a = n(399),
      l = n(93),
      s = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {}, t.handleClick = function (e) {
            var n;
            t.setState({
              selected: e
            }), e === l.ThumbDirections.up ? n = t.props.field.attributes.upValue : void 0 !== e && (n = t.props.field.attributes.downValue), t.props.handleChange({
              target: {
                value: n,
                name: t.props.field.attributes.name
              }
            });
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          return i.createElement(a.Container, {
            className: "Twilio-ThumbsUpThumbsDown"
          }, i.createElement("div", {
            className: "label"
          }, i.createElement("p", null, this.props.field.label)), i.createElement(a.ItemGroup, null, i.createElement(l.ThumbButton, {
            direction: l.ThumbDirections.up,
            icon: "thumbup",
            selected: this.state.selected === l.ThumbDirections.up,
            handleClick: this.handleClick
          }), i.createElement(l.ThumbButton, {
            direction: l.ThumbDirections.down,
            icon: "thumbdown",
            selected: this.state.selected === l.ThumbDirections.down,
            handleClick: this.handleClick
          })));
        }, t;
      }(i.Component);
    t.ThumbsUpOrDownItem = s;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ItemGroup = t.Container = void 0;
    var o,
      i,
      a = n(1);
    t.Container = a.styled("div")(o || (o = r(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 11px;\n\n    background: #fff;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 11px;\n\n    background: #fff;\n"]))), t.ItemGroup = a.styled("div")(i || (i = r(["\n    display: flex;\n    margin-top: 5px;\n"], ["\n    display: flex;\n    margin-top: 5px;\n"])));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ThumbButtonContainer = void 0;
    var o,
      i = n(1);
    t.ThumbButtonContainer = i.styled("div")(o || (o = r(["\n    cursor: pointer;\n\n    input {\n        opacity: 0;\n        margin: 0;\n        height: 0;\n        width: 0;\n        padding: 0;\n        position: absolute;\n    }\n\n    .circle {\n        width: 44px;\n        height: 44px;\n        border: solid 1px #ffffff;\n        border-radius: 50%;\n        margin: 6px;\n\n        background: #233659;\n\n        .Twilio-Icon {\n            margin-top: 13px;\n        }\n\n        svg {\n            g {\n                fill: #ffffff;\n            }\n        }\n    }\n\n    .circle-selected {\n        width: 44px;\n        height: 44px;\n        border: solid 1px #028cff;\n        border-radius: 50%;\n        background: #028cff;\n        margin: 6px;\n\n        .Twilio-Icon {\n            margin-top: 13px;\n        }\n\n        svg {\n            g {\n                fill: #ffffff;\n            }\n        }\n    }\n"], ["\n    cursor: pointer;\n\n    input {\n        opacity: 0;\n        margin: 0;\n        height: 0;\n        width: 0;\n        padding: 0;\n        position: absolute;\n    }\n\n    .circle {\n        width: 44px;\n        height: 44px;\n        border: solid 1px #ffffff;\n        border-radius: 50%;\n        margin: 6px;\n\n        background: #233659;\n\n        .Twilio-Icon {\n            margin-top: 13px;\n        }\n\n        svg {\n            g {\n                fill: #ffffff;\n            }\n        }\n    }\n\n    .circle-selected {\n        width: 44px;\n        height: 44px;\n        border: solid 1px #028cff;\n        border-radius: 50%;\n        background: #028cff;\n        margin: 6px;\n\n        .Twilio-Icon {\n            margin-top: 13px;\n        }\n\n        svg {\n            g {\n                fill: #ffffff;\n            }\n        }\n    }\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LegendLabelPosition = t.LegendItemProps = t.LegendProps = t.Legend = void 0;
    var r = n(402);
    Object.defineProperty(t, "Legend", {
      enumerable: !0,
      get: function get() {
        return r.Legend;
      }
    }), Object.defineProperty(t, "LegendProps", {
      enumerable: !0,
      get: function get() {
        return r.LegendProps;
      }
    }), Object.defineProperty(t, "LegendItemProps", {
      enumerable: !0,
      get: function get() {
        return r.LegendItemProps;
      }
    });
    var o = n(94);
    Object.defineProperty(t, "LegendLabelPosition", {
      enumerable: !0,
      get: function get() {
        return o.LabelPosition;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r64,
      o = this && this.__extends || (_r64 = function r(e, t) {
        return (_r64 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r64(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Legend = void 0;
    var a = n(0),
      l = n(94),
      s = n(404),
      c = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this,
            t = this.props,
            n = t.items,
            r = t.showLabels;
          return a.createElement(s.Container, null, n.map(function (t) {
            return a.createElement(l.LegendItem, i({
              key: t.label,
              showLabel: r,
              labelPosition: e.props.labelPosition,
              renderMarker: e.props.renderMarker
            }, t));
          }));
        }, t.defaultProps = {
          items: [],
          showLabels: !0
        }, t;
      }(a.PureComponent);
    t.Legend = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Label = t.ValueWrapper = t.Value = t.Disc = t.ItemWrapper = void 0;
    var o,
      i,
      a,
      l,
      s,
      c = n(3);
    t.ItemWrapper = c.default("div")(o || (o = r(["\n    & + & {\n        margin-left: 24px;\n    }\n"], ["\n    & + & {\n        margin-left: 24px;\n    }\n"]))), t.Disc = c.default("dt")(i || (i = r(["\n    height: 8px;\n    width: 8px;\n    line-height: 8px;\n    border-radius: 50%;\n    background-color: ", ";\n    margin-right: 8px;\n"], ["\n    height: 8px;\n    width: 8px;\n    line-height: 8px;\n    border-radius: 50%;\n    background-color: ", ";\n    margin-right: 8px;\n"])), function (e) {
      return e.color || e.theme.calculated.textColor;
    }), t.Value = c.default("dd")(a || (a = r(["\n    color: ", ";\n    font-size: 12px;\n"], ["\n    color: ", ";\n    font-size: 12px;\n"])), function (e) {
      return e.theme.calculated.textColor;
    }), t.ValueWrapper = c.default("div")(l || (l = r(["\n    width: 100%;\n    display: flex;\n    align-items: center;\n"], ["\n    width: 100%;\n    display: flex;\n    align-items: center;\n"]))), t.Label = c.default("div")(s || (s = r(["\n    color: ", ";\n    line-height: 18px;\n    font-size: 10px;\n"], ["\n    color: ", ";\n    line-height: 18px;\n    font-size: 10px;\n"])), function (e) {
      return e.theme.calculated.textColor;
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = void 0;
    var o,
      i = n(3);
    t.Container = i.default("div")(o || (o = r(["\n    display: flex;\n    margin-top: auto;\n    justify-content: space-between;\n"], ["\n    display: flex;\n    margin-top: auto;\n    justify-content: space-between;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MenuItemProps = t.MenuItem = t.StyledUl = t.MenuThemeProps = t.MenuProps = t.Menu = void 0;
    var r = n(406);
    Object.defineProperty(t, "Menu", {
      enumerable: !0,
      get: function get() {
        return r.Menu;
      }
    }), Object.defineProperty(t, "MenuProps", {
      enumerable: !0,
      get: function get() {
        return r.MenuProps;
      }
    }), Object.defineProperty(t, "MenuThemeProps", {
      enumerable: !0,
      get: function get() {
        return r.MenuThemeProps;
      }
    });
    var o = n(95);
    Object.defineProperty(t, "StyledUl", {
      enumerable: !0,
      get: function get() {
        return o.StyledUl;
      }
    });
    var i = n(407);
    Object.defineProperty(t, "MenuItem", {
      enumerable: !0,
      get: function get() {
        return i.MenuItem;
      }
    }), Object.defineProperty(t, "MenuItemProps", {
      enumerable: !0,
      get: function get() {
        return i.MenuItemProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r65,
      o = this && this.__extends || (_r65 = function r(e, t) {
        return (_r65 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r65(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Menu = void 0;
    var l = n(0),
      s = n(3),
      c = n(95),
      u = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.children,
            n = e.className,
            r = a(e, ["children", "className"]);
          return l.createElement(c.StyledUl, i({
            className: s.cx("Twilio-Menu", n)
          }, r), t);
        }, t;
      }(l.PureComponent);
    t.Menu = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MenuItem = void 0;
    var i = n(0),
      a = n(12),
      l = n(408);
    t.MenuItem = function (e) {
      var t = e.children,
        n = e.className,
        s = o(e, ["children", "className"]);
      return i.createElement("li", null, i.createElement(l.StyledButton, r({
        className: a.cx("Twilio-MenuItem", n)
      }, s), t));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledButton = void 0;
    var o,
      i = n(1);
    t.StyledButton = i.styled("button")(o || (o = r(["\n    margin-top: auto;\n    margin-bottom: auto;\n    padding: 6px 12px;\n    width: 100%;\n    white-space: nowrap;\n    border: none;\n    background: none;\n    outline: none;\n    text-align: left;\n\n    font-size: 10px;\n    font-weight: ", ";\n    letter-spacing: 2px;\n\n    ", "\n    color: ", ";\n    ", ""], ["\n    margin-top: auto;\n    margin-bottom: auto;\n    padding: 6px 12px;\n    width: 100%;\n    white-space: nowrap;\n    border: none;\n    background: none;\n    outline: none;\n    text-align: left;\n\n    font-size: 10px;\n    font-weight: ", ";\n    letter-spacing: 2px;\n\n    ", "\n    color: ", ";\n    ", ""])), function (e) {
      return e.selected ? "bold" : "normal";
    }, function (e) {
      return e.theme.Menu.Item;
    }, function (e) {
      return e.styleOverride && e.styleOverride.Item.color;
    }, function (e) {
      return i.getBackgroundWithHoverCSS(e.styleOverride ? e.styleOverride.Item.background : void 0, e.styleOverride ? !!e.styleOverride.Item.lightHover : !!e.theme.Menu.Item.lightHover);
    });
  }, function (e, t, n) {
    "use strict";

    var _r66,
      o = this && this.__extends || (_r66 = function r(e, t) {
        return (_r66 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r66(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ModalPopup = void 0;
    var i = n(0),
      a = n(3),
      l = n(410),
      s = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.handleBlur = function (e) {
            t.props.isOpen && t.props.autoClose && (t.isChildOfRoot(e.relatedTarget) || t.hide(e));
          }, t.setRootElementRef = function (e) {
            t.rootElementRef = e;
          }, t;
        }
        return o(t, e), t.prototype.render = function () {
          var e = 0,
            t = 0;
          if (this.rootElementRef) {
            var n = this.rootElementRef.getBoundingClientRect();
            e = n.bottom, t = this.props.alignRight ? window.innerWidth - n.right : n.left;
          }
          return i.createElement(l.Container, {
            className: a.cx("Twilio-ModalPopup", this.props.className),
            onBlur: this.handleBlur,
            innerRef: this.setRootElementRef
          }, i.createElement(l.ModalContainer, {
            className: "Twilio-ModalPopup-ModalContainer",
            alignRight: this.props.alignRight,
            anchorX: t,
            anchorY: e,
            isOpen: this.props.isOpen
          }, this.props.children));
        }, t.prototype.hide = function (e) {
          void 0 === e && (e = void 0), this.props.onBlur && this.props.onBlur(e);
        }, t.prototype.setEntryControl = function (e) {
          e && (e.onblur = this.handleBlur);
        }, t.prototype.isChildOfRoot = function (e) {
          for (; e;) {
            if (e === this.rootElementRef) return !0;
            e = e.parentElement;
          }
          return !1;
        }, t.displayName = "ModalPopup", t;
      }(i.PureComponent);
    t.ModalPopup = s;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = t.ModalContainer = void 0;
    var o,
      i,
      a = n(3),
      l = n(29);
    t.ModalContainer = a.default("div")(o || (o = r(["\n    position: fixed;\n    top: ", "px;\n    left: ", ";\n    right: ", ";\n    bottom: auto;\n\n    ", "\n"], ["\n    position: fixed;\n    top: ", "px;\n    left: ", ";\n    right: ", ";\n    bottom: auto;\n\n    ", "\n"])), function (e) {
      return e.anchorY;
    }, function (e) {
      return e.alignRight ? "auto" : e.anchorX + "px";
    }, function (e) {
      return e.alignRight ? e.anchorX + "px" : "auto";
    }, function (e) {
      return l.Animations.FadeInOutTransition(e.isOpen);
    }), t.Container = a.default("div")(i || (i = r(["\n    position: relative;\n    z-index: 1300;\n    flex: 1;\n    display: flex;\n"], ["\n    position: relative;\n    z-index: 1300;\n    flex: 1;\n    display: flex;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ModalPopupWithEntryControlProps = t.ModalPopupWithEntryControl = void 0;
    var r = n(412);
    Object.defineProperty(t, "ModalPopupWithEntryControl", {
      enumerable: !0,
      get: function get() {
        return r.ModalPopupWithEntryControl;
      }
    }), Object.defineProperty(t, "ModalPopupWithEntryControlProps", {
      enumerable: !0,
      get: function get() {
        return r.ModalPopupWithEntryControlProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r67,
      o = this && this.__extends || (_r67 = function r(e, t) {
        return (_r67 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r67(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ModalPopupWithEntryControl = void 0;
    var i = n(0),
      a = n(3),
      l = n(96),
      s = n(413),
      c = function (e) {
        function t(t) {
          var n = e.call(this, t) || this;
          return n.visibilityChanged = !1, n.onOpenMenuClick = function () {
            n.isOpen ? n.hide() : n.show();
          }, n.onEntryButtonBlur = function (e) {
            n.modalPopup.handleBlur(e);
          }, n.onModalBlur = function (e) {
            e.relatedTarget !== n.entryButtonRef && n.hide();
          }, n.setEntryControlRef = function (e) {
            n.entryButtonRef = e;
          }, n.setModalPopupRef = function (e) {
            n.modalPopup = e, e && n.modalPopup.setEntryControl(n.entryButtonRef);
          }, n.state = {
            isOpen: !1
          }, n;
        }
        return o(t, e), t.prototype.render = function () {
          var e,
            t = this.props.className,
            n = this.getEntryControl(),
            r = i.cloneElement(n, ((e = {
              onClick: this.onOpenMenuClick,
              onBlur: this.onEntryButtonBlur
            })["function" == typeof n.type ? "innerRef" : "ref"] = this.setEntryControlRef, e));
          return i.createElement(s.Container, {
            className: a.cx("Twilio-ModalPopupWithEntryControl", t)
          }, r, i.createElement(s.Container, {
            className: "Twilio-ModalPopupWithEntryControl-MenuContainer"
          }, i.createElement(l.ModalPopup, {
            alignRight: this.props.alignRight,
            autoClose: this.props.autoClose,
            isOpen: this.state.isOpen,
            onBlur: this.onModalBlur,
            ref: this.setModalPopupRef
          }, this.props.children)));
        }, t.prototype.componentDidUpdate = function () {
          this.visibilityChanged && (this.visibilityChanged = !1, this.props.onChange && this.props.onChange());
        }, Object.defineProperty(t.prototype, "isOpen", {
          get: function get() {
            return this.state.isOpen;
          },
          enumerable: !1,
          configurable: !0
        }), t.prototype.show = function () {
          this.state.isOpen || (this.visibilityChanged = !0, this.setState({
            isOpen: !0
          }));
        }, t.prototype.hide = function () {
          this.state.isOpen && (this.visibilityChanged = !0, this.setState({
            isOpen: !1
          }));
        }, t.prototype.getEntryControl = function () {
          var e = this.props.entryControl;
          return "function" == typeof e ? e(this.state.isOpen) : e;
        }, t.defaultProps = {
          className: ""
        }, t;
      }(i.Component);
    t.ModalPopupWithEntryControl = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Container = void 0;
    var o,
      i = n(3);
    t.Container = i.default("div")(o || (o = r(["\n    display: flex;\n    flex-direction: column;\n    flex: 1 0 auto;\n"], ["\n    display: flex;\n    flex-direction: column;\n    flex: 1 0 auto;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NotificationBar = t.NotificationBarItem = void 0;
    var r = n(97);
    Object.defineProperty(t, "NotificationBarItem", {
      enumerable: !0,
      get: function get() {
        return r.NotificationBarItem;
      }
    });
    var o = n(424);
    Object.defineProperty(t, "NotificationBar", {
      enumerable: !0,
      get: function get() {
        return o.NotificationBar;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r68,
      o = this && this.__extends || (_r68 = function r(e, t) {
        return (_r68 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r68(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NotificationBarItem = void 0;
    var a = n(13),
      l = n(0),
      s = n(98),
      c = n(416),
      u = n(419),
      p = n(4),
      d = n(99),
      f = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.closeIconOnClickHandler = function () {
            a.Notifications.dismissNotification(t.props.notification);
            var e = t.props.notification.recurrenceTimeout;
            e && window.setTimeout(function () {
              return a.Notifications.showNotification(t.props.notification.id);
            }, e);
          }, t.handleOnClick = function (e) {
            t.props.notification.onClick && t.props.notification.onClick(e);
          }, t.renderActionItem = function (e, n) {
            if (l.isValidElement(e)) {
              var r = i({}, e.props);
              e.type === d.NotificationBarAction ? e = l.cloneElement(e, i(i({}, e.props), {
                notification: t.props.notification
              })) : "function" == typeof r.onClick && (e = l.cloneElement(e, i(i({}, e.props), {
                onClick: function onClick(e) {
                  return r.onClick(e, t.props.notification);
                }
              })));
            }
            return l.createElement(s.ActionItemContainer, {
              key: n,
              className: "Twilio-NotificationBar-ActionItemContainer"
            }, e);
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          var e = this,
            t = this.props.notification.timeout;
          t && (this.timeoutID = window.setTimeout(function () {
            return e.closeIconOnClickHandler();
          }, t));
        }, t.prototype.componentWillUnmount = function () {
          this.timeoutID && window.clearTimeout(this.timeoutID);
        }, t.prototype.render = function () {
          var e = this.props.notification,
            t = e.type,
            n = e.icon,
            r = e.backgroundColor,
            o = e.closeButton,
            i = e.content,
            a = e.context,
            p = e.actions;
          return l.createElement(s.NotificationContainer, {
            className: "Twilio-NotificationBar-NotificationContainer",
            type: t,
            backgroundColor: r
          }, l.createElement(c.TypeIcon, {
            customIcon: n,
            type: t
          }), l.createElement(s.MessageContainer, {
            onClick: this.handleOnClick,
            className: "Twilio-NotificationBar-MessageContainer"
          }, this.renderMessageContent(i, a)), Array.isArray(p) && p.length && l.createElement(s.ActionsContainer, {
            closeButton: o,
            className: "Twilio-NotificationBar-ActionsContainer"
          }, p.map(this.renderActionItem)), o && l.createElement(u.CloseIcon, {
            onClick: this.closeIconOnClickHandler
          }), l.createElement(s.BottomBorder, null));
        }, t.prototype.renderMessageContent = function (e, t) {
          if ("string" == typeof e && p.templates[e]) return l.createElement(p.Template, i({
            source: p.templates[e]
          }, t));
          if (l.isValidElement(e)) {
            var n = e;
            return l.cloneElement(n, i(i({}, e.props), {
              notificationContext: t
            }));
          }
          return e;
        }, t;
      }(l.PureComponent);
    t.NotificationBarItem = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NotificationIcon = t.TypeIcon = void 0;
    var r = n(417);
    Object.defineProperty(t, "TypeIcon", {
      enumerable: !0,
      get: function get() {
        return r.TypeIcon;
      }
    }), Object.defineProperty(t, "NotificationIcon", {
      enumerable: !0,
      get: function get() {
        return r.NotificationIcon;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r69,
      o = this && this.__extends || (_r69 = function r(e, t) {
        return (_r69 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r69(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__decorate || function (e, t, n, r) {
        var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var l = e.length - 1; l >= 0; l--) (o = e[l]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TypeIcon = t.NotificationIcon = void 0;
    var a,
      l = n(0),
      s = n(13),
      c = n(7),
      u = n(1),
      p = n(418);
    !function (e) {
      e.information = "Info", e.success = "Accept", e.warning = "AlertTriangle", e.error = "Alert";
    }(a = t.NotificationIcon || (t.NotificationIcon = {}));
    var d = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.render = function () {
        var e,
          t,
          n = this.props,
          r = n.customIcon,
          o = n.type;
        if (r) e = r;else switch (o) {
          case s.NotificationType.success:
            e = a.success;
            break;
          case s.NotificationType.warning:
            e = a.warning, t = this.props.theme.colors.notificationIconColorWarning;
            break;
          case s.NotificationType.error:
            e = a.error, t = this.props.theme.colors.notificationIconColorError;
            break;
          default:
            e = a.information;
        }
        return l.createElement(p.NotificationIconContainer, {
          className: "Twilio-NotificationBar-IconTypeContainer",
          iconColor: t
        }, l.createElement(c.Icon, {
          icon: e
        }));
      }, t = i([u.withTheme], t);
    }(l.PureComponent);
    t.TypeIcon = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NotificationIconContainer = void 0;
    var o,
      i = n(1);
    t.NotificationIconContainer = i.styled("div")(o || (o = r(["\n    width: 24px;\n    max-height: 24px;\n    color: ", ";\n"], ["\n    width: 24px;\n    max-height: 24px;\n    color: ", ";\n"])), function (e) {
      return e.iconColor;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CloseIconProps = t.CloseIcon = void 0;
    var r = n(420);
    Object.defineProperty(t, "CloseIcon", {
      enumerable: !0,
      get: function get() {
        return r.CloseIcon;
      }
    }), Object.defineProperty(t, "CloseIconProps", {
      enumerable: !0,
      get: function get() {
        return r.CloseIconProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r70,
      o = this && this.__extends || (_r70 = function r(e, t) {
        return (_r70 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r70(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CloseIcon = void 0;
    var i = n(0),
      a = n(7),
      l = n(421),
      s = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          return i.createElement(l.IconButtonContainer, {
            onClick: this.props.onClick,
            className: "Twilio-NotificationBar-IconButtonContainer"
          }, i.createElement(a.Icon, {
            icon: "Close"
          }));
        }, t;
      }(i.PureComponent);
    t.CloseIcon = s;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IconButtonContainer = void 0;
    var o,
      i = n(1);
    t.IconButtonContainer = i.styled("div")(o || (o = r(["\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n"], ["\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n"])));
  }, function (e, t, n) {
    "use strict";

    var _r71,
      o = this && this.__extends || (_r71 = function r(e, t) {
        return (_r71 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r71(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__makeTemplateObject || function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      },
      a = this && this.__assign || function () {
        return (a = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ActionItem = t.NotificationBarAction = void 0;
    var l,
      s = n(0),
      c = n(4),
      u = n(7),
      p = n(1),
      d = function (e) {
        function n() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.handleOnClick = function (e) {
            return t.props.onClick(e, t.props.notification);
          }, t;
        }
        return o(n, e), n.prototype.render = function () {
          return s.createElement(t.ActionItem, {
            onClick: this.handleOnClick
          }, this.renderIcon(), this.renderLabel());
        }, n.prototype.renderIcon = function () {
          return this.props.icon && s.createElement(u.Icon, {
            icon: this.props.icon
          });
        }, n.prototype.renderLabel = function () {
          var e = this.props,
            t = e.notification,
            n = e.label;
          return "string" == typeof n && c.templates[n] ? s.createElement(c.Template, a({
            source: c.templates[n]
          }, t.context)) : n;
        }, n.defaultProps = {
          notification: {}
        }, n;
      }(s.PureComponent);
    t.NotificationBarAction = d, t.ActionItem = p.styled("div")(l || (l = i(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 12;\n    text-transform: uppercase;\n    cursor: pointer;\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 12;\n    text-transform: uppercase;\n    cursor: pointer;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    var _r72,
      o = this && this.__extends || (_r72 = function r(e, t) {
        return (_r72 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r72(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.NotificationBar = void 0;
    var i = n(0),
      a = n(100),
      l = n(98),
      s = n(97),
      c = n(101),
      u = n(99),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onListenerHandler = function () {
            t.forceUpdate();
          }, t;
        }
        return o(t, e), t.prototype.componentDidMount = function () {
          c.InAppNotificationHandlerImpl.onChange = this.onListenerHandler;
        }, t.prototype.componentWillUnmount = function () {
          c.InAppNotificationHandlerImpl.onChange = void 0;
        }, t.prototype.render = function () {
          return i.createElement(l.NotificationBarContainer, {
            className: "Twilio-NotificationBar"
          }, c.InAppNotificationHandler.getActiveNotifications().map(function (e) {
            return i.createElement(s.NotificationBarItem, {
              key: a.v4(),
              notification: e
            });
          }));
        }, t.Action = u.NotificationBarAction, t;
      }(i.Component);
    t.NotificationBar = p;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SidePanelProps = t.SidePanel = void 0;
    var r = n(426);
    Object.defineProperty(t, "SidePanel", {
      enumerable: !0,
      get: function get() {
        return r.SidePanel;
      }
    }), Object.defineProperty(t, "SidePanelProps", {
      enumerable: !0,
      get: function get() {
        return r.SidePanelProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r73,
      o = this && this.__extends || (_r73 = function r(e, t) {
        return (_r73 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r73(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SidePanel = void 0;
    var i = n(0),
      a = n(427),
      l = n(9),
      s = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.children,
            n = e.displayName,
            r = e.contentStore,
            o = e.isHidden,
            s = e.childrenProps,
            c = e.className;
          return r ? i.createElement(a.Wrapper, {
            className: c,
            isHidden: o
          }, i.createElement(l.DynamicComponent, {
            contentStore: r,
            name: n,
            childProps: s,
            customChildren: t,
            vertical: !0
          }, this.renderContent())) : i.createElement(a.Wrapper, {
            className: c,
            isHidden: o
          }, this.renderContent());
        }, t.prototype.renderContent = function () {
          var e = this.props,
            t = e.children,
            n = e.themeOverride,
            r = e.displayName;
          return i.createElement(a.MainContainer, {
            noShrink: !0,
            vertical: !0,
            themeOverride: n.Container,
            className: "Twilio-SidePanel-Container Twilio-SidePanel-" + r + "-Container"
          }, this.renderHeader(), t);
        }, t.prototype.renderHeader = function () {
          var e = this.props,
            t = e.title,
            n = e.HeaderComponent,
            r = e.themeOverride,
            o = e.handleCloseClick,
            l = e.displayName;
          return n || i.createElement(a.HeaderContainer, {
            themeOverride: r.Header,
            key: "header",
            noShrink: !0,
            noGrow: !0,
            className: "Twilio-SidePanel-HeaderContainer Twilio-SidePanel-" + l + "-HeaderContainer"
          }, i.createElement(a.StyledIconButton, {
            key: "close-button",
            icon: "Close",
            onClick: o,
            themeOverride: r.HeaderButton,
            className: "Twilio-SidePanel-IconButton Twilio-SidePanel-" + l + "-IconButton"
          }), i.createElement(a.Title, {
            className: "Twilio-SidePanel-Title Twilio-SidePanel-" + l + "-Title",
            hasRightButton: !!this.props.rightButton
          }, t), this.props.rightButton);
        }, t.defaultProps = {
          isHidden: !1,
          childrenProps: {},
          themeOverride: {}
        }, t;
      }(i.PureComponent);
    t.SidePanel = s;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledIconButton = t.MainContainer = t.Wrapper = t.HeaderContainer = t.Title = void 0;
    var o,
      i,
      a,
      l,
      s,
      c = n(6),
      u = n(1),
      p = n(18);
    t.Title = u.styled(c.FlexBox)(o || (o = r(["\n    align-items: center;\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: 3px;\n    justify-content: center;\n    text-transform: uppercase;\n    padding-right: ", ";\n"], ["\n    align-items: center;\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: 3px;\n    justify-content: center;\n    text-transform: uppercase;\n    padding-right: ", ";\n"])), function (e) {
      return e.hasRightButton ? 0 : "44px";
    }), t.HeaderContainer = u.styled(c.FlexBox)(i || (i = r(["\n    height: 44px;\n    padding-left: 11px;\n    padding-right: 11px;\n    align-items: center;\n    ", "\n    ", "\n"], ["\n    height: 44px;\n    padding-left: 11px;\n    padding-right: 11px;\n    align-items: center;\n    ", "\n    ", "\n"])), function (e) {
      return e.theme.SidePanel.Header;
    }, function (e) {
      return e.themeOverride;
    }), t.Wrapper = u.styled("div")(a || (a = r(["\n    display: ", ";\n    flex-direction: column;\n    flex-shrink: 0;\n    flex-grow: 1;\n    width: 320px;\n"], ["\n    display: ", ";\n    flex-direction: column;\n    flex-shrink: 0;\n    flex-grow: 1;\n    width: 320px;\n"])), function (e) {
      return e.isHidden ? "none" : "flex";
    }), t.MainContainer = u.styled(c.FlexBox)(l || (l = r(["\n    border-width: 0 0 0 1px;\n    border-style: solid;\n    ", "\n    ", "\n"], ["\n    border-width: 0 0 0 1px;\n    border-style: solid;\n    ", "\n    ", "\n"])), function (e) {
      return e.theme.SidePanel.Container;
    }, function (e) {
      return e.themeOverride;
    }), t.StyledIconButton = u.styled(p.IconButton)(s || (s = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.themeOverride;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.LastSplitterState = t.SplitContentContainerState = t.SplitContentContainerProps = t.SplitContentContainer = void 0;
    var r = n(429);
    Object.defineProperty(t, "SplitContentContainer", {
      enumerable: !0,
      get: function get() {
        return r.SplitContentContainer;
      }
    }), Object.defineProperty(t, "SplitContentContainerProps", {
      enumerable: !0,
      get: function get() {
        return r.SplitContentContainerProps;
      }
    }), Object.defineProperty(t, "SplitContentContainerState", {
      enumerable: !0,
      get: function get() {
        return r.SplitContentContainerState;
      }
    }), Object.defineProperty(t, "LastSplitterState", {
      enumerable: !0,
      get: function get() {
        return r.LastSplitterState;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r74,
      o = this && this.__extends || (_r74 = function r(e, t) {
        return (_r74 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r74(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SplitContentContainer = t.LastSplitterState = void 0;
    var i = n(0),
      a = n(3),
      l = n(2),
      s = n(430);
    function c() {
      window.getSelection && (window.getSelection().empty ? window.getSelection().empty() : window.getSelection().removeAllRanges && window.getSelection().removeAllRanges());
    }
    var u = function u() {};
    t.LastSplitterState = u;
    var p = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        return n.lastState = {
          hasManuallyResized: !1,
          firstPanelSize: 0
        }, n.handleWindowResize = function () {
          n.reInit();
        }, n.handleMouseMove = function (e) {
          if (n.state.resizing) {
            if (0 === e.buttons) return void n.setState({
              resizing: !1
            });
            n.hasManuallyResized = !0, c();
            var t = n.props.vertical ? n.mouseDownY - e.clientY : n.mouseDownX - e.clientX;
            n.setState({
              firstPanelSize: n.clampSize(n.firstPanelSizeAtResize - t)
            }), n.props.onResize && n.props.onResize();
          }
        }, n.handleSplitterMouseDown = function (e) {
          c(), n.mouseDownX = e.clientX, n.mouseDownY = e.clientY, n.firstPanelSizeAtResize = n.state.firstPanelSize, n.setState({
            resizing: !0
          });
        }, n.handleMouseUp = function () {
          n.setState({
            resizing: !1
          });
        }, n.setContainer = function (e) {
          n.container = e;
        }, n.setSplitterDOM = function (e) {
          n.splitterDOM = e;
        }, n.state = {
          firstPanelSize: 0,
          mainContainerSize: 0,
          resizing: !1
        }, n;
      }
      return o(t, e), t.prototype.componentDidMount = function () {
        var e = this;
        window.addEventListener("resize", this.handleWindowResize), window.addEventListener("mousemove", this.handleMouseMove), document.addEventListener("mouseup", this.handleMouseUp), "IntersectionObserver" in window && (this.onIntersection = new IntersectionObserver(function (t) {
          return e.reInit();
        }), this.onIntersection.observe(this.container)), this.props.lastSplitterState ? (this.lastState.hasManuallyResized = this.props.lastSplitterState.hasManuallyResized, this.lastState.firstPanelSize = this.props.lastSplitterState.firstPanelSize, this.initBasedOnLastState()) : this.reInit();
      }, t.prototype.componentDidUpdate = function (e) {
        e.vertical !== this.props.vertical && this.initBasedOnLastState();
      }, t.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.handleWindowResize), window.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), this.onIntersection && this.onIntersection.disconnect(), this.props.lastSplitterState && (this.props.lastSplitterState.firstPanelSize = this.state.firstPanelSize, this.props.lastSplitterState.hasManuallyResized = this.hasManuallyResized);
      }, t.prototype.initBasedOnLastState = function () {
        var e,
          t = this.lastState;
        this.lastState = {
          hasManuallyResized: this.hasManuallyResized,
          firstPanelSize: this.state.firstPanelSize
        }, this.hasManuallyResized = t.hasManuallyResized, this.hasManuallyResized && (e = t.firstPanelSize), this.reInit(e);
      }, t.prototype.renderPanel = function (e, t) {
        var n = {};
        if (t) {
          var r = this.state.firstPanelSize + "px";
          this.props.vertical ? n.height = r : n.width = r, n.flex = "0 0 auto";
        } else {
          r = Math.max(0, this.state.mainContainerSize - this.state.firstPanelSize) + "px";
          this.props.vertical ? n.height = r : n.width = r, n.flex = "0 0 auto";
        }
        return i.createElement(s.Pane, {
          className: "Twilio-Splitter-Pane",
          style: n
        }, e);
      }, t.prototype.reInit = function (e, t) {
        void 0 === e && (e = void 0), void 0 === t && (t = this.container);
        var n = t.getBoundingClientRect(),
          r = this.props.vertical ? n.height : n.width;
        if (!r && t.parentNode && t.parentNode.getBoundingClientRect) return this.reInit(e, t.parentNode);
        var o = this.splitterDOM.getBoundingClientRect(),
          i = this.props.vertical ? o.height : o.width;
        this.props.firstMinSize.endsWith("%") ? this.minSize = r * Number(this.props.firstMinSize.substr(0, this.props.firstMinSize.length - 1)) / 100 : this.props.firstMinSize.endsWith("px") ? this.minSize = Number(this.props.firstMinSize.substr(0, this.props.firstMinSize.length - 2)) : this.minSize = Number(this.props.firstMinSize), this.props.secondMinSize.endsWith("%") ? this.maxSize = r * (100 - Number(this.props.secondMinSize.substr(0, this.props.secondMinSize.length - 1))) / 100 : this.props.secondMinSize.endsWith("px") ? this.maxSize = r - Number(this.props.secondMinSize.substr(0, this.props.secondMinSize.length - 2)) : this.maxSize = r - Number(this.props.secondMinSize);
        var a = 0,
          l = this.props.firstInitialSize;
        a = l.endsWith("%") ? r * Number(l.substr(0, l.length - 1)) / 100 : l.endsWith("px") ? Number(l.substr(0, l.length - 2)) : Number(l), this.hasManuallyResized && (a = void 0 === e ? this.state.firstPanelSize : e), this.setState({
          firstPanelSize: this.clampSize(a),
          mainContainerSize: r - i
        });
      }, t.prototype.clampSize = function (e) {
        return Math.min(Math.max(e, this.minSize), this.maxSize);
      }, t.prototype.render = function () {
        var e = this;
        if (2 !== i.Children.count(this.props.children)) return l.log.warn("Splitter needs exactly 2 children!"), null;
        var t = [];
        return i.Children.forEach(this.props.children, function (n, r) {
          t.push(e.renderPanel(n, 0 === r));
        }), i.createElement(s.Main, {
          className: a.cx("Twilio-Splitter", this.props.vertical && "Twilio-Splitter-Vertical"),
          vertical: this.props.vertical,
          resizing: this.state.resizing,
          innerRef: this.setContainer
        }, t[0], i.createElement(s.Separator, {
          vertical: this.props.vertical,
          role: "separator",
          innerRef: this.setSplitterDOM,
          onMouseDown: this.handleSplitterMouseDown
        }, this.props.separator), t[1]);
      }, t;
    }(i.PureComponent);
    t.SplitContentContainer = p;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Pane = t.Separator = t.Main = void 0;
    var o,
      i,
      a,
      l = n(3);
    t.Main = l.default("div")(o || (o = r(["\n    display: flex;\n    flex: 1 1 auto;\n    max-width: 100%;\n    flex-direction: ", ";\n    cursor: ", ";\n    ", "\n    overflow: hidden;\n"], ["\n    display: flex;\n    flex: 1 1 auto;\n    max-width: 100%;\n    flex-direction: ", ";\n    cursor: ", ";\n    ", "\n    overflow: hidden;\n"])), function (e) {
      return e.vertical ? "column" : "row";
    }, function (e) {
      return e.resizing && (e.vertical ? "row-resize" : "col-resize");
    }, function (e) {
      return e.resizing && "\n       iframe {\n        pointer-events: none;\n        }\n    ";
    }), t.Separator = l.default("div")(i || (i = r(["\n    cursor: ", ";\n    position: relative;\n    z-index: 2;\n    ", "\n"], ["\n    cursor: ", ";\n    position: relative;\n    z-index: 2;\n    ", "\n"])), function (e) {
      return e.vertical ? "row-resize" : "col-resize";
    }, function (e) {
      return e.vertical ? '\n        :before{\n            content:"";\n            position: absolute;\n            height: calc(100% + 10px);\n            width: 100%;\n            left: 0px;\n            top: -5px;\n        }' : '\n        :before{\n            content:"";\n            position: absolute;\n            width: calc(100% + 10px);\n            height: 100%;\n            top: 0px;\n            left: -5px;\n        }';
    }), t.Pane = l.default("div")(a || (a = r(["\n    display: flex;\n    overflow: hidden;\n    flex-direction: column;\n"], ["\n    display: flex;\n    overflow: hidden;\n    flex-direction: column;\n"])));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StackedBarChartProps = t.StackedBarChart = void 0;
    var r = n(432);
    Object.defineProperty(t, "StackedBarChart", {
      enumerable: !0,
      get: function get() {
        return r.StackedBarChart;
      }
    }), Object.defineProperty(t, "StackedBarChartProps", {
      enumerable: !0,
      get: function get() {
        return r.StackedBarChartProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r75,
      o = this && this.__extends || (_r75 = function r(e, t) {
        return (_r75 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r75(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StackedBarChart = void 0;
    var i = n(0),
      a = n(12),
      l = n(433),
      s = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return o(t, e), t.prototype.render = function () {
          var e = this.props,
            t = e.items,
            n = e.className,
            r = t.reduce(function (e, t) {
              return e + t.value;
            }, 0);
          return i.createElement(l.Bar, {
            className: a.cx("Twilio-StackedBarChart-Bar", n)
          }, this.props.items.map(function (e) {
            return i.createElement(l.BarFragment, {
              className: "Twilio-StackedBarChart-BarFragment",
              key: e.label,
              percentageValue: 100 * e.value / (r || 1),
              "aria-label": e.label + ": " + e.value,
              title: e.label + ": " + e.value,
              color: e.color,
              tabIndex: 0
            });
          }));
        }, t.defaultProps = {
          className: ""
        }, t;
      }(i.PureComponent);
    t.StackedBarChart = s;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.BarFragment = t.Bar = void 0;
    var o,
      i,
      a = n(3);
    t.Bar = a.default("div")(o || (o = r(["\n    display: flex;\n    margin-top: 4px; // To align with other AggregatedDataTiles\n    margin-bottom: 16px;\n    height: 12px;\n    background-color: ", ";\n"], ["\n    display: flex;\n    margin-top: 4px; // To align with other AggregatedDataTiles\n    margin-bottom: 16px;\n    height: 12px;\n    background-color: ", ";\n"])), function (e) {
      return e.theme.colors.base3;
    }), t.BarFragment = a.default("div")(i || (i = r(["\n    height: 12px;\n    width: ", "%;\n    background-color: ", ";\n\n    &:focus {\n        outline: none;\n    }\n"], ["\n    height: 12px;\n    width: ", "%;\n    background-color: ", ";\n\n    &:focus {\n        outline: none;\n    }\n"])), function (e) {
      return e.percentageValue;
    }, function (e) {
      return e.color;
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TabsProps = t.Tabs = t.TabProps = t.Tab = void 0;
    var r = n(435);
    Object.defineProperty(t, "Tab", {
      enumerable: !0,
      get: function get() {
        return r.Tab;
      }
    }), Object.defineProperty(t, "TabProps", {
      enumerable: !0,
      get: function get() {
        return r.TabProps;
      }
    });
    var o = n(436);
    Object.defineProperty(t, "Tabs", {
      enumerable: !0,
      get: function get() {
        return o.Tabs;
      }
    }), Object.defineProperty(t, "TabsProps", {
      enumerable: !0,
      get: function get() {
        return o.TabsProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r76,
      o = this && this.__extends || (_r76 = function r(e, t) {
        return (_r76 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r76(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Tab = void 0;
    var i = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return o(t, e), t.prototype.render = function () {
        return this.props.children;
      }, t;
    }(n(0).Component);
    t.Tab = i;
  }, function (e, t, n) {
    "use strict";

    var _r77,
      o = this && this.__extends || (_r77 = function r(e, t) {
        return (_r77 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r77(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Tabs = void 0;
    var a = n(0),
      l = n(3),
      s = n(37),
      c = n(437),
      u = n(439),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.state = {
            lastSelectedTabIndex: 0
          }, t;
        }
        return o(t, e), t.prototype.isChildTabVisible = function (e) {
          return !e.props.hidden;
        }, t.prototype.getFirstVisibleTabIndex = function () {
          var e = this;
          return a.Children.toArray(this.props.children).findIndex(function (t) {
            return e.isChildTabVisible(t);
          });
        }, t.prototype.render = function () {
          var e = this,
            t = this.props,
            n = t.children,
            r = t.alignment,
            o = t.selectedTabName,
            p = a.Children.toArray(n).filter(function (e) {
              return e;
            }),
            d = -1;
          o && (d = p.findIndex(function (e) {
            return e.props.uniqueName === o;
          })), -1 === d && (d = this.state.lastSelectedTabIndex), (p.length < d || !this.isChildTabVisible(p[d])) && (d = this.getFirstVisibleTabIndex());
          var f = p.map(function (t, n) {
              return e.isChildTabVisible(t) ? a.createElement(c.TabHeader, i(i({}, t.props), {
                alignment: r,
                setActive: e.handleTabClick.bind(e, n, p[n].props.uniqueName),
                isActive: n === d,
                key: p[n].props.uniqueName
              })) : null;
            }),
            h = p.map(function (t, n) {
              return e.isChildTabVisible(t) ? a.createElement(s.VisibilityContextProvider.Consumer, null, function (e) {
                return a.createElement(s.VisibilityContextProvider.Provider, {
                  value: e && n === d
                }, a.createElement(u.TabContainer, {
                  className: "Twilio-Tab",
                  isActive: n === d
                }, t));
              }) : null;
            });
          return a.createElement(u.Container, {
            className: l.cx("Twilio-Tabs", this.props.className)
          }, a.createElement(u.LabelsContainer, {
            className: "Twilio-Tabs-Labels"
          }, f), a.createElement(u.PanelsContainer, {
            className: "Twilio-Tabs-Panels"
          }, h));
        }, t.prototype.handleTabClick = function (e, t) {
          this.props.onTabSelected ? this.props.onTabSelected(t) : this.setState({
            lastSelectedTabIndex: e
          });
        }, t.defaultProps = {
          alignment: "center"
        }, t;
      }(a.Component);
    t.Tabs = p;
  }, function (e, t, n) {
    "use strict";

    var _r78,
      o = this && this.__extends || (_r78 = function r(e, t) {
        return (_r78 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r78(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TabHeader = void 0;
    var i = n(0),
      a = n(18),
      l = n(438),
      s = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.setActive = function () {
            return t.props.setActive();
          }, t;
        }
        return o(t, e), t.prototype.renderContent = function () {
          var e = this.props,
            t = e.isActive,
            n = e.label,
            r = e.icon,
            o = e.iconActive,
            s = t && o ? o : r;
          return n ? i.createElement(l.TabLabel, {
            isActive: t,
            onClick: this.setActive
          }, n) : i.createElement(l.IconWrapper, null, i.createElement(a.IconButton, {
            themeOverride: this.props.theme.Tabs.Button,
            icon: s,
            onClick: this.setActive
          }));
        }, t.prototype.render = function () {
          var e = this.props,
            t = e.alignment,
            n = e.isActive,
            r = "Twilio-TabHeader-StateIndicator-" + (n ? "Active" : "Inactive");
          return i.createElement(l.TabHeaderContainer, {
            className: "Twilio-TabHeader",
            alignment: t
          }, this.renderContent(), i.createElement(l.TabHeaderIndicatorContainer, {
            className: r,
            isActive: n
          }));
        }, t;
      }(i.Component);
    t.TabHeader = s;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.IconWrapper = t.TabLabel = t.TabHeaderIndicatorContainer = t.TabHeaderContainer = void 0;
    var o,
      i,
      a,
      l,
      s = n(1);
    t.TabHeaderContainer = s.styled("div")(o || (o = r(["\n    display: flex;\n    position: relative;\n    min-width: 44px;\n    flex: 0 1 auto;\n    margin-right: ", ";\n    margin-left: ", ";\n\n    & .Twilio-IconButton {\n        margin: auto;\n    }\n"], ["\n    display: flex;\n    position: relative;\n    min-width: 44px;\n    flex: 0 1 auto;\n    margin-right: ", ";\n    margin-left: ", ";\n\n    & .Twilio-IconButton {\n        margin: auto;\n    }\n"])), function (e) {
      return "center" === e.alignment ? "auto" : 0;
    }, function (e) {
      return "center" === e.alignment ? "auto" : 0;
    }), t.TabHeaderIndicatorContainer = s.styled("div")(i || (i = r(["\n    position: absolute;\n    height: 4px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: auto;\n\n    ", "\n"], ["\n    position: absolute;\n    height: 4px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: auto;\n\n    ", "\n"])), function (e) {
      return e.isActive ? e.theme.Tabs.Active : e.theme.Tabs.Inactive;
    }), t.TabLabel = s.styled("button")(a || (a = r(["\n    border: none;\n    background: none;\n    color: ", ";\n    transition: color 0.2s;\n    text-transform: uppercase;\n    font-weight: ", ";\n    padding: 12px;\n    line-height: 1.1;\n    letter-spacing: 2px;\n    cursor: pointer;\n    margin-right: auto;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-family: inherit;\n\n    :focus {\n        outline: none;\n    }\n\n    :hover,\n    :focus {\n        color: ", ";\n    }\n"], ["\n    border: none;\n    background: none;\n    color: ", ";\n    transition: color 0.2s;\n    text-transform: uppercase;\n    font-weight: ", ";\n    padding: 12px;\n    line-height: 1.1;\n    letter-spacing: 2px;\n    cursor: pointer;\n    margin-right: auto;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-family: inherit;\n\n    :focus {\n        outline: none;\n    }\n\n    :hover,\n    :focus {\n        color: ", ";\n    }\n"])), function (e) {
      return e.isActive ? e.theme.calculated.textColor : e.theme.colors.base8;
    }, function (e) {
      return e.isActive ? "bold" : "normal";
    }, function (e) {
      return e.theme.colors.base10;
    }), t.IconWrapper = s.styled("div")(l || (l = r(["\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n"], ["\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n"])));
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PanelsContainer = t.TabContainer = t.LabelsContainer = t.Container = void 0;
    var o,
      i,
      a,
      l,
      s = n(29),
      c = n(6),
      u = n(1);
    t.Container = u.styled(c.FlexBoxColumn)(o || (o = r(["\n    ", "\n"], ["\n    ", "\n"])), function (e) {
      return e.theme.Tabs.Container;
    }), t.LabelsContainer = u.styled("div")(i || (i = r(["\n    display: flex;\n    border-style: solid;\n    border-width: 0 0 1px 0;\n    margin-left: 12px;\n    margin-right: 12px;\n    ", "\n"], ["\n    display: flex;\n    border-style: solid;\n    border-width: 0 0 1px 0;\n    margin-left: 12px;\n    margin-right: 12px;\n    ", "\n"])), function (e) {
      return e.theme.Tabs.LabelsContainer;
    }), t.TabContainer = u.styled("div")(a || (a = r(["\n    display: flex;\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    ", "\n"], ["\n    display: flex;\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    ", "\n"])), function (e) {
      return s.Animations.FadeInOutTransition(e.isActive);
    }), t.PanelsContainer = u.styled(c.FlexBoxColumn)(l || (l = r(["\n    position: relative;\n"], ["\n    position: relative;\n"]))), t.PanelsContainer.displayName = "PanelsContainer", t.TabContainer.displayName = "TabContainer";
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.UserCardProps = t.UserCardState = t.UserCard = void 0;
    var r = n(441);
    Object.defineProperty(t, "UserCard", {
      enumerable: !0,
      get: function get() {
        return r.UserCard;
      }
    }), Object.defineProperty(t, "UserCardState", {
      enumerable: !0,
      get: function get() {
        return r.UserCardState;
      }
    }), Object.defineProperty(t, "UserCardProps", {
      enumerable: !0,
      get: function get() {
        return r.UserCardProps;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r79,
      o = this && this.__extends || (_r79 = function r(e, t) {
        return (_r79 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r79(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      a = this && this.__rest || function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.UserCard = void 0;
    var l = n(0),
      s = n(442),
      c = n(12),
      u = function (e) {
        function t(t) {
          var n = e.call(this, t) || this;
          return n.state = {}, n.validateImageUrl(t.imageUrl), n;
        }
        return o(t, e), t.prototype.componentDidUpdate = function (e) {
          e.imageUrl !== this.props.imageUrl && this.validateImageUrl(this.props.imageUrl);
        }, t.prototype.validateImageUrl = function (e) {
          var t = this;
          if (e) {
            var n = new Image();
            n.src = e, n.onload = function () {
              t.setState({
                verifiedImageUrl: e
              });
            };
          }
        }, t.prototype.render = function () {
          var e = this.props,
            t = e.className,
            n = e.large,
            r = (e.firstLine, e.secondLine, e.imageUrl, e.isAvailable, e.onClick),
            o = e.lightHover,
            c = a(e, ["className", "large", "firstLine", "secondLine", "imageUrl", "isAvailable", "onClick", "lightHover"]);
          return r ? l.createElement(s.StyledButton, i({
            large: n,
            className: t,
            onClick: r,
            lightHover: o
          }, c), this.renderContent()) : this.renderContent();
        }, t.prototype.renderContent = function () {
          var e = this.props,
            t = e.className,
            n = e.large,
            r = e.firstLine,
            o = e.secondLine,
            i = e.isAvailable,
            a = this.state.verifiedImageUrl;
          return l.createElement(s.UserCardContainer, {
            className: c.cx("Twilio-UserCard-UserCardContainer", t)
          }, l.createElement(s.AvatarContainer, {
            className: "Twilio-UserCard-AvatarContainer"
          }, l.createElement(s.StyledAvatarWrapper, {
            className: "Twilio-UserCard-StyledAvatarWrapper"
          }, a ? l.createElement(s.StyledAvatarImage, {
            src: a
          }) : l.createElement(s.StyledDefaultAvatarIcon, {
            icon: "DefaultAvatar"
          })), l.createElement(s.StyledAvailabilityIconWrapper, {
            className: "Twilio-UserCard-StyledAvailabilityIconWrapper"
          }, l.createElement(s.StyledAvailabilityIcon, {
            available: !!i
          }))), n && l.createElement(s.InfoContainer, {
            className: "Twilio-UserCard-InfoContainer"
          }, l.createElement(s.FirstLine, {
            className: "Twilio-UserCard-InfoContainer-FirstLine"
          }, r), l.createElement(s.SecondLine, {
            className: "Twilio-UserCard-InfoContainer-SecondLine"
          }, o)));
        }, t;
      }(l.PureComponent);
    t.UserCard = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__makeTemplateObject || function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.StyledButton = t.UserCardContainer = t.SecondLine = t.FirstLine = t.InfoContainer = t.StyledAvailabilityIcon = t.StyledAvailabilityIconWrapper = t.StyledDefaultAvatarIcon = t.StyledAvatarImage = t.StyledAvatarWrapper = t.AvatarContainer = void 0;
    var o,
      i,
      a,
      l,
      s,
      c,
      u,
      p,
      d,
      f,
      h,
      m = n(1),
      g = n(7);
    t.AvatarContainer = m.styled("div")(o || (o = r(["\n    display: flex;\n    flex: 0 0 auto;\n    position: relative;\n    background: inherit;\n"], ["\n    display: flex;\n    flex: 0 0 auto;\n    position: relative;\n    background: inherit;\n"]))), t.StyledAvatarWrapper = m.styled("div")(i || (i = r(["\n    display: flex;\n    margin-top: auto;\n    margin-bottom: auto;\n    margin-left: 6px;\n    margin-right: 6px;\n    width: 32px;\n    height: 32px;\n    border-radius: 100px;\n    border-style: solid;\n    border-width: 1px;\n    overflow: hidden;\n    ", "\n"], ["\n    display: flex;\n    margin-top: auto;\n    margin-bottom: auto;\n    margin-left: 6px;\n    margin-right: 6px;\n    width: 32px;\n    height: 32px;\n    border-radius: 100px;\n    border-style: solid;\n    border-width: 1px;\n    overflow: hidden;\n    ", "\n"])), function (e) {
      return e.theme.UserCard.AvatarContainer;
    }), t.StyledAvatarImage = m.styled("img")(a || (a = r(["\n    margin: auto;\n    display: block;\n    max-width: 32px;\n    max-height: 32px;\n    width: auto;\n    height: auto;\n"], ["\n    margin: auto;\n    display: block;\n    max-width: 32px;\n    max-height: 32px;\n    width: auto;\n    height: auto;\n"]))), t.StyledDefaultAvatarIcon = m.styled(g.Icon)(l || (l = r(["\n    margin: auto;\n"], ["\n    margin: auto;\n"]))), t.StyledAvailabilityIconWrapper = m.styled("div")(s || (s = r(["\n    display: flex;\n    position: absolute;\n    top: auto;\n    left: auto;\n    right: 4px;\n    bottom: 4px;\n    width: 14px;\n    height: 14px;\n    border-radius: 7px;\n    background-color: inherit;\n"], ["\n    display: flex;\n    position: absolute;\n    top: auto;\n    left: auto;\n    right: 4px;\n    bottom: 4px;\n    width: 14px;\n    height: 14px;\n    border-radius: 7px;\n    background-color: inherit;\n"]))), t.StyledAvailabilityIcon = m.styled("div")(c || (c = r(["\n    margin: auto;\n    width: 10px;\n    height: 10px;\n    border-radius: 100px;\n    border-style: solid;\n    border-width: 1px;\n    background-color: ", ";\n    ", "\n"], ["\n    margin: auto;\n    width: 10px;\n    height: 10px;\n    border-radius: 100px;\n    border-style: solid;\n    border-width: 1px;\n    background-color: ", ";\n    ", "\n"])), function (e) {
      return e.available ? e.theme.colors.userAvailableColor : e.theme.colors.userUnavailableColor;
    }, function (e) {
      return e.theme.UserCard.AvailabilityContainer;
    }), t.InfoContainer = m.styled("div")(u || (u = r(["\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    margin-top: auto;\n    margin-bottom: auto;\n    padding-left: 4px;\n    padding-right: 6px;\n    overflow: hidden;\n"], ["\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    margin-top: auto;\n    margin-bottom: auto;\n    padding-left: 4px;\n    padding-right: 6px;\n    overflow: hidden;\n"]))), t.FirstLine = m.styled("div")(p || (p = r(["\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 1px;\n    margin-bottom: 1px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 12px;\n    font-weight: bold;\n    text-align: left;\n    white-space: nowrap;\n"], ["\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 1px;\n    margin-bottom: 1px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 12px;\n    font-weight: bold;\n    text-align: left;\n    white-space: nowrap;\n"]))), t.SecondLine = m.styled(t.FirstLine)(d || (d = r(["\n    font-size: 10px;\n    font-weight: normal;\n"], ["\n    font-size: 10px;\n    font-weight: normal;\n"]))), t.UserCardContainer = m.styled("div")(f || (f = r(["\n    display: flex;\n    overflow: hidden;\n    height: 44px;\n    flex: 1 1 auto;\n"], ["\n    display: flex;\n    overflow: hidden;\n    height: 44px;\n    flex: 1 1 auto;\n"]))), t.StyledButton = m.styled("button")(h || (h = r(["\n    width: 100%;\n    padding: 0;\n    display: flex;\n    color: inherit;\n    outline: none;\n    background: none;\n    border: none;\n    svg {\n        margin: auto;\n    }\n    ", "\n"], ["\n    width: 100%;\n    padding: 0;\n    display: flex;\n    color: inherit;\n    outline: none;\n    background: none;\n    border: none;\n    svg {\n        margin: auto;\n    }\n    ", "\n"])), function (e) {
      return !e.disabled && m.getBackgroundWithHoverCSS(void 0, e.lightHover);
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    t.default = {
      InputPlaceHolder: "Type message",
      TypingIndicator: "{{name}} is typing … ",
      TypingIndicatorMultiple: "{{count}} people are typing … ",
      Connecting: "Connecting …",
      Disconnected: "Connection lost",
      Read: "Read",
      MessageSendingDisabled: "Message sending has been disabled",
      Today: "TODAY",
      Yesterday: "YESTERDAY",
      MessageCanvasTrayContent: "\n        <h6>Complete</h6>\n        <p>This chat is no longer active.</p>",
      MessageCanvasTrayButton: "START NEW CHAT",
      MediaMessageError: "Media messages are not supported",
      WelcomeMessage: "Welcome to customer service",
      NotificationMessage: "Unable to perform action: {{message}}",
      Save: "SAVE",
      Reset: "RESET",
      MessageCharacterCountStatus: "{{currentCharCount}} / {{maxCharCount}}",
      MessageCharacterCountReached: "Character count reached - {{currentCharCount}} / {{maxCharCount}}",
      SendMessageTooltip: "Send Message",
      FieldValidationRequiredField: "Field required",
      FieldValidationInvalidEmail: "Please provide a valid email address",
      ChatInputUserNotMemberDisabledText: "You are not a chat participant",
      FilterItemAny: "Any",
      FilterItemAmountSelected: "{{amount}} selected",
      FilterItemOnly: "{{item.label}} only",
      LegacyFiltersTitle: "Custom Filters",
      LegacyFiltersEmptySelectLabel: "None",
      DialpadNum0Caption: "0",
      DialpadNum0Description: "+",
      DialpadNum1Caption: "1",
      DialpadNum1Description: "—",
      DialpadNum2Caption: "2",
      DialpadNum2Description: "ABC",
      DialpadNum3Caption: "3",
      DialpadNum3Description: "DEF",
      DialpadNum4Caption: "4",
      DialpadNum4Description: "GHI",
      DialpadNum5Caption: "5",
      DialpadNum5Description: "JKL",
      DialpadNum6Caption: "6",
      DialpadNum6Description: "MNO",
      DialpadNum7Caption: "7",
      DialpadNum7Description: "PQRS",
      DialpadNum8Caption: "8",
      DialpadNum8Description: "TUV",
      DialpadNum9Caption: "9",
      DialpadNum9Description: "WXYZ",
      DialpadHashCaption: "#",
      DialpadHashDescription: "",
      DialpadAsteriskCaption: "*",
      DialpadAsteriskDescription: "",
      NewChatMessageNotificationTitle: "New message from {{lastMessage.authorName}}",
      NewChatMessageNotificationBody: "{{#if lastMessage.source.body}} {{lastMessage.source.body}} {{else}} file sent {{/if}}",
      MediaMessageClickToOpen: "Open file",
      SendMediaMessageInvalidType: "{{fileName}} cannot be sent because the file type is unsupported. Please try a different file.",
      SendMediaMessageInvalidSize: "{{fileName}} is too large to send. Maximum file size is {{maxFileSize}}.",
      AttachFileInvalidType: "{{fileName}} cannot be attached because the file type is unsupported. Please try a different file.",
      AttachFileInvalidSize: "{{fileName}} is too large to attach. Maximum file size is {{maxFileSize}}.",
      DownloadFileInvalidType: "{{fileName}} cannot be downloaded because the file type is unsupported. Please try a different file.",
      DownloadFileInvalidSize: "{{fileName}} is too large to download. Maximum file size is {{maxFileSize}}.",
      MediaMessageTransferFailed: "Sending failed",
      AttachFileImageTooltip: "Attach file or image",
      ManageAgentsToQueueBreadCrumb: "Manage Agents",
      QueueStatsBreadCrumb: "Queue Stats",
      FileAttachmentDropAreaTitle: "Attach a file or an image",
      FileAttachmentDropAreaSubtitle: "Drop file here"
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChatConfig = t.ChatState = t.ChatSessionState = t.ChatChannelsState = t.ChatChannelState = void 0;
    var r = n(16);
    t.ChatChannelState = r;
    var o = n(47);
    t.ChatChannelsState = o;
    var i = n(26);
    t.ChatSessionState = i;
    var a = n(446);
    t.ChatState = a;
    var l = n(447);
    t.ChatConfig = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.current = t.setConfig = void 0;
    var r,
      o = n(103),
      i = n(11),
      a = n(2);
    t.setConfig = function (e) {
      var t, n;
      r && r.language === e.language || (t = e.language, n = o.languages[t] || o.languages.default, i.initWithStrings(n)), e.logLevel && a.log.setLevel(e.logLevel), r = e;
    }, t.current = function () {
      return r;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createTheme = t.FlexLight = t.FlexDark = t.GreyLight = t.GreyDark = t.BaseTheme = t.BlueDarkTheme = t.BlueMediumTheme = t.DarkTheme = t.MediumTheme = void 0;
    var r = n(449);
    t.MediumTheme = r.default, Object.defineProperty(t, "GreyLight", {
      enumerable: !0,
      get: function get() {
        return r.GreyLight;
      }
    });
    var o = n(450);
    t.DarkTheme = o.default, Object.defineProperty(t, "GreyDark", {
      enumerable: !0,
      get: function get() {
        return o.GreyDark;
      }
    });
    var i = n(451);
    t.BlueDarkTheme = i.default, Object.defineProperty(t, "FlexDark", {
      enumerable: !0,
      get: function get() {
        return i.FlexDark;
      }
    });
    var a = n(452);
    t.BlueMediumTheme = a.default, Object.defineProperty(t, "FlexLight", {
      enumerable: !0,
      get: function get() {
        return a.FlexLight;
      }
    });
    var l = n(24);
    t.BaseTheme = l.default, Object.defineProperty(t, "createTheme", {
      enumerable: !0,
      get: function get() {
        return l.createTheme;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.GreyLight = void 0;
    var o = n(24),
      i = {
        colors: r(r({}, o.default.colors), {
          base1: "#ffffff",
          base2: "#eeeeee",
          base3: "#dddddd",
          base4: "#cccccc",
          base5: "#bbbbbb",
          base6: "#ababab",
          base7: "#888888",
          base8: "#666666",
          base9: "#444444",
          base10: "#222222",
          base11: "#000000"
        })
      };
    t.GreyLight = i, t.default = i;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.GreyDark = void 0;
    var o = n(24),
      i = {
        colors: r(r({}, o.default.colors), {
          base1: "#000000",
          base2: "#222222",
          base3: "#444444",
          base4: "#666666",
          base5: "#888888",
          base6: "#ababab",
          base7: "#bbbbbb",
          base8: "#cccccc",
          base9: "#dddddd",
          base10: "#eeeeee",
          base11: "#ffffff"
        })
      };
    t.GreyDark = i, t.default = i;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FlexDark = void 0;
    var o = n(24),
      i = {
        colors: r(r({}, o.default.colors), {
          base1: "#000000",
          base2: "#202125",
          base3: "#40434B",
          base4: "#606471",
          base5: "#808697",
          base6: "#A0A8BD",
          base7: "#B3B9CA",
          base8: "#C6CAD7",
          base9: "#D9DCE4",
          base10: "#ECEDF1",
          base11: "#ffffff"
        })
      };
    t.FlexDark = i, t.default = i;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FlexLight = void 0;
    var o = n(24),
      i = {
        colors: r(r({}, o.default.colors), {
          base1: "#FFFFFF",
          base2: "#ECEDF1",
          base3: "#D9DCE4",
          base4: "#C6CAD7",
          base5: "#B3B9CA",
          base6: "#A0A8BD",
          base7: "#808697",
          base8: "#606471",
          base9: "#40434B",
          base10: "#202125",
          base11: "#000000"
        })
      };
    t.FlexLight = i, t.default = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.VERSION = void 0, t.VERSION = "0.57.0";
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              s(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            try {
              s(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, l);
          }
          s((r = r.apply(e, t || [])).next());
        });
      },
      o = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: l(0),
          throw: l(1),
          return: l(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function l(i) {
          return function (l) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, l]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChatActions = void 0;
    var i = n(22),
      a = n(5),
      l = n(19),
      s = n(8),
      c = n(14),
      u = n(17),
      p = n(2),
      d = n(13),
      f = n(16),
      h = n(34),
      m = function () {
        function e() {}
        return e.registerActions = function () {
          i.Actions.registerAction("SendMessage", this.sendMessage, this.updateChatActionPayload), i.Actions.registerAction("SendMediaMessage", this.sendMediaMessage, this.updateChatActionPayload), i.Actions.registerAction("SendTyping", this.sendTyping, this.updateChatActionPayload), i.Actions.registerAction("SetInputText", this.setInputText, this.updateChatActionPayload), i.Actions.registerAction("AttachFile", this.attachFile, this.updateChatActionPayload), i.Actions.registerAction("DetachFile", this.detachFile, this.updateChatActionPayload), i.Actions.registerAction("DownloadMedia", this.downloadMedia, this.updateChatActionPayload);
        }, e.sendMessage = function (t) {
          return r(this, void 0, Promise, function () {
            var n, r, i, u, p;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  n = t.channel, r = t.body, i = t.useSeparateInputStore, e.dispatchInputTextAction(i, n, ""), o.label = 1;
                case 1:
                  return o.trys.push([1, 3,, 4]), [4, n.source.sendMessage(r, t.messageAttributes)];
                case 2:
                  return u = o.sent(), a.ChatModule.events.emitMessagePosted(n.source.sid, r), [2, u];
                case 3:
                  throw p = o.sent(), e.dispatchInputTextAction(i, n, r), s.ErrorManager.createAndProcessError(c.ErrorMessages.FAILED_TO_SEND_MESSAGE_TO_CHANNEL, {
                    type: l.CoreErrorType.chatSDK,
                    description: "Failed to send message to channel " + n.source.sid,
                    context: "Chat",
                    wrappedError: p
                  });
                case 4:
                  return [2];
              }
            });
          });
        }, e.sendMediaMessage = function (e) {
          var t;
          return r(this, void 0, Promise, function () {
            var n, r, i, p, h, m, g;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  if (n = e.channel, r = e.file, i = e.messageAttributes, p = e.channelSid, !u.isFileAttachmentEnabled(p)) throw s.ErrorManager.createAndProcessError(c.ErrorMessages.FILE_ATTACHMENT_DISABLED, {
                    context: "Chat|FileAttachment"
                  });
                  if (u.isFileAttachmentReadOnly()) throw s.ErrorManager.createAndProcessError(c.ErrorMessages.FILE_ATTACHMENT_READ_ONLY, {
                    context: "Chat|FileAttachment",
                    severity: l.CoreErrorSeverity.user
                  });
                  if (!u.isValidFileType(r)) throw d.Notifications.showNotification(d.NotificationIds.SendMediaMessageInvalidType, {
                    fileName: r.name
                  }), s.ErrorManager.createAndProcessError(c.ErrorMessages.FILE_ATTACHMENT_SEND_MESSAGE_INVALID_TYPE, {
                    context: "Chat|FileAttachment",
                    severity: l.CoreErrorSeverity.user
                  });
                  if (!u.isValidFileSize(r)) throw d.Notifications.showNotification(d.NotificationIds.SendMediaMessageInvalidSize, {
                    fileName: r.name,
                    maxFileSize: u.getMaxFileSizeInMB()
                  }), s.ErrorManager.createAndProcessError(c.ErrorMessages.FILE_ATTACHMENT_SEND_MESSAGE_INVALID_SIZE, {
                    context: "Chat|FileAttachment",
                    severity: l.CoreErrorSeverity.user
                  });
                  f.Actions.addPendingMessage(r, n.source), (h = new FormData()).append("file", r), o.label = 1;
                case 1:
                  return o.trys.push([1, 3,, 4]), [4, n.source.sendMessage(h, i)];
                case 2:
                  return m = o.sent(), a.ChatModule.events.emitMediaMessagePosted(n.source.sid, r), f.Actions.removePendingMessage(r, n.source), [2, m];
                case 3:
                  throw g = o.sent(), f.Actions.rejectMediaMessage(r, n.source), s.ErrorManager.createAndProcessError(c.ErrorMessages.FILE_ATTACHMENT_GENERIC_ERROR, {
                    type: l.CoreErrorType.chatSDK,
                    description: "Failed to send media message to chat channel " + (null === (t = null == n ? void 0 : n.source) || void 0 === t ? void 0 : t.sid),
                    context: "Chat|FileAttachment",
                    wrappedError: g
                  });
                case 4:
                  return [2];
              }
            });
          });
        }, e.sendTyping = function (e) {
          var t, n, i, a;
          return r(this, void 0, Promise, function () {
            var r;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  return o.trys.push([0, 2,, 3]), [4, null === (n = null === (t = e.channel) || void 0 === t ? void 0 : t.source) || void 0 === n ? void 0 : n.typing()];
                case 1:
                  return [2, o.sent()];
                case 2:
                  return r = o.sent(), [2, Promise.reject(s.ErrorManager.createAndProcessError(c.ErrorMessages.SEND_TYPING_FAILED, {
                    type: l.CoreErrorType.chatSDK,
                    description: "Failed to send typing indicator to chat channel " + (null === (a = null === (i = e.channel) || void 0 === i ? void 0 : i.source) || void 0 === a ? void 0 : a.sid),
                    context: "SendTyping",
                    wrappedError: r
                  }))];
                case 3:
                  return [2];
              }
            });
          });
        }, e.setInputText = function (t) {
          return r(this, void 0, Promise, function () {
            return o(this, function (n) {
              return t.useSeparateInputStore || e.inputTextDeprecationWarningShown || (p.log.warn("Action `setInputText` received payload.useSeparateInputStore as false. Setting it to true, will store the message text in separate state and improves performance. From the next major release of Flex, useSeparateInputStore will be defaulted to true."), e.inputTextDeprecationWarningShown = !0), e.dispatchInputTextAction(t.useSeparateInputStore, t.channel, t.body, t.selectionStart, t.selectionEnd), "" !== t.body && i.Actions.invokeAction("SendTyping", {
                channel: t.channel,
                channelSid: t.channelSid
              }).catch(function (e) {
                p.log.trace("Unable to send typing to indicator (might be sent already)", e);
              }), [2];
            });
          });
        }, e.attachFile = function (e) {
          return r(this, void 0, Promise, function () {
            var t, n, r;
            return o(this, function (o) {
              if (t = e.channel, n = e.channelSid, r = e.file, !u.isFileAttachmentEnabled(n)) throw s.ErrorManager.createAndProcessError(c.ErrorMessages.FILE_ATTACHMENT_DISABLED, {
                context: "Chat|FileAttachment"
              });
              if (u.isFileAttachmentReadOnly()) throw s.ErrorManager.createAndProcessError(c.ErrorMessages.FILE_ATTACHMENT_READ_ONLY, {
                context: "Chat|FileAttachment",
                severity: l.CoreErrorSeverity.user
              });
              if (!u.isValidFileType(r)) throw d.Notifications.showNotification(d.NotificationIds.AttachFileInvalidType, {
                fileName: r.name
              }), s.ErrorManager.createAndProcessError(c.ErrorMessages.FILE_ATTACHMENT_ATTACH_INVALID_TYPE, {
                context: "Chat|FileAttachment",
                severity: l.CoreErrorSeverity.user
              });
              if (!u.isValidFileSize(r)) throw d.Notifications.showNotification(d.NotificationIds.AttachFileInvalidSize, {
                fileName: r.name,
                maxFileSize: u.getMaxFileSizeInMB()
              }), s.ErrorManager.createAndProcessError(c.ErrorMessages.FILE_ATTACHMENT_ATTACH_INVALID_SIZE, {
                context: "Chat|FileAttachment",
                severity: l.CoreErrorSeverity.user
              });
              return [2, h.Actions.attachFile(t, r)];
            });
          });
        }, e.detachFile = function (e) {
          return r(this, void 0, Promise, function () {
            return o(this, function (t) {
              return [2, h.Actions.detachFile(e.channel, e.file)];
            });
          });
        }, e.downloadMedia = function (e) {
          var t, n;
          return r(this, void 0, Promise, function () {
            var r, i, a;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  if ("media" !== e.message.type) return [3, 4];
                  if (r = {
                    name: e.message.media.filename,
                    size: e.message.media.size,
                    type: e.message.media.contentType
                  }, !u.isValidFileType(r)) throw d.Notifications.showNotification(d.NotificationIds.DownloadFileInvalidType, {
                    fileName: r.name
                  }), s.ErrorManager.createAndProcessError(c.ErrorMessages.FILE_ATTACHMENT_DOWNLOAD_INVALID_TYPE, {
                    context: "Chat|FileAttachment",
                    severity: l.CoreErrorSeverity.user
                  });
                  if (!u.isValidFileSize(r)) throw d.Notifications.showNotification(d.NotificationIds.DownloadFileInvalidSize, {
                    fileName: r.name,
                    maxFileSize: u.getMaxFileSizeInMB()
                  }), s.ErrorManager.createAndProcessError(c.ErrorMessages.FILE_ATTACHMENT_DOWNLOAD_INVALID_SIZE, {
                    context: "Chat|FileAttachment",
                    severity: l.CoreErrorSeverity.user
                  });
                  o.label = 1;
                case 1:
                  return o.trys.push([1, 3,, 4]), [4, e.message.media.getContentUrl()];
                case 2:
                  return i = o.sent(), window.open(i), [3, 4];
                case 3:
                  throw a = o.sent(), s.ErrorManager.createAndProcessError(c.ErrorMessages.FILE_ATTACHMENT_UNABLE_TO_DOWNLOAD, {
                    type: l.CoreErrorType.chatSDK,
                    description: "Failed to download message from chat channel " + (null === (n = null === (t = e.channel) || void 0 === t ? void 0 : t.source) || void 0 === n ? void 0 : n.sid),
                    context: "Chat|FileAttachment",
                    wrappedError: a
                  });
                case 4:
                  return [2];
              }
            });
          });
        }, e.dispatchInputTextAction = function (e, t, n, r, o) {
          e ? h.Actions.setInputText(t, n, r, o) : f.Actions.deprecatedSetInputText(t, n, r, o);
        }, e.updateChatActionPayload = function (e) {
          return e.channel && (e.channelSid = e.channel.source.sid), e.channelSid && !e.channel && (e.channel = a.ChatModule.state.channels[e.channelSid]), e;
        }, e.inputTextDeprecationWarningShown = !1, e;
      }();
    t.ChatActions = m;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ErrorCode = t.AudioPlayerError = t.MediaData = t.AudioPlayerManager = void 0;
    var r = n(456);
    Object.defineProperty(t, "AudioPlayerManager", {
      enumerable: !0,
      get: function get() {
        return r.AudioPlayerManager;
      }
    }), Object.defineProperty(t, "MediaData", {
      enumerable: !0,
      get: function get() {
        return r.MediaData;
      }
    });
    var o = n(104);
    Object.defineProperty(t, "AudioPlayerError", {
      enumerable: !0,
      get: function get() {
        return o.AudioPlayerError;
      }
    }), Object.defineProperty(t, "ErrorCode", {
      enumerable: !0,
      get: function get() {
        return o.ErrorCode;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AudioPlayerManager = void 0;
    var r = n(457),
      o = n(458),
      i = n(100),
      a = n(2),
      l = function () {
        function e() {
          var e = this;
          this.onAudioEnd = function (t, n) {
            return function () {
              t(), e.medias.delete(n);
            };
          }, this.repeatableMediaManager = this.initMediaManager(), this.nonRepeatableMediaManager = this.initMediaManager(1), this.medias = new Map();
        }
        return e.prototype.initMediaManager = function (e) {
          return {
            queue: new o.MediaQueue(e),
            audioPlayer: new r.default()
          };
        }, e.prototype.getMediaManager = function (e) {
          return e.repeatable ? this.repeatableMediaManager : this.nonRepeatableMediaManager;
        }, e.prototype.play = function (e, t) {
          var n = this,
            r = i.v4();
          try {
            var o = this.getMediaManager(e);
            o.queue.enqueue(r, function (i) {
              o.audioPlayer.play(e.url, e.repeatable, n.onAudioEnd(i, r), t);
            }), this.medias.set(r, e);
          } catch (e) {
            a.log.warn(e);
          }
          return r;
        }, e.prototype.stop = function (e) {
          if (this.medias.has(e)) {
            var t = this.medias.get(e),
              n = this.getMediaManager(t);
            n.queue.isProcessing(e) && n.audioPlayer.stop(), n.queue.dequeue(e), this.medias.delete(e);
          }
        }, e.prototype.toggleSound = function (e) {
          this.repeatableMediaManager.audioPlayer.toggleSound(e), this.nonRepeatableMediaManager.audioPlayer.toggleSound(e);
        }, e;
      }();
    t.AudioPlayerManager = new l();
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }).apply(this, arguments);
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(8),
      i = n(14),
      a = n(2),
      l = n(104),
      s = function () {
        function e() {
          var e = this;
          this.isPlaying = !1, this.handleAudioEnded = function () {
            e.isPlaying = !1, e.audio.removeEventListener("ended", e.handleAudioEnded), e.onAudioEnd();
          }, this.audio = new Audio(), this.playInitialAudio();
        }
        return e.prototype.playInitialAudio = function () {
          var e = new Audio("https://media.twiliocdn.com/sdk/js/client/sounds/releases/1.0.0/incoming.mp3");
          e.muted = !0, e.play().then(function () {
            e.pause(), a.log.info("Initial audio play successful");
          }).catch(function () {
            return a.log.warn("Could not play initial audio");
          });
        }, e.prototype.play = function (e, t, n, r) {
          if (!e) throw o.ErrorManager.createAndProcessError(i.ErrorMessages.AUDIO_PLAYER_MEDIA_URL_MISSING, {
            description: "Trying to play a media element without providing a mediaUrl",
            context: "AudioPlayer"
          });
          this.audio.src = e, this.audio.currentTime = 0, this.audio.loop = t, this.onAudioEnd = n, this.onError = r, this.audio.addEventListener("ended", this.handleAudioEnded), this.playAudio();
        }, e.prototype.playAudio = function () {
          var e = this;
          this.audio.play().then(function () {
            e.isPlaying = !0, a.log.info("Play successful");
          }).catch(function (t) {
            e.handlePlayError(t);
          });
        }, e.prototype.handlePlayError = function (e) {
          a.log.warn("Error playing audio: " + e);
          var t = this.getAudioPlayerError(e);
          this.onError && this.onError(t), t.code === l.ErrorCode.NotAllowed ? this.handlePlayNotAllowedError() : this.audio.dispatchEvent(new Event("ended"));
        }, e.prototype.getAudioPlayerError = function (e) {
          var t = {
            name: e.name,
            message: e.message
          };
          switch (e.name) {
            case "NotAllowedError":
              return r({
                code: l.ErrorCode.NotAllowed
              }, t);
            case "NotSupportedError":
              return r({
                code: l.ErrorCode.InvalidMedia
              }, t);
            default:
              return r({
                code: l.ErrorCode.Other
              }, t);
          }
        }, e.prototype.handlePlayNotAllowedError = function () {
          var e = this,
            t = function t() {
              window.removeEventListener("click", n);
            },
            n = function n() {
              t(), e.playAudio();
            },
            r = function r() {
              t(), e.audio.removeEventListener("ended", r);
            };
          window.addEventListener("click", n), this.audio.addEventListener("ended", r);
        }, e.prototype.stop = function () {
          this.isPlaying && this.audio.pause(), this.audio.dispatchEvent(new Event("ended"));
        }, e.prototype.toggleSound = function (e) {
          this.audio.muted = e;
        }, e;
      }();
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MediaQueue = void 0;
    var r = n(459),
      o = n(8),
      i = n(14),
      a = function () {
        function e(e) {
          var t = this;
          void 0 === e && (e = 1 / 0), this.onCurrentJobFinished = function (e) {
            t.currentJob = void 0, t.deleteJob(e);
          }, this.deleteJob = function (e) {
            t.jobs.forEach(function (n, r) {
              n === e && t.jobs.delete(r);
            });
          }, this.queue = new r.default({
            concurrency: 1,
            autostart: !0
          }), this.maxQueueSize = e, this.jobs = new Map(), this.subscribeToEvents();
        }
        return e.prototype.subscribeToEvents = function () {
          var e = this;
          this.queue.on("start", function (t) {
            e.currentJob = t;
          }), this.queue.on("success", function (t, n) {
            e.onCurrentJobFinished(n);
          }), this.queue.on("timeout", function (t, n) {
            e.onCurrentJobFinished(n), t();
          });
        }, e.prototype.enqueue = function (e, t) {
          if (this.queue.length + (this.currentJob ? 1 : 0) >= this.maxQueueSize) throw o.ErrorManager.createAndProcessError(i.ErrorMessages.MEDIA_QUEUE_SIZE, {
            context: "AudioPlayer"
          });
          if (this.jobs.has(e)) throw o.ErrorManager.createAndProcessError(i.ErrorMessages.MEDIA_ALREADY_ENQUEUED, {
            context: "AudioPlayer"
          });
          var n = function n(e) {
            t(e);
          };
          this.queue.push(n), this.jobs.set(e, n);
        }, e.prototype.dequeue = function (e) {
          if (this.jobs.has(e)) {
            var t = this.jobs.get(e),
              n = this.queue.indexOf(t);
            n >= 0 && this.queue.splice(n, 1), this.jobs.delete(e);
          }
        }, e.prototype.isProcessing = function (e) {
          var t = this.jobs.get(e);
          return !!t && !!this.currentJob && this.currentJob === t;
        }, e;
      }();
    t.MediaQueue = a;
  }, function (e, t) {
    e.exports = require("queue");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
        void 0 === r && (r = n), Object.defineProperty(e, r, {
          enumerable: !0,
          get: function get() {
            return t[n];
          }
        });
      } : function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n];
      }),
      o = this && this.__exportStar || function (e, t) {
        for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AbstractTelemetryEventsDelegate = void 0, o(n(461), t);
    var i = n(463);
    Object.defineProperty(t, "AbstractTelemetryEventsDelegate", {
      enumerable: !0,
      get: function get() {
        return i.default;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var _r80,
      o = this && this.__extends || (_r80 = function r(e, t) {
        return (_r80 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r80(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              s(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            try {
              s(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, l);
          }
          s((r = r.apply(e, t || [])).next());
        });
      },
      a = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: l(0),
          throw: l(1),
          return: l(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function l(i) {
          return function (l) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, l]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.FlexSDKManager = t.FlexSDKManagerImpl = void 0;
    var l = n(462),
      s = n(21),
      c = n(8),
      u = n(2),
      p = function (e) {
        function t() {
          var t = null !== e && e.apply(this, arguments) || this;
          return t.onTokenUpdated = function (e) {
            return i(t, void 0, void 0, function () {
              var t;
              return a(this, function (n) {
                switch (n.label) {
                  case 0:
                    return [4, this.validateToken(e)];
                  case 1:
                    return t = n.sent(), this.emit(l.ClientEvent.TokenUpdated, {
                      token: e,
                      roles: t.roles,
                      expiration: t.dateExpired,
                      identity: t.identity
                    }), [2];
                }
              });
            });
          }, t.onTokenExpired = function () {
            t.emit(l.ClientEvent.TokenExpired, void 0);
          }, t;
        }
        return o(t, e), t.prototype.setClient = function (e) {
          this.client = e;
        }, t.prototype.initialize = function (e, t) {
          return i(this, void 0, void 0, function () {
            var n, r;
            return a(this, function (o) {
              switch (o.label) {
                case 0:
                  if (this.client) return [2];
                  o.label = 1;
                case 1:
                  return o.trys.push([1, 3,, 4]), n = this, [4, l.createClient(e, t)];
                case 2:
                  return n.client = o.sent(), this.client.addListener(l.ClientEvent.TokenUpdated, this.onTokenUpdated), this.client.addListener(l.ClientEvent.TokenExpired, this.onTokenExpired), [3, 4];
                case 3:
                  throw r = o.sent(), c.ErrorManager.createAndProcessError("FlexSDK - initialize: flex SDK client could not be initialized", {
                    wrappedError: r
                  });
                case 4:
                  return [2];
              }
            });
          });
        }, t.prototype.validateToken = function (e) {
          return i(this, void 0, Promise, function () {
            var t;
            return a(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, this.getAccountConfig(e)];
                case 1:
                  return t = n.sent().accountSid, [2, l.auth(t).validateToken(e)];
              }
            });
          });
        }, t.prototype.getClient = function () {
          return this.client;
        }, t.prototype.destroy = function () {
          return i(this, void 0, void 0, function () {
            var e;
            return a(this, function (t) {
              switch (t.label) {
                case 0:
                  if (!this.client) return [2];
                  t.label = 1;
                case 1:
                  return t.trys.push([1, 3, 4, 5]), this.client.removeListener(l.ClientEvent.TokenUpdated, this.onTokenUpdated), this.client.removeListener(l.ClientEvent.TokenExpired, this.onTokenExpired), [4, this.client.destroy()];
                case 2:
                  return t.sent(), [3, 5];
                case 3:
                  return e = t.sent(), u.log.error("FlexSDK - destroy: flex SDK client could not be destroyed", e), [3, 5];
                case 4:
                  return this.client = void 0, [7];
                case 5:
                  return [2];
              }
            });
          });
        }, t.prototype.getAccountConfig = function (e, t) {
          return i(this, void 0, Promise, function () {
            return a(this, function (n) {
              return [2, l.getAccountConfig(e, t)];
            });
          });
        }, t.prototype.setAccountConfig = function (e) {
          return i(this, void 0, Promise, function () {
            return a(this, function (t) {
              if (!this.client) throw new Error("FlexSDK - set account config: flex SDK client not initialised");
              return [2, this.client.config.account.set(e)];
            });
          });
        }, t.prototype.getPublicConfig = function (e) {
          return i(this, void 0, Promise, function () {
            return a(this, function (t) {
              return [2, l.getPublicConfig(e)];
            });
          });
        }, t;
      }(s.EventEmitter);
    t.FlexSDKManagerImpl = p, t.FlexSDKManager = new p();
  }, function (e, t) {
    e.exports = require("@twilio/flex-sdk");
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      },
      o = this && this.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              s(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function l(e) {
            try {
              s(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, l);
          }
          s((r = r.apply(e, t || [])).next());
        });
      },
      i = this && this.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: l(0),
          throw: l(1),
          return: l(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function l(i) {
          return function (l) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      a.label = i[1];
                      break;
                    }
                    if (6 === i[0] && a.label < o[1]) {
                      a.label = o[1], o = i;
                      break;
                    }
                    if (o && a.label < o[2]) {
                      a.label = o[2], a.ops.push(i);
                      break;
                    }
                    o[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                i = t.call(e, a);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, l]);
          };
        }
      },
      a = this && this.__spreadArrays || function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          o = 0;
        for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, l = i.length; a < l; a++, o++) r[o] = i[a];
        return r;
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var l = n(2),
      s = function () {
        function e() {}
        return e.prototype.initialize = function (e) {
          var t = e.createTelemetryClient(this.getSchemaName());
          this.eventGroup = t.createEventGroup(this.getEventGroupName());
        }, e.prototype.getEventGroupName = function () {}, e.prototype.report = function (e) {
          return o(this, void 0, Promise, function () {
            var t;
            return i(this, function (n) {
              switch (n.label) {
                case 0:
                  if (!this.eventGroup) return [2];
                  n.label = 1;
                case 1:
                  return n.trys.push([1, 3,, 4]), [4, this.eventGroup.addEvents(r({
                    eventName: this.getEventName()
                  }, e))];
                case 2:
                  return n.sent(), [3, 4];
                case 3:
                  return t = n.sent(), l.log.error("FlexSDK: Can't report a \"" + this.getEventName() + '" event', t), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }, e.prototype.groupReport = function (e) {
          return o(this, void 0, Promise, function () {
            var t,
              n,
              o = this;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  if (!this.eventGroup) return [2];
                  i.label = 1;
                case 1:
                  return i.trys.push([1, 3,, 4]), [4, (n = this.eventGroup).addEvents.apply(n, e.reduce(function (e, t) {
                    return a(e, [r({
                      eventName: o.getEventName()
                    }, t)]);
                  }, []))];
                case 2:
                  return i.sent(), [3, 4];
                case 3:
                  return t = i.sent(), l.log.error("FlexSDK: Can't report a \"" + this.getEventName() + '" event', t), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }, e;
      }();
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), n(101), n(465);
  }, function (e, t, n) {
    "use strict";

    var _r81,
      o = this && this.__extends || (_r81 = function r(e, t) {
        return (_r81 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }
        _r81(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
      i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.BrowserNotificationHandler = void 0;
    var a = n(13),
      l = n(102),
      s = n(4),
      c = function (e) {
        function t() {
          var t = e.call(this) || this;
          return t.id = a.DefaultNotificationHandlerType.Browser, t.isDocumentFocused = !1, t.handleInitialClick = function () {
            t.isDocumentFocused = !0, window.removeEventListener("click", t.handleInitialClick);
          }, t.handleDocumentBlur = function () {
            t.isDocumentFocused = !1;
          }, t.handleDocumentFocus = function () {
            t.isDocumentFocused = !0;
          }, t.currentNotifications = [], t.handleClose = function (e, t) {
            a.Notifications.dismissNotification(t), t.options.browser.onClose && t.options.browser.onClose(t, e);
          }, t.handleShow = function (e, t) {
            t.options.browser.onShow && t.options.browser.onShow(t, e);
          }, t.handleError = function (e, t) {
            t.options.browser.onError && t.options.browser.onError(t, e);
          }, t.handleClick = function (e, t) {
            window.focus(), e.target.close(), t.options.browser.onClick && t.options.browser.onClick(t, e);
          }, window.addEventListener("click", t.handleInitialClick), window.addEventListener("blur", t.handleDocumentBlur), window.addEventListener("focus", t.handleDocumentFocus), t;
        }
        return o(t, e), t.prototype.canHandleNotification = function (e) {
          return !!e.options && !!e.options.browser && !this.isDocumentFocused;
        }, t.prototype.handleNotification = function (e) {
          var t = this,
            n = "",
            r = i({}, e.options.browser.options);
          e.options.browser.title && (n = (o = s.templates[e.options.browser.title]) ? o(e.context) : e.options.browser.title);
          if (e.options.browser.body) {
            var o = s.templates[e.options.browser.body];
            r.body = o ? o(e.context) : e.options.browser.body;
          }
          var a = new Notification(n, r);
          a.onclose = function (n) {
            return t.handleClose(n, e);
          }, a.onclick = function (n) {
            return t.handleClick(n, e);
          }, a.onerror = function (n) {
            return t.handleError(n, e);
          }, a.onshow = function (n) {
            return t.handleShow(n, e);
          }, this.currentNotifications.length >= 5 && this.currentNotifications.shift(), this.currentNotifications.push({
            browser: a,
            inner: e
          });
        }, t.prototype.dismissNotification = function (e) {
          var t = this.currentNotifications.findIndex(function (t) {
            return t.inner === e;
          });
          t > -1 && (this.currentNotifications[t].browser.close(), this.currentNotifications.splice(t, 1));
        }, t;
      }(l.BaseNotificationHandler);
    t.BrowserNotificationHandler = c, a.Notifications.registerHandler(new c());
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.registerNotifications = void 0;
    var r = n(33),
      o = n(13);
    t.registerNotifications = function () {
      var e = {
        id: r.NewChatMessage,
        options: {
          browser: {
            title: "NewChatMessageNotificationTitle",
            body: "NewChatMessageNotificationBody"
          }
        }
      };
      o.Notifications.registerNotification(e);
      var t = {
        id: r.SendMediaMessageInvalidSize,
        content: "SendMediaMessageInvalidSize",
        type: o.NotificationType.error
      };
      o.Notifications.registerNotification(t);
      var n = {
        id: r.SendMediaMessageInvalidType,
        content: "SendMediaMessageInvalidType",
        type: o.NotificationType.error
      };
      o.Notifications.registerNotification(n);
      var i = {
        id: r.AttachFileInvalidSize,
        content: "AttachFileInvalidSize",
        type: o.NotificationType.error
      };
      o.Notifications.registerNotification(i);
      var a = {
        id: r.AttachFileInvalidType,
        content: "AttachFileInvalidType",
        type: o.NotificationType.error
      };
      o.Notifications.registerNotification(a);
      var l = {
        id: r.DownloadFileInvalidSize,
        content: "DownloadFileInvalidSize",
        type: o.NotificationType.error
      };
      o.Notifications.registerNotification(l);
      var s = {
        id: r.DownloadFileInvalidType,
        content: "DownloadFileInvalidType",
        type: o.NotificationType.error
      };
      o.Notifications.registerNotification(s);
    };
  }]);
});